import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
};

export type Action = {
  __typename?: 'Action';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  message?: Maybe<Message>;
  messageId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  personActionProgresses: PaginatedPersonActionProgress;
  register?: Maybe<Register>;
  registerId?: Maybe<Scalars['ID']['output']>;
  searches: PaginatedSearch;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ActionFilterArgs = {
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  description?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  message?: InputMaybe<MessageFilterArgs>;
  messageId?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  order?: InputMaybe<NumberFieldComparison>;
  personActionProgresses?: InputMaybe<PersonActionProgressFilterArgs>;
  register?: InputMaybe<RegisterFilterArgs>;
  registerId?: InputMaybe<StringFieldComparison>;
  searches?: InputMaybe<SearchFilterArgs>;
  type?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type ActionSortArgs = {
  direction: SortDirection;
  field: ActionSortFields;
};

export enum ActionSortFields {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Description = 'description',
  Id = 'id',
  Name = 'name',
  Order = 'order',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type BooleanFieldComparison = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Content = {
  __typename?: 'Content';
  contentFills: PaginatedContentFill;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ContentFill = {
  __typename?: 'ContentFill';
  content: Content;
  contentId: Scalars['ID']['output'];
  fill: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  language: Scalars['String']['output'];
};

export type ContentFillFilterArgs = {
  content?: InputMaybe<ContentFilterArgs>;
  contentId?: InputMaybe<StringFieldComparison>;
  fill?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  language?: InputMaybe<StringFieldComparison>;
};

export type ContentFillSortArgs = {
  direction: SortDirection;
  field: ContentFillSortFields;
};

export enum ContentFillSortFields {
  Fill = 'fill',
  Id = 'id',
  Language = 'language'
}

export type ContentFilterArgs = {
  contentFills?: InputMaybe<ContentFillFilterArgs>;
  id?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
};

export type ContentSortArgs = {
  direction: SortDirection;
  field: ContentSortFields;
};

export enum ContentSortFields {
  Id = 'id',
  Name = 'name'
}

export type DateFieldComparison = {
  between?: InputMaybe<DateFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  notBetween?: InputMaybe<DateFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateFieldComparisonBetween = {
  lower: Scalars['DateTime']['input'];
  upper: Scalars['DateTime']['input'];
};

export type ErrorLog = {
  __typename?: 'ErrorLog';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  domain: Scalars['String']['output'];
  error: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  stack?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ErrorLogFilterArgs = {
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  domain?: InputMaybe<StringFieldComparison>;
  error?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  stack?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type ErrorLogSortArgs = {
  direction: SortDirection;
  field: ErrorLogSortFields;
};

export enum ErrorLogSortFields {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Domain = 'domain',
  Error = 'error',
  Id = 'id',
  Stack = 'stack',
  UpdatedAt = 'updatedAt'
}

export type EventLog = {
  __typename?: 'EventLog';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  log: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EventLogFilterArgs = {
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  log?: InputMaybe<StringFieldComparison>;
  type?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type EventLogSortArgs = {
  direction: SortDirection;
  field: EventLogSortFields;
};

export enum EventLogSortFields {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  Log = 'log',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type Job = {
  __typename?: 'Job';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  log?: Maybe<Scalars['String']['output']>;
  queue: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type JobFilterArgs = {
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  log?: InputMaybe<StringFieldComparison>;
  queue?: InputMaybe<StringFieldComparison>;
  status?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type JobSortArgs = {
  direction: SortDirection;
  field: JobSortFields;
};

export enum JobSortFields {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  Log = 'log',
  Queue = 'queue',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type MailLog = {
  __typename?: 'MailLog';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  emailTemplate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  sentBy: Scalars['String']['output'];
  sentTo: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MailLogFilterArgs = {
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  emailTemplate?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  message?: InputMaybe<StringFieldComparison>;
  reason?: InputMaybe<StringFieldComparison>;
  sentBy?: InputMaybe<StringFieldComparison>;
  sentTo?: InputMaybe<StringFieldComparison>;
  status?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type MailLogSortArgs = {
  direction: SortDirection;
  field: MailLogSortFields;
};

export enum MailLogSortFields {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  EmailTemplate = 'emailTemplate',
  Id = 'id',
  Message = 'message',
  Reason = 'reason',
  SentBy = 'sentBy',
  SentTo = 'sentTo',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type MailTemplate = {
  __typename?: 'MailTemplate';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  mailTemplateFills: PaginatedMailTemplateFill;
  reminder?: Maybe<Reminder>;
};

export type MailTemplateFill = {
  __typename?: 'MailTemplateFill';
  disclaimer?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  language: Scalars['String']['output'];
  mailTemplate: MailTemplate;
  mailTemplateId: Scalars['ID']['output'];
  plainText: Scalars['String']['output'];
  preHeader?: Maybe<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
  text: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  urlText?: Maybe<Scalars['String']['output']>;
};

export type MailTemplateFillFilterArgs = {
  disclaimer?: InputMaybe<StringFieldComparison>;
  heading?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  language?: InputMaybe<StringFieldComparison>;
  mailTemplate?: InputMaybe<MailTemplateFilterArgs>;
  mailTemplateId?: InputMaybe<StringFieldComparison>;
  plainText?: InputMaybe<StringFieldComparison>;
  preHeader?: InputMaybe<StringFieldComparison>;
  subject?: InputMaybe<StringFieldComparison>;
  text?: InputMaybe<StringFieldComparison>;
  title?: InputMaybe<StringFieldComparison>;
  urlText?: InputMaybe<StringFieldComparison>;
};

export type MailTemplateFillSortArgs = {
  direction: SortDirection;
  field: MailTemplateFillSortFields;
};

export enum MailTemplateFillSortFields {
  Disclaimer = 'disclaimer',
  Heading = 'heading',
  Id = 'id',
  Language = 'language',
  PlainText = 'plainText',
  PreHeader = 'preHeader',
  Subject = 'subject',
  Text = 'text',
  Title = 'title',
  UrlText = 'urlText'
}

export type MailTemplateFilterArgs = {
  active?: InputMaybe<BooleanFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  mailTemplateFills?: InputMaybe<MailTemplateFillFilterArgs>;
  reminder?: InputMaybe<ReminderFilterArgs>;
};

export type MailTemplateSortArgs = {
  direction: SortDirection;
  field: MailTemplateSortFields;
};

export enum MailTemplateSortFields {
  Active = 'active',
  Id = 'id'
}

export type Message = {
  __typename?: 'Message';
  actions: PaginatedAction;
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MessageFilterArgs = {
  actions?: InputMaybe<ActionFilterArgs>;
  content?: InputMaybe<StringFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  title?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type MessageSortArgs = {
  direction: SortDirection;
  field: MessageSortFields;
};

export enum MessageSortFields {
  Content = 'content',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

export type Mutation = {
  __typename?: 'Mutation';
  createAction: Action;
  createContent: Content;
  createContentFill: ContentFill;
  createContentWithFill: Scalars['Boolean']['output'];
  createErrorLog: ErrorLog;
  createEventLog: EventLog;
  createJob: Job;
  createMailLog: MailLog;
  createMailTemplate: MailTemplate;
  createMailTemplateFill: MailTemplateFill;
  createMessage: Message;
  createOrganization: Organization;
  createPermission: Permission;
  createPerson: Person;
  createPersonActionProgress: PersonActionProgress;
  createPersonRegisterProgress: PersonRegisterProgress;
  createPersonSearchProgress: PersonSearchProgress;
  createRegister: Register;
  createReminder: Reminder;
  createResetPassword: ResetPassword;
  createRole: Role;
  createSearch: Search;
  createTenant: Tenant;
  createUniqueRegistration: UniqueRegistration;
  createUser: User;
  createUserNctv: User;
  createUserTenantRole: UserTenantRole;
  deleteAction: Action;
  deleteContent: Content;
  deleteContentFill: ContentFill;
  deleteErrorLog: ErrorLog;
  deleteEventLog: EventLog;
  deleteJob: Job;
  deleteMailLog: MailLog;
  deleteMailTemplate: MailTemplate;
  deleteMailTemplateFill: MailTemplateFill;
  deleteManyOrganizations: Array<Organization>;
  deleteMessage: Message;
  deleteOrganization: Organization;
  deletePermission: Permission;
  deletePerson: Person;
  deletePersonActionProgress: PersonActionProgress;
  deletePersonRegisterProgress: PersonRegisterProgress;
  deletePersonSearchProgress: PersonSearchProgress;
  deleteRegister: Register;
  deleteReminder: Reminder;
  deleteResetPassword: ResetPassword;
  deleteRole: Role;
  deleteSearch: Search;
  deleteTenant: Tenant;
  deleteUniqueRegistration: UniqueRegistration;
  deleteUser: User;
  /** Delete all data of a user */
  deleteUserData: Scalars['Boolean']['output'];
  deleteUserTenantRole: UserTenantRole;
  restoreAction: Action;
  restoreErrorLog: ErrorLog;
  restoreEventLog: EventLog;
  restoreJob: Job;
  restoreMailLog: MailLog;
  restoreMessage: Message;
  restoreRegister: Register;
  restoreSearch: Search;
  updateAction: Action;
  updateContent: Content;
  updateContentFill: ContentFill;
  updateContentWithFill: Scalars['Boolean']['output'];
  updateErrorLog: ErrorLog;
  updateEventLog: EventLog;
  updateJob: Job;
  updateMailLog: MailLog;
  updateMailTemplate: MailTemplate;
  updateMailTemplateFill: MailTemplateFill;
  updateMessage: Message;
  updateOrCreatePersonActionProgressProgression: PersonRegisterProgress;
  updateOrCreatePersonSearchProgressProgression: PersonRegisterProgress;
  updateOrganization: Organization;
  updatePermission: Permission;
  updatePerson: Person;
  updatePersonActionProgress: PersonActionProgress;
  updatePersonRegisterProgress: PersonRegisterProgress;
  updatePersonSearchProgress: PersonSearchProgress;
  updateRegister: Register;
  updateReminder: Reminder;
  updateResetPassword: ResetPassword;
  updateRole: Role;
  updateSearch: Search;
  updateTenant: Tenant;
  updateUniqueRegistration: UniqueRegistration;
  updateUser: User;
  updateUserTenantRole: UserTenantRole;
};


export type MutationCreateActionArgs = {
  description: Scalars['String']['input'];
  messageId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  personActionProgressIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  registerId?: InputMaybe<Scalars['ID']['input']>;
  searchIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  type: Scalars['String']['input'];
};


export type MutationCreateContentArgs = {
  contentFillIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name: Scalars['String']['input'];
};


export type MutationCreateContentFillArgs = {
  contentId: Scalars['ID']['input'];
  fill: Scalars['String']['input'];
  language: Scalars['String']['input'];
};


export type MutationCreateContentWithFillArgs = {
  fill: Scalars['String']['input'];
  language: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateErrorLogArgs = {
  domain: Scalars['String']['input'];
  error: Scalars['String']['input'];
  stack?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateEventLogArgs = {
  log: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationCreateJobArgs = {
  log?: InputMaybe<Scalars['String']['input']>;
  queue: Scalars['String']['input'];
  status: Scalars['String']['input'];
};


export type MutationCreateMailLogArgs = {
  emailTemplate?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  sentBy: Scalars['String']['input'];
  sentTo: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateMailTemplateArgs = {
  active: Scalars['Boolean']['input'];
  mailTemplateFillIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  reminderId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateMailTemplateFillArgs = {
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  mailTemplateId: Scalars['ID']['input'];
  plainText: Scalars['String']['input'];
  preHeader?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  text: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  urlText?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateMessageArgs = {
  actionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  content: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type MutationCreateOrganizationArgs = {
  name: Scalars['String']['input'];
  personId: Scalars['ID']['input'];
  registrationNumber: Scalars['String']['input'];
};


export type MutationCreatePermissionArgs = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationCreatePersonArgs = {
  address: Scalars['String']['input'];
  addressNumber: Scalars['String']['input'];
  city: Scalars['String']['input'];
  firstNames: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  personActionProgressIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  personRegisterProgressIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  personSearchProgressIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  postalCode: Scalars['String']['input'];
  prefix?: InputMaybe<Scalars['String']['input']>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreatePersonActionProgressArgs = {
  actionId: Scalars['ID']['input'];
  done?: InputMaybe<Scalars['Boolean']['input']>;
  personId: Scalars['ID']['input'];
  progress: Scalars['String']['input'];
};


export type MutationCreatePersonRegisterProgressArgs = {
  actionDoneAt?: InputMaybe<Scalars['DateTime']['input']>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  foundAt?: InputMaybe<Scalars['DateTime']['input']>;
  personId: Scalars['ID']['input'];
  progress: Scalars['String']['input'];
  registerId: Scalars['ID']['input'];
};


export type MutationCreatePersonSearchProgressArgs = {
  done?: InputMaybe<Scalars['Boolean']['input']>;
  personId: Scalars['ID']['input'];
  progress: Scalars['String']['input'];
  searchId: Scalars['ID']['input'];
};


export type MutationCreateRegisterArgs = {
  actionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  companyRegister: Scalars['Boolean']['input'];
  contactUrl?: InputMaybe<Scalars['String']['input']>;
  derivativesIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  machineName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  personRegisterProgressIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  siteUrl?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['ID']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};


export type MutationCreateReminderArgs = {
  date: Scalars['DateTime']['input'];
  mailTemplateId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationCreateResetPasswordArgs = {
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationCreateRoleArgs = {
  description: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  permissionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  userTenantRoleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationCreateSearchArgs = {
  actionId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  personSearchProgressIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  searchUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateTenantArgs = {
  name: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
  uniqueRegistrationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  userTenantRoleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationCreateUniqueRegistrationArgs = {
  active: Scalars['Boolean']['input'];
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateUserArgs = {
  active: Scalars['Boolean']['input'];
  avatar?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  encryptedSecret?: InputMaybe<Scalars['String']['input']>;
  invite?: InputMaybe<Scalars['Boolean']['input']>;
  locale: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  passwordSalt?: InputMaybe<Scalars['String']['input']>;
  personIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  reminderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  termsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  timeZone: Scalars['String']['input'];
  userTenantRoleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationCreateUserNctvArgs = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  roleId?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['String']['input'];
};


export type MutationCreateUserTenantRoleArgs = {
  roleId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationDeleteActionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteContentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteContentFillArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteErrorLogArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEventLogArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteJobArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMailLogArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMailTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMailTemplateFillArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteManyOrganizationsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteMessageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePermissionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePersonArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePersonActionProgressArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePersonRegisterProgressArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePersonSearchProgressArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRegisterArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteReminderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteResetPasswordArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSearchArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTenantArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUniqueRegistrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserTenantRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreActionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreErrorLogArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreEventLogArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreJobArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreMailLogArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreMessageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreRegisterArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreSearchArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateActionArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  messageId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  personActionProgressIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  registerId?: InputMaybe<Scalars['ID']['input']>;
  searchIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateContentArgs = {
  contentFillIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateContentFillArgs = {
  contentId?: InputMaybe<Scalars['ID']['input']>;
  fill?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateContentWithFillArgs = {
  fill: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  language: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateErrorLogArgs = {
  domain?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  stack?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateEventLogArgs = {
  id: Scalars['ID']['input'];
  log?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateJobArgs = {
  id: Scalars['ID']['input'];
  log?: InputMaybe<Scalars['String']['input']>;
  queue?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMailLogArgs = {
  emailTemplate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMailTemplateArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  mailTemplateFillIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  reminderId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateMailTemplateFillArgs = {
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  mailTemplateId?: InputMaybe<Scalars['ID']['input']>;
  plainText?: InputMaybe<Scalars['String']['input']>;
  preHeader?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  urlText?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMessageArgs = {
  actionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  content?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateOrCreatePersonActionProgressProgressionArgs = {
  actionId: Scalars['String']['input'];
  personId: Scalars['String']['input'];
  progress: Scalars['String']['input'];
  registerId: Scalars['String']['input'];
};


export type MutationUpdateOrCreatePersonSearchProgressProgressionArgs = {
  personId: Scalars['String']['input'];
  progress: Scalars['String']['input'];
  registerId: Scalars['String']['input'];
  searchId: Scalars['String']['input'];
};


export type MutationUpdateOrganizationArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdatePermissionArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationUpdatePersonArgs = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressNumber?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  firstNames?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  personActionProgressIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  personRegisterProgressIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  personSearchProgressIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdatePersonActionProgressArgs = {
  actionId?: InputMaybe<Scalars['ID']['input']>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  personId?: InputMaybe<Scalars['ID']['input']>;
  progress?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdatePersonRegisterProgressArgs = {
  actionDoneAt?: InputMaybe<Scalars['DateTime']['input']>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  foundAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  personId?: InputMaybe<Scalars['ID']['input']>;
  progress?: InputMaybe<Scalars['String']['input']>;
  registerId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdatePersonSearchProgressArgs = {
  done?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  personId?: InputMaybe<Scalars['ID']['input']>;
  progress?: InputMaybe<Scalars['String']['input']>;
  searchId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateRegisterArgs = {
  actionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  companyRegister?: InputMaybe<Scalars['Boolean']['input']>;
  contactUrl?: InputMaybe<Scalars['String']['input']>;
  derivativesIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  logo?: InputMaybe<Scalars['String']['input']>;
  machineName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  personRegisterProgressIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  siteUrl?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['ID']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateReminderArgs = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['ID']['input'];
  mailTemplateId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateResetPasswordArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateRoleArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  permissionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  userTenantRoleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationUpdateSearchArgs = {
  actionId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  personSearchProgressIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  searchUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateTenantArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  uniqueRegistrationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  userTenantRoleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationUpdateUniqueRegistrationArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateUserArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  encryptedSecret?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  passwordSalt?: InputMaybe<Scalars['String']['input']>;
  personIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  reminderIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  termsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  userTenantRoleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type MutationUpdateUserTenantRoleArgs = {
  id: Scalars['ID']['input'];
  roleId?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type NumberFieldComparison = {
  between?: InputMaybe<NumberFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  notBetween?: InputMaybe<NumberFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NumberFieldComparisonBetween = {
  lower: Scalars['Float']['input'];
  upper: Scalars['Float']['input'];
};

export type Organization = {
  __typename?: 'Organization';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  person: Person;
  personId: Scalars['ID']['output'];
  registrationNumber: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrganizationFilterArgs = {
  createdAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  person?: InputMaybe<PersonFilterArgs>;
  personId?: InputMaybe<StringFieldComparison>;
  registrationNumber?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type OrganizationSortArgs = {
  direction: SortDirection;
  field: OrganizationSortFields;
};

export enum OrganizationSortFields {
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  RegistrationNumber = 'registrationNumber',
  UpdatedAt = 'updatedAt'
}

export type PageArgs = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type PaginatedAction = {
  __typename?: 'PaginatedAction';
  items?: Maybe<Array<Action>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedContent = {
  __typename?: 'PaginatedContent';
  items?: Maybe<Array<Content>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedContentFill = {
  __typename?: 'PaginatedContentFill';
  items?: Maybe<Array<ContentFill>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedErrorLog = {
  __typename?: 'PaginatedErrorLog';
  items?: Maybe<Array<ErrorLog>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedEventLog = {
  __typename?: 'PaginatedEventLog';
  items?: Maybe<Array<EventLog>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedJob = {
  __typename?: 'PaginatedJob';
  items?: Maybe<Array<Job>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedMailLog = {
  __typename?: 'PaginatedMailLog';
  items?: Maybe<Array<MailLog>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedMailTemplate = {
  __typename?: 'PaginatedMailTemplate';
  items?: Maybe<Array<MailTemplate>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedMailTemplateFill = {
  __typename?: 'PaginatedMailTemplateFill';
  items?: Maybe<Array<MailTemplateFill>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedMessage = {
  __typename?: 'PaginatedMessage';
  items?: Maybe<Array<Message>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedOrganization = {
  __typename?: 'PaginatedOrganization';
  items?: Maybe<Array<Organization>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedPermission = {
  __typename?: 'PaginatedPermission';
  items?: Maybe<Array<Permission>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedPerson = {
  __typename?: 'PaginatedPerson';
  items?: Maybe<Array<Person>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedPersonActionProgress = {
  __typename?: 'PaginatedPersonActionProgress';
  items?: Maybe<Array<PersonActionProgress>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedPersonRegisterProgress = {
  __typename?: 'PaginatedPersonRegisterProgress';
  items?: Maybe<Array<PersonRegisterProgress>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedPersonSearchProgress = {
  __typename?: 'PaginatedPersonSearchProgress';
  items?: Maybe<Array<PersonSearchProgress>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedRegister = {
  __typename?: 'PaginatedRegister';
  items?: Maybe<Array<Register>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedReminder = {
  __typename?: 'PaginatedReminder';
  items?: Maybe<Array<Reminder>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedResetPassword = {
  __typename?: 'PaginatedResetPassword';
  items?: Maybe<Array<ResetPassword>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedRole = {
  __typename?: 'PaginatedRole';
  items?: Maybe<Array<Role>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedSearch = {
  __typename?: 'PaginatedSearch';
  items?: Maybe<Array<Search>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedTenant = {
  __typename?: 'PaginatedTenant';
  items?: Maybe<Array<Tenant>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedUniqueRegistration = {
  __typename?: 'PaginatedUniqueRegistration';
  items?: Maybe<Array<UniqueRegistration>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedUser = {
  __typename?: 'PaginatedUser';
  items?: Maybe<Array<User>>;
  totalCount: Scalars['Int']['output'];
};

export type PaginatedUserTenantRole = {
  __typename?: 'PaginatedUserTenantRole';
  items?: Maybe<Array<UserTenantRole>>;
  totalCount: Scalars['Int']['output'];
};

export type Permission = {
  __typename?: 'Permission';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  roles: PaginatedRole;
};

export type PermissionFilterArgs = {
  description?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  roles?: InputMaybe<RoleFilterArgs>;
};

export type PermissionSortArgs = {
  direction: SortDirection;
  field: PermissionSortFields;
};

export enum PermissionSortFields {
  Description = 'description',
  Id = 'id',
  Name = 'name'
}

export type Person = {
  __typename?: 'Person';
  address: Scalars['String']['output'];
  addressNumber: Scalars['String']['output'];
  city: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  firstNames: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  organizations: PaginatedOrganization;
  personActionProgresses: PaginatedPersonActionProgress;
  personRegisterProgresses: PaginatedPersonRegisterProgress;
  personSearchProgresses: PaginatedPersonSearchProgress;
  postalCode: Scalars['String']['output'];
  prefix?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type PersonActionProgress = {
  __typename?: 'PersonActionProgress';
  action?: Maybe<Action>;
  actionId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  done?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  person: Person;
  personId: Scalars['ID']['output'];
  progress: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PersonActionProgressFilterArgs = {
  action?: InputMaybe<ActionFilterArgs>;
  actionId?: InputMaybe<StringFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  done?: InputMaybe<BooleanFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  person?: InputMaybe<PersonFilterArgs>;
  personId?: InputMaybe<StringFieldComparison>;
  progress?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type PersonActionProgressSortArgs = {
  direction: SortDirection;
  field: PersonActionProgressSortFields;
};

export enum PersonActionProgressSortFields {
  CreatedAt = 'createdAt',
  Done = 'done',
  Id = 'id',
  Progress = 'progress',
  UpdatedAt = 'updatedAt'
}

export type PersonFilterArgs = {
  address?: InputMaybe<StringFieldComparison>;
  addressNumber?: InputMaybe<StringFieldComparison>;
  city?: InputMaybe<StringFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  firstNames?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  lastName?: InputMaybe<StringFieldComparison>;
  organizations?: InputMaybe<OrganizationFilterArgs>;
  personActionProgresses?: InputMaybe<PersonActionProgressFilterArgs>;
  personRegisterProgresses?: InputMaybe<PersonRegisterProgressFilterArgs>;
  personSearchProgresses?: InputMaybe<PersonSearchProgressFilterArgs>;
  postalCode?: InputMaybe<StringFieldComparison>;
  prefix?: InputMaybe<StringFieldComparison>;
  progress?: InputMaybe<NumberFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  user?: InputMaybe<UserFilterArgs>;
  userId?: InputMaybe<StringFieldComparison>;
};

export type PersonRegisterProgress = {
  __typename?: 'PersonRegisterProgress';
  actionDoneAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  done?: Maybe<Scalars['Boolean']['output']>;
  foundAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  person: Person;
  personId: Scalars['ID']['output'];
  progress: Scalars['String']['output'];
  register?: Maybe<Register>;
  registerId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PersonRegisterProgressFilterArgs = {
  actionDoneAt?: InputMaybe<DateFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  done?: InputMaybe<BooleanFieldComparison>;
  foundAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  person?: InputMaybe<PersonFilterArgs>;
  personId?: InputMaybe<StringFieldComparison>;
  progress?: InputMaybe<StringFieldComparison>;
  register?: InputMaybe<RegisterFilterArgs>;
  registerId?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type PersonRegisterProgressSortArgs = {
  direction: SortDirection;
  field: PersonRegisterProgressSortFields;
};

export enum PersonRegisterProgressSortFields {
  ActionDoneAt = 'actionDoneAt',
  CreatedAt = 'createdAt',
  Done = 'done',
  FoundAt = 'foundAt',
  Id = 'id',
  Progress = 'progress',
  UpdatedAt = 'updatedAt'
}

export type PersonSearchProgress = {
  __typename?: 'PersonSearchProgress';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  done?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  person: Person;
  personId: Scalars['ID']['output'];
  progress: Scalars['String']['output'];
  search?: Maybe<Search>;
  searchId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PersonSearchProgressFilterArgs = {
  createdAt?: InputMaybe<DateFieldComparison>;
  done?: InputMaybe<BooleanFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  person?: InputMaybe<PersonFilterArgs>;
  personId?: InputMaybe<StringFieldComparison>;
  progress?: InputMaybe<StringFieldComparison>;
  search?: InputMaybe<SearchFilterArgs>;
  searchId?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type PersonSearchProgressSortArgs = {
  direction: SortDirection;
  field: PersonSearchProgressSortFields;
};

export enum PersonSearchProgressSortFields {
  CreatedAt = 'createdAt',
  Done = 'done',
  Id = 'id',
  Progress = 'progress',
  UpdatedAt = 'updatedAt'
}

export type PersonSortArgs = {
  direction: SortDirection;
  field: PersonSortFields;
};

export enum PersonSortFields {
  Address = 'address',
  AddressNumber = 'addressNumber',
  City = 'city',
  CreatedAt = 'createdAt',
  FirstNames = 'firstNames',
  Id = 'id',
  LastName = 'lastName',
  PostalCode = 'postalCode',
  Prefix = 'prefix',
  Progress = 'progress',
  UpdatedAt = 'updatedAt'
}

export type Query = {
  __typename?: 'Query';
  action?: Maybe<Action>;
  actions: PaginatedAction;
  content?: Maybe<Content>;
  contentFill?: Maybe<ContentFill>;
  contentFills: PaginatedContentFill;
  contents: PaginatedContent;
  errorLog?: Maybe<ErrorLog>;
  errorLogs: PaginatedErrorLog;
  eventLog?: Maybe<EventLog>;
  eventLogs: PaginatedEventLog;
  job?: Maybe<Job>;
  jobs: PaginatedJob;
  mailLog?: Maybe<MailLog>;
  mailLogs: PaginatedMailLog;
  mailTemplate?: Maybe<MailTemplate>;
  mailTemplateFill?: Maybe<MailTemplateFill>;
  mailTemplateFills: PaginatedMailTemplateFill;
  mailTemplates: PaginatedMailTemplate;
  message?: Maybe<Message>;
  messages: PaginatedMessage;
  organization?: Maybe<Organization>;
  organizations: PaginatedOrganization;
  people: PaginatedPerson;
  permission?: Maybe<Permission>;
  permissions: PaginatedPermission;
  person?: Maybe<Person>;
  personActionProgress?: Maybe<PersonActionProgress>;
  personActionProgresses: PaginatedPersonActionProgress;
  personRegisterProgress?: Maybe<PersonRegisterProgress>;
  personRegisterProgresses: PaginatedPersonRegisterProgress;
  personSearchProgress?: Maybe<PersonSearchProgress>;
  personSearchProgresses: PaginatedPersonSearchProgress;
  register?: Maybe<Register>;
  registers: PaginatedRegister;
  reminder?: Maybe<Reminder>;
  reminders: PaginatedReminder;
  resetPassword?: Maybe<ResetPassword>;
  resetPasswords: PaginatedResetPassword;
  role?: Maybe<Role>;
  roles: PaginatedRole;
  search?: Maybe<Search>;
  searches: PaginatedSearch;
  tenant?: Maybe<Tenant>;
  tenants: PaginatedTenant;
  uniqueRegistration?: Maybe<UniqueRegistration>;
  uniqueRegistrations: PaginatedUniqueRegistration;
  user?: Maybe<User>;
  userTenantRole?: Maybe<UserTenantRole>;
  userTenantRoles: PaginatedUserTenantRole;
  users: PaginatedUser;
};


export type QueryActionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryActionsArgs = {
  filter?: InputMaybe<ActionFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ActionSortArgs>>;
};


export type QueryContentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContentFillArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContentFillsArgs = {
  filter?: InputMaybe<ContentFillFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContentFillSortArgs>>;
};


export type QueryContentsArgs = {
  filter?: InputMaybe<ContentFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContentSortArgs>>;
};


export type QueryErrorLogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryErrorLogsArgs = {
  filter?: InputMaybe<ErrorLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ErrorLogSortArgs>>;
};


export type QueryEventLogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEventLogsArgs = {
  filter?: InputMaybe<EventLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<EventLogSortArgs>>;
};


export type QueryJobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJobsArgs = {
  filter?: InputMaybe<JobFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<JobSortArgs>>;
};


export type QueryMailLogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMailLogsArgs = {
  filter?: InputMaybe<MailLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailLogSortArgs>>;
};


export type QueryMailTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMailTemplateFillArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMailTemplateFillsArgs = {
  filter?: InputMaybe<MailTemplateFillFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateFillSortArgs>>;
};


export type QueryMailTemplatesArgs = {
  filter?: InputMaybe<MailTemplateFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateSortArgs>>;
};


export type QueryMessageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMessagesArgs = {
  filter?: InputMaybe<MessageFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MessageSortArgs>>;
};


export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationsArgs = {
  filter?: InputMaybe<OrganizationFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<OrganizationSortArgs>>;
};


export type QueryPeopleArgs = {
  filter?: InputMaybe<PersonFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PersonSortArgs>>;
};


export type QueryPermissionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPermissionsArgs = {
  filter?: InputMaybe<PermissionFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PermissionSortArgs>>;
};


export type QueryPersonArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPersonActionProgressArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPersonActionProgressesArgs = {
  filter?: InputMaybe<PersonActionProgressFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PersonActionProgressSortArgs>>;
};


export type QueryPersonRegisterProgressArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPersonRegisterProgressesArgs = {
  filter?: InputMaybe<PersonRegisterProgressFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PersonRegisterProgressSortArgs>>;
};


export type QueryPersonSearchProgressArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPersonSearchProgressesArgs = {
  filter?: InputMaybe<PersonSearchProgressFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PersonSearchProgressSortArgs>>;
};


export type QueryRegisterArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRegistersArgs = {
  filter?: InputMaybe<RegisterFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<RegisterSortArgs>>;
};


export type QueryReminderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRemindersArgs = {
  filter?: InputMaybe<ReminderFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ReminderSortArgs>>;
};


export type QueryResetPasswordArgs = {
  id: Scalars['ID']['input'];
};


export type QueryResetPasswordsArgs = {
  filter?: InputMaybe<ResetPasswordFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ResetPasswordSortArgs>>;
};


export type QueryRoleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRolesArgs = {
  filter?: InputMaybe<RoleFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<RoleSortArgs>>;
};


export type QuerySearchArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySearchesArgs = {
  filter?: InputMaybe<SearchFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<SearchSortArgs>>;
};


export type QueryTenantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTenantsArgs = {
  filter?: InputMaybe<TenantFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<TenantSortArgs>>;
};


export type QueryUniqueRegistrationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUniqueRegistrationsArgs = {
  filter?: InputMaybe<UniqueRegistrationFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UniqueRegistrationSortArgs>>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserTenantRoleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserTenantRolesArgs = {
  filter?: InputMaybe<UserTenantRoleFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserTenantRoleSortArgs>>;
};


export type QueryUsersArgs = {
  filter?: InputMaybe<UserFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserSortArgs>>;
};

export type Register = {
  __typename?: 'Register';
  actions: PaginatedAction;
  companyRegister: Scalars['Boolean']['output'];
  contactUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  derivatives: PaginatedRegister;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  machineName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  personRegisterProgresses: PaginatedPersonRegisterProgress;
  siteUrl?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Register>;
  sourceId?: Maybe<Scalars['ID']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RegisterFilterArgs = {
  actions?: InputMaybe<ActionFilterArgs>;
  companyRegister?: InputMaybe<BooleanFieldComparison>;
  contactUrl?: InputMaybe<StringFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  derivatives?: InputMaybe<RegisterFilterArgs>;
  description?: InputMaybe<StringFieldComparison>;
  email?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  logo?: InputMaybe<StringFieldComparison>;
  machineName?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  order?: InputMaybe<NumberFieldComparison>;
  personRegisterProgresses?: InputMaybe<PersonRegisterProgressFilterArgs>;
  siteUrl?: InputMaybe<StringFieldComparison>;
  source?: InputMaybe<RegisterFilterArgs>;
  sourceId?: InputMaybe<StringFieldComparison>;
  subtitle?: InputMaybe<StringFieldComparison>;
  type?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type RegisterSortArgs = {
  direction: SortDirection;
  field: RegisterSortFields;
};

export enum RegisterSortFields {
  CompanyRegister = 'companyRegister',
  ContactUrl = 'contactUrl',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Description = 'description',
  Email = 'email',
  Id = 'id',
  Logo = 'logo',
  MachineName = 'machineName',
  Name = 'name',
  Order = 'order',
  SiteUrl = 'siteUrl',
  Subtitle = 'subtitle',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type Reminder = {
  __typename?: 'Reminder';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  mailTemplate: MailTemplate;
  mailTemplateId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user: User;
  userId: Scalars['ID']['output'];
};

export type ReminderFilterArgs = {
  createdAt?: InputMaybe<DateFieldComparison>;
  date?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  mailTemplate?: InputMaybe<MailTemplateFilterArgs>;
  mailTemplateId?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  user?: InputMaybe<UserFilterArgs>;
  userId?: InputMaybe<StringFieldComparison>;
};

export type ReminderSortArgs = {
  direction: SortDirection;
  field: ReminderSortFields;
};

export enum ReminderSortFields {
  CreatedAt = 'createdAt',
  Date = 'date',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type ResetPassword = {
  __typename?: 'ResetPassword';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  token: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ResetPasswordFilterArgs = {
  createdAt?: InputMaybe<DateFieldComparison>;
  email?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  token?: InputMaybe<StringFieldComparison>;
  type?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type ResetPasswordSortArgs = {
  direction: SortDirection;
  field: ResetPasswordSortFields;
};

export enum ResetPasswordSortFields {
  CreatedAt = 'createdAt',
  Email = 'email',
  Id = 'id',
  Token = 'token',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type Role = {
  __typename?: 'Role';
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  machineName: Scalars['String']['output'];
  permissions: PaginatedPermission;
  userTenantRoles: PaginatedUserTenantRole;
};

export type RoleFilterArgs = {
  description?: InputMaybe<StringFieldComparison>;
  displayName?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  machineName?: InputMaybe<StringFieldComparison>;
  permissions?: InputMaybe<PermissionFilterArgs>;
  userTenantRoles?: InputMaybe<UserTenantRoleFilterArgs>;
};

export type RoleSortArgs = {
  direction: SortDirection;
  field: RoleSortFields;
};

export enum RoleSortFields {
  Description = 'description',
  DisplayName = 'displayName',
  Id = 'id',
  MachineName = 'machineName'
}

export type Search = {
  __typename?: 'Search';
  action?: Maybe<Action>;
  actionId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  personSearchProgresses: PaginatedPersonSearchProgress;
  searchUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SearchFilterArgs = {
  action?: InputMaybe<ActionFilterArgs>;
  actionId?: InputMaybe<StringFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  deletedAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  order?: InputMaybe<NumberFieldComparison>;
  personSearchProgresses?: InputMaybe<PersonSearchProgressFilterArgs>;
  searchUrl?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type SearchSortArgs = {
  direction: SortDirection;
  field: SearchSortFields;
};

export enum SearchSortFields {
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  Id = 'id',
  Name = 'name',
  Order = 'order',
  SearchUrl = 'searchUrl',
  UpdatedAt = 'updatedAt'
}

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StringFieldComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  createdAction: Action;
  createdContent: Content;
  createdContentFill: ContentFill;
  createdErrorLog: ErrorLog;
  createdEventLog: EventLog;
  createdJob: Job;
  createdMailLog: MailLog;
  createdMailTemplate: MailTemplate;
  createdMailTemplateFill: MailTemplateFill;
  createdMessage: Message;
  createdOrganization: Organization;
  createdPermission: Permission;
  createdPerson: Person;
  createdPersonActionProgress: PersonActionProgress;
  createdPersonRegisterProgress: PersonRegisterProgress;
  createdPersonSearchProgress: PersonSearchProgress;
  createdRegister: Register;
  createdReminder: Reminder;
  createdResetPassword: ResetPassword;
  createdRole: Role;
  createdSearch: Search;
  createdTenant: Tenant;
  createdUniqueRegistration: UniqueRegistration;
  createdUser: User;
  createdUserTenantRole: UserTenantRole;
  deletedAction: Action;
  deletedContent: Content;
  deletedContentFill: ContentFill;
  deletedErrorLog: ErrorLog;
  deletedEventLog: EventLog;
  deletedJob: Job;
  deletedMailLog: MailLog;
  deletedMailTemplate: MailTemplate;
  deletedMailTemplateFill: MailTemplateFill;
  deletedMessage: Message;
  deletedOrganization: Organization;
  deletedPermission: Permission;
  deletedPerson: Person;
  deletedPersonActionProgress: PersonActionProgress;
  deletedPersonRegisterProgress: PersonRegisterProgress;
  deletedPersonSearchProgress: PersonSearchProgress;
  deletedRegister: Register;
  deletedReminder: Reminder;
  deletedResetPassword: ResetPassword;
  deletedRole: Role;
  deletedSearch: Search;
  deletedTenant: Tenant;
  deletedUniqueRegistration: UniqueRegistration;
  deletedUser: User;
  deletedUserTenantRole: UserTenantRole;
  restoredAction: Action;
  restoredErrorLog: ErrorLog;
  restoredEventLog: EventLog;
  restoredJob: Job;
  restoredMailLog: MailLog;
  restoredMessage: Message;
  restoredRegister: Register;
  restoredSearch: Search;
  updatedAction: Action;
  updatedContent: Content;
  updatedContentFill: ContentFill;
  updatedErrorLog: ErrorLog;
  updatedEventLog: EventLog;
  updatedJob: Job;
  updatedMailLog: MailLog;
  updatedMailTemplate: MailTemplate;
  updatedMailTemplateFill: MailTemplateFill;
  updatedMessage: Message;
  updatedOrganization: Organization;
  updatedPermission: Permission;
  updatedPerson: Person;
  updatedPersonActionProgress: PersonActionProgress;
  updatedPersonRegisterProgress: PersonRegisterProgress;
  updatedPersonSearchProgress: PersonSearchProgress;
  updatedRegister: Register;
  updatedReminder: Reminder;
  updatedResetPassword: ResetPassword;
  updatedRole: Role;
  updatedSearch: Search;
  updatedTenant: Tenant;
  updatedUniqueRegistration: UniqueRegistration;
  updatedUser: User;
  updatedUserTenantRole: UserTenantRole;
};


export type SubscriptionCreatedActionArgs = {
  filter?: InputMaybe<ActionFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ActionSortArgs>>;
};


export type SubscriptionCreatedContentArgs = {
  filter?: InputMaybe<ContentFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContentSortArgs>>;
};


export type SubscriptionCreatedContentFillArgs = {
  filter?: InputMaybe<ContentFillFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContentFillSortArgs>>;
};


export type SubscriptionCreatedErrorLogArgs = {
  filter?: InputMaybe<ErrorLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ErrorLogSortArgs>>;
};


export type SubscriptionCreatedEventLogArgs = {
  filter?: InputMaybe<EventLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<EventLogSortArgs>>;
};


export type SubscriptionCreatedJobArgs = {
  filter?: InputMaybe<JobFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<JobSortArgs>>;
};


export type SubscriptionCreatedMailLogArgs = {
  filter?: InputMaybe<MailLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailLogSortArgs>>;
};


export type SubscriptionCreatedMailTemplateArgs = {
  filter?: InputMaybe<MailTemplateFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateSortArgs>>;
};


export type SubscriptionCreatedMailTemplateFillArgs = {
  filter?: InputMaybe<MailTemplateFillFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateFillSortArgs>>;
};


export type SubscriptionCreatedMessageArgs = {
  filter?: InputMaybe<MessageFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MessageSortArgs>>;
};


export type SubscriptionCreatedOrganizationArgs = {
  filter?: InputMaybe<OrganizationFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<OrganizationSortArgs>>;
};


export type SubscriptionCreatedPermissionArgs = {
  filter?: InputMaybe<PermissionFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PermissionSortArgs>>;
};


export type SubscriptionCreatedPersonArgs = {
  filter?: InputMaybe<PersonFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PersonSortArgs>>;
};


export type SubscriptionCreatedPersonActionProgressArgs = {
  filter?: InputMaybe<PersonActionProgressFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PersonActionProgressSortArgs>>;
};


export type SubscriptionCreatedPersonRegisterProgressArgs = {
  filter?: InputMaybe<PersonRegisterProgressFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PersonRegisterProgressSortArgs>>;
};


export type SubscriptionCreatedPersonSearchProgressArgs = {
  filter?: InputMaybe<PersonSearchProgressFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PersonSearchProgressSortArgs>>;
};


export type SubscriptionCreatedRegisterArgs = {
  filter?: InputMaybe<RegisterFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<RegisterSortArgs>>;
};


export type SubscriptionCreatedReminderArgs = {
  filter?: InputMaybe<ReminderFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ReminderSortArgs>>;
};


export type SubscriptionCreatedResetPasswordArgs = {
  filter?: InputMaybe<ResetPasswordFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ResetPasswordSortArgs>>;
};


export type SubscriptionCreatedRoleArgs = {
  filter?: InputMaybe<RoleFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<RoleSortArgs>>;
};


export type SubscriptionCreatedSearchArgs = {
  filter?: InputMaybe<SearchFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<SearchSortArgs>>;
};


export type SubscriptionCreatedTenantArgs = {
  filter?: InputMaybe<TenantFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<TenantSortArgs>>;
};


export type SubscriptionCreatedUniqueRegistrationArgs = {
  filter?: InputMaybe<UniqueRegistrationFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UniqueRegistrationSortArgs>>;
};


export type SubscriptionCreatedUserArgs = {
  filter?: InputMaybe<UserFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserSortArgs>>;
};


export type SubscriptionCreatedUserTenantRoleArgs = {
  filter?: InputMaybe<UserTenantRoleFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserTenantRoleSortArgs>>;
};


export type SubscriptionDeletedActionArgs = {
  filter?: InputMaybe<ActionFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ActionSortArgs>>;
};


export type SubscriptionDeletedContentArgs = {
  filter?: InputMaybe<ContentFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContentSortArgs>>;
};


export type SubscriptionDeletedContentFillArgs = {
  filter?: InputMaybe<ContentFillFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContentFillSortArgs>>;
};


export type SubscriptionDeletedErrorLogArgs = {
  filter?: InputMaybe<ErrorLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ErrorLogSortArgs>>;
};


export type SubscriptionDeletedEventLogArgs = {
  filter?: InputMaybe<EventLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<EventLogSortArgs>>;
};


export type SubscriptionDeletedJobArgs = {
  filter?: InputMaybe<JobFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<JobSortArgs>>;
};


export type SubscriptionDeletedMailLogArgs = {
  filter?: InputMaybe<MailLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailLogSortArgs>>;
};


export type SubscriptionDeletedMailTemplateArgs = {
  filter?: InputMaybe<MailTemplateFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateSortArgs>>;
};


export type SubscriptionDeletedMailTemplateFillArgs = {
  filter?: InputMaybe<MailTemplateFillFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateFillSortArgs>>;
};


export type SubscriptionDeletedMessageArgs = {
  filter?: InputMaybe<MessageFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MessageSortArgs>>;
};


export type SubscriptionDeletedOrganizationArgs = {
  filter?: InputMaybe<OrganizationFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<OrganizationSortArgs>>;
};


export type SubscriptionDeletedPermissionArgs = {
  filter?: InputMaybe<PermissionFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PermissionSortArgs>>;
};


export type SubscriptionDeletedPersonArgs = {
  filter?: InputMaybe<PersonFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PersonSortArgs>>;
};


export type SubscriptionDeletedPersonActionProgressArgs = {
  filter?: InputMaybe<PersonActionProgressFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PersonActionProgressSortArgs>>;
};


export type SubscriptionDeletedPersonRegisterProgressArgs = {
  filter?: InputMaybe<PersonRegisterProgressFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PersonRegisterProgressSortArgs>>;
};


export type SubscriptionDeletedPersonSearchProgressArgs = {
  filter?: InputMaybe<PersonSearchProgressFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PersonSearchProgressSortArgs>>;
};


export type SubscriptionDeletedRegisterArgs = {
  filter?: InputMaybe<RegisterFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<RegisterSortArgs>>;
};


export type SubscriptionDeletedReminderArgs = {
  filter?: InputMaybe<ReminderFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ReminderSortArgs>>;
};


export type SubscriptionDeletedResetPasswordArgs = {
  filter?: InputMaybe<ResetPasswordFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ResetPasswordSortArgs>>;
};


export type SubscriptionDeletedRoleArgs = {
  filter?: InputMaybe<RoleFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<RoleSortArgs>>;
};


export type SubscriptionDeletedSearchArgs = {
  filter?: InputMaybe<SearchFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<SearchSortArgs>>;
};


export type SubscriptionDeletedTenantArgs = {
  filter?: InputMaybe<TenantFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<TenantSortArgs>>;
};


export type SubscriptionDeletedUniqueRegistrationArgs = {
  filter?: InputMaybe<UniqueRegistrationFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UniqueRegistrationSortArgs>>;
};


export type SubscriptionDeletedUserArgs = {
  filter?: InputMaybe<UserFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserSortArgs>>;
};


export type SubscriptionDeletedUserTenantRoleArgs = {
  filter?: InputMaybe<UserTenantRoleFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserTenantRoleSortArgs>>;
};


export type SubscriptionRestoredActionArgs = {
  filter?: InputMaybe<ActionFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ActionSortArgs>>;
};


export type SubscriptionRestoredErrorLogArgs = {
  filter?: InputMaybe<ErrorLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ErrorLogSortArgs>>;
};


export type SubscriptionRestoredEventLogArgs = {
  filter?: InputMaybe<EventLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<EventLogSortArgs>>;
};


export type SubscriptionRestoredJobArgs = {
  filter?: InputMaybe<JobFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<JobSortArgs>>;
};


export type SubscriptionRestoredMailLogArgs = {
  filter?: InputMaybe<MailLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailLogSortArgs>>;
};


export type SubscriptionRestoredMessageArgs = {
  filter?: InputMaybe<MessageFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MessageSortArgs>>;
};


export type SubscriptionRestoredRegisterArgs = {
  filter?: InputMaybe<RegisterFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<RegisterSortArgs>>;
};


export type SubscriptionRestoredSearchArgs = {
  filter?: InputMaybe<SearchFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<SearchSortArgs>>;
};


export type SubscriptionUpdatedActionArgs = {
  filter?: InputMaybe<ActionFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ActionSortArgs>>;
};


export type SubscriptionUpdatedContentArgs = {
  filter?: InputMaybe<ContentFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContentSortArgs>>;
};


export type SubscriptionUpdatedContentFillArgs = {
  filter?: InputMaybe<ContentFillFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContentFillSortArgs>>;
};


export type SubscriptionUpdatedErrorLogArgs = {
  filter?: InputMaybe<ErrorLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ErrorLogSortArgs>>;
};


export type SubscriptionUpdatedEventLogArgs = {
  filter?: InputMaybe<EventLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<EventLogSortArgs>>;
};


export type SubscriptionUpdatedJobArgs = {
  filter?: InputMaybe<JobFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<JobSortArgs>>;
};


export type SubscriptionUpdatedMailLogArgs = {
  filter?: InputMaybe<MailLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailLogSortArgs>>;
};


export type SubscriptionUpdatedMailTemplateArgs = {
  filter?: InputMaybe<MailTemplateFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateSortArgs>>;
};


export type SubscriptionUpdatedMailTemplateFillArgs = {
  filter?: InputMaybe<MailTemplateFillFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateFillSortArgs>>;
};


export type SubscriptionUpdatedMessageArgs = {
  filter?: InputMaybe<MessageFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MessageSortArgs>>;
};


export type SubscriptionUpdatedOrganizationArgs = {
  filter?: InputMaybe<OrganizationFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<OrganizationSortArgs>>;
};


export type SubscriptionUpdatedPermissionArgs = {
  filter?: InputMaybe<PermissionFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PermissionSortArgs>>;
};


export type SubscriptionUpdatedPersonArgs = {
  filter?: InputMaybe<PersonFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PersonSortArgs>>;
};


export type SubscriptionUpdatedPersonActionProgressArgs = {
  filter?: InputMaybe<PersonActionProgressFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PersonActionProgressSortArgs>>;
};


export type SubscriptionUpdatedPersonRegisterProgressArgs = {
  filter?: InputMaybe<PersonRegisterProgressFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PersonRegisterProgressSortArgs>>;
};


export type SubscriptionUpdatedPersonSearchProgressArgs = {
  filter?: InputMaybe<PersonSearchProgressFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PersonSearchProgressSortArgs>>;
};


export type SubscriptionUpdatedRegisterArgs = {
  filter?: InputMaybe<RegisterFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<RegisterSortArgs>>;
};


export type SubscriptionUpdatedReminderArgs = {
  filter?: InputMaybe<ReminderFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ReminderSortArgs>>;
};


export type SubscriptionUpdatedResetPasswordArgs = {
  filter?: InputMaybe<ResetPasswordFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ResetPasswordSortArgs>>;
};


export type SubscriptionUpdatedRoleArgs = {
  filter?: InputMaybe<RoleFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<RoleSortArgs>>;
};


export type SubscriptionUpdatedSearchArgs = {
  filter?: InputMaybe<SearchFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<SearchSortArgs>>;
};


export type SubscriptionUpdatedTenantArgs = {
  filter?: InputMaybe<TenantFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<TenantSortArgs>>;
};


export type SubscriptionUpdatedUniqueRegistrationArgs = {
  filter?: InputMaybe<UniqueRegistrationFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UniqueRegistrationSortArgs>>;
};


export type SubscriptionUpdatedUserArgs = {
  filter?: InputMaybe<UserFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserSortArgs>>;
};


export type SubscriptionUpdatedUserTenantRoleArgs = {
  filter?: InputMaybe<UserTenantRoleFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserTenantRoleSortArgs>>;
};

export type Tenant = {
  __typename?: 'Tenant';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  timeZone: Scalars['String']['output'];
  uniqueRegistrations: PaginatedUniqueRegistration;
  userTenantRoles: PaginatedUserTenantRole;
};

export type TenantFilterArgs = {
  id?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  timeZone?: InputMaybe<StringFieldComparison>;
  uniqueRegistrations?: InputMaybe<UniqueRegistrationFilterArgs>;
  userTenantRoles?: InputMaybe<UserTenantRoleFilterArgs>;
};

export type TenantSortArgs = {
  direction: SortDirection;
  field: TenantSortFields;
};

export enum TenantSortFields {
  Id = 'id',
  Name = 'name',
  TimeZone = 'timeZone'
}

export type UniqueRegistration = {
  __typename?: 'UniqueRegistration';
  active: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UniqueRegistrationFilterArgs = {
  active?: InputMaybe<BooleanFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  tenant?: InputMaybe<TenantFilterArgs>;
  tenantId?: InputMaybe<StringFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
};

export type UniqueRegistrationSortArgs = {
  direction: SortDirection;
  field: UniqueRegistrationSortFields;
};

export enum UniqueRegistrationSortFields {
  Active = 'active',
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type User = {
  __typename?: 'User';
  active: Scalars['Boolean']['output'];
  avatar?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  emailVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  encryptedSecret?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locale: Scalars['String']['output'];
  name: Scalars['String']['output'];
  passwordSalt?: Maybe<Scalars['String']['output']>;
  people: PaginatedPerson;
  progress?: Maybe<Scalars['Int']['output']>;
  reminders: PaginatedReminder;
  termsAndConditions?: Maybe<Scalars['Boolean']['output']>;
  timeZone: Scalars['String']['output'];
  totpVerified?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userTenantRoles: PaginatedUserTenantRole;
};

export type UserFilterArgs = {
  active?: InputMaybe<BooleanFieldComparison>;
  avatar?: InputMaybe<StringFieldComparison>;
  createdAt?: InputMaybe<DateFieldComparison>;
  email?: InputMaybe<StringFieldComparison>;
  emailVerifiedAt?: InputMaybe<DateFieldComparison>;
  encryptedSecret?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<StringFieldComparison>;
  locale?: InputMaybe<StringFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  passwordSalt?: InputMaybe<StringFieldComparison>;
  people?: InputMaybe<PersonFilterArgs>;
  progress?: InputMaybe<NumberFieldComparison>;
  reminders?: InputMaybe<ReminderFilterArgs>;
  termsAndConditions?: InputMaybe<BooleanFieldComparison>;
  timeZone?: InputMaybe<StringFieldComparison>;
  totpVerified?: InputMaybe<BooleanFieldComparison>;
  updatedAt?: InputMaybe<DateFieldComparison>;
  userTenantRoles?: InputMaybe<UserTenantRoleFilterArgs>;
};

export type UserSortArgs = {
  direction: SortDirection;
  field: UserSortFields;
};

export enum UserSortFields {
  Active = 'active',
  Avatar = 'avatar',
  CreatedAt = 'createdAt',
  Email = 'email',
  EmailVerifiedAt = 'emailVerifiedAt',
  EncryptedSecret = 'encryptedSecret',
  Id = 'id',
  Locale = 'locale',
  Name = 'name',
  PasswordSalt = 'passwordSalt',
  Progress = 'progress',
  TermsAndConditions = 'termsAndConditions',
  TimeZone = 'timeZone',
  TotpVerified = 'totpVerified',
  UpdatedAt = 'updatedAt'
}

export type UserTenantRole = {
  __typename?: 'UserTenantRole';
  id: Scalars['ID']['output'];
  role: Role;
  roleId: Scalars['ID']['output'];
  tenant: Tenant;
  tenantId: Scalars['ID']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export type UserTenantRoleFilterArgs = {
  id?: InputMaybe<StringFieldComparison>;
  role?: InputMaybe<RoleFilterArgs>;
  roleId?: InputMaybe<StringFieldComparison>;
  tenant?: InputMaybe<TenantFilterArgs>;
  tenantId?: InputMaybe<StringFieldComparison>;
  user?: InputMaybe<UserFilterArgs>;
  userId?: InputMaybe<StringFieldComparison>;
};

export type UserTenantRoleSortArgs = {
  direction: SortDirection;
  field: UserTenantRoleSortFields;
};

export enum UserTenantRoleSortFields {
  Id = 'id'
}

export type ActionFieldsFragment = { __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, register?: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, searches?: { __typename?: 'PaginatedSearch', totalCount: number, items?: Array<{ __typename?: 'Search', id: string, name: string, searchUrl?: string | null, order?: number | null, actionId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, message?: { __typename?: 'Message', id: string, title: string, content: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, personActionProgresses?: { __typename?: 'PaginatedPersonActionProgress', totalCount: number, items?: Array<{ __typename?: 'PersonActionProgress', id: string, progress: string, done?: boolean | null, personId: string, actionId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } };

export type GetActionsQueryVariables = Exact<{
  filter?: InputMaybe<ActionFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ActionSortArgs> | ActionSortArgs>;
  withRegister?: InputMaybe<Scalars['Boolean']['input']>;
  withSearches?: InputMaybe<Scalars['Boolean']['input']>;
  withMessage?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonActionProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetActionsQuery = { __typename?: 'Query', actions: { __typename?: 'PaginatedAction', totalCount: number, items?: Array<{ __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, register?: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, searches?: { __typename?: 'PaginatedSearch', totalCount: number, items?: Array<{ __typename?: 'Search', id: string, name: string, searchUrl?: string | null, order?: number | null, actionId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, message?: { __typename?: 'Message', id: string, title: string, content: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, personActionProgresses?: { __typename?: 'PaginatedPersonActionProgress', totalCount: number, items?: Array<{ __typename?: 'PersonActionProgress', id: string, progress: string, done?: boolean | null, personId: string, actionId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } }> | null } };

export type GetActionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withRegister?: InputMaybe<Scalars['Boolean']['input']>;
  withSearches?: InputMaybe<Scalars['Boolean']['input']>;
  withMessage?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonActionProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetActionQuery = { __typename?: 'Query', action?: { __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, register?: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, searches?: { __typename?: 'PaginatedSearch', totalCount: number, items?: Array<{ __typename?: 'Search', id: string, name: string, searchUrl?: string | null, order?: number | null, actionId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, message?: { __typename?: 'Message', id: string, title: string, content: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, personActionProgresses?: { __typename?: 'PaginatedPersonActionProgress', totalCount: number, items?: Array<{ __typename?: 'PersonActionProgress', id: string, progress: string, done?: boolean | null, personId: string, actionId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } | null };

export type GetAllRelatedDataForActionQueryVariables = Exact<{
  withRegisters?: InputMaybe<Scalars['Boolean']['input']>;
  withSearches?: InputMaybe<Scalars['Boolean']['input']>;
  withMessages?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonActionProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForActionQuery = { __typename?: 'Query', registers?: { __typename?: 'PaginatedRegister', items?: Array<{ __typename?: 'Register', id: string, displayField: string }> | null }, searches?: { __typename?: 'PaginatedSearch', items?: Array<{ __typename?: 'Search', id: string, displayField: string }> | null }, messages?: { __typename?: 'PaginatedMessage', items?: Array<{ __typename?: 'Message', id: string, displayField: string }> | null }, personActionProgresses?: { __typename?: 'PaginatedPersonActionProgress', items?: Array<{ __typename?: 'PersonActionProgress', id: string, displayField: string }> | null } };

export type CreateActionMutationVariables = Exact<{
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
  description: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  registerId?: InputMaybe<Scalars['ID']['input']>;
  searches?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  messageId?: InputMaybe<Scalars['ID']['input']>;
  personActionProgresses?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withRegister?: InputMaybe<Scalars['Boolean']['input']>;
  withSearches?: InputMaybe<Scalars['Boolean']['input']>;
  withMessage?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonActionProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateActionMutation = { __typename?: 'Mutation', createAction: { __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, register?: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, searches?: { __typename?: 'PaginatedSearch', totalCount: number, items?: Array<{ __typename?: 'Search', id: string, name: string, searchUrl?: string | null, order?: number | null, actionId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, message?: { __typename?: 'Message', id: string, title: string, content: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, personActionProgresses?: { __typename?: 'PaginatedPersonActionProgress', totalCount: number, items?: Array<{ __typename?: 'PersonActionProgress', id: string, progress: string, done?: boolean | null, personId: string, actionId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type UpdateActionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  registerId?: InputMaybe<Scalars['ID']['input']>;
  searches?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  messageId?: InputMaybe<Scalars['ID']['input']>;
  personActionProgresses?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withRegister?: InputMaybe<Scalars['Boolean']['input']>;
  withSearches?: InputMaybe<Scalars['Boolean']['input']>;
  withMessage?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonActionProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateActionMutation = { __typename?: 'Mutation', updateAction: { __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, register?: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, searches?: { __typename?: 'PaginatedSearch', totalCount: number, items?: Array<{ __typename?: 'Search', id: string, name: string, searchUrl?: string | null, order?: number | null, actionId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, message?: { __typename?: 'Message', id: string, title: string, content: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, personActionProgresses?: { __typename?: 'PaginatedPersonActionProgress', totalCount: number, items?: Array<{ __typename?: 'PersonActionProgress', id: string, progress: string, done?: boolean | null, personId: string, actionId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type DeleteActionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withRegister?: InputMaybe<Scalars['Boolean']['input']>;
  withSearches?: InputMaybe<Scalars['Boolean']['input']>;
  withMessage?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonActionProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteActionMutation = { __typename?: 'Mutation', deleteAction: { __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, register?: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, searches?: { __typename?: 'PaginatedSearch', totalCount: number, items?: Array<{ __typename?: 'Search', id: string, name: string, searchUrl?: string | null, order?: number | null, actionId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, message?: { __typename?: 'Message', id: string, title: string, content: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, personActionProgresses?: { __typename?: 'PaginatedPersonActionProgress', totalCount: number, items?: Array<{ __typename?: 'PersonActionProgress', id: string, progress: string, done?: boolean | null, personId: string, actionId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type CreatedActionSubscriptionVariables = Exact<{
  filter?: InputMaybe<ActionFilterArgs>;
  withRegister?: InputMaybe<Scalars['Boolean']['input']>;
  withSearches?: InputMaybe<Scalars['Boolean']['input']>;
  withMessage?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonActionProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedActionSubscription = { __typename?: 'Subscription', createdAction: { __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, register?: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, searches?: { __typename?: 'PaginatedSearch', totalCount: number, items?: Array<{ __typename?: 'Search', id: string, name: string, searchUrl?: string | null, order?: number | null, actionId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, message?: { __typename?: 'Message', id: string, title: string, content: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, personActionProgresses?: { __typename?: 'PaginatedPersonActionProgress', totalCount: number, items?: Array<{ __typename?: 'PersonActionProgress', id: string, progress: string, done?: boolean | null, personId: string, actionId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type UpdatedActionSubscriptionVariables = Exact<{
  filter?: InputMaybe<ActionFilterArgs>;
  withRegister?: InputMaybe<Scalars['Boolean']['input']>;
  withSearches?: InputMaybe<Scalars['Boolean']['input']>;
  withMessage?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonActionProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedActionSubscription = { __typename?: 'Subscription', updatedAction: { __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, register?: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, searches?: { __typename?: 'PaginatedSearch', totalCount: number, items?: Array<{ __typename?: 'Search', id: string, name: string, searchUrl?: string | null, order?: number | null, actionId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, message?: { __typename?: 'Message', id: string, title: string, content: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, personActionProgresses?: { __typename?: 'PaginatedPersonActionProgress', totalCount: number, items?: Array<{ __typename?: 'PersonActionProgress', id: string, progress: string, done?: boolean | null, personId: string, actionId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type DeletedActionSubscriptionVariables = Exact<{
  filter?: InputMaybe<ActionFilterArgs>;
}>;


export type DeletedActionSubscription = { __typename?: 'Subscription', deletedAction: { __typename?: 'Action', id: string } };

export type RestoredActionSubscriptionVariables = Exact<{
  filter?: InputMaybe<ActionFilterArgs>;
  withRegister?: InputMaybe<Scalars['Boolean']['input']>;
  withSearches?: InputMaybe<Scalars['Boolean']['input']>;
  withMessage?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonActionProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RestoredActionSubscription = { __typename?: 'Subscription', restoredAction: { __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, register?: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, searches?: { __typename?: 'PaginatedSearch', totalCount: number, items?: Array<{ __typename?: 'Search', id: string, name: string, searchUrl?: string | null, order?: number | null, actionId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, message?: { __typename?: 'Message', id: string, title: string, content: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, personActionProgresses?: { __typename?: 'PaginatedPersonActionProgress', totalCount: number, items?: Array<{ __typename?: 'PersonActionProgress', id: string, progress: string, done?: boolean | null, personId: string, actionId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type ContentFieldsFragment = { __typename?: 'Content', id: string, name: string, contentFills?: { __typename?: 'PaginatedContentFill', totalCount: number, items?: Array<{ __typename?: 'ContentFill', id: string, fill: string, language: string, contentId: string, displayField: string }> | null } };

export type GetContentsQueryVariables = Exact<{
  filter?: InputMaybe<ContentFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContentSortArgs> | ContentSortArgs>;
  withContentFills?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetContentsQuery = { __typename?: 'Query', contents: { __typename?: 'PaginatedContent', totalCount: number, items?: Array<{ __typename?: 'Content', id: string, name: string, contentFills?: { __typename?: 'PaginatedContentFill', totalCount: number, items?: Array<{ __typename?: 'ContentFill', id: string, fill: string, language: string, contentId: string, displayField: string }> | null } }> | null } };

export type GetContentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withContentFills?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetContentQuery = { __typename?: 'Query', content?: { __typename?: 'Content', id: string, name: string, contentFills?: { __typename?: 'PaginatedContentFill', totalCount: number, items?: Array<{ __typename?: 'ContentFill', id: string, fill: string, language: string, contentId: string, displayField: string }> | null } } | null };

export type GetAllRelatedDataForContentQueryVariables = Exact<{
  withContentFills?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForContentQuery = { __typename?: 'Query', contentFills?: { __typename?: 'PaginatedContentFill', items?: Array<{ __typename?: 'ContentFill', id: string, displayField: string }> | null } };

export type CreateContentMutationVariables = Exact<{
  name: Scalars['String']['input'];
  contentFills?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withContentFills?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateContentMutation = { __typename?: 'Mutation', createContent: { __typename?: 'Content', id: string, name: string, contentFills?: { __typename?: 'PaginatedContentFill', totalCount: number, items?: Array<{ __typename?: 'ContentFill', id: string, fill: string, language: string, contentId: string, displayField: string }> | null } } };

export type UpdateContentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  contentFills?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withContentFills?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateContentMutation = { __typename?: 'Mutation', updateContent: { __typename?: 'Content', id: string, name: string, contentFills?: { __typename?: 'PaginatedContentFill', totalCount: number, items?: Array<{ __typename?: 'ContentFill', id: string, fill: string, language: string, contentId: string, displayField: string }> | null } } };

export type DeleteContentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withContentFills?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteContentMutation = { __typename?: 'Mutation', deleteContent: { __typename?: 'Content', id: string, name: string, contentFills?: { __typename?: 'PaginatedContentFill', totalCount: number, items?: Array<{ __typename?: 'ContentFill', id: string, fill: string, language: string, contentId: string, displayField: string }> | null } } };

export type CreatedContentSubscriptionVariables = Exact<{
  filter?: InputMaybe<ContentFilterArgs>;
  withContentFills?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedContentSubscription = { __typename?: 'Subscription', createdContent: { __typename?: 'Content', id: string, name: string, contentFills?: { __typename?: 'PaginatedContentFill', totalCount: number, items?: Array<{ __typename?: 'ContentFill', id: string, fill: string, language: string, contentId: string, displayField: string }> | null } } };

export type UpdatedContentSubscriptionVariables = Exact<{
  filter?: InputMaybe<ContentFilterArgs>;
  withContentFills?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedContentSubscription = { __typename?: 'Subscription', updatedContent: { __typename?: 'Content', id: string, name: string, contentFills?: { __typename?: 'PaginatedContentFill', totalCount: number, items?: Array<{ __typename?: 'ContentFill', id: string, fill: string, language: string, contentId: string, displayField: string }> | null } } };

export type DeletedContentSubscriptionVariables = Exact<{
  filter?: InputMaybe<ContentFilterArgs>;
}>;


export type DeletedContentSubscription = { __typename?: 'Subscription', deletedContent: { __typename?: 'Content', id: string } };

export type ContentFillFieldsFragment = { __typename?: 'ContentFill', id: string, fill: string, language: string, content?: { __typename?: 'Content', id: string, name: string, displayField: string } };

export type GetContentFillsQueryVariables = Exact<{
  filter?: InputMaybe<ContentFillFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ContentFillSortArgs> | ContentFillSortArgs>;
  withContent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetContentFillsQuery = { __typename?: 'Query', contentFills: { __typename?: 'PaginatedContentFill', totalCount: number, items?: Array<{ __typename?: 'ContentFill', id: string, fill: string, language: string, content?: { __typename?: 'Content', id: string, name: string, displayField: string } }> | null } };

export type GetContentFillQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withContent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetContentFillQuery = { __typename?: 'Query', contentFill?: { __typename?: 'ContentFill', id: string, fill: string, language: string, content?: { __typename?: 'Content', id: string, name: string, displayField: string } } | null };

export type GetAllRelatedDataForContentFillQueryVariables = Exact<{
  withContents?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForContentFillQuery = { __typename?: 'Query', contents?: { __typename?: 'PaginatedContent', items?: Array<{ __typename?: 'Content', id: string, displayField: string }> | null } };

export type CreateContentFillMutationVariables = Exact<{
  fill: Scalars['String']['input'];
  language: Scalars['String']['input'];
  contentId: Scalars['ID']['input'];
  withContent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateContentFillMutation = { __typename?: 'Mutation', createContentFill: { __typename?: 'ContentFill', id: string, fill: string, language: string, content?: { __typename?: 'Content', id: string, name: string, displayField: string } } };

export type UpdateContentFillMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fill?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  contentId?: InputMaybe<Scalars['ID']['input']>;
  withContent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateContentFillMutation = { __typename?: 'Mutation', updateContentFill: { __typename?: 'ContentFill', id: string, fill: string, language: string, content?: { __typename?: 'Content', id: string, name: string, displayField: string } } };

export type DeleteContentFillMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withContent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteContentFillMutation = { __typename?: 'Mutation', deleteContentFill: { __typename?: 'ContentFill', id: string, fill: string, language: string, content?: { __typename?: 'Content', id: string, name: string, displayField: string } } };

export type CreatedContentFillSubscriptionVariables = Exact<{
  filter?: InputMaybe<ContentFillFilterArgs>;
  withContent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedContentFillSubscription = { __typename?: 'Subscription', createdContentFill: { __typename?: 'ContentFill', id: string, fill: string, language: string, content?: { __typename?: 'Content', id: string, name: string, displayField: string } } };

export type UpdatedContentFillSubscriptionVariables = Exact<{
  filter?: InputMaybe<ContentFillFilterArgs>;
  withContent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedContentFillSubscription = { __typename?: 'Subscription', updatedContentFill: { __typename?: 'ContentFill', id: string, fill: string, language: string, content?: { __typename?: 'Content', id: string, name: string, displayField: string } } };

export type DeletedContentFillSubscriptionVariables = Exact<{
  filter?: InputMaybe<ContentFillFilterArgs>;
}>;


export type DeletedContentFillSubscription = { __typename?: 'Subscription', deletedContentFill: { __typename?: 'ContentFill', id: string } };

export type ErrorLogFieldsFragment = { __typename?: 'ErrorLog', id: string, error: string, stack?: string | null, domain: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null };

export type GetErrorLogsQueryVariables = Exact<{
  filter?: InputMaybe<ErrorLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ErrorLogSortArgs> | ErrorLogSortArgs>;
}>;


export type GetErrorLogsQuery = { __typename?: 'Query', errorLogs: { __typename?: 'PaginatedErrorLog', totalCount: number, items?: Array<{ __typename?: 'ErrorLog', id: string, error: string, stack?: string | null, domain: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null }> | null } };

export type GetErrorLogQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetErrorLogQuery = { __typename?: 'Query', errorLog?: { __typename?: 'ErrorLog', id: string, error: string, stack?: string | null, domain: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } | null };

export type CreateErrorLogMutationVariables = Exact<{
  error: Scalars['String']['input'];
  stack?: InputMaybe<Scalars['String']['input']>;
  domain: Scalars['String']['input'];
}>;


export type CreateErrorLogMutation = { __typename?: 'Mutation', createErrorLog: { __typename?: 'ErrorLog', id: string, error: string, stack?: string | null, domain: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type UpdateErrorLogMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  error?: InputMaybe<Scalars['String']['input']>;
  stack?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateErrorLogMutation = { __typename?: 'Mutation', updateErrorLog: { __typename?: 'ErrorLog', id: string, error: string, stack?: string | null, domain: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type DeleteErrorLogMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteErrorLogMutation = { __typename?: 'Mutation', deleteErrorLog: { __typename?: 'ErrorLog', id: string, error: string, stack?: string | null, domain: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type CreatedErrorLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<ErrorLogFilterArgs>;
}>;


export type CreatedErrorLogSubscription = { __typename?: 'Subscription', createdErrorLog: { __typename?: 'ErrorLog', id: string, error: string, stack?: string | null, domain: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type UpdatedErrorLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<ErrorLogFilterArgs>;
}>;


export type UpdatedErrorLogSubscription = { __typename?: 'Subscription', updatedErrorLog: { __typename?: 'ErrorLog', id: string, error: string, stack?: string | null, domain: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type DeletedErrorLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<ErrorLogFilterArgs>;
}>;


export type DeletedErrorLogSubscription = { __typename?: 'Subscription', deletedErrorLog: { __typename?: 'ErrorLog', id: string } };

export type RestoredErrorLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<ErrorLogFilterArgs>;
}>;


export type RestoredErrorLogSubscription = { __typename?: 'Subscription', restoredErrorLog: { __typename?: 'ErrorLog', id: string, error: string, stack?: string | null, domain: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type EventLogFieldsFragment = { __typename?: 'EventLog', id: string, log: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null };

export type GetEventLogsQueryVariables = Exact<{
  filter?: InputMaybe<EventLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<EventLogSortArgs> | EventLogSortArgs>;
}>;


export type GetEventLogsQuery = { __typename?: 'Query', eventLogs: { __typename?: 'PaginatedEventLog', totalCount: number, items?: Array<{ __typename?: 'EventLog', id: string, log: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null }> | null } };

export type GetEventLogQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetEventLogQuery = { __typename?: 'Query', eventLog?: { __typename?: 'EventLog', id: string, log: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } | null };

export type CreateEventLogMutationVariables = Exact<{
  log: Scalars['String']['input'];
  type: Scalars['String']['input'];
}>;


export type CreateEventLogMutation = { __typename?: 'Mutation', createEventLog: { __typename?: 'EventLog', id: string, log: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type UpdateEventLogMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  log?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateEventLogMutation = { __typename?: 'Mutation', updateEventLog: { __typename?: 'EventLog', id: string, log: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type DeleteEventLogMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteEventLogMutation = { __typename?: 'Mutation', deleteEventLog: { __typename?: 'EventLog', id: string, log: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type CreatedEventLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<EventLogFilterArgs>;
}>;


export type CreatedEventLogSubscription = { __typename?: 'Subscription', createdEventLog: { __typename?: 'EventLog', id: string, log: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type UpdatedEventLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<EventLogFilterArgs>;
}>;


export type UpdatedEventLogSubscription = { __typename?: 'Subscription', updatedEventLog: { __typename?: 'EventLog', id: string, log: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type DeletedEventLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<EventLogFilterArgs>;
}>;


export type DeletedEventLogSubscription = { __typename?: 'Subscription', deletedEventLog: { __typename?: 'EventLog', id: string } };

export type RestoredEventLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<EventLogFilterArgs>;
}>;


export type RestoredEventLogSubscription = { __typename?: 'Subscription', restoredEventLog: { __typename?: 'EventLog', id: string, log: string, type: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type JobFieldsFragment = { __typename?: 'Job', id: string, queue: string, status: string, log?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null };

export type GetJobsQueryVariables = Exact<{
  filter?: InputMaybe<JobFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<JobSortArgs> | JobSortArgs>;
}>;


export type GetJobsQuery = { __typename?: 'Query', jobs: { __typename?: 'PaginatedJob', totalCount: number, items?: Array<{ __typename?: 'Job', id: string, queue: string, status: string, log?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null }> | null } };

export type GetJobQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetJobQuery = { __typename?: 'Query', job?: { __typename?: 'Job', id: string, queue: string, status: string, log?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } | null };

export type CreateJobMutationVariables = Exact<{
  queue: Scalars['String']['input'];
  status: Scalars['String']['input'];
  log?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateJobMutation = { __typename?: 'Mutation', createJob: { __typename?: 'Job', id: string, queue: string, status: string, log?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type UpdateJobMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  queue?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  log?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateJobMutation = { __typename?: 'Mutation', updateJob: { __typename?: 'Job', id: string, queue: string, status: string, log?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type DeleteJobMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteJobMutation = { __typename?: 'Mutation', deleteJob: { __typename?: 'Job', id: string, queue: string, status: string, log?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type CreatedJobSubscriptionVariables = Exact<{
  filter?: InputMaybe<JobFilterArgs>;
}>;


export type CreatedJobSubscription = { __typename?: 'Subscription', createdJob: { __typename?: 'Job', id: string, queue: string, status: string, log?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type UpdatedJobSubscriptionVariables = Exact<{
  filter?: InputMaybe<JobFilterArgs>;
}>;


export type UpdatedJobSubscription = { __typename?: 'Subscription', updatedJob: { __typename?: 'Job', id: string, queue: string, status: string, log?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type DeletedJobSubscriptionVariables = Exact<{
  filter?: InputMaybe<JobFilterArgs>;
}>;


export type DeletedJobSubscription = { __typename?: 'Subscription', deletedJob: { __typename?: 'Job', id: string } };

export type RestoredJobSubscriptionVariables = Exact<{
  filter?: InputMaybe<JobFilterArgs>;
}>;


export type RestoredJobSubscription = { __typename?: 'Subscription', restoredJob: { __typename?: 'Job', id: string, queue: string, status: string, log?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type MailLogFieldsFragment = { __typename?: 'MailLog', id: string, sentTo: string, sentBy: string, emailTemplate?: string | null, status?: string | null, message?: string | null, reason?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null };

export type GetMailLogsQueryVariables = Exact<{
  filter?: InputMaybe<MailLogFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailLogSortArgs> | MailLogSortArgs>;
}>;


export type GetMailLogsQuery = { __typename?: 'Query', mailLogs: { __typename?: 'PaginatedMailLog', totalCount: number, items?: Array<{ __typename?: 'MailLog', id: string, sentTo: string, sentBy: string, emailTemplate?: string | null, status?: string | null, message?: string | null, reason?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null }> | null } };

export type GetMailLogQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMailLogQuery = { __typename?: 'Query', mailLog?: { __typename?: 'MailLog', id: string, sentTo: string, sentBy: string, emailTemplate?: string | null, status?: string | null, message?: string | null, reason?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } | null };

export type CreateMailLogMutationVariables = Exact<{
  sentTo: Scalars['String']['input'];
  sentBy: Scalars['String']['input'];
  emailTemplate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateMailLogMutation = { __typename?: 'Mutation', createMailLog: { __typename?: 'MailLog', id: string, sentTo: string, sentBy: string, emailTemplate?: string | null, status?: string | null, message?: string | null, reason?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type UpdateMailLogMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  sentTo?: InputMaybe<Scalars['String']['input']>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
  emailTemplate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateMailLogMutation = { __typename?: 'Mutation', updateMailLog: { __typename?: 'MailLog', id: string, sentTo: string, sentBy: string, emailTemplate?: string | null, status?: string | null, message?: string | null, reason?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type DeleteMailLogMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMailLogMutation = { __typename?: 'Mutation', deleteMailLog: { __typename?: 'MailLog', id: string, sentTo: string, sentBy: string, emailTemplate?: string | null, status?: string | null, message?: string | null, reason?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type CreatedMailLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailLogFilterArgs>;
}>;


export type CreatedMailLogSubscription = { __typename?: 'Subscription', createdMailLog: { __typename?: 'MailLog', id: string, sentTo: string, sentBy: string, emailTemplate?: string | null, status?: string | null, message?: string | null, reason?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type UpdatedMailLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailLogFilterArgs>;
}>;


export type UpdatedMailLogSubscription = { __typename?: 'Subscription', updatedMailLog: { __typename?: 'MailLog', id: string, sentTo: string, sentBy: string, emailTemplate?: string | null, status?: string | null, message?: string | null, reason?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type DeletedMailLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailLogFilterArgs>;
}>;


export type DeletedMailLogSubscription = { __typename?: 'Subscription', deletedMailLog: { __typename?: 'MailLog', id: string } };

export type RestoredMailLogSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailLogFilterArgs>;
}>;


export type RestoredMailLogSubscription = { __typename?: 'Subscription', restoredMailLog: { __typename?: 'MailLog', id: string, sentTo: string, sentBy: string, emailTemplate?: string | null, status?: string | null, message?: string | null, reason?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null } };

export type MailTemplateFieldsFragment = { __typename?: 'MailTemplate', id: string, active: boolean, mailTemplateFills?: { __typename?: 'PaginatedMailTemplateFill', totalCount: number, items?: Array<{ __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplateId: string, displayField?: string | null }> | null }, reminder?: { __typename?: 'Reminder', id: string, userId: string, mailTemplateId: string, date: any, createdAt?: any | null, updatedAt?: any | null, displayField: string } | null };

export type GetMailTemplatesQueryVariables = Exact<{
  filter?: InputMaybe<MailTemplateFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateSortArgs> | MailTemplateSortArgs>;
  withMailTemplateFills?: InputMaybe<Scalars['Boolean']['input']>;
  withReminder?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMailTemplatesQuery = { __typename?: 'Query', mailTemplates: { __typename?: 'PaginatedMailTemplate', totalCount: number, items?: Array<{ __typename?: 'MailTemplate', id: string, active: boolean, mailTemplateFills?: { __typename?: 'PaginatedMailTemplateFill', totalCount: number, items?: Array<{ __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplateId: string, displayField?: string | null }> | null }, reminder?: { __typename?: 'Reminder', id: string, userId: string, mailTemplateId: string, date: any, createdAt?: any | null, updatedAt?: any | null, displayField: string } | null }> | null } };

export type GetMailTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withMailTemplateFills?: InputMaybe<Scalars['Boolean']['input']>;
  withReminder?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMailTemplateQuery = { __typename?: 'Query', mailTemplate?: { __typename?: 'MailTemplate', id: string, active: boolean, mailTemplateFills?: { __typename?: 'PaginatedMailTemplateFill', totalCount: number, items?: Array<{ __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplateId: string, displayField?: string | null }> | null }, reminder?: { __typename?: 'Reminder', id: string, userId: string, mailTemplateId: string, date: any, createdAt?: any | null, updatedAt?: any | null, displayField: string } | null } | null };

export type GetAllRelatedDataForMailTemplateQueryVariables = Exact<{
  withMailTemplateFills?: InputMaybe<Scalars['Boolean']['input']>;
  withReminders?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForMailTemplateQuery = { __typename?: 'Query', mailTemplateFills?: { __typename?: 'PaginatedMailTemplateFill', items?: Array<{ __typename?: 'MailTemplateFill', id: string, displayField?: string | null }> | null }, reminders?: { __typename?: 'PaginatedReminder', items?: Array<{ __typename?: 'Reminder', id: string, displayField: string }> | null } };

export type CreateMailTemplateMutationVariables = Exact<{
  active: Scalars['Boolean']['input'];
  mailTemplateFills?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withMailTemplateFills?: InputMaybe<Scalars['Boolean']['input']>;
  withReminder?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateMailTemplateMutation = { __typename?: 'Mutation', createMailTemplate: { __typename?: 'MailTemplate', id: string, active: boolean, mailTemplateFills?: { __typename?: 'PaginatedMailTemplateFill', totalCount: number, items?: Array<{ __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplateId: string, displayField?: string | null }> | null }, reminder?: { __typename?: 'Reminder', id: string, userId: string, mailTemplateId: string, date: any, createdAt?: any | null, updatedAt?: any | null, displayField: string } | null } };

export type UpdateMailTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  mailTemplateFills?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withMailTemplateFills?: InputMaybe<Scalars['Boolean']['input']>;
  withReminder?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateMailTemplateMutation = { __typename?: 'Mutation', updateMailTemplate: { __typename?: 'MailTemplate', id: string, active: boolean, mailTemplateFills?: { __typename?: 'PaginatedMailTemplateFill', totalCount: number, items?: Array<{ __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplateId: string, displayField?: string | null }> | null }, reminder?: { __typename?: 'Reminder', id: string, userId: string, mailTemplateId: string, date: any, createdAt?: any | null, updatedAt?: any | null, displayField: string } | null } };

export type DeleteMailTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withMailTemplateFills?: InputMaybe<Scalars['Boolean']['input']>;
  withReminder?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteMailTemplateMutation = { __typename?: 'Mutation', deleteMailTemplate: { __typename?: 'MailTemplate', id: string, active: boolean, mailTemplateFills?: { __typename?: 'PaginatedMailTemplateFill', totalCount: number, items?: Array<{ __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplateId: string, displayField?: string | null }> | null }, reminder?: { __typename?: 'Reminder', id: string, userId: string, mailTemplateId: string, date: any, createdAt?: any | null, updatedAt?: any | null, displayField: string } | null } };

export type CreatedMailTemplateSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailTemplateFilterArgs>;
  withMailTemplateFills?: InputMaybe<Scalars['Boolean']['input']>;
  withReminder?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedMailTemplateSubscription = { __typename?: 'Subscription', createdMailTemplate: { __typename?: 'MailTemplate', id: string, active: boolean, mailTemplateFills?: { __typename?: 'PaginatedMailTemplateFill', totalCount: number, items?: Array<{ __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplateId: string, displayField?: string | null }> | null }, reminder?: { __typename?: 'Reminder', id: string, userId: string, mailTemplateId: string, date: any, createdAt?: any | null, updatedAt?: any | null, displayField: string } | null } };

export type UpdatedMailTemplateSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailTemplateFilterArgs>;
  withMailTemplateFills?: InputMaybe<Scalars['Boolean']['input']>;
  withReminder?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedMailTemplateSubscription = { __typename?: 'Subscription', updatedMailTemplate: { __typename?: 'MailTemplate', id: string, active: boolean, mailTemplateFills?: { __typename?: 'PaginatedMailTemplateFill', totalCount: number, items?: Array<{ __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplateId: string, displayField?: string | null }> | null }, reminder?: { __typename?: 'Reminder', id: string, userId: string, mailTemplateId: string, date: any, createdAt?: any | null, updatedAt?: any | null, displayField: string } | null } };

export type DeletedMailTemplateSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailTemplateFilterArgs>;
}>;


export type DeletedMailTemplateSubscription = { __typename?: 'Subscription', deletedMailTemplate: { __typename?: 'MailTemplate', id: string } };

export type MailTemplateFillFieldsFragment = { __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplate?: { __typename?: 'MailTemplate', id: string, active: boolean, displayField: string } };

export type GetMailTemplateFillsQueryVariables = Exact<{
  filter?: InputMaybe<MailTemplateFillFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MailTemplateFillSortArgs> | MailTemplateFillSortArgs>;
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMailTemplateFillsQuery = { __typename?: 'Query', mailTemplateFills: { __typename?: 'PaginatedMailTemplateFill', totalCount: number, items?: Array<{ __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplate?: { __typename?: 'MailTemplate', id: string, active: boolean, displayField: string } }> | null } };

export type GetMailTemplateFillQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMailTemplateFillQuery = { __typename?: 'Query', mailTemplateFill?: { __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplate?: { __typename?: 'MailTemplate', id: string, active: boolean, displayField: string } } | null };

export type GetAllRelatedDataForMailTemplateFillQueryVariables = Exact<{
  withMailTemplates?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForMailTemplateFillQuery = { __typename?: 'Query', mailTemplates?: { __typename?: 'PaginatedMailTemplate', items?: Array<{ __typename?: 'MailTemplate', id: string, displayField: string }> | null } };

export type CreateMailTemplateFillMutationVariables = Exact<{
  subject: Scalars['String']['input'];
  urlText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  preHeader?: InputMaybe<Scalars['String']['input']>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
  plainText: Scalars['String']['input'];
  language: Scalars['String']['input'];
  mailTemplateId: Scalars['ID']['input'];
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateMailTemplateFillMutation = { __typename?: 'Mutation', createMailTemplateFill: { __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplate?: { __typename?: 'MailTemplate', id: string, active: boolean, displayField: string } } };

export type UpdateMailTemplateFillMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  urlText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  preHeader?: InputMaybe<Scalars['String']['input']>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  plainText?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  mailTemplateId?: InputMaybe<Scalars['ID']['input']>;
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateMailTemplateFillMutation = { __typename?: 'Mutation', updateMailTemplateFill: { __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplate?: { __typename?: 'MailTemplate', id: string, active: boolean, displayField: string } } };

export type DeleteMailTemplateFillMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteMailTemplateFillMutation = { __typename?: 'Mutation', deleteMailTemplateFill: { __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplate?: { __typename?: 'MailTemplate', id: string, active: boolean, displayField: string } } };

export type CreatedMailTemplateFillSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailTemplateFillFilterArgs>;
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedMailTemplateFillSubscription = { __typename?: 'Subscription', createdMailTemplateFill: { __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplate?: { __typename?: 'MailTemplate', id: string, active: boolean, displayField: string } } };

export type UpdatedMailTemplateFillSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailTemplateFillFilterArgs>;
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedMailTemplateFillSubscription = { __typename?: 'Subscription', updatedMailTemplateFill: { __typename?: 'MailTemplateFill', id: string, subject: string, urlText?: string | null, title?: string | null, heading?: string | null, preHeader?: string | null, disclaimer?: string | null, text: string, plainText: string, language: string, mailTemplate?: { __typename?: 'MailTemplate', id: string, active: boolean, displayField: string } } };

export type DeletedMailTemplateFillSubscriptionVariables = Exact<{
  filter?: InputMaybe<MailTemplateFillFilterArgs>;
}>;


export type DeletedMailTemplateFillSubscription = { __typename?: 'Subscription', deletedMailTemplateFill: { __typename?: 'MailTemplateFill', id: string } };

export type MessageFieldsFragment = { __typename?: 'Message', id: string, title: string, content: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, actions?: { __typename?: 'PaginatedAction', totalCount: number, items?: Array<{ __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } };

export type GetMessagesQueryVariables = Exact<{
  filter?: InputMaybe<MessageFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<MessageSortArgs> | MessageSortArgs>;
  withActions?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMessagesQuery = { __typename?: 'Query', messages: { __typename?: 'PaginatedMessage', totalCount: number, items?: Array<{ __typename?: 'Message', id: string, title: string, content: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, actions?: { __typename?: 'PaginatedAction', totalCount: number, items?: Array<{ __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } }> | null } };

export type GetMessageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withActions?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMessageQuery = { __typename?: 'Query', message?: { __typename?: 'Message', id: string, title: string, content: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, actions?: { __typename?: 'PaginatedAction', totalCount: number, items?: Array<{ __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } | null };

export type GetAllRelatedDataForMessageQueryVariables = Exact<{
  withActions?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForMessageQuery = { __typename?: 'Query', actions?: { __typename?: 'PaginatedAction', items?: Array<{ __typename?: 'Action', id: string, displayField: string }> | null } };

export type CreateMessageMutationVariables = Exact<{
  title: Scalars['String']['input'];
  content: Scalars['String']['input'];
  actions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withActions?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateMessageMutation = { __typename?: 'Mutation', createMessage: { __typename?: 'Message', id: string, title: string, content: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, actions?: { __typename?: 'PaginatedAction', totalCount: number, items?: Array<{ __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type UpdateMessageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  actions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withActions?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateMessageMutation = { __typename?: 'Mutation', updateMessage: { __typename?: 'Message', id: string, title: string, content: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, actions?: { __typename?: 'PaginatedAction', totalCount: number, items?: Array<{ __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type DeleteMessageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withActions?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteMessageMutation = { __typename?: 'Mutation', deleteMessage: { __typename?: 'Message', id: string, title: string, content: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, actions?: { __typename?: 'PaginatedAction', totalCount: number, items?: Array<{ __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type CreatedMessageSubscriptionVariables = Exact<{
  filter?: InputMaybe<MessageFilterArgs>;
  withActions?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedMessageSubscription = { __typename?: 'Subscription', createdMessage: { __typename?: 'Message', id: string, title: string, content: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, actions?: { __typename?: 'PaginatedAction', totalCount: number, items?: Array<{ __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type UpdatedMessageSubscriptionVariables = Exact<{
  filter?: InputMaybe<MessageFilterArgs>;
  withActions?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedMessageSubscription = { __typename?: 'Subscription', updatedMessage: { __typename?: 'Message', id: string, title: string, content: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, actions?: { __typename?: 'PaginatedAction', totalCount: number, items?: Array<{ __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type DeletedMessageSubscriptionVariables = Exact<{
  filter?: InputMaybe<MessageFilterArgs>;
}>;


export type DeletedMessageSubscription = { __typename?: 'Subscription', deletedMessage: { __typename?: 'Message', id: string } };

export type RestoredMessageSubscriptionVariables = Exact<{
  filter?: InputMaybe<MessageFilterArgs>;
  withActions?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RestoredMessageSubscription = { __typename?: 'Subscription', restoredMessage: { __typename?: 'Message', id: string, title: string, content: string, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, actions?: { __typename?: 'PaginatedAction', totalCount: number, items?: Array<{ __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null } } };

export type OrganizationFieldsFragment = { __typename?: 'Organization', id: string, name: string, registrationNumber: string, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string } };

export type GetOrganizationsQueryVariables = Exact<{
  filter?: InputMaybe<OrganizationFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<OrganizationSortArgs> | OrganizationSortArgs>;
  withPerson?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetOrganizationsQuery = { __typename?: 'Query', organizations: { __typename?: 'PaginatedOrganization', totalCount: number, items?: Array<{ __typename?: 'Organization', id: string, name: string, registrationNumber: string, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string } }> | null } };

export type GetOrganizationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withPerson?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetOrganizationQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, name: string, registrationNumber: string, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string } } | null };

export type GetAllRelatedDataForOrganizationQueryVariables = Exact<{
  withPeople?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForOrganizationQuery = { __typename?: 'Query', people?: { __typename?: 'PaginatedPerson', items?: Array<{ __typename?: 'Person', id: string, displayField: string }> | null } };

export type CreateOrganizationMutationVariables = Exact<{
  name: Scalars['String']['input'];
  registrationNumber: Scalars['String']['input'];
  personId: Scalars['ID']['input'];
  withPerson?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization: { __typename?: 'Organization', id: string, name: string, registrationNumber: string, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string } } };

export type UpdateOrganizationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
  withPerson?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'Organization', id: string, name: string, registrationNumber: string, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string } } };

export type DeleteOrganizationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withPerson?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteOrganizationMutation = { __typename?: 'Mutation', deleteOrganization: { __typename?: 'Organization', id: string, name: string, registrationNumber: string, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string } } };

export type CreatedOrganizationSubscriptionVariables = Exact<{
  filter?: InputMaybe<OrganizationFilterArgs>;
  withPerson?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedOrganizationSubscription = { __typename?: 'Subscription', createdOrganization: { __typename?: 'Organization', id: string, name: string, registrationNumber: string, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string } } };

export type UpdatedOrganizationSubscriptionVariables = Exact<{
  filter?: InputMaybe<OrganizationFilterArgs>;
  withPerson?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedOrganizationSubscription = { __typename?: 'Subscription', updatedOrganization: { __typename?: 'Organization', id: string, name: string, registrationNumber: string, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string } } };

export type DeletedOrganizationSubscriptionVariables = Exact<{
  filter?: InputMaybe<OrganizationFilterArgs>;
}>;


export type DeletedOrganizationSubscription = { __typename?: 'Subscription', deletedOrganization: { __typename?: 'Organization', id: string } };

export type PermissionFieldsFragment = { __typename?: 'Permission', id: string, name: string, description: string, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string }> | null } };

export type GetPermissionsQueryVariables = Exact<{
  filter?: InputMaybe<PermissionFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PermissionSortArgs> | PermissionSortArgs>;
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPermissionsQuery = { __typename?: 'Query', permissions: { __typename?: 'PaginatedPermission', totalCount: number, items?: Array<{ __typename?: 'Permission', id: string, name: string, description: string, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string }> | null } }> | null } };

export type GetPermissionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPermissionQuery = { __typename?: 'Query', permission?: { __typename?: 'Permission', id: string, name: string, description: string, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string }> | null } } | null };

export type GetAllRelatedDataForPermissionQueryVariables = Exact<{
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForPermissionQuery = { __typename?: 'Query', roles?: { __typename?: 'PaginatedRole', items?: Array<{ __typename?: 'Role', id: string, displayField: string }> | null } };

export type CreatePermissionMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  roles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatePermissionMutation = { __typename?: 'Mutation', createPermission: { __typename?: 'Permission', id: string, name: string, description: string, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string }> | null } } };

export type UpdatePermissionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatePermissionMutation = { __typename?: 'Mutation', updatePermission: { __typename?: 'Permission', id: string, name: string, description: string, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string }> | null } } };

export type DeletePermissionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeletePermissionMutation = { __typename?: 'Mutation', deletePermission: { __typename?: 'Permission', id: string, name: string, description: string, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string }> | null } } };

export type CreatedPermissionSubscriptionVariables = Exact<{
  filter?: InputMaybe<PermissionFilterArgs>;
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedPermissionSubscription = { __typename?: 'Subscription', createdPermission: { __typename?: 'Permission', id: string, name: string, description: string, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string }> | null } } };

export type UpdatedPermissionSubscriptionVariables = Exact<{
  filter?: InputMaybe<PermissionFilterArgs>;
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedPermissionSubscription = { __typename?: 'Subscription', updatedPermission: { __typename?: 'Permission', id: string, name: string, description: string, roles?: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string }> | null } } };

export type DeletedPermissionSubscriptionVariables = Exact<{
  filter?: InputMaybe<PermissionFilterArgs>;
}>;


export type DeletedPermissionSubscription = { __typename?: 'Subscription', deletedPermission: { __typename?: 'Permission', id: string } };

export type PersonFieldsFragment = { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, createdAt?: any | null, updatedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, displayField: string } | null, organizations?: { __typename?: 'PaginatedOrganization', totalCount: number, items?: Array<{ __typename?: 'Organization', id: string, personId: string, name: string, registrationNumber: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, personActionProgresses?: { __typename?: 'PaginatedPersonActionProgress', totalCount: number, items?: Array<{ __typename?: 'PersonActionProgress', id: string, progress: string, done?: boolean | null, personId: string, actionId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, personRegisterProgresses?: { __typename?: 'PaginatedPersonRegisterProgress', totalCount: number, items?: Array<{ __typename?: 'PersonRegisterProgress', id: string, progress: string, done?: boolean | null, foundAt?: any | null, actionDoneAt?: any | null, personId: string, registerId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, personSearchProgresses?: { __typename?: 'PaginatedPersonSearchProgress', totalCount: number, items?: Array<{ __typename?: 'PersonSearchProgress', id: string, progress: string, done?: boolean | null, personId: string, searchId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } };

export type GetPeopleQueryVariables = Exact<{
  filter?: InputMaybe<PersonFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PersonSortArgs> | PersonSortArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonActionProgresses?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonRegisterProgresses?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonSearchProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPeopleQuery = { __typename?: 'Query', people: { __typename?: 'PaginatedPerson', totalCount: number, items?: Array<{ __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, createdAt?: any | null, updatedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, displayField: string } | null, organizations?: { __typename?: 'PaginatedOrganization', totalCount: number, items?: Array<{ __typename?: 'Organization', id: string, personId: string, name: string, registrationNumber: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, personActionProgresses?: { __typename?: 'PaginatedPersonActionProgress', totalCount: number, items?: Array<{ __typename?: 'PersonActionProgress', id: string, progress: string, done?: boolean | null, personId: string, actionId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, personRegisterProgresses?: { __typename?: 'PaginatedPersonRegisterProgress', totalCount: number, items?: Array<{ __typename?: 'PersonRegisterProgress', id: string, progress: string, done?: boolean | null, foundAt?: any | null, actionDoneAt?: any | null, personId: string, registerId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, personSearchProgresses?: { __typename?: 'PaginatedPersonSearchProgress', totalCount: number, items?: Array<{ __typename?: 'PersonSearchProgress', id: string, progress: string, done?: boolean | null, personId: string, searchId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } }> | null } };

export type GetPersonQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonActionProgresses?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonRegisterProgresses?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonSearchProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPersonQuery = { __typename?: 'Query', person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, createdAt?: any | null, updatedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, displayField: string } | null, organizations?: { __typename?: 'PaginatedOrganization', totalCount: number, items?: Array<{ __typename?: 'Organization', id: string, personId: string, name: string, registrationNumber: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, personActionProgresses?: { __typename?: 'PaginatedPersonActionProgress', totalCount: number, items?: Array<{ __typename?: 'PersonActionProgress', id: string, progress: string, done?: boolean | null, personId: string, actionId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, personRegisterProgresses?: { __typename?: 'PaginatedPersonRegisterProgress', totalCount: number, items?: Array<{ __typename?: 'PersonRegisterProgress', id: string, progress: string, done?: boolean | null, foundAt?: any | null, actionDoneAt?: any | null, personId: string, registerId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, personSearchProgresses?: { __typename?: 'PaginatedPersonSearchProgress', totalCount: number, items?: Array<{ __typename?: 'PersonSearchProgress', id: string, progress: string, done?: boolean | null, personId: string, searchId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } | null };

export type GetAllRelatedDataForPersonQueryVariables = Exact<{
  withUsers?: InputMaybe<Scalars['Boolean']['input']>;
  withOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonActionProgresses?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonRegisterProgresses?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonSearchProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForPersonQuery = { __typename?: 'Query', users?: { __typename?: 'PaginatedUser', items?: Array<{ __typename?: 'User', id: string, displayField: string }> | null }, organizations?: { __typename?: 'PaginatedOrganization', items?: Array<{ __typename?: 'Organization', id: string, displayField: string }> | null }, personActionProgresses?: { __typename?: 'PaginatedPersonActionProgress', items?: Array<{ __typename?: 'PersonActionProgress', id: string, displayField: string }> | null }, personRegisterProgresses?: { __typename?: 'PaginatedPersonRegisterProgress', items?: Array<{ __typename?: 'PersonRegisterProgress', id: string, displayField: string }> | null }, personSearchProgresses?: { __typename?: 'PaginatedPersonSearchProgress', items?: Array<{ __typename?: 'PersonSearchProgress', id: string, displayField: string }> | null } };

export type CreatePersonMutationVariables = Exact<{
  firstNames: Scalars['String']['input'];
  prefix?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  address: Scalars['String']['input'];
  addressNumber: Scalars['String']['input'];
  city: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  progress?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  organizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  personActionProgresses?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  personRegisterProgresses?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  personSearchProgresses?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonActionProgresses?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonRegisterProgresses?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonSearchProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatePersonMutation = { __typename?: 'Mutation', createPerson: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, createdAt?: any | null, updatedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, displayField: string } | null, organizations?: { __typename?: 'PaginatedOrganization', totalCount: number, items?: Array<{ __typename?: 'Organization', id: string, personId: string, name: string, registrationNumber: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, personActionProgresses?: { __typename?: 'PaginatedPersonActionProgress', totalCount: number, items?: Array<{ __typename?: 'PersonActionProgress', id: string, progress: string, done?: boolean | null, personId: string, actionId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, personRegisterProgresses?: { __typename?: 'PaginatedPersonRegisterProgress', totalCount: number, items?: Array<{ __typename?: 'PersonRegisterProgress', id: string, progress: string, done?: boolean | null, foundAt?: any | null, actionDoneAt?: any | null, personId: string, registerId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, personSearchProgresses?: { __typename?: 'PaginatedPersonSearchProgress', totalCount: number, items?: Array<{ __typename?: 'PersonSearchProgress', id: string, progress: string, done?: boolean | null, personId: string, searchId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type UpdatePersonMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  firstNames?: InputMaybe<Scalars['String']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  addressNumber?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  organizations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  personActionProgresses?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  personRegisterProgresses?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  personSearchProgresses?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonActionProgresses?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonRegisterProgresses?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonSearchProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatePersonMutation = { __typename?: 'Mutation', updatePerson: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, createdAt?: any | null, updatedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, displayField: string } | null, organizations?: { __typename?: 'PaginatedOrganization', totalCount: number, items?: Array<{ __typename?: 'Organization', id: string, personId: string, name: string, registrationNumber: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, personActionProgresses?: { __typename?: 'PaginatedPersonActionProgress', totalCount: number, items?: Array<{ __typename?: 'PersonActionProgress', id: string, progress: string, done?: boolean | null, personId: string, actionId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, personRegisterProgresses?: { __typename?: 'PaginatedPersonRegisterProgress', totalCount: number, items?: Array<{ __typename?: 'PersonRegisterProgress', id: string, progress: string, done?: boolean | null, foundAt?: any | null, actionDoneAt?: any | null, personId: string, registerId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, personSearchProgresses?: { __typename?: 'PaginatedPersonSearchProgress', totalCount: number, items?: Array<{ __typename?: 'PersonSearchProgress', id: string, progress: string, done?: boolean | null, personId: string, searchId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type DeletePersonMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonActionProgresses?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonRegisterProgresses?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonSearchProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeletePersonMutation = { __typename?: 'Mutation', deletePerson: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, createdAt?: any | null, updatedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, displayField: string } | null, organizations?: { __typename?: 'PaginatedOrganization', totalCount: number, items?: Array<{ __typename?: 'Organization', id: string, personId: string, name: string, registrationNumber: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, personActionProgresses?: { __typename?: 'PaginatedPersonActionProgress', totalCount: number, items?: Array<{ __typename?: 'PersonActionProgress', id: string, progress: string, done?: boolean | null, personId: string, actionId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, personRegisterProgresses?: { __typename?: 'PaginatedPersonRegisterProgress', totalCount: number, items?: Array<{ __typename?: 'PersonRegisterProgress', id: string, progress: string, done?: boolean | null, foundAt?: any | null, actionDoneAt?: any | null, personId: string, registerId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, personSearchProgresses?: { __typename?: 'PaginatedPersonSearchProgress', totalCount: number, items?: Array<{ __typename?: 'PersonSearchProgress', id: string, progress: string, done?: boolean | null, personId: string, searchId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type CreatedPersonSubscriptionVariables = Exact<{
  filter?: InputMaybe<PersonFilterArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonActionProgresses?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonRegisterProgresses?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonSearchProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedPersonSubscription = { __typename?: 'Subscription', createdPerson: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, createdAt?: any | null, updatedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, displayField: string } | null, organizations?: { __typename?: 'PaginatedOrganization', totalCount: number, items?: Array<{ __typename?: 'Organization', id: string, personId: string, name: string, registrationNumber: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, personActionProgresses?: { __typename?: 'PaginatedPersonActionProgress', totalCount: number, items?: Array<{ __typename?: 'PersonActionProgress', id: string, progress: string, done?: boolean | null, personId: string, actionId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, personRegisterProgresses?: { __typename?: 'PaginatedPersonRegisterProgress', totalCount: number, items?: Array<{ __typename?: 'PersonRegisterProgress', id: string, progress: string, done?: boolean | null, foundAt?: any | null, actionDoneAt?: any | null, personId: string, registerId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, personSearchProgresses?: { __typename?: 'PaginatedPersonSearchProgress', totalCount: number, items?: Array<{ __typename?: 'PersonSearchProgress', id: string, progress: string, done?: boolean | null, personId: string, searchId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type UpdatedPersonSubscriptionVariables = Exact<{
  filter?: InputMaybe<PersonFilterArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withOrganizations?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonActionProgresses?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonRegisterProgresses?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonSearchProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedPersonSubscription = { __typename?: 'Subscription', updatedPerson: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, createdAt?: any | null, updatedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, displayField: string } | null, organizations?: { __typename?: 'PaginatedOrganization', totalCount: number, items?: Array<{ __typename?: 'Organization', id: string, personId: string, name: string, registrationNumber: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, personActionProgresses?: { __typename?: 'PaginatedPersonActionProgress', totalCount: number, items?: Array<{ __typename?: 'PersonActionProgress', id: string, progress: string, done?: boolean | null, personId: string, actionId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, personRegisterProgresses?: { __typename?: 'PaginatedPersonRegisterProgress', totalCount: number, items?: Array<{ __typename?: 'PersonRegisterProgress', id: string, progress: string, done?: boolean | null, foundAt?: any | null, actionDoneAt?: any | null, personId: string, registerId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, personSearchProgresses?: { __typename?: 'PaginatedPersonSearchProgress', totalCount: number, items?: Array<{ __typename?: 'PersonSearchProgress', id: string, progress: string, done?: boolean | null, personId: string, searchId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type DeletedPersonSubscriptionVariables = Exact<{
  filter?: InputMaybe<PersonFilterArgs>;
}>;


export type DeletedPersonSubscription = { __typename?: 'Subscription', deletedPerson: { __typename?: 'Person', id: string } };

export type PersonActionProgressFieldsFragment = { __typename?: 'PersonActionProgress', id: string, progress: string, done?: boolean | null, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, action?: { __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null };

export type GetPersonActionProgressesQueryVariables = Exact<{
  filter?: InputMaybe<PersonActionProgressFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PersonActionProgressSortArgs> | PersonActionProgressSortArgs>;
  withPerson?: InputMaybe<Scalars['Boolean']['input']>;
  withAction?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPersonActionProgressesQuery = { __typename?: 'Query', personActionProgresses: { __typename?: 'PaginatedPersonActionProgress', totalCount: number, items?: Array<{ __typename?: 'PersonActionProgress', id: string, progress: string, done?: boolean | null, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, action?: { __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null }> | null } };

export type GetPersonActionProgressQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withPerson?: InputMaybe<Scalars['Boolean']['input']>;
  withAction?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPersonActionProgressQuery = { __typename?: 'Query', personActionProgress?: { __typename?: 'PersonActionProgress', id: string, progress: string, done?: boolean | null, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, action?: { __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } | null };

export type GetAllRelatedDataForPersonActionProgressQueryVariables = Exact<{
  withPeople?: InputMaybe<Scalars['Boolean']['input']>;
  withActions?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForPersonActionProgressQuery = { __typename?: 'Query', people?: { __typename?: 'PaginatedPerson', items?: Array<{ __typename?: 'Person', id: string, displayField: string }> | null }, actions?: { __typename?: 'PaginatedAction', items?: Array<{ __typename?: 'Action', id: string, displayField: string }> | null } };

export type CreatePersonActionProgressMutationVariables = Exact<{
  progress: Scalars['String']['input'];
  done?: InputMaybe<Scalars['Boolean']['input']>;
  personId: Scalars['ID']['input'];
  actionId: Scalars['ID']['input'];
  withPerson?: InputMaybe<Scalars['Boolean']['input']>;
  withAction?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatePersonActionProgressMutation = { __typename?: 'Mutation', createPersonActionProgress: { __typename?: 'PersonActionProgress', id: string, progress: string, done?: boolean | null, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, action?: { __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type UpdatePersonActionProgressMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  progress?: InputMaybe<Scalars['String']['input']>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
  actionId?: InputMaybe<Scalars['ID']['input']>;
  withPerson?: InputMaybe<Scalars['Boolean']['input']>;
  withAction?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatePersonActionProgressMutation = { __typename?: 'Mutation', updatePersonActionProgress: { __typename?: 'PersonActionProgress', id: string, progress: string, done?: boolean | null, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, action?: { __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type DeletePersonActionProgressMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withPerson?: InputMaybe<Scalars['Boolean']['input']>;
  withAction?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeletePersonActionProgressMutation = { __typename?: 'Mutation', deletePersonActionProgress: { __typename?: 'PersonActionProgress', id: string, progress: string, done?: boolean | null, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, action?: { __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type CreatedPersonActionProgressSubscriptionVariables = Exact<{
  filter?: InputMaybe<PersonActionProgressFilterArgs>;
  withPerson?: InputMaybe<Scalars['Boolean']['input']>;
  withAction?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedPersonActionProgressSubscription = { __typename?: 'Subscription', createdPersonActionProgress: { __typename?: 'PersonActionProgress', id: string, progress: string, done?: boolean | null, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, action?: { __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type UpdatedPersonActionProgressSubscriptionVariables = Exact<{
  filter?: InputMaybe<PersonActionProgressFilterArgs>;
  withPerson?: InputMaybe<Scalars['Boolean']['input']>;
  withAction?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedPersonActionProgressSubscription = { __typename?: 'Subscription', updatedPersonActionProgress: { __typename?: 'PersonActionProgress', id: string, progress: string, done?: boolean | null, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, action?: { __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type DeletedPersonActionProgressSubscriptionVariables = Exact<{
  filter?: InputMaybe<PersonActionProgressFilterArgs>;
}>;


export type DeletedPersonActionProgressSubscription = { __typename?: 'Subscription', deletedPersonActionProgress: { __typename?: 'PersonActionProgress', id: string } };

export type PersonRegisterProgressFieldsFragment = { __typename?: 'PersonRegisterProgress', id: string, progress: string, done?: boolean | null, foundAt?: any | null, actionDoneAt?: any | null, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, register?: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null };

export type GetPersonRegisterProgressesQueryVariables = Exact<{
  filter?: InputMaybe<PersonRegisterProgressFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PersonRegisterProgressSortArgs> | PersonRegisterProgressSortArgs>;
  withPerson?: InputMaybe<Scalars['Boolean']['input']>;
  withRegister?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPersonRegisterProgressesQuery = { __typename?: 'Query', personRegisterProgresses: { __typename?: 'PaginatedPersonRegisterProgress', totalCount: number, items?: Array<{ __typename?: 'PersonRegisterProgress', id: string, progress: string, done?: boolean | null, foundAt?: any | null, actionDoneAt?: any | null, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, register?: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null }> | null } };

export type GetPersonRegisterProgressQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withPerson?: InputMaybe<Scalars['Boolean']['input']>;
  withRegister?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPersonRegisterProgressQuery = { __typename?: 'Query', personRegisterProgress?: { __typename?: 'PersonRegisterProgress', id: string, progress: string, done?: boolean | null, foundAt?: any | null, actionDoneAt?: any | null, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, register?: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } | null };

export type GetAllRelatedDataForPersonRegisterProgressQueryVariables = Exact<{
  withPeople?: InputMaybe<Scalars['Boolean']['input']>;
  withRegisters?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForPersonRegisterProgressQuery = { __typename?: 'Query', people?: { __typename?: 'PaginatedPerson', items?: Array<{ __typename?: 'Person', id: string, displayField: string }> | null }, registers?: { __typename?: 'PaginatedRegister', items?: Array<{ __typename?: 'Register', id: string, displayField: string }> | null } };

export type CreatePersonRegisterProgressMutationVariables = Exact<{
  progress: Scalars['String']['input'];
  done?: InputMaybe<Scalars['Boolean']['input']>;
  foundAt?: InputMaybe<Scalars['DateTime']['input']>;
  actionDoneAt?: InputMaybe<Scalars['DateTime']['input']>;
  personId: Scalars['ID']['input'];
  registerId: Scalars['ID']['input'];
  withPerson?: InputMaybe<Scalars['Boolean']['input']>;
  withRegister?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatePersonRegisterProgressMutation = { __typename?: 'Mutation', createPersonRegisterProgress: { __typename?: 'PersonRegisterProgress', id: string, progress: string, done?: boolean | null, foundAt?: any | null, actionDoneAt?: any | null, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, register?: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type UpdatePersonRegisterProgressMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  progress?: InputMaybe<Scalars['String']['input']>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  foundAt?: InputMaybe<Scalars['DateTime']['input']>;
  actionDoneAt?: InputMaybe<Scalars['DateTime']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
  registerId?: InputMaybe<Scalars['ID']['input']>;
  withPerson?: InputMaybe<Scalars['Boolean']['input']>;
  withRegister?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatePersonRegisterProgressMutation = { __typename?: 'Mutation', updatePersonRegisterProgress: { __typename?: 'PersonRegisterProgress', id: string, progress: string, done?: boolean | null, foundAt?: any | null, actionDoneAt?: any | null, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, register?: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type DeletePersonRegisterProgressMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withPerson?: InputMaybe<Scalars['Boolean']['input']>;
  withRegister?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeletePersonRegisterProgressMutation = { __typename?: 'Mutation', deletePersonRegisterProgress: { __typename?: 'PersonRegisterProgress', id: string, progress: string, done?: boolean | null, foundAt?: any | null, actionDoneAt?: any | null, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, register?: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type CreatedPersonRegisterProgressSubscriptionVariables = Exact<{
  filter?: InputMaybe<PersonRegisterProgressFilterArgs>;
  withPerson?: InputMaybe<Scalars['Boolean']['input']>;
  withRegister?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedPersonRegisterProgressSubscription = { __typename?: 'Subscription', createdPersonRegisterProgress: { __typename?: 'PersonRegisterProgress', id: string, progress: string, done?: boolean | null, foundAt?: any | null, actionDoneAt?: any | null, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, register?: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type UpdatedPersonRegisterProgressSubscriptionVariables = Exact<{
  filter?: InputMaybe<PersonRegisterProgressFilterArgs>;
  withPerson?: InputMaybe<Scalars['Boolean']['input']>;
  withRegister?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedPersonRegisterProgressSubscription = { __typename?: 'Subscription', updatedPersonRegisterProgress: { __typename?: 'PersonRegisterProgress', id: string, progress: string, done?: boolean | null, foundAt?: any | null, actionDoneAt?: any | null, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, register?: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type DeletedPersonRegisterProgressSubscriptionVariables = Exact<{
  filter?: InputMaybe<PersonRegisterProgressFilterArgs>;
}>;


export type DeletedPersonRegisterProgressSubscription = { __typename?: 'Subscription', deletedPersonRegisterProgress: { __typename?: 'PersonRegisterProgress', id: string } };

export type PersonSearchProgressFieldsFragment = { __typename?: 'PersonSearchProgress', id: string, progress: string, done?: boolean | null, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, search?: { __typename?: 'Search', id: string, name: string, searchUrl?: string | null, order?: number | null, actionId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null };

export type GetPersonSearchProgressesQueryVariables = Exact<{
  filter?: InputMaybe<PersonSearchProgressFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<PersonSearchProgressSortArgs> | PersonSearchProgressSortArgs>;
  withPerson?: InputMaybe<Scalars['Boolean']['input']>;
  withSearch?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPersonSearchProgressesQuery = { __typename?: 'Query', personSearchProgresses: { __typename?: 'PaginatedPersonSearchProgress', totalCount: number, items?: Array<{ __typename?: 'PersonSearchProgress', id: string, progress: string, done?: boolean | null, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, search?: { __typename?: 'Search', id: string, name: string, searchUrl?: string | null, order?: number | null, actionId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null }> | null } };

export type GetPersonSearchProgressQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withPerson?: InputMaybe<Scalars['Boolean']['input']>;
  withSearch?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPersonSearchProgressQuery = { __typename?: 'Query', personSearchProgress?: { __typename?: 'PersonSearchProgress', id: string, progress: string, done?: boolean | null, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, search?: { __typename?: 'Search', id: string, name: string, searchUrl?: string | null, order?: number | null, actionId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } | null };

export type GetAllRelatedDataForPersonSearchProgressQueryVariables = Exact<{
  withPeople?: InputMaybe<Scalars['Boolean']['input']>;
  withSearches?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForPersonSearchProgressQuery = { __typename?: 'Query', people?: { __typename?: 'PaginatedPerson', items?: Array<{ __typename?: 'Person', id: string, displayField: string }> | null }, searches?: { __typename?: 'PaginatedSearch', items?: Array<{ __typename?: 'Search', id: string, displayField: string }> | null } };

export type CreatePersonSearchProgressMutationVariables = Exact<{
  progress: Scalars['String']['input'];
  done?: InputMaybe<Scalars['Boolean']['input']>;
  personId: Scalars['ID']['input'];
  searchId: Scalars['ID']['input'];
  withPerson?: InputMaybe<Scalars['Boolean']['input']>;
  withSearch?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatePersonSearchProgressMutation = { __typename?: 'Mutation', createPersonSearchProgress: { __typename?: 'PersonSearchProgress', id: string, progress: string, done?: boolean | null, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, search?: { __typename?: 'Search', id: string, name: string, searchUrl?: string | null, order?: number | null, actionId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type UpdatePersonSearchProgressMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  progress?: InputMaybe<Scalars['String']['input']>;
  done?: InputMaybe<Scalars['Boolean']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
  searchId?: InputMaybe<Scalars['ID']['input']>;
  withPerson?: InputMaybe<Scalars['Boolean']['input']>;
  withSearch?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatePersonSearchProgressMutation = { __typename?: 'Mutation', updatePersonSearchProgress: { __typename?: 'PersonSearchProgress', id: string, progress: string, done?: boolean | null, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, search?: { __typename?: 'Search', id: string, name: string, searchUrl?: string | null, order?: number | null, actionId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type DeletePersonSearchProgressMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withPerson?: InputMaybe<Scalars['Boolean']['input']>;
  withSearch?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeletePersonSearchProgressMutation = { __typename?: 'Mutation', deletePersonSearchProgress: { __typename?: 'PersonSearchProgress', id: string, progress: string, done?: boolean | null, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, search?: { __typename?: 'Search', id: string, name: string, searchUrl?: string | null, order?: number | null, actionId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type CreatedPersonSearchProgressSubscriptionVariables = Exact<{
  filter?: InputMaybe<PersonSearchProgressFilterArgs>;
  withPerson?: InputMaybe<Scalars['Boolean']['input']>;
  withSearch?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedPersonSearchProgressSubscription = { __typename?: 'Subscription', createdPersonSearchProgress: { __typename?: 'PersonSearchProgress', id: string, progress: string, done?: boolean | null, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, search?: { __typename?: 'Search', id: string, name: string, searchUrl?: string | null, order?: number | null, actionId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type UpdatedPersonSearchProgressSubscriptionVariables = Exact<{
  filter?: InputMaybe<PersonSearchProgressFilterArgs>;
  withPerson?: InputMaybe<Scalars['Boolean']['input']>;
  withSearch?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedPersonSearchProgressSubscription = { __typename?: 'Subscription', updatedPersonSearchProgress: { __typename?: 'PersonSearchProgress', id: string, progress: string, done?: boolean | null, createdAt?: any | null, updatedAt?: any | null, person?: { __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }, search?: { __typename?: 'Search', id: string, name: string, searchUrl?: string | null, order?: number | null, actionId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null } };

export type DeletedPersonSearchProgressSubscriptionVariables = Exact<{
  filter?: InputMaybe<PersonSearchProgressFilterArgs>;
}>;


export type DeletedPersonSearchProgressSubscription = { __typename?: 'Subscription', deletedPersonSearchProgress: { __typename?: 'PersonSearchProgress', id: string } };

export type RegisterFieldsFragment = { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, derivatives?: { __typename?: 'PaginatedRegister', totalCount: number, items?: Array<{ __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, source?: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, actions?: { __typename?: 'PaginatedAction', totalCount: number, items?: Array<{ __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, personRegisterProgresses?: { __typename?: 'PaginatedPersonRegisterProgress', totalCount: number, items?: Array<{ __typename?: 'PersonRegisterProgress', id: string, progress: string, done?: boolean | null, foundAt?: any | null, actionDoneAt?: any | null, personId: string, registerId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } };

export type GetRegistersQueryVariables = Exact<{
  filter?: InputMaybe<RegisterFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<RegisterSortArgs> | RegisterSortArgs>;
  withDerivatives?: InputMaybe<Scalars['Boolean']['input']>;
  withSource?: InputMaybe<Scalars['Boolean']['input']>;
  withActions?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonRegisterProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetRegistersQuery = { __typename?: 'Query', registers: { __typename?: 'PaginatedRegister', totalCount: number, items?: Array<{ __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, derivatives?: { __typename?: 'PaginatedRegister', totalCount: number, items?: Array<{ __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, source?: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, actions?: { __typename?: 'PaginatedAction', totalCount: number, items?: Array<{ __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, personRegisterProgresses?: { __typename?: 'PaginatedPersonRegisterProgress', totalCount: number, items?: Array<{ __typename?: 'PersonRegisterProgress', id: string, progress: string, done?: boolean | null, foundAt?: any | null, actionDoneAt?: any | null, personId: string, registerId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } }> | null } };

export type GetRegisterQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withDerivatives?: InputMaybe<Scalars['Boolean']['input']>;
  withSource?: InputMaybe<Scalars['Boolean']['input']>;
  withActions?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonRegisterProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetRegisterQuery = { __typename?: 'Query', register?: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, derivatives?: { __typename?: 'PaginatedRegister', totalCount: number, items?: Array<{ __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, source?: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, actions?: { __typename?: 'PaginatedAction', totalCount: number, items?: Array<{ __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, personRegisterProgresses?: { __typename?: 'PaginatedPersonRegisterProgress', totalCount: number, items?: Array<{ __typename?: 'PersonRegisterProgress', id: string, progress: string, done?: boolean | null, foundAt?: any | null, actionDoneAt?: any | null, personId: string, registerId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } | null };

export type GetAllRelatedDataForRegisterQueryVariables = Exact<{
  withDerivatives?: InputMaybe<Scalars['Boolean']['input']>;
  withSources?: InputMaybe<Scalars['Boolean']['input']>;
  withActions?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonRegisterProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForRegisterQuery = { __typename?: 'Query', registers?: { __typename?: 'PaginatedRegister', items?: Array<{ __typename?: 'Register', id: string, displayField: string }> | null }, actions?: { __typename?: 'PaginatedAction', items?: Array<{ __typename?: 'Action', id: string, displayField: string }> | null }, personRegisterProgresses?: { __typename?: 'PaginatedPersonRegisterProgress', items?: Array<{ __typename?: 'PersonRegisterProgress', id: string, displayField: string }> | null } };

export type CreateRegisterMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  companyRegister: Scalars['Boolean']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  machineName: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  contactUrl?: InputMaybe<Scalars['String']['input']>;
  siteUrl?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  derivatives?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  sourceId?: InputMaybe<Scalars['ID']['input']>;
  actions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  personRegisterProgresses?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withDerivatives?: InputMaybe<Scalars['Boolean']['input']>;
  withSource?: InputMaybe<Scalars['Boolean']['input']>;
  withActions?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonRegisterProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateRegisterMutation = { __typename?: 'Mutation', createRegister: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, derivatives?: { __typename?: 'PaginatedRegister', totalCount: number, items?: Array<{ __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, source?: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, actions?: { __typename?: 'PaginatedAction', totalCount: number, items?: Array<{ __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, personRegisterProgresses?: { __typename?: 'PaginatedPersonRegisterProgress', totalCount: number, items?: Array<{ __typename?: 'PersonRegisterProgress', id: string, progress: string, done?: boolean | null, foundAt?: any | null, actionDoneAt?: any | null, personId: string, registerId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type UpdateRegisterMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  companyRegister?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  machineName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  contactUrl?: InputMaybe<Scalars['String']['input']>;
  siteUrl?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  derivatives?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  sourceId?: InputMaybe<Scalars['ID']['input']>;
  actions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  personRegisterProgresses?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withDerivatives?: InputMaybe<Scalars['Boolean']['input']>;
  withSource?: InputMaybe<Scalars['Boolean']['input']>;
  withActions?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonRegisterProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateRegisterMutation = { __typename?: 'Mutation', updateRegister: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, derivatives?: { __typename?: 'PaginatedRegister', totalCount: number, items?: Array<{ __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, source?: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, actions?: { __typename?: 'PaginatedAction', totalCount: number, items?: Array<{ __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, personRegisterProgresses?: { __typename?: 'PaginatedPersonRegisterProgress', totalCount: number, items?: Array<{ __typename?: 'PersonRegisterProgress', id: string, progress: string, done?: boolean | null, foundAt?: any | null, actionDoneAt?: any | null, personId: string, registerId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type DeleteRegisterMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withDerivatives?: InputMaybe<Scalars['Boolean']['input']>;
  withSource?: InputMaybe<Scalars['Boolean']['input']>;
  withActions?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonRegisterProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteRegisterMutation = { __typename?: 'Mutation', deleteRegister: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, derivatives?: { __typename?: 'PaginatedRegister', totalCount: number, items?: Array<{ __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, source?: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, actions?: { __typename?: 'PaginatedAction', totalCount: number, items?: Array<{ __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, personRegisterProgresses?: { __typename?: 'PaginatedPersonRegisterProgress', totalCount: number, items?: Array<{ __typename?: 'PersonRegisterProgress', id: string, progress: string, done?: boolean | null, foundAt?: any | null, actionDoneAt?: any | null, personId: string, registerId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type CreatedRegisterSubscriptionVariables = Exact<{
  filter?: InputMaybe<RegisterFilterArgs>;
  withDerivatives?: InputMaybe<Scalars['Boolean']['input']>;
  withSource?: InputMaybe<Scalars['Boolean']['input']>;
  withActions?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonRegisterProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedRegisterSubscription = { __typename?: 'Subscription', createdRegister: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, derivatives?: { __typename?: 'PaginatedRegister', totalCount: number, items?: Array<{ __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, source?: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, actions?: { __typename?: 'PaginatedAction', totalCount: number, items?: Array<{ __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, personRegisterProgresses?: { __typename?: 'PaginatedPersonRegisterProgress', totalCount: number, items?: Array<{ __typename?: 'PersonRegisterProgress', id: string, progress: string, done?: boolean | null, foundAt?: any | null, actionDoneAt?: any | null, personId: string, registerId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type UpdatedRegisterSubscriptionVariables = Exact<{
  filter?: InputMaybe<RegisterFilterArgs>;
  withDerivatives?: InputMaybe<Scalars['Boolean']['input']>;
  withSource?: InputMaybe<Scalars['Boolean']['input']>;
  withActions?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonRegisterProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedRegisterSubscription = { __typename?: 'Subscription', updatedRegister: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, derivatives?: { __typename?: 'PaginatedRegister', totalCount: number, items?: Array<{ __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, source?: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, actions?: { __typename?: 'PaginatedAction', totalCount: number, items?: Array<{ __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, personRegisterProgresses?: { __typename?: 'PaginatedPersonRegisterProgress', totalCount: number, items?: Array<{ __typename?: 'PersonRegisterProgress', id: string, progress: string, done?: boolean | null, foundAt?: any | null, actionDoneAt?: any | null, personId: string, registerId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type DeletedRegisterSubscriptionVariables = Exact<{
  filter?: InputMaybe<RegisterFilterArgs>;
}>;


export type DeletedRegisterSubscription = { __typename?: 'Subscription', deletedRegister: { __typename?: 'Register', id: string } };

export type RestoredRegisterSubscriptionVariables = Exact<{
  filter?: InputMaybe<RegisterFilterArgs>;
  withDerivatives?: InputMaybe<Scalars['Boolean']['input']>;
  withSource?: InputMaybe<Scalars['Boolean']['input']>;
  withActions?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonRegisterProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RestoredRegisterSubscription = { __typename?: 'Subscription', restoredRegister: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, derivatives?: { __typename?: 'PaginatedRegister', totalCount: number, items?: Array<{ __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, source?: { __typename?: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, order?: number | null, name: string, machineName: string, description?: string | null, subtitle?: string | null, contactUrl?: string | null, siteUrl?: string | null, logo?: string | null, sourceId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, actions?: { __typename?: 'PaginatedAction', totalCount: number, items?: Array<{ __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string }> | null }, personRegisterProgresses?: { __typename?: 'PaginatedPersonRegisterProgress', totalCount: number, items?: Array<{ __typename?: 'PersonRegisterProgress', id: string, progress: string, done?: boolean | null, foundAt?: any | null, actionDoneAt?: any | null, personId: string, registerId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type ReminderFieldsFragment = { __typename?: 'Reminder', id: string, date: any, createdAt?: any | null, updatedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, displayField: string }, mailTemplate?: { __typename?: 'MailTemplate', id: string, active: boolean, displayField: string } };

export type GetRemindersQueryVariables = Exact<{
  filter?: InputMaybe<ReminderFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ReminderSortArgs> | ReminderSortArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetRemindersQuery = { __typename?: 'Query', reminders: { __typename?: 'PaginatedReminder', totalCount: number, items?: Array<{ __typename?: 'Reminder', id: string, date: any, createdAt?: any | null, updatedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, displayField: string }, mailTemplate?: { __typename?: 'MailTemplate', id: string, active: boolean, displayField: string } }> | null } };

export type GetReminderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetReminderQuery = { __typename?: 'Query', reminder?: { __typename?: 'Reminder', id: string, date: any, createdAt?: any | null, updatedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, displayField: string }, mailTemplate?: { __typename?: 'MailTemplate', id: string, active: boolean, displayField: string } } | null };

export type GetAllRelatedDataForReminderQueryVariables = Exact<{
  withUsers?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplates?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForReminderQuery = { __typename?: 'Query', users?: { __typename?: 'PaginatedUser', items?: Array<{ __typename?: 'User', id: string, displayField: string }> | null }, mailTemplates?: { __typename?: 'PaginatedMailTemplate', items?: Array<{ __typename?: 'MailTemplate', id: string, displayField: string }> | null } };

export type CreateReminderMutationVariables = Exact<{
  date: Scalars['DateTime']['input'];
  userId: Scalars['ID']['input'];
  mailTemplateId: Scalars['ID']['input'];
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateReminderMutation = { __typename?: 'Mutation', createReminder: { __typename?: 'Reminder', id: string, date: any, createdAt?: any | null, updatedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, displayField: string }, mailTemplate?: { __typename?: 'MailTemplate', id: string, active: boolean, displayField: string } } };

export type UpdateReminderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['DateTime']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  mailTemplateId?: InputMaybe<Scalars['ID']['input']>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateReminderMutation = { __typename?: 'Mutation', updateReminder: { __typename?: 'Reminder', id: string, date: any, createdAt?: any | null, updatedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, displayField: string }, mailTemplate?: { __typename?: 'MailTemplate', id: string, active: boolean, displayField: string } } };

export type DeleteReminderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteReminderMutation = { __typename?: 'Mutation', deleteReminder: { __typename?: 'Reminder', id: string, date: any, createdAt?: any | null, updatedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, displayField: string }, mailTemplate?: { __typename?: 'MailTemplate', id: string, active: boolean, displayField: string } } };

export type CreatedReminderSubscriptionVariables = Exact<{
  filter?: InputMaybe<ReminderFilterArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedReminderSubscription = { __typename?: 'Subscription', createdReminder: { __typename?: 'Reminder', id: string, date: any, createdAt?: any | null, updatedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, displayField: string }, mailTemplate?: { __typename?: 'MailTemplate', id: string, active: boolean, displayField: string } } };

export type UpdatedReminderSubscriptionVariables = Exact<{
  filter?: InputMaybe<ReminderFilterArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withMailTemplate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedReminderSubscription = { __typename?: 'Subscription', updatedReminder: { __typename?: 'Reminder', id: string, date: any, createdAt?: any | null, updatedAt?: any | null, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, displayField: string }, mailTemplate?: { __typename?: 'MailTemplate', id: string, active: boolean, displayField: string } } };

export type DeletedReminderSubscriptionVariables = Exact<{
  filter?: InputMaybe<ReminderFilterArgs>;
}>;


export type DeletedReminderSubscription = { __typename?: 'Subscription', deletedReminder: { __typename?: 'Reminder', id: string } };

export type ResetPasswordFieldsFragment = { __typename?: 'ResetPassword', id: string, email: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null };

export type GetResetPasswordsQueryVariables = Exact<{
  filter?: InputMaybe<ResetPasswordFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<ResetPasswordSortArgs> | ResetPasswordSortArgs>;
}>;


export type GetResetPasswordsQuery = { __typename?: 'Query', resetPasswords: { __typename?: 'PaginatedResetPassword', totalCount: number, items?: Array<{ __typename?: 'ResetPassword', id: string, email: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null }> | null } };

export type GetResetPasswordQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetResetPasswordQuery = { __typename?: 'Query', resetPassword?: { __typename?: 'ResetPassword', id: string, email: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null } | null };

export type CreateResetPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
  type: Scalars['String']['input'];
}>;


export type CreateResetPasswordMutation = { __typename?: 'Mutation', createResetPassword: { __typename?: 'ResetPassword', id: string, email: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null } };

export type UpdateResetPasswordMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateResetPasswordMutation = { __typename?: 'Mutation', updateResetPassword: { __typename?: 'ResetPassword', id: string, email: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null } };

export type DeleteResetPasswordMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteResetPasswordMutation = { __typename?: 'Mutation', deleteResetPassword: { __typename?: 'ResetPassword', id: string, email: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null } };

export type CreatedResetPasswordSubscriptionVariables = Exact<{
  filter?: InputMaybe<ResetPasswordFilterArgs>;
}>;


export type CreatedResetPasswordSubscription = { __typename?: 'Subscription', createdResetPassword: { __typename?: 'ResetPassword', id: string, email: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null } };

export type UpdatedResetPasswordSubscriptionVariables = Exact<{
  filter?: InputMaybe<ResetPasswordFilterArgs>;
}>;


export type UpdatedResetPasswordSubscription = { __typename?: 'Subscription', updatedResetPassword: { __typename?: 'ResetPassword', id: string, email: string, token: string, type: string, createdAt?: any | null, updatedAt?: any | null } };

export type DeletedResetPasswordSubscriptionVariables = Exact<{
  filter?: InputMaybe<ResetPasswordFilterArgs>;
}>;


export type DeletedResetPasswordSubscription = { __typename?: 'Subscription', deletedResetPassword: { __typename?: 'ResetPassword', id: string } };

export type RoleFieldsFragment = { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, permissions?: { __typename?: 'PaginatedPermission', totalCount: number, items?: Array<{ __typename?: 'Permission', id: string, name: string, description: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null } };

export type GetRolesQueryVariables = Exact<{
  filter?: InputMaybe<RoleFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<RoleSortArgs> | RoleSortArgs>;
  withPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetRolesQuery = { __typename?: 'Query', roles: { __typename?: 'PaginatedRole', totalCount: number, items?: Array<{ __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, permissions?: { __typename?: 'PaginatedPermission', totalCount: number, items?: Array<{ __typename?: 'Permission', id: string, name: string, description: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null } }> | null } };

export type GetRoleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetRoleQuery = { __typename?: 'Query', role?: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, permissions?: { __typename?: 'PaginatedPermission', totalCount: number, items?: Array<{ __typename?: 'Permission', id: string, name: string, description: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null } } | null };

export type GetAllRelatedDataForRoleQueryVariables = Exact<{
  withPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForRoleQuery = { __typename?: 'Query', permissions?: { __typename?: 'PaginatedPermission', items?: Array<{ __typename?: 'Permission', id: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', items?: Array<{ __typename?: 'UserTenantRole', id: string, displayField: string }> | null } };

export type CreateRoleMutationVariables = Exact<{
  displayName: Scalars['String']['input'];
  description: Scalars['String']['input'];
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  userTenantRoles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateRoleMutation = { __typename?: 'Mutation', createRole: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, permissions?: { __typename?: 'PaginatedPermission', totalCount: number, items?: Array<{ __typename?: 'Permission', id: string, name: string, description: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null } } };

export type UpdateRoleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  userTenantRoles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateRoleMutation = { __typename?: 'Mutation', updateRole: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, permissions?: { __typename?: 'PaginatedPermission', totalCount: number, items?: Array<{ __typename?: 'Permission', id: string, name: string, description: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null } } };

export type DeleteRoleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteRoleMutation = { __typename?: 'Mutation', deleteRole: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, permissions?: { __typename?: 'PaginatedPermission', totalCount: number, items?: Array<{ __typename?: 'Permission', id: string, name: string, description: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null } } };

export type CreatedRoleSubscriptionVariables = Exact<{
  filter?: InputMaybe<RoleFilterArgs>;
  withPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedRoleSubscription = { __typename?: 'Subscription', createdRole: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, permissions?: { __typename?: 'PaginatedPermission', totalCount: number, items?: Array<{ __typename?: 'Permission', id: string, name: string, description: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null } } };

export type UpdatedRoleSubscriptionVariables = Exact<{
  filter?: InputMaybe<RoleFilterArgs>;
  withPermissions?: InputMaybe<Scalars['Boolean']['input']>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedRoleSubscription = { __typename?: 'Subscription', updatedRole: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, permissions?: { __typename?: 'PaginatedPermission', totalCount: number, items?: Array<{ __typename?: 'Permission', id: string, name: string, description: string, displayField: string }> | null }, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null } } };

export type DeletedRoleSubscriptionVariables = Exact<{
  filter?: InputMaybe<RoleFilterArgs>;
}>;


export type DeletedRoleSubscription = { __typename?: 'Subscription', deletedRole: { __typename?: 'Role', id: string } };

export type SearchFieldsFragment = { __typename?: 'Search', id: string, name: string, searchUrl?: string | null, order?: number | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, action?: { __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, personSearchProgresses?: { __typename?: 'PaginatedPersonSearchProgress', totalCount: number, items?: Array<{ __typename?: 'PersonSearchProgress', id: string, progress: string, done?: boolean | null, personId: string, searchId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } };

export type GetSearchesQueryVariables = Exact<{
  filter?: InputMaybe<SearchFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<SearchSortArgs> | SearchSortArgs>;
  withAction?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonSearchProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetSearchesQuery = { __typename?: 'Query', searches: { __typename?: 'PaginatedSearch', totalCount: number, items?: Array<{ __typename?: 'Search', id: string, name: string, searchUrl?: string | null, order?: number | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, action?: { __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, personSearchProgresses?: { __typename?: 'PaginatedPersonSearchProgress', totalCount: number, items?: Array<{ __typename?: 'PersonSearchProgress', id: string, progress: string, done?: boolean | null, personId: string, searchId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } }> | null } };

export type GetSearchQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withAction?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonSearchProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetSearchQuery = { __typename?: 'Query', search?: { __typename?: 'Search', id: string, name: string, searchUrl?: string | null, order?: number | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, action?: { __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, personSearchProgresses?: { __typename?: 'PaginatedPersonSearchProgress', totalCount: number, items?: Array<{ __typename?: 'PersonSearchProgress', id: string, progress: string, done?: boolean | null, personId: string, searchId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } | null };

export type GetAllRelatedDataForSearchQueryVariables = Exact<{
  withActions?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonSearchProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForSearchQuery = { __typename?: 'Query', actions?: { __typename?: 'PaginatedAction', items?: Array<{ __typename?: 'Action', id: string, displayField: string }> | null }, personSearchProgresses?: { __typename?: 'PaginatedPersonSearchProgress', items?: Array<{ __typename?: 'PersonSearchProgress', id: string, displayField: string }> | null } };

export type CreateSearchMutationVariables = Exact<{
  name: Scalars['String']['input'];
  searchUrl?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  actionId?: InputMaybe<Scalars['ID']['input']>;
  personSearchProgresses?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withAction?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonSearchProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateSearchMutation = { __typename?: 'Mutation', createSearch: { __typename?: 'Search', id: string, name: string, searchUrl?: string | null, order?: number | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, action?: { __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, personSearchProgresses?: { __typename?: 'PaginatedPersonSearchProgress', totalCount: number, items?: Array<{ __typename?: 'PersonSearchProgress', id: string, progress: string, done?: boolean | null, personId: string, searchId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type UpdateSearchMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  searchUrl?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  actionId?: InputMaybe<Scalars['ID']['input']>;
  personSearchProgresses?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withAction?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonSearchProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateSearchMutation = { __typename?: 'Mutation', updateSearch: { __typename?: 'Search', id: string, name: string, searchUrl?: string | null, order?: number | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, action?: { __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, personSearchProgresses?: { __typename?: 'PaginatedPersonSearchProgress', totalCount: number, items?: Array<{ __typename?: 'PersonSearchProgress', id: string, progress: string, done?: boolean | null, personId: string, searchId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type DeleteSearchMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withAction?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonSearchProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteSearchMutation = { __typename?: 'Mutation', deleteSearch: { __typename?: 'Search', id: string, name: string, searchUrl?: string | null, order?: number | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, action?: { __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, personSearchProgresses?: { __typename?: 'PaginatedPersonSearchProgress', totalCount: number, items?: Array<{ __typename?: 'PersonSearchProgress', id: string, progress: string, done?: boolean | null, personId: string, searchId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type CreatedSearchSubscriptionVariables = Exact<{
  filter?: InputMaybe<SearchFilterArgs>;
  withAction?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonSearchProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedSearchSubscription = { __typename?: 'Subscription', createdSearch: { __typename?: 'Search', id: string, name: string, searchUrl?: string | null, order?: number | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, action?: { __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, personSearchProgresses?: { __typename?: 'PaginatedPersonSearchProgress', totalCount: number, items?: Array<{ __typename?: 'PersonSearchProgress', id: string, progress: string, done?: boolean | null, personId: string, searchId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type UpdatedSearchSubscriptionVariables = Exact<{
  filter?: InputMaybe<SearchFilterArgs>;
  withAction?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonSearchProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedSearchSubscription = { __typename?: 'Subscription', updatedSearch: { __typename?: 'Search', id: string, name: string, searchUrl?: string | null, order?: number | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, action?: { __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, personSearchProgresses?: { __typename?: 'PaginatedPersonSearchProgress', totalCount: number, items?: Array<{ __typename?: 'PersonSearchProgress', id: string, progress: string, done?: boolean | null, personId: string, searchId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type DeletedSearchSubscriptionVariables = Exact<{
  filter?: InputMaybe<SearchFilterArgs>;
}>;


export type DeletedSearchSubscription = { __typename?: 'Subscription', deletedSearch: { __typename?: 'Search', id: string } };

export type RestoredSearchSubscriptionVariables = Exact<{
  filter?: InputMaybe<SearchFilterArgs>;
  withAction?: InputMaybe<Scalars['Boolean']['input']>;
  withPersonSearchProgresses?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RestoredSearchSubscription = { __typename?: 'Subscription', restoredSearch: { __typename?: 'Search', id: string, name: string, searchUrl?: string | null, order?: number | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, action?: { __typename?: 'Action', id: string, name: string, type: string, description: string, order?: number | null, registerId?: string | null, messageId?: string | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, displayField: string } | null, personSearchProgresses?: { __typename?: 'PaginatedPersonSearchProgress', totalCount: number, items?: Array<{ __typename?: 'PersonSearchProgress', id: string, progress: string, done?: boolean | null, personId: string, searchId: string, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type TenantFieldsFragment = { __typename?: 'Tenant', id: string, name: string, timeZone: string, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null }, uniqueRegistrations?: { __typename?: 'PaginatedUniqueRegistration', totalCount: number, items?: Array<{ __typename?: 'UniqueRegistration', id: string, active: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } };

export type GetTenantsQueryVariables = Exact<{
  filter?: InputMaybe<TenantFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<TenantSortArgs> | TenantSortArgs>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withUniqueRegistrations?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetTenantsQuery = { __typename?: 'Query', tenants: { __typename?: 'PaginatedTenant', totalCount: number, items?: Array<{ __typename?: 'Tenant', id: string, name: string, timeZone: string, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null }, uniqueRegistrations?: { __typename?: 'PaginatedUniqueRegistration', totalCount: number, items?: Array<{ __typename?: 'UniqueRegistration', id: string, active: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } }> | null } };

export type GetTenantQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withUniqueRegistrations?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetTenantQuery = { __typename?: 'Query', tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null }, uniqueRegistrations?: { __typename?: 'PaginatedUniqueRegistration', totalCount: number, items?: Array<{ __typename?: 'UniqueRegistration', id: string, active: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } | null };

export type GetAllRelatedDataForTenantQueryVariables = Exact<{
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withUniqueRegistrations?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForTenantQuery = { __typename?: 'Query', userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', items?: Array<{ __typename?: 'UserTenantRole', id: string, displayField: string }> | null }, uniqueRegistrations?: { __typename?: 'PaginatedUniqueRegistration', items?: Array<{ __typename?: 'UniqueRegistration', id: string, displayField: string }> | null } };

export type CreateTenantMutationVariables = Exact<{
  name: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
  userTenantRoles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  uniqueRegistrations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withUniqueRegistrations?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateTenantMutation = { __typename?: 'Mutation', createTenant: { __typename?: 'Tenant', id: string, name: string, timeZone: string, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null }, uniqueRegistrations?: { __typename?: 'PaginatedUniqueRegistration', totalCount: number, items?: Array<{ __typename?: 'UniqueRegistration', id: string, active: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type UpdateTenantMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  userTenantRoles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  uniqueRegistrations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withUniqueRegistrations?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateTenantMutation = { __typename?: 'Mutation', updateTenant: { __typename?: 'Tenant', id: string, name: string, timeZone: string, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null }, uniqueRegistrations?: { __typename?: 'PaginatedUniqueRegistration', totalCount: number, items?: Array<{ __typename?: 'UniqueRegistration', id: string, active: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type DeleteTenantMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withUniqueRegistrations?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteTenantMutation = { __typename?: 'Mutation', deleteTenant: { __typename?: 'Tenant', id: string, name: string, timeZone: string, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null }, uniqueRegistrations?: { __typename?: 'PaginatedUniqueRegistration', totalCount: number, items?: Array<{ __typename?: 'UniqueRegistration', id: string, active: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type CreatedTenantSubscriptionVariables = Exact<{
  filter?: InputMaybe<TenantFilterArgs>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withUniqueRegistrations?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedTenantSubscription = { __typename?: 'Subscription', createdTenant: { __typename?: 'Tenant', id: string, name: string, timeZone: string, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null }, uniqueRegistrations?: { __typename?: 'PaginatedUniqueRegistration', totalCount: number, items?: Array<{ __typename?: 'UniqueRegistration', id: string, active: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type UpdatedTenantSubscriptionVariables = Exact<{
  filter?: InputMaybe<TenantFilterArgs>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withUniqueRegistrations?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedTenantSubscription = { __typename?: 'Subscription', updatedTenant: { __typename?: 'Tenant', id: string, name: string, timeZone: string, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null }, uniqueRegistrations?: { __typename?: 'PaginatedUniqueRegistration', totalCount: number, items?: Array<{ __typename?: 'UniqueRegistration', id: string, active: boolean, tenantId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type DeletedTenantSubscriptionVariables = Exact<{
  filter?: InputMaybe<TenantFilterArgs>;
}>;


export type DeletedTenantSubscription = { __typename?: 'Subscription', deletedTenant: { __typename?: 'Tenant', id: string } };

export type UniqueRegistrationFieldsFragment = { __typename?: 'UniqueRegistration', id: string, active: boolean, createdAt?: any | null, updatedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, displayField: string } | null };

export type GetUniqueRegistrationsQueryVariables = Exact<{
  filter?: InputMaybe<UniqueRegistrationFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UniqueRegistrationSortArgs> | UniqueRegistrationSortArgs>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetUniqueRegistrationsQuery = { __typename?: 'Query', uniqueRegistrations: { __typename?: 'PaginatedUniqueRegistration', totalCount: number, items?: Array<{ __typename?: 'UniqueRegistration', id: string, active: boolean, createdAt?: any | null, updatedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, displayField: string } | null }> | null } };

export type GetUniqueRegistrationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetUniqueRegistrationQuery = { __typename?: 'Query', uniqueRegistration?: { __typename?: 'UniqueRegistration', id: string, active: boolean, createdAt?: any | null, updatedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, displayField: string } | null } | null };

export type GetAllRelatedDataForUniqueRegistrationQueryVariables = Exact<{
  withTenants?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForUniqueRegistrationQuery = { __typename?: 'Query', tenants?: { __typename?: 'PaginatedTenant', items?: Array<{ __typename?: 'Tenant', id: string, displayField: string }> | null } };

export type CreateUniqueRegistrationMutationVariables = Exact<{
  active: Scalars['Boolean']['input'];
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateUniqueRegistrationMutation = { __typename?: 'Mutation', createUniqueRegistration: { __typename?: 'UniqueRegistration', id: string, active: boolean, createdAt?: any | null, updatedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, displayField: string } | null } };

export type UpdateUniqueRegistrationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateUniqueRegistrationMutation = { __typename?: 'Mutation', updateUniqueRegistration: { __typename?: 'UniqueRegistration', id: string, active: boolean, createdAt?: any | null, updatedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, displayField: string } | null } };

export type DeleteUniqueRegistrationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteUniqueRegistrationMutation = { __typename?: 'Mutation', deleteUniqueRegistration: { __typename?: 'UniqueRegistration', id: string, active: boolean, createdAt?: any | null, updatedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, displayField: string } | null } };

export type CreatedUniqueRegistrationSubscriptionVariables = Exact<{
  filter?: InputMaybe<UniqueRegistrationFilterArgs>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedUniqueRegistrationSubscription = { __typename?: 'Subscription', createdUniqueRegistration: { __typename?: 'UniqueRegistration', id: string, active: boolean, createdAt?: any | null, updatedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, displayField: string } | null } };

export type UpdatedUniqueRegistrationSubscriptionVariables = Exact<{
  filter?: InputMaybe<UniqueRegistrationFilterArgs>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedUniqueRegistrationSubscription = { __typename?: 'Subscription', updatedUniqueRegistration: { __typename?: 'UniqueRegistration', id: string, active: boolean, createdAt?: any | null, updatedAt?: any | null, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, displayField: string } | null } };

export type DeletedUniqueRegistrationSubscriptionVariables = Exact<{
  filter?: InputMaybe<UniqueRegistrationFilterArgs>;
}>;


export type DeletedUniqueRegistrationSubscription = { __typename?: 'Subscription', deletedUniqueRegistration: { __typename?: 'UniqueRegistration', id: string } };

export type UserFieldsFragment = { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null }, people?: { __typename?: 'PaginatedPerson', totalCount: number, items?: Array<{ __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, reminders?: { __typename?: 'PaginatedReminder', totalCount: number, items?: Array<{ __typename?: 'Reminder', id: string, userId: string, mailTemplateId: string, date: any, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } };

export type GetUsersQueryVariables = Exact<{
  filter?: InputMaybe<UserFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserSortArgs> | UserSortArgs>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withPeople?: InputMaybe<Scalars['Boolean']['input']>;
  withReminders?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetUsersQuery = { __typename?: 'Query', users: { __typename?: 'PaginatedUser', totalCount: number, items?: Array<{ __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null }, people?: { __typename?: 'PaginatedPerson', totalCount: number, items?: Array<{ __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, reminders?: { __typename?: 'PaginatedReminder', totalCount: number, items?: Array<{ __typename?: 'Reminder', id: string, userId: string, mailTemplateId: string, date: any, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } }> | null } };

export type GetUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withPeople?: InputMaybe<Scalars['Boolean']['input']>;
  withReminders?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null }, people?: { __typename?: 'PaginatedPerson', totalCount: number, items?: Array<{ __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, reminders?: { __typename?: 'PaginatedReminder', totalCount: number, items?: Array<{ __typename?: 'Reminder', id: string, userId: string, mailTemplateId: string, date: any, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } | null };

export type GetAllRelatedDataForUserQueryVariables = Exact<{
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withPeople?: InputMaybe<Scalars['Boolean']['input']>;
  withReminders?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForUserQuery = { __typename?: 'Query', userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', items?: Array<{ __typename?: 'UserTenantRole', id: string, displayField: string }> | null }, people?: { __typename?: 'PaginatedPerson', items?: Array<{ __typename?: 'Person', id: string, displayField: string }> | null }, reminders?: { __typename?: 'PaginatedReminder', items?: Array<{ __typename?: 'Reminder', id: string, displayField: string }> | null } };

export type CreateUserMutationVariables = Exact<{
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  active: Scalars['Boolean']['input'];
  avatar?: InputMaybe<Scalars['String']['input']>;
  termsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  locale: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
  progress?: InputMaybe<Scalars['Int']['input']>;
  userTenantRoles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  people?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  reminders?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withPeople?: InputMaybe<Scalars['Boolean']['input']>;
  withReminders?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null }, people?: { __typename?: 'PaginatedPerson', totalCount: number, items?: Array<{ __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, reminders?: { __typename?: 'PaginatedReminder', totalCount: number, items?: Array<{ __typename?: 'Reminder', id: string, userId: string, mailTemplateId: string, date: any, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  termsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  userTenantRoles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  people?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  reminders?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withPeople?: InputMaybe<Scalars['Boolean']['input']>;
  withReminders?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null }, people?: { __typename?: 'PaginatedPerson', totalCount: number, items?: Array<{ __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, reminders?: { __typename?: 'PaginatedReminder', totalCount: number, items?: Array<{ __typename?: 'Reminder', id: string, userId: string, mailTemplateId: string, date: any, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withPeople?: InputMaybe<Scalars['Boolean']['input']>;
  withReminders?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null }, people?: { __typename?: 'PaginatedPerson', totalCount: number, items?: Array<{ __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, reminders?: { __typename?: 'PaginatedReminder', totalCount: number, items?: Array<{ __typename?: 'Reminder', id: string, userId: string, mailTemplateId: string, date: any, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type CreatedUserSubscriptionVariables = Exact<{
  filter?: InputMaybe<UserFilterArgs>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withPeople?: InputMaybe<Scalars['Boolean']['input']>;
  withReminders?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedUserSubscription = { __typename?: 'Subscription', createdUser: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null }, people?: { __typename?: 'PaginatedPerson', totalCount: number, items?: Array<{ __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, reminders?: { __typename?: 'PaginatedReminder', totalCount: number, items?: Array<{ __typename?: 'Reminder', id: string, userId: string, mailTemplateId: string, date: any, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type UpdatedUserSubscriptionVariables = Exact<{
  filter?: InputMaybe<UserFilterArgs>;
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withPeople?: InputMaybe<Scalars['Boolean']['input']>;
  withReminders?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedUserSubscription = { __typename?: 'Subscription', updatedUser: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null }, people?: { __typename?: 'PaginatedPerson', totalCount: number, items?: Array<{ __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, reminders?: { __typename?: 'PaginatedReminder', totalCount: number, items?: Array<{ __typename?: 'Reminder', id: string, userId: string, mailTemplateId: string, date: any, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type DeletedUserSubscriptionVariables = Exact<{
  filter?: InputMaybe<UserFilterArgs>;
}>;


export type DeletedUserSubscription = { __typename?: 'Subscription', deletedUser: { __typename?: 'User', id: string } };

export type UserTenantRoleFieldsFragment = { __typename?: 'UserTenantRole', id: string, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, displayField: string }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, displayField: string }, role?: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string } };

export type GetUserTenantRolesQueryVariables = Exact<{
  filter?: InputMaybe<UserTenantRoleFilterArgs>;
  paging?: InputMaybe<PageArgs>;
  sorting?: InputMaybe<Array<UserTenantRoleSortArgs> | UserTenantRoleSortArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withRole?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetUserTenantRolesQuery = { __typename?: 'Query', userTenantRoles: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, displayField: string }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, displayField: string }, role?: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string } }> | null } };

export type GetUserTenantRoleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withRole?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetUserTenantRoleQuery = { __typename?: 'Query', userTenantRole?: { __typename?: 'UserTenantRole', id: string, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, displayField: string }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, displayField: string }, role?: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string } } | null };

export type GetAllRelatedDataForUserTenantRoleQueryVariables = Exact<{
  withUsers?: InputMaybe<Scalars['Boolean']['input']>;
  withTenants?: InputMaybe<Scalars['Boolean']['input']>;
  withRoles?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllRelatedDataForUserTenantRoleQuery = { __typename?: 'Query', users?: { __typename?: 'PaginatedUser', items?: Array<{ __typename?: 'User', id: string, displayField: string }> | null }, tenants?: { __typename?: 'PaginatedTenant', items?: Array<{ __typename?: 'Tenant', id: string, displayField: string }> | null }, roles?: { __typename?: 'PaginatedRole', items?: Array<{ __typename?: 'Role', id: string, displayField: string }> | null } };

export type CreateUserTenantRoleMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withRole?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateUserTenantRoleMutation = { __typename?: 'Mutation', createUserTenantRole: { __typename?: 'UserTenantRole', id: string, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, displayField: string }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, displayField: string }, role?: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string } } };

export type UpdateUserTenantRoleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  roleId?: InputMaybe<Scalars['ID']['input']>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withRole?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateUserTenantRoleMutation = { __typename?: 'Mutation', updateUserTenantRole: { __typename?: 'UserTenantRole', id: string, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, displayField: string }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, displayField: string }, role?: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string } } };

export type DeleteUserTenantRoleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withRole?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteUserTenantRoleMutation = { __typename?: 'Mutation', deleteUserTenantRole: { __typename?: 'UserTenantRole', id: string, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, displayField: string }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, displayField: string }, role?: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string } } };

export type CreatedUserTenantRoleSubscriptionVariables = Exact<{
  filter?: InputMaybe<UserTenantRoleFilterArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withRole?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatedUserTenantRoleSubscription = { __typename?: 'Subscription', createdUserTenantRole: { __typename?: 'UserTenantRole', id: string, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, displayField: string }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, displayField: string }, role?: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string } } };

export type UpdatedUserTenantRoleSubscriptionVariables = Exact<{
  filter?: InputMaybe<UserTenantRoleFilterArgs>;
  withUser?: InputMaybe<Scalars['Boolean']['input']>;
  withTenant?: InputMaybe<Scalars['Boolean']['input']>;
  withRole?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatedUserTenantRoleSubscription = { __typename?: 'Subscription', updatedUserTenantRole: { __typename?: 'UserTenantRole', id: string, user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, displayField: string }, tenant?: { __typename?: 'Tenant', id: string, name: string, timeZone: string, displayField: string }, role?: { __typename?: 'Role', id: string, machineName: string, displayName: string, description: string, displayField: string } } };

export type DeletedUserTenantRoleSubscriptionVariables = Exact<{
  filter?: InputMaybe<UserTenantRoleFilterArgs>;
}>;


export type DeletedUserTenantRoleSubscription = { __typename?: 'Subscription', deletedUserTenantRole: { __typename?: 'UserTenantRole', id: string } };

export type GetFullUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetFullUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, createdAt?: any | null, updatedAt?: any | null, userTenantRoles: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string, role: { __typename?: 'Role', id: string, machineName: string, displayField: string }, tenant: { __typename?: 'Tenant', id: string, name: string, displayField: string } }> | null } } | null };

export type CreateUserWithTenantRoleMutationVariables = Exact<{
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  active: Scalars['Boolean']['input'];
  avatar?: InputMaybe<Scalars['String']['input']>;
  termsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  userTenantRoles?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  invite?: InputMaybe<Scalars['Boolean']['input']>;
  locale: Scalars['String']['input'];
  timeZone: Scalars['String']['input'];
  withUserTenantRoles?: InputMaybe<Scalars['Boolean']['input']>;
  withPeople?: InputMaybe<Scalars['Boolean']['input']>;
  withReminders?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateUserWithTenantRoleMutation = { __typename?: 'Mutation', createUser: { __typename?: 'User', id: string, name: string, email: string, emailVerifiedAt?: any | null, active: boolean, avatar?: string | null, totpVerified?: boolean | null, termsAndConditions?: boolean | null, locale: string, timeZone: string, createdAt?: any | null, updatedAt?: any | null, passwordSalt?: string | null, encryptedSecret?: string | null, progress?: number | null, userTenantRoles?: { __typename?: 'PaginatedUserTenantRole', totalCount: number, items?: Array<{ __typename?: 'UserTenantRole', id: string, userId: string, tenantId: string, roleId: string, displayField: string }> | null }, people?: { __typename?: 'PaginatedPerson', totalCount: number, items?: Array<{ __typename?: 'Person', id: string, firstNames: string, prefix?: string | null, lastName: string, address: string, addressNumber: string, city: string, postalCode: string, progress?: number | null, userId?: string | null, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null }, reminders?: { __typename?: 'PaginatedReminder', totalCount: number, items?: Array<{ __typename?: 'Reminder', id: string, userId: string, mailTemplateId: string, date: any, createdAt?: any | null, updatedAt?: any | null, displayField: string }> | null } } };

export type CreateContentWithFillMutationVariables = Exact<{
  name: Scalars['String']['input'];
  fill: Scalars['String']['input'];
  language: Scalars['String']['input'];
}>;


export type CreateContentWithFillMutation = { __typename?: 'Mutation', createContentWithFill: boolean };

export type UpdateContentWithFillMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  fill: Scalars['String']['input'];
  language: Scalars['String']['input'];
}>;


export type UpdateContentWithFillMutation = { __typename?: 'Mutation', updateContentWithFill: boolean };

export type GetPersonOrganizationsQueryVariables = Exact<{
  personId: Scalars['String']['input'];
}>;


export type GetPersonOrganizationsQuery = { __typename?: 'Query', organizations: { __typename?: 'PaginatedOrganization', items?: Array<{ __typename?: 'Organization', id: string, name: string, registrationNumber: string, personId: string }> | null } };

export type DeleteOrganizationsDataMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteOrganizationsDataMutation = { __typename?: 'Mutation', deleteManyOrganizations: Array<{ __typename?: 'Organization', id: string }> };

export type PersonRegisterProgressQueryFragment = { __typename?: 'PersonRegisterProgress', id: string, progress: string, done?: boolean | null, foundAt?: any | null, actionDoneAt?: any | null, createdAt?: any | null };

export type GetPersonRegisterProgressDataQueryVariables = Exact<{
  personId: Scalars['String']['input'];
  registerId: Scalars['String']['input'];
}>;


export type GetPersonRegisterProgressDataQuery = { __typename?: 'Query', personRegisterProgresses: { __typename?: 'PaginatedPersonRegisterProgress', items?: Array<{ __typename?: 'PersonRegisterProgress', id: string, progress: string, done?: boolean | null, foundAt?: any | null, actionDoneAt?: any | null, createdAt?: any | null }> | null } };

export type UpdatePersonSearchProgressionMutationVariables = Exact<{
  searchId: Scalars['String']['input'];
  personId: Scalars['String']['input'];
  registerId: Scalars['String']['input'];
  progress: Scalars['String']['input'];
}>;


export type UpdatePersonSearchProgressionMutation = { __typename?: 'Mutation', updateOrCreatePersonSearchProgressProgression: { __typename?: 'PersonRegisterProgress', id: string, progress: string, done?: boolean | null, foundAt?: any | null, actionDoneAt?: any | null, createdAt?: any | null } };

export type UpdatePersonActionProgressionMutationVariables = Exact<{
  actionId: Scalars['String']['input'];
  personId: Scalars['String']['input'];
  registerId: Scalars['String']['input'];
  progress: Scalars['String']['input'];
}>;


export type UpdatePersonActionProgressionMutation = { __typename?: 'Mutation', updateOrCreatePersonActionProgressProgression: { __typename?: 'PersonRegisterProgress', id: string, progress: string, done?: boolean | null, foundAt?: any | null, actionDoneAt?: any | null, createdAt?: any | null } };

export type GetRegistersDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRegistersDataQuery = { __typename?: 'Query', registers: { __typename?: 'PaginatedRegister', items?: Array<{ __typename: 'Register', id: string, email?: string | null, type: string, companyRegister: boolean, name: string, subtitle?: string | null, description?: string | null, siteUrl?: string | null, contactUrl?: string | null, order?: number | null, logo?: string | null, actions: { __typename?: 'PaginatedAction', items?: Array<{ __typename: 'Action', id: string, name: string, description: string, order?: number | null, type: string, message?: { __typename: 'Message', id: string, title: string, content: string } | null, searches: { __typename?: 'PaginatedSearch', items?: Array<{ __typename: 'Search', id: string, name: string, order?: number | null, searchUrl?: string | null }> | null } }> | null } }> | null } };

export const ActionFieldsFragmentDoc = gql`
    fragment actionFields on Action {
  id
  name
  type
  description
  order
  register @include(if: $withRegister) {
    id
    email
    type
    companyRegister
    order
    name
    machineName
    description
    subtitle
    contactUrl
    siteUrl
    logo
    sourceId
    createdAt
    updatedAt
    deletedAt
    displayField: name
  }
  searches @include(if: $withSearches) {
    items {
      id
      name
      searchUrl
      order
      actionId
      createdAt
      updatedAt
      deletedAt
      displayField: name
    }
    totalCount
  }
  message @include(if: $withMessage) {
    id
    title
    content
    createdAt
    updatedAt
    deletedAt
    displayField: title
  }
  personActionProgresses @include(if: $withPersonActionProgresses) {
    items {
      id
      progress
      done
      personId
      actionId
      createdAt
      updatedAt
      displayField: id
    }
    totalCount
  }
  createdAt
  updatedAt
  deletedAt
}
    `;
export const ContentFieldsFragmentDoc = gql`
    fragment contentFields on Content {
  id
  name
  contentFills @include(if: $withContentFills) {
    items {
      id
      fill
      language
      contentId
      displayField: id
    }
    totalCount
  }
}
    `;
export const ContentFillFieldsFragmentDoc = gql`
    fragment contentFillFields on ContentFill {
  id
  fill
  language
  content @include(if: $withContent) {
    id
    name
    displayField: name
  }
}
    `;
export const ErrorLogFieldsFragmentDoc = gql`
    fragment errorLogFields on ErrorLog {
  id
  error
  stack
  domain
  createdAt
  updatedAt
  deletedAt
}
    `;
export const EventLogFieldsFragmentDoc = gql`
    fragment eventLogFields on EventLog {
  id
  log
  type
  createdAt
  updatedAt
  deletedAt
}
    `;
export const JobFieldsFragmentDoc = gql`
    fragment jobFields on Job {
  id
  queue
  status
  log
  createdAt
  updatedAt
  deletedAt
}
    `;
export const MailLogFieldsFragmentDoc = gql`
    fragment mailLogFields on MailLog {
  id
  sentTo
  sentBy
  emailTemplate
  status
  message
  reason
  createdAt
  updatedAt
  deletedAt
}
    `;
export const MailTemplateFieldsFragmentDoc = gql`
    fragment mailTemplateFields on MailTemplate {
  id
  active
  mailTemplateFills @include(if: $withMailTemplateFills) {
    items {
      id
      subject
      urlText
      title
      heading
      preHeader
      disclaimer
      text
      plainText
      language
      mailTemplateId
      displayField: title
    }
    totalCount
  }
  reminder @include(if: $withReminder) {
    id
    userId
    mailTemplateId
    date
    createdAt
    updatedAt
    displayField: id
  }
}
    `;
export const MailTemplateFillFieldsFragmentDoc = gql`
    fragment mailTemplateFillFields on MailTemplateFill {
  id
  subject
  urlText
  title
  heading
  preHeader
  disclaimer
  text
  plainText
  language
  mailTemplate @include(if: $withMailTemplate) {
    id
    active
    displayField: id
  }
}
    `;
export const MessageFieldsFragmentDoc = gql`
    fragment messageFields on Message {
  id
  title
  content
  actions @include(if: $withActions) {
    items {
      id
      name
      type
      description
      order
      registerId
      messageId
      createdAt
      updatedAt
      deletedAt
      displayField: name
    }
    totalCount
  }
  createdAt
  updatedAt
  deletedAt
}
    `;
export const OrganizationFieldsFragmentDoc = gql`
    fragment organizationFields on Organization {
  id
  person @include(if: $withPerson) {
    id
    firstNames
    prefix
    lastName
    address
    addressNumber
    city
    postalCode
    progress
    userId
    createdAt
    updatedAt
    displayField: id
  }
  name
  registrationNumber
  createdAt
  updatedAt
}
    `;
export const PermissionFieldsFragmentDoc = gql`
    fragment permissionFields on Permission {
  id
  name
  description
  roles @include(if: $withRoles) {
    items {
      id
      machineName
      displayName
      description
      displayField: displayName
    }
    totalCount
  }
}
    `;
export const PersonFieldsFragmentDoc = gql`
    fragment personFields on Person {
  id
  firstNames
  prefix
  lastName
  address
  addressNumber
  city
  postalCode
  progress
  user @include(if: $withUser) {
    id
    name
    email
    emailVerifiedAt
    active
    avatar
    totpVerified
    termsAndConditions
    locale
    timeZone
    createdAt
    updatedAt
    passwordSalt
    encryptedSecret
    progress
    displayField: name
  }
  organizations @include(if: $withOrganizations) {
    items {
      id
      personId
      name
      registrationNumber
      createdAt
      updatedAt
      displayField: name
    }
    totalCount
  }
  personActionProgresses @include(if: $withPersonActionProgresses) {
    items {
      id
      progress
      done
      personId
      actionId
      createdAt
      updatedAt
      displayField: id
    }
    totalCount
  }
  personRegisterProgresses @include(if: $withPersonRegisterProgresses) {
    items {
      id
      progress
      done
      foundAt
      actionDoneAt
      personId
      registerId
      createdAt
      updatedAt
      displayField: id
    }
    totalCount
  }
  personSearchProgresses @include(if: $withPersonSearchProgresses) {
    items {
      id
      progress
      done
      personId
      searchId
      createdAt
      updatedAt
      displayField: id
    }
    totalCount
  }
  createdAt
  updatedAt
}
    `;
export const PersonActionProgressFieldsFragmentDoc = gql`
    fragment personActionProgressFields on PersonActionProgress {
  id
  progress
  done
  person @include(if: $withPerson) {
    id
    firstNames
    prefix
    lastName
    address
    addressNumber
    city
    postalCode
    progress
    userId
    createdAt
    updatedAt
    displayField: id
  }
  action @include(if: $withAction) {
    id
    name
    type
    description
    order
    registerId
    messageId
    createdAt
    updatedAt
    deletedAt
    displayField: name
  }
  createdAt
  updatedAt
}
    `;
export const PersonRegisterProgressFieldsFragmentDoc = gql`
    fragment personRegisterProgressFields on PersonRegisterProgress {
  id
  progress
  done
  foundAt
  actionDoneAt
  person @include(if: $withPerson) {
    id
    firstNames
    prefix
    lastName
    address
    addressNumber
    city
    postalCode
    progress
    userId
    createdAt
    updatedAt
    displayField: id
  }
  register @include(if: $withRegister) {
    id
    email
    type
    companyRegister
    order
    name
    machineName
    description
    subtitle
    contactUrl
    siteUrl
    logo
    sourceId
    createdAt
    updatedAt
    deletedAt
    displayField: name
  }
  createdAt
  updatedAt
}
    `;
export const PersonSearchProgressFieldsFragmentDoc = gql`
    fragment personSearchProgressFields on PersonSearchProgress {
  id
  progress
  done
  person @include(if: $withPerson) {
    id
    firstNames
    prefix
    lastName
    address
    addressNumber
    city
    postalCode
    progress
    userId
    createdAt
    updatedAt
    displayField: id
  }
  search @include(if: $withSearch) {
    id
    name
    searchUrl
    order
    actionId
    createdAt
    updatedAt
    deletedAt
    displayField: name
  }
  createdAt
  updatedAt
}
    `;
export const RegisterFieldsFragmentDoc = gql`
    fragment registerFields on Register {
  id
  email
  type
  companyRegister
  order
  name
  machineName
  description
  subtitle
  contactUrl
  siteUrl
  logo
  derivatives @include(if: $withDerivatives) {
    items {
      id
      email
      type
      companyRegister
      order
      name
      machineName
      description
      subtitle
      contactUrl
      siteUrl
      logo
      sourceId
      createdAt
      updatedAt
      deletedAt
      displayField: name
    }
    totalCount
  }
  source @include(if: $withSource) {
    id
    email
    type
    companyRegister
    order
    name
    machineName
    description
    subtitle
    contactUrl
    siteUrl
    logo
    sourceId
    createdAt
    updatedAt
    deletedAt
    displayField: name
  }
  actions @include(if: $withActions) {
    items {
      id
      name
      type
      description
      order
      registerId
      messageId
      createdAt
      updatedAt
      deletedAt
      displayField: name
    }
    totalCount
  }
  personRegisterProgresses @include(if: $withPersonRegisterProgresses) {
    items {
      id
      progress
      done
      foundAt
      actionDoneAt
      personId
      registerId
      createdAt
      updatedAt
      displayField: id
    }
    totalCount
  }
  createdAt
  updatedAt
  deletedAt
}
    `;
export const ReminderFieldsFragmentDoc = gql`
    fragment reminderFields on Reminder {
  id
  user @include(if: $withUser) {
    id
    name
    email
    emailVerifiedAt
    active
    avatar
    totpVerified
    termsAndConditions
    locale
    timeZone
    createdAt
    updatedAt
    passwordSalt
    encryptedSecret
    progress
    displayField: name
  }
  mailTemplate @include(if: $withMailTemplate) {
    id
    active
    displayField: id
  }
  date
  createdAt
  updatedAt
}
    `;
export const ResetPasswordFieldsFragmentDoc = gql`
    fragment resetPasswordFields on ResetPassword {
  id
  email
  token
  type
  createdAt
  updatedAt
}
    `;
export const RoleFieldsFragmentDoc = gql`
    fragment roleFields on Role {
  id
  machineName
  displayName
  description
  permissions @include(if: $withPermissions) {
    items {
      id
      name
      description
      displayField: name
    }
    totalCount
  }
  userTenantRoles @include(if: $withUserTenantRoles) {
    items {
      id
      userId
      tenantId
      roleId
      displayField: id
    }
    totalCount
  }
}
    `;
export const SearchFieldsFragmentDoc = gql`
    fragment searchFields on Search {
  id
  name
  searchUrl
  order
  action @include(if: $withAction) {
    id
    name
    type
    description
    order
    registerId
    messageId
    createdAt
    updatedAt
    deletedAt
    displayField: name
  }
  personSearchProgresses @include(if: $withPersonSearchProgresses) {
    items {
      id
      progress
      done
      personId
      searchId
      createdAt
      updatedAt
      displayField: id
    }
    totalCount
  }
  createdAt
  updatedAt
  deletedAt
}
    `;
export const TenantFieldsFragmentDoc = gql`
    fragment tenantFields on Tenant {
  id
  name
  timeZone
  userTenantRoles @include(if: $withUserTenantRoles) {
    items {
      id
      userId
      tenantId
      roleId
      displayField: id
    }
    totalCount
  }
  uniqueRegistrations @include(if: $withUniqueRegistrations) {
    items {
      id
      active
      tenantId
      createdAt
      updatedAt
      displayField: id
    }
    totalCount
  }
}
    `;
export const UniqueRegistrationFieldsFragmentDoc = gql`
    fragment uniqueRegistrationFields on UniqueRegistration {
  id
  active
  tenant @include(if: $withTenant) {
    id
    name
    timeZone
    displayField: name
  }
  createdAt
  updatedAt
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment userFields on User {
  id
  name
  email
  emailVerifiedAt
  active
  avatar
  totpVerified
  termsAndConditions
  locale
  timeZone
  userTenantRoles @include(if: $withUserTenantRoles) {
    items {
      id
      userId
      tenantId
      roleId
      displayField: id
    }
    totalCount
  }
  createdAt
  updatedAt
  passwordSalt
  encryptedSecret
  progress
  people @include(if: $withPeople) {
    items {
      id
      firstNames
      prefix
      lastName
      address
      addressNumber
      city
      postalCode
      progress
      userId
      createdAt
      updatedAt
      displayField: id
    }
    totalCount
  }
  reminders @include(if: $withReminders) {
    items {
      id
      userId
      mailTemplateId
      date
      createdAt
      updatedAt
      displayField: id
    }
    totalCount
  }
}
    `;
export const UserTenantRoleFieldsFragmentDoc = gql`
    fragment userTenantRoleFields on UserTenantRole {
  id
  user @include(if: $withUser) {
    id
    name
    email
    emailVerifiedAt
    active
    avatar
    totpVerified
    termsAndConditions
    locale
    timeZone
    createdAt
    updatedAt
    passwordSalt
    encryptedSecret
    progress
    displayField: name
  }
  tenant @include(if: $withTenant) {
    id
    name
    timeZone
    displayField: name
  }
  role @include(if: $withRole) {
    id
    machineName
    displayName
    description
    displayField: displayName
  }
}
    `;
export const PersonRegisterProgressQueryFragmentDoc = gql`
    fragment personRegisterProgressQuery on PersonRegisterProgress {
  id
  progress
  done
  foundAt
  actionDoneAt
  createdAt
}
    `;
export const GetActionsDocument = gql`
    query GetActions($filter: ActionFilterArgs, $paging: PageArgs, $sorting: [ActionSortArgs!], $withRegister: Boolean = false, $withSearches: Boolean = false, $withMessage: Boolean = false, $withPersonActionProgresses: Boolean = false) {
  actions(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...actionFields
    }
    totalCount
  }
}
    ${ActionFieldsFragmentDoc}`;

/**
 * __useGetActionsQuery__
 *
 * To run a query within a React component, call `useGetActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withRegister: // value for 'withRegister'
 *      withSearches: // value for 'withSearches'
 *      withMessage: // value for 'withMessage'
 *      withPersonActionProgresses: // value for 'withPersonActionProgresses'
 *   },
 * });
 */
export function useGetActionsQuery(baseOptions?: Apollo.QueryHookOptions<GetActionsQuery, GetActionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActionsQuery, GetActionsQueryVariables>(GetActionsDocument, options);
      }
export function useGetActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActionsQuery, GetActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActionsQuery, GetActionsQueryVariables>(GetActionsDocument, options);
        }
export function useGetActionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActionsQuery, GetActionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActionsQuery, GetActionsQueryVariables>(GetActionsDocument, options);
        }
export type GetActionsQueryHookResult = ReturnType<typeof useGetActionsQuery>;
export type GetActionsLazyQueryHookResult = ReturnType<typeof useGetActionsLazyQuery>;
export type GetActionsSuspenseQueryHookResult = ReturnType<typeof useGetActionsSuspenseQuery>;
export type GetActionsQueryResult = Apollo.QueryResult<GetActionsQuery, GetActionsQueryVariables>;
export const GetActionDocument = gql`
    query GetAction($id: ID!, $withRegister: Boolean = false, $withSearches: Boolean = false, $withMessage: Boolean = false, $withPersonActionProgresses: Boolean = false) {
  action(id: $id) {
    ...actionFields
  }
}
    ${ActionFieldsFragmentDoc}`;

/**
 * __useGetActionQuery__
 *
 * To run a query within a React component, call `useGetActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withRegister: // value for 'withRegister'
 *      withSearches: // value for 'withSearches'
 *      withMessage: // value for 'withMessage'
 *      withPersonActionProgresses: // value for 'withPersonActionProgresses'
 *   },
 * });
 */
export function useGetActionQuery(baseOptions: Apollo.QueryHookOptions<GetActionQuery, GetActionQueryVariables> & ({ variables: GetActionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActionQuery, GetActionQueryVariables>(GetActionDocument, options);
      }
export function useGetActionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActionQuery, GetActionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActionQuery, GetActionQueryVariables>(GetActionDocument, options);
        }
export function useGetActionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActionQuery, GetActionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActionQuery, GetActionQueryVariables>(GetActionDocument, options);
        }
export type GetActionQueryHookResult = ReturnType<typeof useGetActionQuery>;
export type GetActionLazyQueryHookResult = ReturnType<typeof useGetActionLazyQuery>;
export type GetActionSuspenseQueryHookResult = ReturnType<typeof useGetActionSuspenseQuery>;
export type GetActionQueryResult = Apollo.QueryResult<GetActionQuery, GetActionQueryVariables>;
export const GetAllRelatedDataForActionDocument = gql`
    query GetAllRelatedDataForAction($withRegisters: Boolean = false, $withSearches: Boolean = false, $withMessages: Boolean = false, $withPersonActionProgresses: Boolean = false) {
  registers @include(if: $withRegisters) {
    items {
      id
      displayField: name
    }
  }
  searches @include(if: $withSearches) {
    items {
      id
      displayField: name
    }
  }
  messages @include(if: $withMessages) {
    items {
      id
      displayField: title
    }
  }
  personActionProgresses @include(if: $withPersonActionProgresses) {
    items {
      id
      displayField: id
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForActionQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForActionQuery({
 *   variables: {
 *      withRegisters: // value for 'withRegisters'
 *      withSearches: // value for 'withSearches'
 *      withMessages: // value for 'withMessages'
 *      withPersonActionProgresses: // value for 'withPersonActionProgresses'
 *   },
 * });
 */
export function useGetAllRelatedDataForActionQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForActionQuery, GetAllRelatedDataForActionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForActionQuery, GetAllRelatedDataForActionQueryVariables>(GetAllRelatedDataForActionDocument, options);
      }
export function useGetAllRelatedDataForActionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForActionQuery, GetAllRelatedDataForActionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForActionQuery, GetAllRelatedDataForActionQueryVariables>(GetAllRelatedDataForActionDocument, options);
        }
export function useGetAllRelatedDataForActionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForActionQuery, GetAllRelatedDataForActionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForActionQuery, GetAllRelatedDataForActionQueryVariables>(GetAllRelatedDataForActionDocument, options);
        }
export type GetAllRelatedDataForActionQueryHookResult = ReturnType<typeof useGetAllRelatedDataForActionQuery>;
export type GetAllRelatedDataForActionLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForActionLazyQuery>;
export type GetAllRelatedDataForActionSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForActionSuspenseQuery>;
export type GetAllRelatedDataForActionQueryResult = Apollo.QueryResult<GetAllRelatedDataForActionQuery, GetAllRelatedDataForActionQueryVariables>;
export const CreateActionDocument = gql`
    mutation CreateAction($name: String!, $type: String!, $description: String!, $order: Int, $registerId: ID, $searches: [ID], $messageId: ID, $personActionProgresses: [ID], $withRegister: Boolean = false, $withSearches: Boolean = false, $withMessage: Boolean = false, $withPersonActionProgresses: Boolean = false) {
  createAction(
    name: $name
    type: $type
    description: $description
    order: $order
    registerId: $registerId
    searchIds: $searches
    messageId: $messageId
    personActionProgressIds: $personActionProgresses
  ) {
    ...actionFields
  }
}
    ${ActionFieldsFragmentDoc}`;
export type CreateActionMutationFn = Apollo.MutationFunction<CreateActionMutation, CreateActionMutationVariables>;

/**
 * __useCreateActionMutation__
 *
 * To run a mutation, you first call `useCreateActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createActionMutation, { data, loading, error }] = useCreateActionMutation({
 *   variables: {
 *      name: // value for 'name'
 *      type: // value for 'type'
 *      description: // value for 'description'
 *      order: // value for 'order'
 *      registerId: // value for 'registerId'
 *      searches: // value for 'searches'
 *      messageId: // value for 'messageId'
 *      personActionProgresses: // value for 'personActionProgresses'
 *      withRegister: // value for 'withRegister'
 *      withSearches: // value for 'withSearches'
 *      withMessage: // value for 'withMessage'
 *      withPersonActionProgresses: // value for 'withPersonActionProgresses'
 *   },
 * });
 */
export function useCreateActionMutation(baseOptions?: Apollo.MutationHookOptions<CreateActionMutation, CreateActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateActionMutation, CreateActionMutationVariables>(CreateActionDocument, options);
      }
export type CreateActionMutationHookResult = ReturnType<typeof useCreateActionMutation>;
export type CreateActionMutationResult = Apollo.MutationResult<CreateActionMutation>;
export type CreateActionMutationOptions = Apollo.BaseMutationOptions<CreateActionMutation, CreateActionMutationVariables>;
export const UpdateActionDocument = gql`
    mutation UpdateAction($id: ID!, $name: String, $type: String, $description: String, $order: Int, $registerId: ID, $searches: [ID], $messageId: ID, $personActionProgresses: [ID], $withRegister: Boolean = false, $withSearches: Boolean = false, $withMessage: Boolean = false, $withPersonActionProgresses: Boolean = false) {
  updateAction(
    id: $id
    name: $name
    type: $type
    description: $description
    order: $order
    registerId: $registerId
    searchIds: $searches
    messageId: $messageId
    personActionProgressIds: $personActionProgresses
  ) {
    ...actionFields
  }
}
    ${ActionFieldsFragmentDoc}`;
export type UpdateActionMutationFn = Apollo.MutationFunction<UpdateActionMutation, UpdateActionMutationVariables>;

/**
 * __useUpdateActionMutation__
 *
 * To run a mutation, you first call `useUpdateActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActionMutation, { data, loading, error }] = useUpdateActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      type: // value for 'type'
 *      description: // value for 'description'
 *      order: // value for 'order'
 *      registerId: // value for 'registerId'
 *      searches: // value for 'searches'
 *      messageId: // value for 'messageId'
 *      personActionProgresses: // value for 'personActionProgresses'
 *      withRegister: // value for 'withRegister'
 *      withSearches: // value for 'withSearches'
 *      withMessage: // value for 'withMessage'
 *      withPersonActionProgresses: // value for 'withPersonActionProgresses'
 *   },
 * });
 */
export function useUpdateActionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActionMutation, UpdateActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActionMutation, UpdateActionMutationVariables>(UpdateActionDocument, options);
      }
export type UpdateActionMutationHookResult = ReturnType<typeof useUpdateActionMutation>;
export type UpdateActionMutationResult = Apollo.MutationResult<UpdateActionMutation>;
export type UpdateActionMutationOptions = Apollo.BaseMutationOptions<UpdateActionMutation, UpdateActionMutationVariables>;
export const DeleteActionDocument = gql`
    mutation DeleteAction($id: ID!, $withRegister: Boolean = false, $withSearches: Boolean = false, $withMessage: Boolean = false, $withPersonActionProgresses: Boolean = false) {
  deleteAction(id: $id) {
    ...actionFields
  }
}
    ${ActionFieldsFragmentDoc}`;
export type DeleteActionMutationFn = Apollo.MutationFunction<DeleteActionMutation, DeleteActionMutationVariables>;

/**
 * __useDeleteActionMutation__
 *
 * To run a mutation, you first call `useDeleteActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteActionMutation, { data, loading, error }] = useDeleteActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withRegister: // value for 'withRegister'
 *      withSearches: // value for 'withSearches'
 *      withMessage: // value for 'withMessage'
 *      withPersonActionProgresses: // value for 'withPersonActionProgresses'
 *   },
 * });
 */
export function useDeleteActionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteActionMutation, DeleteActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteActionMutation, DeleteActionMutationVariables>(DeleteActionDocument, options);
      }
export type DeleteActionMutationHookResult = ReturnType<typeof useDeleteActionMutation>;
export type DeleteActionMutationResult = Apollo.MutationResult<DeleteActionMutation>;
export type DeleteActionMutationOptions = Apollo.BaseMutationOptions<DeleteActionMutation, DeleteActionMutationVariables>;
export const CreatedActionDocument = gql`
    subscription CreatedAction($filter: ActionFilterArgs, $withRegister: Boolean = false, $withSearches: Boolean = false, $withMessage: Boolean = false, $withPersonActionProgresses: Boolean = false) {
  createdAction(filter: $filter) {
    ...actionFields
  }
}
    ${ActionFieldsFragmentDoc}`;

/**
 * __useCreatedActionSubscription__
 *
 * To run a query within a React component, call `useCreatedActionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedActionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedActionSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withRegister: // value for 'withRegister'
 *      withSearches: // value for 'withSearches'
 *      withMessage: // value for 'withMessage'
 *      withPersonActionProgresses: // value for 'withPersonActionProgresses'
 *   },
 * });
 */
export function useCreatedActionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedActionSubscription, CreatedActionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedActionSubscription, CreatedActionSubscriptionVariables>(CreatedActionDocument, options);
      }
export type CreatedActionSubscriptionHookResult = ReturnType<typeof useCreatedActionSubscription>;
export type CreatedActionSubscriptionResult = Apollo.SubscriptionResult<CreatedActionSubscription>;
export const UpdatedActionDocument = gql`
    subscription UpdatedAction($filter: ActionFilterArgs, $withRegister: Boolean = false, $withSearches: Boolean = false, $withMessage: Boolean = false, $withPersonActionProgresses: Boolean = false) {
  updatedAction(filter: $filter) {
    ...actionFields
  }
}
    ${ActionFieldsFragmentDoc}`;

/**
 * __useUpdatedActionSubscription__
 *
 * To run a query within a React component, call `useUpdatedActionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedActionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedActionSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withRegister: // value for 'withRegister'
 *      withSearches: // value for 'withSearches'
 *      withMessage: // value for 'withMessage'
 *      withPersonActionProgresses: // value for 'withPersonActionProgresses'
 *   },
 * });
 */
export function useUpdatedActionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedActionSubscription, UpdatedActionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedActionSubscription, UpdatedActionSubscriptionVariables>(UpdatedActionDocument, options);
      }
export type UpdatedActionSubscriptionHookResult = ReturnType<typeof useUpdatedActionSubscription>;
export type UpdatedActionSubscriptionResult = Apollo.SubscriptionResult<UpdatedActionSubscription>;
export const DeletedActionDocument = gql`
    subscription DeletedAction($filter: ActionFilterArgs) {
  deletedAction(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedActionSubscription__
 *
 * To run a query within a React component, call `useDeletedActionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedActionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedActionSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedActionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedActionSubscription, DeletedActionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedActionSubscription, DeletedActionSubscriptionVariables>(DeletedActionDocument, options);
      }
export type DeletedActionSubscriptionHookResult = ReturnType<typeof useDeletedActionSubscription>;
export type DeletedActionSubscriptionResult = Apollo.SubscriptionResult<DeletedActionSubscription>;
export const RestoredActionDocument = gql`
    subscription RestoredAction($filter: ActionFilterArgs, $withRegister: Boolean = false, $withSearches: Boolean = false, $withMessage: Boolean = false, $withPersonActionProgresses: Boolean = false) {
  restoredAction(filter: $filter) {
    ...actionFields
  }
}
    ${ActionFieldsFragmentDoc}`;

/**
 * __useRestoredActionSubscription__
 *
 * To run a query within a React component, call `useRestoredActionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredActionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredActionSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withRegister: // value for 'withRegister'
 *      withSearches: // value for 'withSearches'
 *      withMessage: // value for 'withMessage'
 *      withPersonActionProgresses: // value for 'withPersonActionProgresses'
 *   },
 * });
 */
export function useRestoredActionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredActionSubscription, RestoredActionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredActionSubscription, RestoredActionSubscriptionVariables>(RestoredActionDocument, options);
      }
export type RestoredActionSubscriptionHookResult = ReturnType<typeof useRestoredActionSubscription>;
export type RestoredActionSubscriptionResult = Apollo.SubscriptionResult<RestoredActionSubscription>;
export const GetContentsDocument = gql`
    query GetContents($filter: ContentFilterArgs, $paging: PageArgs, $sorting: [ContentSortArgs!], $withContentFills: Boolean = false) {
  contents(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...contentFields
    }
    totalCount
  }
}
    ${ContentFieldsFragmentDoc}`;

/**
 * __useGetContentsQuery__
 *
 * To run a query within a React component, call `useGetContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withContentFills: // value for 'withContentFills'
 *   },
 * });
 */
export function useGetContentsQuery(baseOptions?: Apollo.QueryHookOptions<GetContentsQuery, GetContentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentsQuery, GetContentsQueryVariables>(GetContentsDocument, options);
      }
export function useGetContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentsQuery, GetContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentsQuery, GetContentsQueryVariables>(GetContentsDocument, options);
        }
export function useGetContentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentsQuery, GetContentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentsQuery, GetContentsQueryVariables>(GetContentsDocument, options);
        }
export type GetContentsQueryHookResult = ReturnType<typeof useGetContentsQuery>;
export type GetContentsLazyQueryHookResult = ReturnType<typeof useGetContentsLazyQuery>;
export type GetContentsSuspenseQueryHookResult = ReturnType<typeof useGetContentsSuspenseQuery>;
export type GetContentsQueryResult = Apollo.QueryResult<GetContentsQuery, GetContentsQueryVariables>;
export const GetContentDocument = gql`
    query GetContent($id: ID!, $withContentFills: Boolean = false) {
  content(id: $id) {
    ...contentFields
  }
}
    ${ContentFieldsFragmentDoc}`;

/**
 * __useGetContentQuery__
 *
 * To run a query within a React component, call `useGetContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withContentFills: // value for 'withContentFills'
 *   },
 * });
 */
export function useGetContentQuery(baseOptions: Apollo.QueryHookOptions<GetContentQuery, GetContentQueryVariables> & ({ variables: GetContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentQuery, GetContentQueryVariables>(GetContentDocument, options);
      }
export function useGetContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentQuery, GetContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentQuery, GetContentQueryVariables>(GetContentDocument, options);
        }
export function useGetContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentQuery, GetContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentQuery, GetContentQueryVariables>(GetContentDocument, options);
        }
export type GetContentQueryHookResult = ReturnType<typeof useGetContentQuery>;
export type GetContentLazyQueryHookResult = ReturnType<typeof useGetContentLazyQuery>;
export type GetContentSuspenseQueryHookResult = ReturnType<typeof useGetContentSuspenseQuery>;
export type GetContentQueryResult = Apollo.QueryResult<GetContentQuery, GetContentQueryVariables>;
export const GetAllRelatedDataForContentDocument = gql`
    query GetAllRelatedDataForContent($withContentFills: Boolean = false) {
  contentFills @include(if: $withContentFills) {
    items {
      id
      displayField: id
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForContentQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForContentQuery({
 *   variables: {
 *      withContentFills: // value for 'withContentFills'
 *   },
 * });
 */
export function useGetAllRelatedDataForContentQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForContentQuery, GetAllRelatedDataForContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForContentQuery, GetAllRelatedDataForContentQueryVariables>(GetAllRelatedDataForContentDocument, options);
      }
export function useGetAllRelatedDataForContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForContentQuery, GetAllRelatedDataForContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForContentQuery, GetAllRelatedDataForContentQueryVariables>(GetAllRelatedDataForContentDocument, options);
        }
export function useGetAllRelatedDataForContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForContentQuery, GetAllRelatedDataForContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForContentQuery, GetAllRelatedDataForContentQueryVariables>(GetAllRelatedDataForContentDocument, options);
        }
export type GetAllRelatedDataForContentQueryHookResult = ReturnType<typeof useGetAllRelatedDataForContentQuery>;
export type GetAllRelatedDataForContentLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForContentLazyQuery>;
export type GetAllRelatedDataForContentSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForContentSuspenseQuery>;
export type GetAllRelatedDataForContentQueryResult = Apollo.QueryResult<GetAllRelatedDataForContentQuery, GetAllRelatedDataForContentQueryVariables>;
export const CreateContentDocument = gql`
    mutation CreateContent($name: String!, $contentFills: [ID], $withContentFills: Boolean = false) {
  createContent(name: $name, contentFillIds: $contentFills) {
    ...contentFields
  }
}
    ${ContentFieldsFragmentDoc}`;
export type CreateContentMutationFn = Apollo.MutationFunction<CreateContentMutation, CreateContentMutationVariables>;

/**
 * __useCreateContentMutation__
 *
 * To run a mutation, you first call `useCreateContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentMutation, { data, loading, error }] = useCreateContentMutation({
 *   variables: {
 *      name: // value for 'name'
 *      contentFills: // value for 'contentFills'
 *      withContentFills: // value for 'withContentFills'
 *   },
 * });
 */
export function useCreateContentMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentMutation, CreateContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentMutation, CreateContentMutationVariables>(CreateContentDocument, options);
      }
export type CreateContentMutationHookResult = ReturnType<typeof useCreateContentMutation>;
export type CreateContentMutationResult = Apollo.MutationResult<CreateContentMutation>;
export type CreateContentMutationOptions = Apollo.BaseMutationOptions<CreateContentMutation, CreateContentMutationVariables>;
export const UpdateContentDocument = gql`
    mutation UpdateContent($id: ID!, $name: String, $contentFills: [ID], $withContentFills: Boolean = false) {
  updateContent(id: $id, name: $name, contentFillIds: $contentFills) {
    ...contentFields
  }
}
    ${ContentFieldsFragmentDoc}`;
export type UpdateContentMutationFn = Apollo.MutationFunction<UpdateContentMutation, UpdateContentMutationVariables>;

/**
 * __useUpdateContentMutation__
 *
 * To run a mutation, you first call `useUpdateContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentMutation, { data, loading, error }] = useUpdateContentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      contentFills: // value for 'contentFills'
 *      withContentFills: // value for 'withContentFills'
 *   },
 * });
 */
export function useUpdateContentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentMutation, UpdateContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentMutation, UpdateContentMutationVariables>(UpdateContentDocument, options);
      }
export type UpdateContentMutationHookResult = ReturnType<typeof useUpdateContentMutation>;
export type UpdateContentMutationResult = Apollo.MutationResult<UpdateContentMutation>;
export type UpdateContentMutationOptions = Apollo.BaseMutationOptions<UpdateContentMutation, UpdateContentMutationVariables>;
export const DeleteContentDocument = gql`
    mutation DeleteContent($id: ID!, $withContentFills: Boolean = false) {
  deleteContent(id: $id) {
    ...contentFields
  }
}
    ${ContentFieldsFragmentDoc}`;
export type DeleteContentMutationFn = Apollo.MutationFunction<DeleteContentMutation, DeleteContentMutationVariables>;

/**
 * __useDeleteContentMutation__
 *
 * To run a mutation, you first call `useDeleteContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentMutation, { data, loading, error }] = useDeleteContentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withContentFills: // value for 'withContentFills'
 *   },
 * });
 */
export function useDeleteContentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContentMutation, DeleteContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContentMutation, DeleteContentMutationVariables>(DeleteContentDocument, options);
      }
export type DeleteContentMutationHookResult = ReturnType<typeof useDeleteContentMutation>;
export type DeleteContentMutationResult = Apollo.MutationResult<DeleteContentMutation>;
export type DeleteContentMutationOptions = Apollo.BaseMutationOptions<DeleteContentMutation, DeleteContentMutationVariables>;
export const CreatedContentDocument = gql`
    subscription CreatedContent($filter: ContentFilterArgs, $withContentFills: Boolean = false) {
  createdContent(filter: $filter) {
    ...contentFields
  }
}
    ${ContentFieldsFragmentDoc}`;

/**
 * __useCreatedContentSubscription__
 *
 * To run a query within a React component, call `useCreatedContentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedContentSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedContentSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withContentFills: // value for 'withContentFills'
 *   },
 * });
 */
export function useCreatedContentSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedContentSubscription, CreatedContentSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedContentSubscription, CreatedContentSubscriptionVariables>(CreatedContentDocument, options);
      }
export type CreatedContentSubscriptionHookResult = ReturnType<typeof useCreatedContentSubscription>;
export type CreatedContentSubscriptionResult = Apollo.SubscriptionResult<CreatedContentSubscription>;
export const UpdatedContentDocument = gql`
    subscription UpdatedContent($filter: ContentFilterArgs, $withContentFills: Boolean = false) {
  updatedContent(filter: $filter) {
    ...contentFields
  }
}
    ${ContentFieldsFragmentDoc}`;

/**
 * __useUpdatedContentSubscription__
 *
 * To run a query within a React component, call `useUpdatedContentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedContentSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedContentSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withContentFills: // value for 'withContentFills'
 *   },
 * });
 */
export function useUpdatedContentSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedContentSubscription, UpdatedContentSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedContentSubscription, UpdatedContentSubscriptionVariables>(UpdatedContentDocument, options);
      }
export type UpdatedContentSubscriptionHookResult = ReturnType<typeof useUpdatedContentSubscription>;
export type UpdatedContentSubscriptionResult = Apollo.SubscriptionResult<UpdatedContentSubscription>;
export const DeletedContentDocument = gql`
    subscription DeletedContent($filter: ContentFilterArgs) {
  deletedContent(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedContentSubscription__
 *
 * To run a query within a React component, call `useDeletedContentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedContentSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedContentSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedContentSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedContentSubscription, DeletedContentSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedContentSubscription, DeletedContentSubscriptionVariables>(DeletedContentDocument, options);
      }
export type DeletedContentSubscriptionHookResult = ReturnType<typeof useDeletedContentSubscription>;
export type DeletedContentSubscriptionResult = Apollo.SubscriptionResult<DeletedContentSubscription>;
export const GetContentFillsDocument = gql`
    query GetContentFills($filter: ContentFillFilterArgs, $paging: PageArgs, $sorting: [ContentFillSortArgs!], $withContent: Boolean = false) {
  contentFills(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...contentFillFields
    }
    totalCount
  }
}
    ${ContentFillFieldsFragmentDoc}`;

/**
 * __useGetContentFillsQuery__
 *
 * To run a query within a React component, call `useGetContentFillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentFillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentFillsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withContent: // value for 'withContent'
 *   },
 * });
 */
export function useGetContentFillsQuery(baseOptions?: Apollo.QueryHookOptions<GetContentFillsQuery, GetContentFillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentFillsQuery, GetContentFillsQueryVariables>(GetContentFillsDocument, options);
      }
export function useGetContentFillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentFillsQuery, GetContentFillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentFillsQuery, GetContentFillsQueryVariables>(GetContentFillsDocument, options);
        }
export function useGetContentFillsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentFillsQuery, GetContentFillsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentFillsQuery, GetContentFillsQueryVariables>(GetContentFillsDocument, options);
        }
export type GetContentFillsQueryHookResult = ReturnType<typeof useGetContentFillsQuery>;
export type GetContentFillsLazyQueryHookResult = ReturnType<typeof useGetContentFillsLazyQuery>;
export type GetContentFillsSuspenseQueryHookResult = ReturnType<typeof useGetContentFillsSuspenseQuery>;
export type GetContentFillsQueryResult = Apollo.QueryResult<GetContentFillsQuery, GetContentFillsQueryVariables>;
export const GetContentFillDocument = gql`
    query GetContentFill($id: ID!, $withContent: Boolean = false) {
  contentFill(id: $id) {
    ...contentFillFields
  }
}
    ${ContentFillFieldsFragmentDoc}`;

/**
 * __useGetContentFillQuery__
 *
 * To run a query within a React component, call `useGetContentFillQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentFillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentFillQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withContent: // value for 'withContent'
 *   },
 * });
 */
export function useGetContentFillQuery(baseOptions: Apollo.QueryHookOptions<GetContentFillQuery, GetContentFillQueryVariables> & ({ variables: GetContentFillQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentFillQuery, GetContentFillQueryVariables>(GetContentFillDocument, options);
      }
export function useGetContentFillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentFillQuery, GetContentFillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentFillQuery, GetContentFillQueryVariables>(GetContentFillDocument, options);
        }
export function useGetContentFillSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContentFillQuery, GetContentFillQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContentFillQuery, GetContentFillQueryVariables>(GetContentFillDocument, options);
        }
export type GetContentFillQueryHookResult = ReturnType<typeof useGetContentFillQuery>;
export type GetContentFillLazyQueryHookResult = ReturnType<typeof useGetContentFillLazyQuery>;
export type GetContentFillSuspenseQueryHookResult = ReturnType<typeof useGetContentFillSuspenseQuery>;
export type GetContentFillQueryResult = Apollo.QueryResult<GetContentFillQuery, GetContentFillQueryVariables>;
export const GetAllRelatedDataForContentFillDocument = gql`
    query GetAllRelatedDataForContentFill($withContents: Boolean = false) {
  contents @include(if: $withContents) {
    items {
      id
      displayField: name
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForContentFillQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForContentFillQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForContentFillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForContentFillQuery({
 *   variables: {
 *      withContents: // value for 'withContents'
 *   },
 * });
 */
export function useGetAllRelatedDataForContentFillQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForContentFillQuery, GetAllRelatedDataForContentFillQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForContentFillQuery, GetAllRelatedDataForContentFillQueryVariables>(GetAllRelatedDataForContentFillDocument, options);
      }
export function useGetAllRelatedDataForContentFillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForContentFillQuery, GetAllRelatedDataForContentFillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForContentFillQuery, GetAllRelatedDataForContentFillQueryVariables>(GetAllRelatedDataForContentFillDocument, options);
        }
export function useGetAllRelatedDataForContentFillSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForContentFillQuery, GetAllRelatedDataForContentFillQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForContentFillQuery, GetAllRelatedDataForContentFillQueryVariables>(GetAllRelatedDataForContentFillDocument, options);
        }
export type GetAllRelatedDataForContentFillQueryHookResult = ReturnType<typeof useGetAllRelatedDataForContentFillQuery>;
export type GetAllRelatedDataForContentFillLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForContentFillLazyQuery>;
export type GetAllRelatedDataForContentFillSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForContentFillSuspenseQuery>;
export type GetAllRelatedDataForContentFillQueryResult = Apollo.QueryResult<GetAllRelatedDataForContentFillQuery, GetAllRelatedDataForContentFillQueryVariables>;
export const CreateContentFillDocument = gql`
    mutation CreateContentFill($fill: String!, $language: String!, $contentId: ID!, $withContent: Boolean = false) {
  createContentFill(fill: $fill, language: $language, contentId: $contentId) {
    ...contentFillFields
  }
}
    ${ContentFillFieldsFragmentDoc}`;
export type CreateContentFillMutationFn = Apollo.MutationFunction<CreateContentFillMutation, CreateContentFillMutationVariables>;

/**
 * __useCreateContentFillMutation__
 *
 * To run a mutation, you first call `useCreateContentFillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentFillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentFillMutation, { data, loading, error }] = useCreateContentFillMutation({
 *   variables: {
 *      fill: // value for 'fill'
 *      language: // value for 'language'
 *      contentId: // value for 'contentId'
 *      withContent: // value for 'withContent'
 *   },
 * });
 */
export function useCreateContentFillMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentFillMutation, CreateContentFillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentFillMutation, CreateContentFillMutationVariables>(CreateContentFillDocument, options);
      }
export type CreateContentFillMutationHookResult = ReturnType<typeof useCreateContentFillMutation>;
export type CreateContentFillMutationResult = Apollo.MutationResult<CreateContentFillMutation>;
export type CreateContentFillMutationOptions = Apollo.BaseMutationOptions<CreateContentFillMutation, CreateContentFillMutationVariables>;
export const UpdateContentFillDocument = gql`
    mutation UpdateContentFill($id: ID!, $fill: String, $language: String, $contentId: ID, $withContent: Boolean = false) {
  updateContentFill(
    id: $id
    fill: $fill
    language: $language
    contentId: $contentId
  ) {
    ...contentFillFields
  }
}
    ${ContentFillFieldsFragmentDoc}`;
export type UpdateContentFillMutationFn = Apollo.MutationFunction<UpdateContentFillMutation, UpdateContentFillMutationVariables>;

/**
 * __useUpdateContentFillMutation__
 *
 * To run a mutation, you first call `useUpdateContentFillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentFillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentFillMutation, { data, loading, error }] = useUpdateContentFillMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fill: // value for 'fill'
 *      language: // value for 'language'
 *      contentId: // value for 'contentId'
 *      withContent: // value for 'withContent'
 *   },
 * });
 */
export function useUpdateContentFillMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentFillMutation, UpdateContentFillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentFillMutation, UpdateContentFillMutationVariables>(UpdateContentFillDocument, options);
      }
export type UpdateContentFillMutationHookResult = ReturnType<typeof useUpdateContentFillMutation>;
export type UpdateContentFillMutationResult = Apollo.MutationResult<UpdateContentFillMutation>;
export type UpdateContentFillMutationOptions = Apollo.BaseMutationOptions<UpdateContentFillMutation, UpdateContentFillMutationVariables>;
export const DeleteContentFillDocument = gql`
    mutation DeleteContentFill($id: ID!, $withContent: Boolean = false) {
  deleteContentFill(id: $id) {
    ...contentFillFields
  }
}
    ${ContentFillFieldsFragmentDoc}`;
export type DeleteContentFillMutationFn = Apollo.MutationFunction<DeleteContentFillMutation, DeleteContentFillMutationVariables>;

/**
 * __useDeleteContentFillMutation__
 *
 * To run a mutation, you first call `useDeleteContentFillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentFillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentFillMutation, { data, loading, error }] = useDeleteContentFillMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withContent: // value for 'withContent'
 *   },
 * });
 */
export function useDeleteContentFillMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContentFillMutation, DeleteContentFillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContentFillMutation, DeleteContentFillMutationVariables>(DeleteContentFillDocument, options);
      }
export type DeleteContentFillMutationHookResult = ReturnType<typeof useDeleteContentFillMutation>;
export type DeleteContentFillMutationResult = Apollo.MutationResult<DeleteContentFillMutation>;
export type DeleteContentFillMutationOptions = Apollo.BaseMutationOptions<DeleteContentFillMutation, DeleteContentFillMutationVariables>;
export const CreatedContentFillDocument = gql`
    subscription CreatedContentFill($filter: ContentFillFilterArgs, $withContent: Boolean = false) {
  createdContentFill(filter: $filter) {
    ...contentFillFields
  }
}
    ${ContentFillFieldsFragmentDoc}`;

/**
 * __useCreatedContentFillSubscription__
 *
 * To run a query within a React component, call `useCreatedContentFillSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedContentFillSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedContentFillSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withContent: // value for 'withContent'
 *   },
 * });
 */
export function useCreatedContentFillSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedContentFillSubscription, CreatedContentFillSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedContentFillSubscription, CreatedContentFillSubscriptionVariables>(CreatedContentFillDocument, options);
      }
export type CreatedContentFillSubscriptionHookResult = ReturnType<typeof useCreatedContentFillSubscription>;
export type CreatedContentFillSubscriptionResult = Apollo.SubscriptionResult<CreatedContentFillSubscription>;
export const UpdatedContentFillDocument = gql`
    subscription UpdatedContentFill($filter: ContentFillFilterArgs, $withContent: Boolean = false) {
  updatedContentFill(filter: $filter) {
    ...contentFillFields
  }
}
    ${ContentFillFieldsFragmentDoc}`;

/**
 * __useUpdatedContentFillSubscription__
 *
 * To run a query within a React component, call `useUpdatedContentFillSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedContentFillSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedContentFillSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withContent: // value for 'withContent'
 *   },
 * });
 */
export function useUpdatedContentFillSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedContentFillSubscription, UpdatedContentFillSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedContentFillSubscription, UpdatedContentFillSubscriptionVariables>(UpdatedContentFillDocument, options);
      }
export type UpdatedContentFillSubscriptionHookResult = ReturnType<typeof useUpdatedContentFillSubscription>;
export type UpdatedContentFillSubscriptionResult = Apollo.SubscriptionResult<UpdatedContentFillSubscription>;
export const DeletedContentFillDocument = gql`
    subscription DeletedContentFill($filter: ContentFillFilterArgs) {
  deletedContentFill(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedContentFillSubscription__
 *
 * To run a query within a React component, call `useDeletedContentFillSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedContentFillSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedContentFillSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedContentFillSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedContentFillSubscription, DeletedContentFillSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedContentFillSubscription, DeletedContentFillSubscriptionVariables>(DeletedContentFillDocument, options);
      }
export type DeletedContentFillSubscriptionHookResult = ReturnType<typeof useDeletedContentFillSubscription>;
export type DeletedContentFillSubscriptionResult = Apollo.SubscriptionResult<DeletedContentFillSubscription>;
export const GetErrorLogsDocument = gql`
    query GetErrorLogs($filter: ErrorLogFilterArgs, $paging: PageArgs, $sorting: [ErrorLogSortArgs!]) {
  errorLogs(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...errorLogFields
    }
    totalCount
  }
}
    ${ErrorLogFieldsFragmentDoc}`;

/**
 * __useGetErrorLogsQuery__
 *
 * To run a query within a React component, call `useGetErrorLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetErrorLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetErrorLogsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useGetErrorLogsQuery(baseOptions?: Apollo.QueryHookOptions<GetErrorLogsQuery, GetErrorLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetErrorLogsQuery, GetErrorLogsQueryVariables>(GetErrorLogsDocument, options);
      }
export function useGetErrorLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetErrorLogsQuery, GetErrorLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetErrorLogsQuery, GetErrorLogsQueryVariables>(GetErrorLogsDocument, options);
        }
export function useGetErrorLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetErrorLogsQuery, GetErrorLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetErrorLogsQuery, GetErrorLogsQueryVariables>(GetErrorLogsDocument, options);
        }
export type GetErrorLogsQueryHookResult = ReturnType<typeof useGetErrorLogsQuery>;
export type GetErrorLogsLazyQueryHookResult = ReturnType<typeof useGetErrorLogsLazyQuery>;
export type GetErrorLogsSuspenseQueryHookResult = ReturnType<typeof useGetErrorLogsSuspenseQuery>;
export type GetErrorLogsQueryResult = Apollo.QueryResult<GetErrorLogsQuery, GetErrorLogsQueryVariables>;
export const GetErrorLogDocument = gql`
    query GetErrorLog($id: ID!) {
  errorLog(id: $id) {
    ...errorLogFields
  }
}
    ${ErrorLogFieldsFragmentDoc}`;

/**
 * __useGetErrorLogQuery__
 *
 * To run a query within a React component, call `useGetErrorLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetErrorLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetErrorLogQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetErrorLogQuery(baseOptions: Apollo.QueryHookOptions<GetErrorLogQuery, GetErrorLogQueryVariables> & ({ variables: GetErrorLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetErrorLogQuery, GetErrorLogQueryVariables>(GetErrorLogDocument, options);
      }
export function useGetErrorLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetErrorLogQuery, GetErrorLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetErrorLogQuery, GetErrorLogQueryVariables>(GetErrorLogDocument, options);
        }
export function useGetErrorLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetErrorLogQuery, GetErrorLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetErrorLogQuery, GetErrorLogQueryVariables>(GetErrorLogDocument, options);
        }
export type GetErrorLogQueryHookResult = ReturnType<typeof useGetErrorLogQuery>;
export type GetErrorLogLazyQueryHookResult = ReturnType<typeof useGetErrorLogLazyQuery>;
export type GetErrorLogSuspenseQueryHookResult = ReturnType<typeof useGetErrorLogSuspenseQuery>;
export type GetErrorLogQueryResult = Apollo.QueryResult<GetErrorLogQuery, GetErrorLogQueryVariables>;
export const CreateErrorLogDocument = gql`
    mutation CreateErrorLog($error: String!, $stack: String, $domain: String!) {
  createErrorLog(error: $error, stack: $stack, domain: $domain) {
    ...errorLogFields
  }
}
    ${ErrorLogFieldsFragmentDoc}`;
export type CreateErrorLogMutationFn = Apollo.MutationFunction<CreateErrorLogMutation, CreateErrorLogMutationVariables>;

/**
 * __useCreateErrorLogMutation__
 *
 * To run a mutation, you first call `useCreateErrorLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateErrorLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createErrorLogMutation, { data, loading, error }] = useCreateErrorLogMutation({
 *   variables: {
 *      error: // value for 'error'
 *      stack: // value for 'stack'
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useCreateErrorLogMutation(baseOptions?: Apollo.MutationHookOptions<CreateErrorLogMutation, CreateErrorLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateErrorLogMutation, CreateErrorLogMutationVariables>(CreateErrorLogDocument, options);
      }
export type CreateErrorLogMutationHookResult = ReturnType<typeof useCreateErrorLogMutation>;
export type CreateErrorLogMutationResult = Apollo.MutationResult<CreateErrorLogMutation>;
export type CreateErrorLogMutationOptions = Apollo.BaseMutationOptions<CreateErrorLogMutation, CreateErrorLogMutationVariables>;
export const UpdateErrorLogDocument = gql`
    mutation UpdateErrorLog($id: ID!, $error: String, $stack: String, $domain: String) {
  updateErrorLog(id: $id, error: $error, stack: $stack, domain: $domain) {
    ...errorLogFields
  }
}
    ${ErrorLogFieldsFragmentDoc}`;
export type UpdateErrorLogMutationFn = Apollo.MutationFunction<UpdateErrorLogMutation, UpdateErrorLogMutationVariables>;

/**
 * __useUpdateErrorLogMutation__
 *
 * To run a mutation, you first call `useUpdateErrorLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateErrorLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateErrorLogMutation, { data, loading, error }] = useUpdateErrorLogMutation({
 *   variables: {
 *      id: // value for 'id'
 *      error: // value for 'error'
 *      stack: // value for 'stack'
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useUpdateErrorLogMutation(baseOptions?: Apollo.MutationHookOptions<UpdateErrorLogMutation, UpdateErrorLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateErrorLogMutation, UpdateErrorLogMutationVariables>(UpdateErrorLogDocument, options);
      }
export type UpdateErrorLogMutationHookResult = ReturnType<typeof useUpdateErrorLogMutation>;
export type UpdateErrorLogMutationResult = Apollo.MutationResult<UpdateErrorLogMutation>;
export type UpdateErrorLogMutationOptions = Apollo.BaseMutationOptions<UpdateErrorLogMutation, UpdateErrorLogMutationVariables>;
export const DeleteErrorLogDocument = gql`
    mutation DeleteErrorLog($id: ID!) {
  deleteErrorLog(id: $id) {
    ...errorLogFields
  }
}
    ${ErrorLogFieldsFragmentDoc}`;
export type DeleteErrorLogMutationFn = Apollo.MutationFunction<DeleteErrorLogMutation, DeleteErrorLogMutationVariables>;

/**
 * __useDeleteErrorLogMutation__
 *
 * To run a mutation, you first call `useDeleteErrorLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteErrorLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteErrorLogMutation, { data, loading, error }] = useDeleteErrorLogMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteErrorLogMutation(baseOptions?: Apollo.MutationHookOptions<DeleteErrorLogMutation, DeleteErrorLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteErrorLogMutation, DeleteErrorLogMutationVariables>(DeleteErrorLogDocument, options);
      }
export type DeleteErrorLogMutationHookResult = ReturnType<typeof useDeleteErrorLogMutation>;
export type DeleteErrorLogMutationResult = Apollo.MutationResult<DeleteErrorLogMutation>;
export type DeleteErrorLogMutationOptions = Apollo.BaseMutationOptions<DeleteErrorLogMutation, DeleteErrorLogMutationVariables>;
export const CreatedErrorLogDocument = gql`
    subscription CreatedErrorLog($filter: ErrorLogFilterArgs) {
  createdErrorLog(filter: $filter) {
    ...errorLogFields
  }
}
    ${ErrorLogFieldsFragmentDoc}`;

/**
 * __useCreatedErrorLogSubscription__
 *
 * To run a query within a React component, call `useCreatedErrorLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedErrorLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedErrorLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCreatedErrorLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedErrorLogSubscription, CreatedErrorLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedErrorLogSubscription, CreatedErrorLogSubscriptionVariables>(CreatedErrorLogDocument, options);
      }
export type CreatedErrorLogSubscriptionHookResult = ReturnType<typeof useCreatedErrorLogSubscription>;
export type CreatedErrorLogSubscriptionResult = Apollo.SubscriptionResult<CreatedErrorLogSubscription>;
export const UpdatedErrorLogDocument = gql`
    subscription UpdatedErrorLog($filter: ErrorLogFilterArgs) {
  updatedErrorLog(filter: $filter) {
    ...errorLogFields
  }
}
    ${ErrorLogFieldsFragmentDoc}`;

/**
 * __useUpdatedErrorLogSubscription__
 *
 * To run a query within a React component, call `useUpdatedErrorLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedErrorLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedErrorLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUpdatedErrorLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedErrorLogSubscription, UpdatedErrorLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedErrorLogSubscription, UpdatedErrorLogSubscriptionVariables>(UpdatedErrorLogDocument, options);
      }
export type UpdatedErrorLogSubscriptionHookResult = ReturnType<typeof useUpdatedErrorLogSubscription>;
export type UpdatedErrorLogSubscriptionResult = Apollo.SubscriptionResult<UpdatedErrorLogSubscription>;
export const DeletedErrorLogDocument = gql`
    subscription DeletedErrorLog($filter: ErrorLogFilterArgs) {
  deletedErrorLog(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedErrorLogSubscription__
 *
 * To run a query within a React component, call `useDeletedErrorLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedErrorLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedErrorLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedErrorLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedErrorLogSubscription, DeletedErrorLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedErrorLogSubscription, DeletedErrorLogSubscriptionVariables>(DeletedErrorLogDocument, options);
      }
export type DeletedErrorLogSubscriptionHookResult = ReturnType<typeof useDeletedErrorLogSubscription>;
export type DeletedErrorLogSubscriptionResult = Apollo.SubscriptionResult<DeletedErrorLogSubscription>;
export const RestoredErrorLogDocument = gql`
    subscription RestoredErrorLog($filter: ErrorLogFilterArgs) {
  restoredErrorLog(filter: $filter) {
    ...errorLogFields
  }
}
    ${ErrorLogFieldsFragmentDoc}`;

/**
 * __useRestoredErrorLogSubscription__
 *
 * To run a query within a React component, call `useRestoredErrorLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredErrorLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredErrorLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRestoredErrorLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredErrorLogSubscription, RestoredErrorLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredErrorLogSubscription, RestoredErrorLogSubscriptionVariables>(RestoredErrorLogDocument, options);
      }
export type RestoredErrorLogSubscriptionHookResult = ReturnType<typeof useRestoredErrorLogSubscription>;
export type RestoredErrorLogSubscriptionResult = Apollo.SubscriptionResult<RestoredErrorLogSubscription>;
export const GetEventLogsDocument = gql`
    query GetEventLogs($filter: EventLogFilterArgs, $paging: PageArgs, $sorting: [EventLogSortArgs!]) {
  eventLogs(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...eventLogFields
    }
    totalCount
  }
}
    ${EventLogFieldsFragmentDoc}`;

/**
 * __useGetEventLogsQuery__
 *
 * To run a query within a React component, call `useGetEventLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventLogsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useGetEventLogsQuery(baseOptions?: Apollo.QueryHookOptions<GetEventLogsQuery, GetEventLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventLogsQuery, GetEventLogsQueryVariables>(GetEventLogsDocument, options);
      }
export function useGetEventLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventLogsQuery, GetEventLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventLogsQuery, GetEventLogsQueryVariables>(GetEventLogsDocument, options);
        }
export function useGetEventLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventLogsQuery, GetEventLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventLogsQuery, GetEventLogsQueryVariables>(GetEventLogsDocument, options);
        }
export type GetEventLogsQueryHookResult = ReturnType<typeof useGetEventLogsQuery>;
export type GetEventLogsLazyQueryHookResult = ReturnType<typeof useGetEventLogsLazyQuery>;
export type GetEventLogsSuspenseQueryHookResult = ReturnType<typeof useGetEventLogsSuspenseQuery>;
export type GetEventLogsQueryResult = Apollo.QueryResult<GetEventLogsQuery, GetEventLogsQueryVariables>;
export const GetEventLogDocument = gql`
    query GetEventLog($id: ID!) {
  eventLog(id: $id) {
    ...eventLogFields
  }
}
    ${EventLogFieldsFragmentDoc}`;

/**
 * __useGetEventLogQuery__
 *
 * To run a query within a React component, call `useGetEventLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventLogQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventLogQuery(baseOptions: Apollo.QueryHookOptions<GetEventLogQuery, GetEventLogQueryVariables> & ({ variables: GetEventLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventLogQuery, GetEventLogQueryVariables>(GetEventLogDocument, options);
      }
export function useGetEventLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventLogQuery, GetEventLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventLogQuery, GetEventLogQueryVariables>(GetEventLogDocument, options);
        }
export function useGetEventLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEventLogQuery, GetEventLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEventLogQuery, GetEventLogQueryVariables>(GetEventLogDocument, options);
        }
export type GetEventLogQueryHookResult = ReturnType<typeof useGetEventLogQuery>;
export type GetEventLogLazyQueryHookResult = ReturnType<typeof useGetEventLogLazyQuery>;
export type GetEventLogSuspenseQueryHookResult = ReturnType<typeof useGetEventLogSuspenseQuery>;
export type GetEventLogQueryResult = Apollo.QueryResult<GetEventLogQuery, GetEventLogQueryVariables>;
export const CreateEventLogDocument = gql`
    mutation CreateEventLog($log: String!, $type: String!) {
  createEventLog(log: $log, type: $type) {
    ...eventLogFields
  }
}
    ${EventLogFieldsFragmentDoc}`;
export type CreateEventLogMutationFn = Apollo.MutationFunction<CreateEventLogMutation, CreateEventLogMutationVariables>;

/**
 * __useCreateEventLogMutation__
 *
 * To run a mutation, you first call `useCreateEventLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventLogMutation, { data, loading, error }] = useCreateEventLogMutation({
 *   variables: {
 *      log: // value for 'log'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateEventLogMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventLogMutation, CreateEventLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventLogMutation, CreateEventLogMutationVariables>(CreateEventLogDocument, options);
      }
export type CreateEventLogMutationHookResult = ReturnType<typeof useCreateEventLogMutation>;
export type CreateEventLogMutationResult = Apollo.MutationResult<CreateEventLogMutation>;
export type CreateEventLogMutationOptions = Apollo.BaseMutationOptions<CreateEventLogMutation, CreateEventLogMutationVariables>;
export const UpdateEventLogDocument = gql`
    mutation UpdateEventLog($id: ID!, $log: String, $type: String) {
  updateEventLog(id: $id, log: $log, type: $type) {
    ...eventLogFields
  }
}
    ${EventLogFieldsFragmentDoc}`;
export type UpdateEventLogMutationFn = Apollo.MutationFunction<UpdateEventLogMutation, UpdateEventLogMutationVariables>;

/**
 * __useUpdateEventLogMutation__
 *
 * To run a mutation, you first call `useUpdateEventLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventLogMutation, { data, loading, error }] = useUpdateEventLogMutation({
 *   variables: {
 *      id: // value for 'id'
 *      log: // value for 'log'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateEventLogMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventLogMutation, UpdateEventLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventLogMutation, UpdateEventLogMutationVariables>(UpdateEventLogDocument, options);
      }
export type UpdateEventLogMutationHookResult = ReturnType<typeof useUpdateEventLogMutation>;
export type UpdateEventLogMutationResult = Apollo.MutationResult<UpdateEventLogMutation>;
export type UpdateEventLogMutationOptions = Apollo.BaseMutationOptions<UpdateEventLogMutation, UpdateEventLogMutationVariables>;
export const DeleteEventLogDocument = gql`
    mutation DeleteEventLog($id: ID!) {
  deleteEventLog(id: $id) {
    ...eventLogFields
  }
}
    ${EventLogFieldsFragmentDoc}`;
export type DeleteEventLogMutationFn = Apollo.MutationFunction<DeleteEventLogMutation, DeleteEventLogMutationVariables>;

/**
 * __useDeleteEventLogMutation__
 *
 * To run a mutation, you first call `useDeleteEventLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventLogMutation, { data, loading, error }] = useDeleteEventLogMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEventLogMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventLogMutation, DeleteEventLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventLogMutation, DeleteEventLogMutationVariables>(DeleteEventLogDocument, options);
      }
export type DeleteEventLogMutationHookResult = ReturnType<typeof useDeleteEventLogMutation>;
export type DeleteEventLogMutationResult = Apollo.MutationResult<DeleteEventLogMutation>;
export type DeleteEventLogMutationOptions = Apollo.BaseMutationOptions<DeleteEventLogMutation, DeleteEventLogMutationVariables>;
export const CreatedEventLogDocument = gql`
    subscription CreatedEventLog($filter: EventLogFilterArgs) {
  createdEventLog(filter: $filter) {
    ...eventLogFields
  }
}
    ${EventLogFieldsFragmentDoc}`;

/**
 * __useCreatedEventLogSubscription__
 *
 * To run a query within a React component, call `useCreatedEventLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedEventLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedEventLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCreatedEventLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedEventLogSubscription, CreatedEventLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedEventLogSubscription, CreatedEventLogSubscriptionVariables>(CreatedEventLogDocument, options);
      }
export type CreatedEventLogSubscriptionHookResult = ReturnType<typeof useCreatedEventLogSubscription>;
export type CreatedEventLogSubscriptionResult = Apollo.SubscriptionResult<CreatedEventLogSubscription>;
export const UpdatedEventLogDocument = gql`
    subscription UpdatedEventLog($filter: EventLogFilterArgs) {
  updatedEventLog(filter: $filter) {
    ...eventLogFields
  }
}
    ${EventLogFieldsFragmentDoc}`;

/**
 * __useUpdatedEventLogSubscription__
 *
 * To run a query within a React component, call `useUpdatedEventLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedEventLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedEventLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUpdatedEventLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedEventLogSubscription, UpdatedEventLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedEventLogSubscription, UpdatedEventLogSubscriptionVariables>(UpdatedEventLogDocument, options);
      }
export type UpdatedEventLogSubscriptionHookResult = ReturnType<typeof useUpdatedEventLogSubscription>;
export type UpdatedEventLogSubscriptionResult = Apollo.SubscriptionResult<UpdatedEventLogSubscription>;
export const DeletedEventLogDocument = gql`
    subscription DeletedEventLog($filter: EventLogFilterArgs) {
  deletedEventLog(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedEventLogSubscription__
 *
 * To run a query within a React component, call `useDeletedEventLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedEventLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedEventLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedEventLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedEventLogSubscription, DeletedEventLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedEventLogSubscription, DeletedEventLogSubscriptionVariables>(DeletedEventLogDocument, options);
      }
export type DeletedEventLogSubscriptionHookResult = ReturnType<typeof useDeletedEventLogSubscription>;
export type DeletedEventLogSubscriptionResult = Apollo.SubscriptionResult<DeletedEventLogSubscription>;
export const RestoredEventLogDocument = gql`
    subscription RestoredEventLog($filter: EventLogFilterArgs) {
  restoredEventLog(filter: $filter) {
    ...eventLogFields
  }
}
    ${EventLogFieldsFragmentDoc}`;

/**
 * __useRestoredEventLogSubscription__
 *
 * To run a query within a React component, call `useRestoredEventLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredEventLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredEventLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRestoredEventLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredEventLogSubscription, RestoredEventLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredEventLogSubscription, RestoredEventLogSubscriptionVariables>(RestoredEventLogDocument, options);
      }
export type RestoredEventLogSubscriptionHookResult = ReturnType<typeof useRestoredEventLogSubscription>;
export type RestoredEventLogSubscriptionResult = Apollo.SubscriptionResult<RestoredEventLogSubscription>;
export const GetJobsDocument = gql`
    query GetJobs($filter: JobFilterArgs, $paging: PageArgs, $sorting: [JobSortArgs!]) {
  jobs(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...jobFields
    }
    totalCount
  }
}
    ${JobFieldsFragmentDoc}`;

/**
 * __useGetJobsQuery__
 *
 * To run a query within a React component, call `useGetJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useGetJobsQuery(baseOptions?: Apollo.QueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
      }
export function useGetJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
        }
export function useGetJobsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
        }
export type GetJobsQueryHookResult = ReturnType<typeof useGetJobsQuery>;
export type GetJobsLazyQueryHookResult = ReturnType<typeof useGetJobsLazyQuery>;
export type GetJobsSuspenseQueryHookResult = ReturnType<typeof useGetJobsSuspenseQuery>;
export type GetJobsQueryResult = Apollo.QueryResult<GetJobsQuery, GetJobsQueryVariables>;
export const GetJobDocument = gql`
    query GetJob($id: ID!) {
  job(id: $id) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDoc}`;

/**
 * __useGetJobQuery__
 *
 * To run a query within a React component, call `useGetJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobQuery(baseOptions: Apollo.QueryHookOptions<GetJobQuery, GetJobQueryVariables> & ({ variables: GetJobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
      }
export function useGetJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobQuery, GetJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
        }
export function useGetJobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJobQuery, GetJobQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
        }
export type GetJobQueryHookResult = ReturnType<typeof useGetJobQuery>;
export type GetJobLazyQueryHookResult = ReturnType<typeof useGetJobLazyQuery>;
export type GetJobSuspenseQueryHookResult = ReturnType<typeof useGetJobSuspenseQuery>;
export type GetJobQueryResult = Apollo.QueryResult<GetJobQuery, GetJobQueryVariables>;
export const CreateJobDocument = gql`
    mutation CreateJob($queue: String!, $status: String!, $log: String) {
  createJob(queue: $queue, status: $status, log: $log) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDoc}`;
export type CreateJobMutationFn = Apollo.MutationFunction<CreateJobMutation, CreateJobMutationVariables>;

/**
 * __useCreateJobMutation__
 *
 * To run a mutation, you first call `useCreateJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobMutation, { data, loading, error }] = useCreateJobMutation({
 *   variables: {
 *      queue: // value for 'queue'
 *      status: // value for 'status'
 *      log: // value for 'log'
 *   },
 * });
 */
export function useCreateJobMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobMutation, CreateJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobMutation, CreateJobMutationVariables>(CreateJobDocument, options);
      }
export type CreateJobMutationHookResult = ReturnType<typeof useCreateJobMutation>;
export type CreateJobMutationResult = Apollo.MutationResult<CreateJobMutation>;
export type CreateJobMutationOptions = Apollo.BaseMutationOptions<CreateJobMutation, CreateJobMutationVariables>;
export const UpdateJobDocument = gql`
    mutation UpdateJob($id: ID!, $queue: String, $status: String, $log: String) {
  updateJob(id: $id, queue: $queue, status: $status, log: $log) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDoc}`;
export type UpdateJobMutationFn = Apollo.MutationFunction<UpdateJobMutation, UpdateJobMutationVariables>;

/**
 * __useUpdateJobMutation__
 *
 * To run a mutation, you first call `useUpdateJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobMutation, { data, loading, error }] = useUpdateJobMutation({
 *   variables: {
 *      id: // value for 'id'
 *      queue: // value for 'queue'
 *      status: // value for 'status'
 *      log: // value for 'log'
 *   },
 * });
 */
export function useUpdateJobMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobMutation, UpdateJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobMutation, UpdateJobMutationVariables>(UpdateJobDocument, options);
      }
export type UpdateJobMutationHookResult = ReturnType<typeof useUpdateJobMutation>;
export type UpdateJobMutationResult = Apollo.MutationResult<UpdateJobMutation>;
export type UpdateJobMutationOptions = Apollo.BaseMutationOptions<UpdateJobMutation, UpdateJobMutationVariables>;
export const DeleteJobDocument = gql`
    mutation DeleteJob($id: ID!) {
  deleteJob(id: $id) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDoc}`;
export type DeleteJobMutationFn = Apollo.MutationFunction<DeleteJobMutation, DeleteJobMutationVariables>;

/**
 * __useDeleteJobMutation__
 *
 * To run a mutation, you first call `useDeleteJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobMutation, { data, loading, error }] = useDeleteJobMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteJobMutation(baseOptions?: Apollo.MutationHookOptions<DeleteJobMutation, DeleteJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteJobMutation, DeleteJobMutationVariables>(DeleteJobDocument, options);
      }
export type DeleteJobMutationHookResult = ReturnType<typeof useDeleteJobMutation>;
export type DeleteJobMutationResult = Apollo.MutationResult<DeleteJobMutation>;
export type DeleteJobMutationOptions = Apollo.BaseMutationOptions<DeleteJobMutation, DeleteJobMutationVariables>;
export const CreatedJobDocument = gql`
    subscription CreatedJob($filter: JobFilterArgs) {
  createdJob(filter: $filter) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDoc}`;

/**
 * __useCreatedJobSubscription__
 *
 * To run a query within a React component, call `useCreatedJobSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedJobSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedJobSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCreatedJobSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedJobSubscription, CreatedJobSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedJobSubscription, CreatedJobSubscriptionVariables>(CreatedJobDocument, options);
      }
export type CreatedJobSubscriptionHookResult = ReturnType<typeof useCreatedJobSubscription>;
export type CreatedJobSubscriptionResult = Apollo.SubscriptionResult<CreatedJobSubscription>;
export const UpdatedJobDocument = gql`
    subscription UpdatedJob($filter: JobFilterArgs) {
  updatedJob(filter: $filter) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDoc}`;

/**
 * __useUpdatedJobSubscription__
 *
 * To run a query within a React component, call `useUpdatedJobSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedJobSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedJobSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUpdatedJobSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedJobSubscription, UpdatedJobSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedJobSubscription, UpdatedJobSubscriptionVariables>(UpdatedJobDocument, options);
      }
export type UpdatedJobSubscriptionHookResult = ReturnType<typeof useUpdatedJobSubscription>;
export type UpdatedJobSubscriptionResult = Apollo.SubscriptionResult<UpdatedJobSubscription>;
export const DeletedJobDocument = gql`
    subscription DeletedJob($filter: JobFilterArgs) {
  deletedJob(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedJobSubscription__
 *
 * To run a query within a React component, call `useDeletedJobSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedJobSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedJobSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedJobSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedJobSubscription, DeletedJobSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedJobSubscription, DeletedJobSubscriptionVariables>(DeletedJobDocument, options);
      }
export type DeletedJobSubscriptionHookResult = ReturnType<typeof useDeletedJobSubscription>;
export type DeletedJobSubscriptionResult = Apollo.SubscriptionResult<DeletedJobSubscription>;
export const RestoredJobDocument = gql`
    subscription RestoredJob($filter: JobFilterArgs) {
  restoredJob(filter: $filter) {
    ...jobFields
  }
}
    ${JobFieldsFragmentDoc}`;

/**
 * __useRestoredJobSubscription__
 *
 * To run a query within a React component, call `useRestoredJobSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredJobSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredJobSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRestoredJobSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredJobSubscription, RestoredJobSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredJobSubscription, RestoredJobSubscriptionVariables>(RestoredJobDocument, options);
      }
export type RestoredJobSubscriptionHookResult = ReturnType<typeof useRestoredJobSubscription>;
export type RestoredJobSubscriptionResult = Apollo.SubscriptionResult<RestoredJobSubscription>;
export const GetMailLogsDocument = gql`
    query GetMailLogs($filter: MailLogFilterArgs, $paging: PageArgs, $sorting: [MailLogSortArgs!]) {
  mailLogs(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...mailLogFields
    }
    totalCount
  }
}
    ${MailLogFieldsFragmentDoc}`;

/**
 * __useGetMailLogsQuery__
 *
 * To run a query within a React component, call `useGetMailLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailLogsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useGetMailLogsQuery(baseOptions?: Apollo.QueryHookOptions<GetMailLogsQuery, GetMailLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailLogsQuery, GetMailLogsQueryVariables>(GetMailLogsDocument, options);
      }
export function useGetMailLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailLogsQuery, GetMailLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailLogsQuery, GetMailLogsQueryVariables>(GetMailLogsDocument, options);
        }
export function useGetMailLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailLogsQuery, GetMailLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMailLogsQuery, GetMailLogsQueryVariables>(GetMailLogsDocument, options);
        }
export type GetMailLogsQueryHookResult = ReturnType<typeof useGetMailLogsQuery>;
export type GetMailLogsLazyQueryHookResult = ReturnType<typeof useGetMailLogsLazyQuery>;
export type GetMailLogsSuspenseQueryHookResult = ReturnType<typeof useGetMailLogsSuspenseQuery>;
export type GetMailLogsQueryResult = Apollo.QueryResult<GetMailLogsQuery, GetMailLogsQueryVariables>;
export const GetMailLogDocument = gql`
    query GetMailLog($id: ID!) {
  mailLog(id: $id) {
    ...mailLogFields
  }
}
    ${MailLogFieldsFragmentDoc}`;

/**
 * __useGetMailLogQuery__
 *
 * To run a query within a React component, call `useGetMailLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailLogQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMailLogQuery(baseOptions: Apollo.QueryHookOptions<GetMailLogQuery, GetMailLogQueryVariables> & ({ variables: GetMailLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailLogQuery, GetMailLogQueryVariables>(GetMailLogDocument, options);
      }
export function useGetMailLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailLogQuery, GetMailLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailLogQuery, GetMailLogQueryVariables>(GetMailLogDocument, options);
        }
export function useGetMailLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailLogQuery, GetMailLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMailLogQuery, GetMailLogQueryVariables>(GetMailLogDocument, options);
        }
export type GetMailLogQueryHookResult = ReturnType<typeof useGetMailLogQuery>;
export type GetMailLogLazyQueryHookResult = ReturnType<typeof useGetMailLogLazyQuery>;
export type GetMailLogSuspenseQueryHookResult = ReturnType<typeof useGetMailLogSuspenseQuery>;
export type GetMailLogQueryResult = Apollo.QueryResult<GetMailLogQuery, GetMailLogQueryVariables>;
export const CreateMailLogDocument = gql`
    mutation CreateMailLog($sentTo: String!, $sentBy: String!, $emailTemplate: String, $status: String, $message: String, $reason: String) {
  createMailLog(
    sentTo: $sentTo
    sentBy: $sentBy
    emailTemplate: $emailTemplate
    status: $status
    message: $message
    reason: $reason
  ) {
    ...mailLogFields
  }
}
    ${MailLogFieldsFragmentDoc}`;
export type CreateMailLogMutationFn = Apollo.MutationFunction<CreateMailLogMutation, CreateMailLogMutationVariables>;

/**
 * __useCreateMailLogMutation__
 *
 * To run a mutation, you first call `useCreateMailLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMailLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMailLogMutation, { data, loading, error }] = useCreateMailLogMutation({
 *   variables: {
 *      sentTo: // value for 'sentTo'
 *      sentBy: // value for 'sentBy'
 *      emailTemplate: // value for 'emailTemplate'
 *      status: // value for 'status'
 *      message: // value for 'message'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCreateMailLogMutation(baseOptions?: Apollo.MutationHookOptions<CreateMailLogMutation, CreateMailLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMailLogMutation, CreateMailLogMutationVariables>(CreateMailLogDocument, options);
      }
export type CreateMailLogMutationHookResult = ReturnType<typeof useCreateMailLogMutation>;
export type CreateMailLogMutationResult = Apollo.MutationResult<CreateMailLogMutation>;
export type CreateMailLogMutationOptions = Apollo.BaseMutationOptions<CreateMailLogMutation, CreateMailLogMutationVariables>;
export const UpdateMailLogDocument = gql`
    mutation UpdateMailLog($id: ID!, $sentTo: String, $sentBy: String, $emailTemplate: String, $status: String, $message: String, $reason: String) {
  updateMailLog(
    id: $id
    sentTo: $sentTo
    sentBy: $sentBy
    emailTemplate: $emailTemplate
    status: $status
    message: $message
    reason: $reason
  ) {
    ...mailLogFields
  }
}
    ${MailLogFieldsFragmentDoc}`;
export type UpdateMailLogMutationFn = Apollo.MutationFunction<UpdateMailLogMutation, UpdateMailLogMutationVariables>;

/**
 * __useUpdateMailLogMutation__
 *
 * To run a mutation, you first call `useUpdateMailLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMailLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMailLogMutation, { data, loading, error }] = useUpdateMailLogMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sentTo: // value for 'sentTo'
 *      sentBy: // value for 'sentBy'
 *      emailTemplate: // value for 'emailTemplate'
 *      status: // value for 'status'
 *      message: // value for 'message'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useUpdateMailLogMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMailLogMutation, UpdateMailLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMailLogMutation, UpdateMailLogMutationVariables>(UpdateMailLogDocument, options);
      }
export type UpdateMailLogMutationHookResult = ReturnType<typeof useUpdateMailLogMutation>;
export type UpdateMailLogMutationResult = Apollo.MutationResult<UpdateMailLogMutation>;
export type UpdateMailLogMutationOptions = Apollo.BaseMutationOptions<UpdateMailLogMutation, UpdateMailLogMutationVariables>;
export const DeleteMailLogDocument = gql`
    mutation DeleteMailLog($id: ID!) {
  deleteMailLog(id: $id) {
    ...mailLogFields
  }
}
    ${MailLogFieldsFragmentDoc}`;
export type DeleteMailLogMutationFn = Apollo.MutationFunction<DeleteMailLogMutation, DeleteMailLogMutationVariables>;

/**
 * __useDeleteMailLogMutation__
 *
 * To run a mutation, you first call `useDeleteMailLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMailLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMailLogMutation, { data, loading, error }] = useDeleteMailLogMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMailLogMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMailLogMutation, DeleteMailLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMailLogMutation, DeleteMailLogMutationVariables>(DeleteMailLogDocument, options);
      }
export type DeleteMailLogMutationHookResult = ReturnType<typeof useDeleteMailLogMutation>;
export type DeleteMailLogMutationResult = Apollo.MutationResult<DeleteMailLogMutation>;
export type DeleteMailLogMutationOptions = Apollo.BaseMutationOptions<DeleteMailLogMutation, DeleteMailLogMutationVariables>;
export const CreatedMailLogDocument = gql`
    subscription CreatedMailLog($filter: MailLogFilterArgs) {
  createdMailLog(filter: $filter) {
    ...mailLogFields
  }
}
    ${MailLogFieldsFragmentDoc}`;

/**
 * __useCreatedMailLogSubscription__
 *
 * To run a query within a React component, call `useCreatedMailLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedMailLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedMailLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCreatedMailLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedMailLogSubscription, CreatedMailLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedMailLogSubscription, CreatedMailLogSubscriptionVariables>(CreatedMailLogDocument, options);
      }
export type CreatedMailLogSubscriptionHookResult = ReturnType<typeof useCreatedMailLogSubscription>;
export type CreatedMailLogSubscriptionResult = Apollo.SubscriptionResult<CreatedMailLogSubscription>;
export const UpdatedMailLogDocument = gql`
    subscription UpdatedMailLog($filter: MailLogFilterArgs) {
  updatedMailLog(filter: $filter) {
    ...mailLogFields
  }
}
    ${MailLogFieldsFragmentDoc}`;

/**
 * __useUpdatedMailLogSubscription__
 *
 * To run a query within a React component, call `useUpdatedMailLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedMailLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedMailLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUpdatedMailLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedMailLogSubscription, UpdatedMailLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedMailLogSubscription, UpdatedMailLogSubscriptionVariables>(UpdatedMailLogDocument, options);
      }
export type UpdatedMailLogSubscriptionHookResult = ReturnType<typeof useUpdatedMailLogSubscription>;
export type UpdatedMailLogSubscriptionResult = Apollo.SubscriptionResult<UpdatedMailLogSubscription>;
export const DeletedMailLogDocument = gql`
    subscription DeletedMailLog($filter: MailLogFilterArgs) {
  deletedMailLog(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedMailLogSubscription__
 *
 * To run a query within a React component, call `useDeletedMailLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedMailLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedMailLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedMailLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedMailLogSubscription, DeletedMailLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedMailLogSubscription, DeletedMailLogSubscriptionVariables>(DeletedMailLogDocument, options);
      }
export type DeletedMailLogSubscriptionHookResult = ReturnType<typeof useDeletedMailLogSubscription>;
export type DeletedMailLogSubscriptionResult = Apollo.SubscriptionResult<DeletedMailLogSubscription>;
export const RestoredMailLogDocument = gql`
    subscription RestoredMailLog($filter: MailLogFilterArgs) {
  restoredMailLog(filter: $filter) {
    ...mailLogFields
  }
}
    ${MailLogFieldsFragmentDoc}`;

/**
 * __useRestoredMailLogSubscription__
 *
 * To run a query within a React component, call `useRestoredMailLogSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredMailLogSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredMailLogSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRestoredMailLogSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredMailLogSubscription, RestoredMailLogSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredMailLogSubscription, RestoredMailLogSubscriptionVariables>(RestoredMailLogDocument, options);
      }
export type RestoredMailLogSubscriptionHookResult = ReturnType<typeof useRestoredMailLogSubscription>;
export type RestoredMailLogSubscriptionResult = Apollo.SubscriptionResult<RestoredMailLogSubscription>;
export const GetMailTemplatesDocument = gql`
    query GetMailTemplates($filter: MailTemplateFilterArgs, $paging: PageArgs, $sorting: [MailTemplateSortArgs!], $withMailTemplateFills: Boolean = false, $withReminder: Boolean = false) {
  mailTemplates(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...mailTemplateFields
    }
    totalCount
  }
}
    ${MailTemplateFieldsFragmentDoc}`;

/**
 * __useGetMailTemplatesQuery__
 *
 * To run a query within a React component, call `useGetMailTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailTemplatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withMailTemplateFills: // value for 'withMailTemplateFills'
 *      withReminder: // value for 'withReminder'
 *   },
 * });
 */
export function useGetMailTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetMailTemplatesQuery, GetMailTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailTemplatesQuery, GetMailTemplatesQueryVariables>(GetMailTemplatesDocument, options);
      }
export function useGetMailTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailTemplatesQuery, GetMailTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailTemplatesQuery, GetMailTemplatesQueryVariables>(GetMailTemplatesDocument, options);
        }
export function useGetMailTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailTemplatesQuery, GetMailTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMailTemplatesQuery, GetMailTemplatesQueryVariables>(GetMailTemplatesDocument, options);
        }
export type GetMailTemplatesQueryHookResult = ReturnType<typeof useGetMailTemplatesQuery>;
export type GetMailTemplatesLazyQueryHookResult = ReturnType<typeof useGetMailTemplatesLazyQuery>;
export type GetMailTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetMailTemplatesSuspenseQuery>;
export type GetMailTemplatesQueryResult = Apollo.QueryResult<GetMailTemplatesQuery, GetMailTemplatesQueryVariables>;
export const GetMailTemplateDocument = gql`
    query GetMailTemplate($id: ID!, $withMailTemplateFills: Boolean = false, $withReminder: Boolean = false) {
  mailTemplate(id: $id) {
    ...mailTemplateFields
  }
}
    ${MailTemplateFieldsFragmentDoc}`;

/**
 * __useGetMailTemplateQuery__
 *
 * To run a query within a React component, call `useGetMailTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withMailTemplateFills: // value for 'withMailTemplateFills'
 *      withReminder: // value for 'withReminder'
 *   },
 * });
 */
export function useGetMailTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetMailTemplateQuery, GetMailTemplateQueryVariables> & ({ variables: GetMailTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailTemplateQuery, GetMailTemplateQueryVariables>(GetMailTemplateDocument, options);
      }
export function useGetMailTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailTemplateQuery, GetMailTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailTemplateQuery, GetMailTemplateQueryVariables>(GetMailTemplateDocument, options);
        }
export function useGetMailTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailTemplateQuery, GetMailTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMailTemplateQuery, GetMailTemplateQueryVariables>(GetMailTemplateDocument, options);
        }
export type GetMailTemplateQueryHookResult = ReturnType<typeof useGetMailTemplateQuery>;
export type GetMailTemplateLazyQueryHookResult = ReturnType<typeof useGetMailTemplateLazyQuery>;
export type GetMailTemplateSuspenseQueryHookResult = ReturnType<typeof useGetMailTemplateSuspenseQuery>;
export type GetMailTemplateQueryResult = Apollo.QueryResult<GetMailTemplateQuery, GetMailTemplateQueryVariables>;
export const GetAllRelatedDataForMailTemplateDocument = gql`
    query GetAllRelatedDataForMailTemplate($withMailTemplateFills: Boolean = false, $withReminders: Boolean = false) {
  mailTemplateFills @include(if: $withMailTemplateFills) {
    items {
      id
      displayField: title
    }
  }
  reminders @include(if: $withReminders) {
    items {
      id
      displayField: id
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForMailTemplateQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForMailTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForMailTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForMailTemplateQuery({
 *   variables: {
 *      withMailTemplateFills: // value for 'withMailTemplateFills'
 *      withReminders: // value for 'withReminders'
 *   },
 * });
 */
export function useGetAllRelatedDataForMailTemplateQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForMailTemplateQuery, GetAllRelatedDataForMailTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForMailTemplateQuery, GetAllRelatedDataForMailTemplateQueryVariables>(GetAllRelatedDataForMailTemplateDocument, options);
      }
export function useGetAllRelatedDataForMailTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForMailTemplateQuery, GetAllRelatedDataForMailTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForMailTemplateQuery, GetAllRelatedDataForMailTemplateQueryVariables>(GetAllRelatedDataForMailTemplateDocument, options);
        }
export function useGetAllRelatedDataForMailTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForMailTemplateQuery, GetAllRelatedDataForMailTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForMailTemplateQuery, GetAllRelatedDataForMailTemplateQueryVariables>(GetAllRelatedDataForMailTemplateDocument, options);
        }
export type GetAllRelatedDataForMailTemplateQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMailTemplateQuery>;
export type GetAllRelatedDataForMailTemplateLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMailTemplateLazyQuery>;
export type GetAllRelatedDataForMailTemplateSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMailTemplateSuspenseQuery>;
export type GetAllRelatedDataForMailTemplateQueryResult = Apollo.QueryResult<GetAllRelatedDataForMailTemplateQuery, GetAllRelatedDataForMailTemplateQueryVariables>;
export const CreateMailTemplateDocument = gql`
    mutation CreateMailTemplate($active: Boolean!, $mailTemplateFills: [ID], $withMailTemplateFills: Boolean = false, $withReminder: Boolean = false) {
  createMailTemplate(active: $active, mailTemplateFillIds: $mailTemplateFills) {
    ...mailTemplateFields
  }
}
    ${MailTemplateFieldsFragmentDoc}`;
export type CreateMailTemplateMutationFn = Apollo.MutationFunction<CreateMailTemplateMutation, CreateMailTemplateMutationVariables>;

/**
 * __useCreateMailTemplateMutation__
 *
 * To run a mutation, you first call `useCreateMailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMailTemplateMutation, { data, loading, error }] = useCreateMailTemplateMutation({
 *   variables: {
 *      active: // value for 'active'
 *      mailTemplateFills: // value for 'mailTemplateFills'
 *      withMailTemplateFills: // value for 'withMailTemplateFills'
 *      withReminder: // value for 'withReminder'
 *   },
 * });
 */
export function useCreateMailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateMailTemplateMutation, CreateMailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMailTemplateMutation, CreateMailTemplateMutationVariables>(CreateMailTemplateDocument, options);
      }
export type CreateMailTemplateMutationHookResult = ReturnType<typeof useCreateMailTemplateMutation>;
export type CreateMailTemplateMutationResult = Apollo.MutationResult<CreateMailTemplateMutation>;
export type CreateMailTemplateMutationOptions = Apollo.BaseMutationOptions<CreateMailTemplateMutation, CreateMailTemplateMutationVariables>;
export const UpdateMailTemplateDocument = gql`
    mutation UpdateMailTemplate($id: ID!, $active: Boolean, $mailTemplateFills: [ID], $withMailTemplateFills: Boolean = false, $withReminder: Boolean = false) {
  updateMailTemplate(
    id: $id
    active: $active
    mailTemplateFillIds: $mailTemplateFills
  ) {
    ...mailTemplateFields
  }
}
    ${MailTemplateFieldsFragmentDoc}`;
export type UpdateMailTemplateMutationFn = Apollo.MutationFunction<UpdateMailTemplateMutation, UpdateMailTemplateMutationVariables>;

/**
 * __useUpdateMailTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateMailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMailTemplateMutation, { data, loading, error }] = useUpdateMailTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      active: // value for 'active'
 *      mailTemplateFills: // value for 'mailTemplateFills'
 *      withMailTemplateFills: // value for 'withMailTemplateFills'
 *      withReminder: // value for 'withReminder'
 *   },
 * });
 */
export function useUpdateMailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMailTemplateMutation, UpdateMailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMailTemplateMutation, UpdateMailTemplateMutationVariables>(UpdateMailTemplateDocument, options);
      }
export type UpdateMailTemplateMutationHookResult = ReturnType<typeof useUpdateMailTemplateMutation>;
export type UpdateMailTemplateMutationResult = Apollo.MutationResult<UpdateMailTemplateMutation>;
export type UpdateMailTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateMailTemplateMutation, UpdateMailTemplateMutationVariables>;
export const DeleteMailTemplateDocument = gql`
    mutation DeleteMailTemplate($id: ID!, $withMailTemplateFills: Boolean = false, $withReminder: Boolean = false) {
  deleteMailTemplate(id: $id) {
    ...mailTemplateFields
  }
}
    ${MailTemplateFieldsFragmentDoc}`;
export type DeleteMailTemplateMutationFn = Apollo.MutationFunction<DeleteMailTemplateMutation, DeleteMailTemplateMutationVariables>;

/**
 * __useDeleteMailTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteMailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMailTemplateMutation, { data, loading, error }] = useDeleteMailTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withMailTemplateFills: // value for 'withMailTemplateFills'
 *      withReminder: // value for 'withReminder'
 *   },
 * });
 */
export function useDeleteMailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMailTemplateMutation, DeleteMailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMailTemplateMutation, DeleteMailTemplateMutationVariables>(DeleteMailTemplateDocument, options);
      }
export type DeleteMailTemplateMutationHookResult = ReturnType<typeof useDeleteMailTemplateMutation>;
export type DeleteMailTemplateMutationResult = Apollo.MutationResult<DeleteMailTemplateMutation>;
export type DeleteMailTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteMailTemplateMutation, DeleteMailTemplateMutationVariables>;
export const CreatedMailTemplateDocument = gql`
    subscription CreatedMailTemplate($filter: MailTemplateFilterArgs, $withMailTemplateFills: Boolean = false, $withReminder: Boolean = false) {
  createdMailTemplate(filter: $filter) {
    ...mailTemplateFields
  }
}
    ${MailTemplateFieldsFragmentDoc}`;

/**
 * __useCreatedMailTemplateSubscription__
 *
 * To run a query within a React component, call `useCreatedMailTemplateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedMailTemplateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedMailTemplateSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withMailTemplateFills: // value for 'withMailTemplateFills'
 *      withReminder: // value for 'withReminder'
 *   },
 * });
 */
export function useCreatedMailTemplateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedMailTemplateSubscription, CreatedMailTemplateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedMailTemplateSubscription, CreatedMailTemplateSubscriptionVariables>(CreatedMailTemplateDocument, options);
      }
export type CreatedMailTemplateSubscriptionHookResult = ReturnType<typeof useCreatedMailTemplateSubscription>;
export type CreatedMailTemplateSubscriptionResult = Apollo.SubscriptionResult<CreatedMailTemplateSubscription>;
export const UpdatedMailTemplateDocument = gql`
    subscription UpdatedMailTemplate($filter: MailTemplateFilterArgs, $withMailTemplateFills: Boolean = false, $withReminder: Boolean = false) {
  updatedMailTemplate(filter: $filter) {
    ...mailTemplateFields
  }
}
    ${MailTemplateFieldsFragmentDoc}`;

/**
 * __useUpdatedMailTemplateSubscription__
 *
 * To run a query within a React component, call `useUpdatedMailTemplateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedMailTemplateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedMailTemplateSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withMailTemplateFills: // value for 'withMailTemplateFills'
 *      withReminder: // value for 'withReminder'
 *   },
 * });
 */
export function useUpdatedMailTemplateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedMailTemplateSubscription, UpdatedMailTemplateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedMailTemplateSubscription, UpdatedMailTemplateSubscriptionVariables>(UpdatedMailTemplateDocument, options);
      }
export type UpdatedMailTemplateSubscriptionHookResult = ReturnType<typeof useUpdatedMailTemplateSubscription>;
export type UpdatedMailTemplateSubscriptionResult = Apollo.SubscriptionResult<UpdatedMailTemplateSubscription>;
export const DeletedMailTemplateDocument = gql`
    subscription DeletedMailTemplate($filter: MailTemplateFilterArgs) {
  deletedMailTemplate(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedMailTemplateSubscription__
 *
 * To run a query within a React component, call `useDeletedMailTemplateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedMailTemplateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedMailTemplateSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedMailTemplateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedMailTemplateSubscription, DeletedMailTemplateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedMailTemplateSubscription, DeletedMailTemplateSubscriptionVariables>(DeletedMailTemplateDocument, options);
      }
export type DeletedMailTemplateSubscriptionHookResult = ReturnType<typeof useDeletedMailTemplateSubscription>;
export type DeletedMailTemplateSubscriptionResult = Apollo.SubscriptionResult<DeletedMailTemplateSubscription>;
export const GetMailTemplateFillsDocument = gql`
    query GetMailTemplateFills($filter: MailTemplateFillFilterArgs, $paging: PageArgs, $sorting: [MailTemplateFillSortArgs!], $withMailTemplate: Boolean = false) {
  mailTemplateFills(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...mailTemplateFillFields
    }
    totalCount
  }
}
    ${MailTemplateFillFieldsFragmentDoc}`;

/**
 * __useGetMailTemplateFillsQuery__
 *
 * To run a query within a React component, call `useGetMailTemplateFillsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailTemplateFillsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailTemplateFillsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useGetMailTemplateFillsQuery(baseOptions?: Apollo.QueryHookOptions<GetMailTemplateFillsQuery, GetMailTemplateFillsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailTemplateFillsQuery, GetMailTemplateFillsQueryVariables>(GetMailTemplateFillsDocument, options);
      }
export function useGetMailTemplateFillsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailTemplateFillsQuery, GetMailTemplateFillsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailTemplateFillsQuery, GetMailTemplateFillsQueryVariables>(GetMailTemplateFillsDocument, options);
        }
export function useGetMailTemplateFillsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailTemplateFillsQuery, GetMailTemplateFillsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMailTemplateFillsQuery, GetMailTemplateFillsQueryVariables>(GetMailTemplateFillsDocument, options);
        }
export type GetMailTemplateFillsQueryHookResult = ReturnType<typeof useGetMailTemplateFillsQuery>;
export type GetMailTemplateFillsLazyQueryHookResult = ReturnType<typeof useGetMailTemplateFillsLazyQuery>;
export type GetMailTemplateFillsSuspenseQueryHookResult = ReturnType<typeof useGetMailTemplateFillsSuspenseQuery>;
export type GetMailTemplateFillsQueryResult = Apollo.QueryResult<GetMailTemplateFillsQuery, GetMailTemplateFillsQueryVariables>;
export const GetMailTemplateFillDocument = gql`
    query GetMailTemplateFill($id: ID!, $withMailTemplate: Boolean = false) {
  mailTemplateFill(id: $id) {
    ...mailTemplateFillFields
  }
}
    ${MailTemplateFillFieldsFragmentDoc}`;

/**
 * __useGetMailTemplateFillQuery__
 *
 * To run a query within a React component, call `useGetMailTemplateFillQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailTemplateFillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailTemplateFillQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useGetMailTemplateFillQuery(baseOptions: Apollo.QueryHookOptions<GetMailTemplateFillQuery, GetMailTemplateFillQueryVariables> & ({ variables: GetMailTemplateFillQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailTemplateFillQuery, GetMailTemplateFillQueryVariables>(GetMailTemplateFillDocument, options);
      }
export function useGetMailTemplateFillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailTemplateFillQuery, GetMailTemplateFillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailTemplateFillQuery, GetMailTemplateFillQueryVariables>(GetMailTemplateFillDocument, options);
        }
export function useGetMailTemplateFillSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMailTemplateFillQuery, GetMailTemplateFillQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMailTemplateFillQuery, GetMailTemplateFillQueryVariables>(GetMailTemplateFillDocument, options);
        }
export type GetMailTemplateFillQueryHookResult = ReturnType<typeof useGetMailTemplateFillQuery>;
export type GetMailTemplateFillLazyQueryHookResult = ReturnType<typeof useGetMailTemplateFillLazyQuery>;
export type GetMailTemplateFillSuspenseQueryHookResult = ReturnType<typeof useGetMailTemplateFillSuspenseQuery>;
export type GetMailTemplateFillQueryResult = Apollo.QueryResult<GetMailTemplateFillQuery, GetMailTemplateFillQueryVariables>;
export const GetAllRelatedDataForMailTemplateFillDocument = gql`
    query GetAllRelatedDataForMailTemplateFill($withMailTemplates: Boolean = false) {
  mailTemplates @include(if: $withMailTemplates) {
    items {
      id
      displayField: id
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForMailTemplateFillQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForMailTemplateFillQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForMailTemplateFillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForMailTemplateFillQuery({
 *   variables: {
 *      withMailTemplates: // value for 'withMailTemplates'
 *   },
 * });
 */
export function useGetAllRelatedDataForMailTemplateFillQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForMailTemplateFillQuery, GetAllRelatedDataForMailTemplateFillQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForMailTemplateFillQuery, GetAllRelatedDataForMailTemplateFillQueryVariables>(GetAllRelatedDataForMailTemplateFillDocument, options);
      }
export function useGetAllRelatedDataForMailTemplateFillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForMailTemplateFillQuery, GetAllRelatedDataForMailTemplateFillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForMailTemplateFillQuery, GetAllRelatedDataForMailTemplateFillQueryVariables>(GetAllRelatedDataForMailTemplateFillDocument, options);
        }
export function useGetAllRelatedDataForMailTemplateFillSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForMailTemplateFillQuery, GetAllRelatedDataForMailTemplateFillQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForMailTemplateFillQuery, GetAllRelatedDataForMailTemplateFillQueryVariables>(GetAllRelatedDataForMailTemplateFillDocument, options);
        }
export type GetAllRelatedDataForMailTemplateFillQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMailTemplateFillQuery>;
export type GetAllRelatedDataForMailTemplateFillLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMailTemplateFillLazyQuery>;
export type GetAllRelatedDataForMailTemplateFillSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMailTemplateFillSuspenseQuery>;
export type GetAllRelatedDataForMailTemplateFillQueryResult = Apollo.QueryResult<GetAllRelatedDataForMailTemplateFillQuery, GetAllRelatedDataForMailTemplateFillQueryVariables>;
export const CreateMailTemplateFillDocument = gql`
    mutation CreateMailTemplateFill($subject: String!, $urlText: String, $title: String, $heading: String, $preHeader: String, $disclaimer: String, $text: String!, $plainText: String!, $language: String!, $mailTemplateId: ID!, $withMailTemplate: Boolean = false) {
  createMailTemplateFill(
    subject: $subject
    urlText: $urlText
    title: $title
    heading: $heading
    preHeader: $preHeader
    disclaimer: $disclaimer
    text: $text
    plainText: $plainText
    language: $language
    mailTemplateId: $mailTemplateId
  ) {
    ...mailTemplateFillFields
  }
}
    ${MailTemplateFillFieldsFragmentDoc}`;
export type CreateMailTemplateFillMutationFn = Apollo.MutationFunction<CreateMailTemplateFillMutation, CreateMailTemplateFillMutationVariables>;

/**
 * __useCreateMailTemplateFillMutation__
 *
 * To run a mutation, you first call `useCreateMailTemplateFillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMailTemplateFillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMailTemplateFillMutation, { data, loading, error }] = useCreateMailTemplateFillMutation({
 *   variables: {
 *      subject: // value for 'subject'
 *      urlText: // value for 'urlText'
 *      title: // value for 'title'
 *      heading: // value for 'heading'
 *      preHeader: // value for 'preHeader'
 *      disclaimer: // value for 'disclaimer'
 *      text: // value for 'text'
 *      plainText: // value for 'plainText'
 *      language: // value for 'language'
 *      mailTemplateId: // value for 'mailTemplateId'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useCreateMailTemplateFillMutation(baseOptions?: Apollo.MutationHookOptions<CreateMailTemplateFillMutation, CreateMailTemplateFillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMailTemplateFillMutation, CreateMailTemplateFillMutationVariables>(CreateMailTemplateFillDocument, options);
      }
export type CreateMailTemplateFillMutationHookResult = ReturnType<typeof useCreateMailTemplateFillMutation>;
export type CreateMailTemplateFillMutationResult = Apollo.MutationResult<CreateMailTemplateFillMutation>;
export type CreateMailTemplateFillMutationOptions = Apollo.BaseMutationOptions<CreateMailTemplateFillMutation, CreateMailTemplateFillMutationVariables>;
export const UpdateMailTemplateFillDocument = gql`
    mutation UpdateMailTemplateFill($id: ID!, $subject: String, $urlText: String, $title: String, $heading: String, $preHeader: String, $disclaimer: String, $text: String, $plainText: String, $language: String, $mailTemplateId: ID, $withMailTemplate: Boolean = false) {
  updateMailTemplateFill(
    id: $id
    subject: $subject
    urlText: $urlText
    title: $title
    heading: $heading
    preHeader: $preHeader
    disclaimer: $disclaimer
    text: $text
    plainText: $plainText
    language: $language
    mailTemplateId: $mailTemplateId
  ) {
    ...mailTemplateFillFields
  }
}
    ${MailTemplateFillFieldsFragmentDoc}`;
export type UpdateMailTemplateFillMutationFn = Apollo.MutationFunction<UpdateMailTemplateFillMutation, UpdateMailTemplateFillMutationVariables>;

/**
 * __useUpdateMailTemplateFillMutation__
 *
 * To run a mutation, you first call `useUpdateMailTemplateFillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMailTemplateFillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMailTemplateFillMutation, { data, loading, error }] = useUpdateMailTemplateFillMutation({
 *   variables: {
 *      id: // value for 'id'
 *      subject: // value for 'subject'
 *      urlText: // value for 'urlText'
 *      title: // value for 'title'
 *      heading: // value for 'heading'
 *      preHeader: // value for 'preHeader'
 *      disclaimer: // value for 'disclaimer'
 *      text: // value for 'text'
 *      plainText: // value for 'plainText'
 *      language: // value for 'language'
 *      mailTemplateId: // value for 'mailTemplateId'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useUpdateMailTemplateFillMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMailTemplateFillMutation, UpdateMailTemplateFillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMailTemplateFillMutation, UpdateMailTemplateFillMutationVariables>(UpdateMailTemplateFillDocument, options);
      }
export type UpdateMailTemplateFillMutationHookResult = ReturnType<typeof useUpdateMailTemplateFillMutation>;
export type UpdateMailTemplateFillMutationResult = Apollo.MutationResult<UpdateMailTemplateFillMutation>;
export type UpdateMailTemplateFillMutationOptions = Apollo.BaseMutationOptions<UpdateMailTemplateFillMutation, UpdateMailTemplateFillMutationVariables>;
export const DeleteMailTemplateFillDocument = gql`
    mutation DeleteMailTemplateFill($id: ID!, $withMailTemplate: Boolean = false) {
  deleteMailTemplateFill(id: $id) {
    ...mailTemplateFillFields
  }
}
    ${MailTemplateFillFieldsFragmentDoc}`;
export type DeleteMailTemplateFillMutationFn = Apollo.MutationFunction<DeleteMailTemplateFillMutation, DeleteMailTemplateFillMutationVariables>;

/**
 * __useDeleteMailTemplateFillMutation__
 *
 * To run a mutation, you first call `useDeleteMailTemplateFillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMailTemplateFillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMailTemplateFillMutation, { data, loading, error }] = useDeleteMailTemplateFillMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useDeleteMailTemplateFillMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMailTemplateFillMutation, DeleteMailTemplateFillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMailTemplateFillMutation, DeleteMailTemplateFillMutationVariables>(DeleteMailTemplateFillDocument, options);
      }
export type DeleteMailTemplateFillMutationHookResult = ReturnType<typeof useDeleteMailTemplateFillMutation>;
export type DeleteMailTemplateFillMutationResult = Apollo.MutationResult<DeleteMailTemplateFillMutation>;
export type DeleteMailTemplateFillMutationOptions = Apollo.BaseMutationOptions<DeleteMailTemplateFillMutation, DeleteMailTemplateFillMutationVariables>;
export const CreatedMailTemplateFillDocument = gql`
    subscription CreatedMailTemplateFill($filter: MailTemplateFillFilterArgs, $withMailTemplate: Boolean = false) {
  createdMailTemplateFill(filter: $filter) {
    ...mailTemplateFillFields
  }
}
    ${MailTemplateFillFieldsFragmentDoc}`;

/**
 * __useCreatedMailTemplateFillSubscription__
 *
 * To run a query within a React component, call `useCreatedMailTemplateFillSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedMailTemplateFillSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedMailTemplateFillSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useCreatedMailTemplateFillSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedMailTemplateFillSubscription, CreatedMailTemplateFillSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedMailTemplateFillSubscription, CreatedMailTemplateFillSubscriptionVariables>(CreatedMailTemplateFillDocument, options);
      }
export type CreatedMailTemplateFillSubscriptionHookResult = ReturnType<typeof useCreatedMailTemplateFillSubscription>;
export type CreatedMailTemplateFillSubscriptionResult = Apollo.SubscriptionResult<CreatedMailTemplateFillSubscription>;
export const UpdatedMailTemplateFillDocument = gql`
    subscription UpdatedMailTemplateFill($filter: MailTemplateFillFilterArgs, $withMailTemplate: Boolean = false) {
  updatedMailTemplateFill(filter: $filter) {
    ...mailTemplateFillFields
  }
}
    ${MailTemplateFillFieldsFragmentDoc}`;

/**
 * __useUpdatedMailTemplateFillSubscription__
 *
 * To run a query within a React component, call `useUpdatedMailTemplateFillSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedMailTemplateFillSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedMailTemplateFillSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useUpdatedMailTemplateFillSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedMailTemplateFillSubscription, UpdatedMailTemplateFillSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedMailTemplateFillSubscription, UpdatedMailTemplateFillSubscriptionVariables>(UpdatedMailTemplateFillDocument, options);
      }
export type UpdatedMailTemplateFillSubscriptionHookResult = ReturnType<typeof useUpdatedMailTemplateFillSubscription>;
export type UpdatedMailTemplateFillSubscriptionResult = Apollo.SubscriptionResult<UpdatedMailTemplateFillSubscription>;
export const DeletedMailTemplateFillDocument = gql`
    subscription DeletedMailTemplateFill($filter: MailTemplateFillFilterArgs) {
  deletedMailTemplateFill(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedMailTemplateFillSubscription__
 *
 * To run a query within a React component, call `useDeletedMailTemplateFillSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedMailTemplateFillSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedMailTemplateFillSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedMailTemplateFillSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedMailTemplateFillSubscription, DeletedMailTemplateFillSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedMailTemplateFillSubscription, DeletedMailTemplateFillSubscriptionVariables>(DeletedMailTemplateFillDocument, options);
      }
export type DeletedMailTemplateFillSubscriptionHookResult = ReturnType<typeof useDeletedMailTemplateFillSubscription>;
export type DeletedMailTemplateFillSubscriptionResult = Apollo.SubscriptionResult<DeletedMailTemplateFillSubscription>;
export const GetMessagesDocument = gql`
    query GetMessages($filter: MessageFilterArgs, $paging: PageArgs, $sorting: [MessageSortArgs!], $withActions: Boolean = false) {
  messages(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...messageFields
    }
    totalCount
  }
}
    ${MessageFieldsFragmentDoc}`;

/**
 * __useGetMessagesQuery__
 *
 * To run a query within a React component, call `useGetMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessagesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withActions: // value for 'withActions'
 *   },
 * });
 */
export function useGetMessagesQuery(baseOptions?: Apollo.QueryHookOptions<GetMessagesQuery, GetMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessagesQuery, GetMessagesQueryVariables>(GetMessagesDocument, options);
      }
export function useGetMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessagesQuery, GetMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessagesQuery, GetMessagesQueryVariables>(GetMessagesDocument, options);
        }
export function useGetMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMessagesQuery, GetMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMessagesQuery, GetMessagesQueryVariables>(GetMessagesDocument, options);
        }
export type GetMessagesQueryHookResult = ReturnType<typeof useGetMessagesQuery>;
export type GetMessagesLazyQueryHookResult = ReturnType<typeof useGetMessagesLazyQuery>;
export type GetMessagesSuspenseQueryHookResult = ReturnType<typeof useGetMessagesSuspenseQuery>;
export type GetMessagesQueryResult = Apollo.QueryResult<GetMessagesQuery, GetMessagesQueryVariables>;
export const GetMessageDocument = gql`
    query GetMessage($id: ID!, $withActions: Boolean = false) {
  message(id: $id) {
    ...messageFields
  }
}
    ${MessageFieldsFragmentDoc}`;

/**
 * __useGetMessageQuery__
 *
 * To run a query within a React component, call `useGetMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withActions: // value for 'withActions'
 *   },
 * });
 */
export function useGetMessageQuery(baseOptions: Apollo.QueryHookOptions<GetMessageQuery, GetMessageQueryVariables> & ({ variables: GetMessageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessageQuery, GetMessageQueryVariables>(GetMessageDocument, options);
      }
export function useGetMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessageQuery, GetMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessageQuery, GetMessageQueryVariables>(GetMessageDocument, options);
        }
export function useGetMessageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMessageQuery, GetMessageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMessageQuery, GetMessageQueryVariables>(GetMessageDocument, options);
        }
export type GetMessageQueryHookResult = ReturnType<typeof useGetMessageQuery>;
export type GetMessageLazyQueryHookResult = ReturnType<typeof useGetMessageLazyQuery>;
export type GetMessageSuspenseQueryHookResult = ReturnType<typeof useGetMessageSuspenseQuery>;
export type GetMessageQueryResult = Apollo.QueryResult<GetMessageQuery, GetMessageQueryVariables>;
export const GetAllRelatedDataForMessageDocument = gql`
    query GetAllRelatedDataForMessage($withActions: Boolean = false) {
  actions @include(if: $withActions) {
    items {
      id
      displayField: name
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForMessageQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForMessageQuery({
 *   variables: {
 *      withActions: // value for 'withActions'
 *   },
 * });
 */
export function useGetAllRelatedDataForMessageQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForMessageQuery, GetAllRelatedDataForMessageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForMessageQuery, GetAllRelatedDataForMessageQueryVariables>(GetAllRelatedDataForMessageDocument, options);
      }
export function useGetAllRelatedDataForMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForMessageQuery, GetAllRelatedDataForMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForMessageQuery, GetAllRelatedDataForMessageQueryVariables>(GetAllRelatedDataForMessageDocument, options);
        }
export function useGetAllRelatedDataForMessageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForMessageQuery, GetAllRelatedDataForMessageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForMessageQuery, GetAllRelatedDataForMessageQueryVariables>(GetAllRelatedDataForMessageDocument, options);
        }
export type GetAllRelatedDataForMessageQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMessageQuery>;
export type GetAllRelatedDataForMessageLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMessageLazyQuery>;
export type GetAllRelatedDataForMessageSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForMessageSuspenseQuery>;
export type GetAllRelatedDataForMessageQueryResult = Apollo.QueryResult<GetAllRelatedDataForMessageQuery, GetAllRelatedDataForMessageQueryVariables>;
export const CreateMessageDocument = gql`
    mutation CreateMessage($title: String!, $content: String!, $actions: [ID], $withActions: Boolean = false) {
  createMessage(title: $title, content: $content, actionIds: $actions) {
    ...messageFields
  }
}
    ${MessageFieldsFragmentDoc}`;
export type CreateMessageMutationFn = Apollo.MutationFunction<CreateMessageMutation, CreateMessageMutationVariables>;

/**
 * __useCreateMessageMutation__
 *
 * To run a mutation, you first call `useCreateMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageMutation, { data, loading, error }] = useCreateMessageMutation({
 *   variables: {
 *      title: // value for 'title'
 *      content: // value for 'content'
 *      actions: // value for 'actions'
 *      withActions: // value for 'withActions'
 *   },
 * });
 */
export function useCreateMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateMessageMutation, CreateMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMessageMutation, CreateMessageMutationVariables>(CreateMessageDocument, options);
      }
export type CreateMessageMutationHookResult = ReturnType<typeof useCreateMessageMutation>;
export type CreateMessageMutationResult = Apollo.MutationResult<CreateMessageMutation>;
export type CreateMessageMutationOptions = Apollo.BaseMutationOptions<CreateMessageMutation, CreateMessageMutationVariables>;
export const UpdateMessageDocument = gql`
    mutation UpdateMessage($id: ID!, $title: String, $content: String, $actions: [ID], $withActions: Boolean = false) {
  updateMessage(id: $id, title: $title, content: $content, actionIds: $actions) {
    ...messageFields
  }
}
    ${MessageFieldsFragmentDoc}`;
export type UpdateMessageMutationFn = Apollo.MutationFunction<UpdateMessageMutation, UpdateMessageMutationVariables>;

/**
 * __useUpdateMessageMutation__
 *
 * To run a mutation, you first call `useUpdateMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessageMutation, { data, loading, error }] = useUpdateMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      content: // value for 'content'
 *      actions: // value for 'actions'
 *      withActions: // value for 'withActions'
 *   },
 * });
 */
export function useUpdateMessageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMessageMutation, UpdateMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMessageMutation, UpdateMessageMutationVariables>(UpdateMessageDocument, options);
      }
export type UpdateMessageMutationHookResult = ReturnType<typeof useUpdateMessageMutation>;
export type UpdateMessageMutationResult = Apollo.MutationResult<UpdateMessageMutation>;
export type UpdateMessageMutationOptions = Apollo.BaseMutationOptions<UpdateMessageMutation, UpdateMessageMutationVariables>;
export const DeleteMessageDocument = gql`
    mutation DeleteMessage($id: ID!, $withActions: Boolean = false) {
  deleteMessage(id: $id) {
    ...messageFields
  }
}
    ${MessageFieldsFragmentDoc}`;
export type DeleteMessageMutationFn = Apollo.MutationFunction<DeleteMessageMutation, DeleteMessageMutationVariables>;

/**
 * __useDeleteMessageMutation__
 *
 * To run a mutation, you first call `useDeleteMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessageMutation, { data, loading, error }] = useDeleteMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withActions: // value for 'withActions'
 *   },
 * });
 */
export function useDeleteMessageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMessageMutation, DeleteMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMessageMutation, DeleteMessageMutationVariables>(DeleteMessageDocument, options);
      }
export type DeleteMessageMutationHookResult = ReturnType<typeof useDeleteMessageMutation>;
export type DeleteMessageMutationResult = Apollo.MutationResult<DeleteMessageMutation>;
export type DeleteMessageMutationOptions = Apollo.BaseMutationOptions<DeleteMessageMutation, DeleteMessageMutationVariables>;
export const CreatedMessageDocument = gql`
    subscription CreatedMessage($filter: MessageFilterArgs, $withActions: Boolean = false) {
  createdMessage(filter: $filter) {
    ...messageFields
  }
}
    ${MessageFieldsFragmentDoc}`;

/**
 * __useCreatedMessageSubscription__
 *
 * To run a query within a React component, call `useCreatedMessageSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedMessageSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedMessageSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withActions: // value for 'withActions'
 *   },
 * });
 */
export function useCreatedMessageSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedMessageSubscription, CreatedMessageSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedMessageSubscription, CreatedMessageSubscriptionVariables>(CreatedMessageDocument, options);
      }
export type CreatedMessageSubscriptionHookResult = ReturnType<typeof useCreatedMessageSubscription>;
export type CreatedMessageSubscriptionResult = Apollo.SubscriptionResult<CreatedMessageSubscription>;
export const UpdatedMessageDocument = gql`
    subscription UpdatedMessage($filter: MessageFilterArgs, $withActions: Boolean = false) {
  updatedMessage(filter: $filter) {
    ...messageFields
  }
}
    ${MessageFieldsFragmentDoc}`;

/**
 * __useUpdatedMessageSubscription__
 *
 * To run a query within a React component, call `useUpdatedMessageSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedMessageSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedMessageSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withActions: // value for 'withActions'
 *   },
 * });
 */
export function useUpdatedMessageSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedMessageSubscription, UpdatedMessageSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedMessageSubscription, UpdatedMessageSubscriptionVariables>(UpdatedMessageDocument, options);
      }
export type UpdatedMessageSubscriptionHookResult = ReturnType<typeof useUpdatedMessageSubscription>;
export type UpdatedMessageSubscriptionResult = Apollo.SubscriptionResult<UpdatedMessageSubscription>;
export const DeletedMessageDocument = gql`
    subscription DeletedMessage($filter: MessageFilterArgs) {
  deletedMessage(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedMessageSubscription__
 *
 * To run a query within a React component, call `useDeletedMessageSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedMessageSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedMessageSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedMessageSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedMessageSubscription, DeletedMessageSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedMessageSubscription, DeletedMessageSubscriptionVariables>(DeletedMessageDocument, options);
      }
export type DeletedMessageSubscriptionHookResult = ReturnType<typeof useDeletedMessageSubscription>;
export type DeletedMessageSubscriptionResult = Apollo.SubscriptionResult<DeletedMessageSubscription>;
export const RestoredMessageDocument = gql`
    subscription RestoredMessage($filter: MessageFilterArgs, $withActions: Boolean = false) {
  restoredMessage(filter: $filter) {
    ...messageFields
  }
}
    ${MessageFieldsFragmentDoc}`;

/**
 * __useRestoredMessageSubscription__
 *
 * To run a query within a React component, call `useRestoredMessageSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredMessageSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredMessageSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withActions: // value for 'withActions'
 *   },
 * });
 */
export function useRestoredMessageSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredMessageSubscription, RestoredMessageSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredMessageSubscription, RestoredMessageSubscriptionVariables>(RestoredMessageDocument, options);
      }
export type RestoredMessageSubscriptionHookResult = ReturnType<typeof useRestoredMessageSubscription>;
export type RestoredMessageSubscriptionResult = Apollo.SubscriptionResult<RestoredMessageSubscription>;
export const GetOrganizationsDocument = gql`
    query GetOrganizations($filter: OrganizationFilterArgs, $paging: PageArgs, $sorting: [OrganizationSortArgs!], $withPerson: Boolean = false) {
  organizations(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...organizationFields
    }
    totalCount
  }
}
    ${OrganizationFieldsFragmentDoc}`;

/**
 * __useGetOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withPerson: // value for 'withPerson'
 *   },
 * });
 */
export function useGetOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
      }
export function useGetOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
export function useGetOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
export type GetOrganizationsQueryHookResult = ReturnType<typeof useGetOrganizationsQuery>;
export type GetOrganizationsLazyQueryHookResult = ReturnType<typeof useGetOrganizationsLazyQuery>;
export type GetOrganizationsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationsSuspenseQuery>;
export type GetOrganizationsQueryResult = Apollo.QueryResult<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export const GetOrganizationDocument = gql`
    query GetOrganization($id: ID!, $withPerson: Boolean = false) {
  organization(id: $id) {
    ...organizationFields
  }
}
    ${OrganizationFieldsFragmentDoc}`;

/**
 * __useGetOrganizationQuery__
 *
 * To run a query within a React component, call `useGetOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withPerson: // value for 'withPerson'
 *   },
 * });
 */
export function useGetOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables> & ({ variables: GetOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
      }
export function useGetOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
        }
export function useGetOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
        }
export type GetOrganizationQueryHookResult = ReturnType<typeof useGetOrganizationQuery>;
export type GetOrganizationLazyQueryHookResult = ReturnType<typeof useGetOrganizationLazyQuery>;
export type GetOrganizationSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationSuspenseQuery>;
export type GetOrganizationQueryResult = Apollo.QueryResult<GetOrganizationQuery, GetOrganizationQueryVariables>;
export const GetAllRelatedDataForOrganizationDocument = gql`
    query GetAllRelatedDataForOrganization($withPeople: Boolean = false) {
  people @include(if: $withPeople) {
    items {
      id
      displayField: id
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForOrganizationQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForOrganizationQuery({
 *   variables: {
 *      withPeople: // value for 'withPeople'
 *   },
 * });
 */
export function useGetAllRelatedDataForOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForOrganizationQuery, GetAllRelatedDataForOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForOrganizationQuery, GetAllRelatedDataForOrganizationQueryVariables>(GetAllRelatedDataForOrganizationDocument, options);
      }
export function useGetAllRelatedDataForOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForOrganizationQuery, GetAllRelatedDataForOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForOrganizationQuery, GetAllRelatedDataForOrganizationQueryVariables>(GetAllRelatedDataForOrganizationDocument, options);
        }
export function useGetAllRelatedDataForOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForOrganizationQuery, GetAllRelatedDataForOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForOrganizationQuery, GetAllRelatedDataForOrganizationQueryVariables>(GetAllRelatedDataForOrganizationDocument, options);
        }
export type GetAllRelatedDataForOrganizationQueryHookResult = ReturnType<typeof useGetAllRelatedDataForOrganizationQuery>;
export type GetAllRelatedDataForOrganizationLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForOrganizationLazyQuery>;
export type GetAllRelatedDataForOrganizationSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForOrganizationSuspenseQuery>;
export type GetAllRelatedDataForOrganizationQueryResult = Apollo.QueryResult<GetAllRelatedDataForOrganizationQuery, GetAllRelatedDataForOrganizationQueryVariables>;
export const CreateOrganizationDocument = gql`
    mutation CreateOrganization($name: String!, $registrationNumber: String!, $personId: ID!, $withPerson: Boolean = false) {
  createOrganization(
    name: $name
    registrationNumber: $registrationNumber
    personId: $personId
  ) {
    ...organizationFields
  }
}
    ${OrganizationFieldsFragmentDoc}`;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<CreateOrganizationMutation, CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      registrationNumber: // value for 'registrationNumber'
 *      personId: // value for 'personId'
 *      withPerson: // value for 'withPerson'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const UpdateOrganizationDocument = gql`
    mutation UpdateOrganization($id: ID!, $name: String, $registrationNumber: String, $personId: ID, $withPerson: Boolean = false) {
  updateOrganization(
    id: $id
    name: $name
    registrationNumber: $registrationNumber
    personId: $personId
  ) {
    ...organizationFields
  }
}
    ${OrganizationFieldsFragmentDoc}`;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      registrationNumber: // value for 'registrationNumber'
 *      personId: // value for 'personId'
 *      withPerson: // value for 'withPerson'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const DeleteOrganizationDocument = gql`
    mutation DeleteOrganization($id: ID!, $withPerson: Boolean = false) {
  deleteOrganization(id: $id) {
    ...organizationFields
  }
}
    ${OrganizationFieldsFragmentDoc}`;
export type DeleteOrganizationMutationFn = Apollo.MutationFunction<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;

/**
 * __useDeleteOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationMutation, { data, loading, error }] = useDeleteOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withPerson: // value for 'withPerson'
 *   },
 * });
 */
export function useDeleteOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>(DeleteOrganizationDocument, options);
      }
export type DeleteOrganizationMutationHookResult = ReturnType<typeof useDeleteOrganizationMutation>;
export type DeleteOrganizationMutationResult = Apollo.MutationResult<DeleteOrganizationMutation>;
export type DeleteOrganizationMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;
export const CreatedOrganizationDocument = gql`
    subscription CreatedOrganization($filter: OrganizationFilterArgs, $withPerson: Boolean = false) {
  createdOrganization(filter: $filter) {
    ...organizationFields
  }
}
    ${OrganizationFieldsFragmentDoc}`;

/**
 * __useCreatedOrganizationSubscription__
 *
 * To run a query within a React component, call `useCreatedOrganizationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedOrganizationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedOrganizationSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withPerson: // value for 'withPerson'
 *   },
 * });
 */
export function useCreatedOrganizationSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedOrganizationSubscription, CreatedOrganizationSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedOrganizationSubscription, CreatedOrganizationSubscriptionVariables>(CreatedOrganizationDocument, options);
      }
export type CreatedOrganizationSubscriptionHookResult = ReturnType<typeof useCreatedOrganizationSubscription>;
export type CreatedOrganizationSubscriptionResult = Apollo.SubscriptionResult<CreatedOrganizationSubscription>;
export const UpdatedOrganizationDocument = gql`
    subscription UpdatedOrganization($filter: OrganizationFilterArgs, $withPerson: Boolean = false) {
  updatedOrganization(filter: $filter) {
    ...organizationFields
  }
}
    ${OrganizationFieldsFragmentDoc}`;

/**
 * __useUpdatedOrganizationSubscription__
 *
 * To run a query within a React component, call `useUpdatedOrganizationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedOrganizationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedOrganizationSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withPerson: // value for 'withPerson'
 *   },
 * });
 */
export function useUpdatedOrganizationSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedOrganizationSubscription, UpdatedOrganizationSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedOrganizationSubscription, UpdatedOrganizationSubscriptionVariables>(UpdatedOrganizationDocument, options);
      }
export type UpdatedOrganizationSubscriptionHookResult = ReturnType<typeof useUpdatedOrganizationSubscription>;
export type UpdatedOrganizationSubscriptionResult = Apollo.SubscriptionResult<UpdatedOrganizationSubscription>;
export const DeletedOrganizationDocument = gql`
    subscription DeletedOrganization($filter: OrganizationFilterArgs) {
  deletedOrganization(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedOrganizationSubscription__
 *
 * To run a query within a React component, call `useDeletedOrganizationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedOrganizationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedOrganizationSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedOrganizationSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedOrganizationSubscription, DeletedOrganizationSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedOrganizationSubscription, DeletedOrganizationSubscriptionVariables>(DeletedOrganizationDocument, options);
      }
export type DeletedOrganizationSubscriptionHookResult = ReturnType<typeof useDeletedOrganizationSubscription>;
export type DeletedOrganizationSubscriptionResult = Apollo.SubscriptionResult<DeletedOrganizationSubscription>;
export const GetPermissionsDocument = gql`
    query GetPermissions($filter: PermissionFilterArgs, $paging: PageArgs, $sorting: [PermissionSortArgs!], $withRoles: Boolean = false) {
  permissions(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...permissionFields
    }
    totalCount
  }
}
    ${PermissionFieldsFragmentDoc}`;

/**
 * __useGetPermissionsQuery__
 *
 * To run a query within a React component, call `useGetPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useGetPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPermissionsQuery, GetPermissionsQueryVariables>(GetPermissionsDocument, options);
      }
export function useGetPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPermissionsQuery, GetPermissionsQueryVariables>(GetPermissionsDocument, options);
        }
export function useGetPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPermissionsQuery, GetPermissionsQueryVariables>(GetPermissionsDocument, options);
        }
export type GetPermissionsQueryHookResult = ReturnType<typeof useGetPermissionsQuery>;
export type GetPermissionsLazyQueryHookResult = ReturnType<typeof useGetPermissionsLazyQuery>;
export type GetPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetPermissionsSuspenseQuery>;
export type GetPermissionsQueryResult = Apollo.QueryResult<GetPermissionsQuery, GetPermissionsQueryVariables>;
export const GetPermissionDocument = gql`
    query GetPermission($id: ID!, $withRoles: Boolean = false) {
  permission(id: $id) {
    ...permissionFields
  }
}
    ${PermissionFieldsFragmentDoc}`;

/**
 * __useGetPermissionQuery__
 *
 * To run a query within a React component, call `useGetPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useGetPermissionQuery(baseOptions: Apollo.QueryHookOptions<GetPermissionQuery, GetPermissionQueryVariables> & ({ variables: GetPermissionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPermissionQuery, GetPermissionQueryVariables>(GetPermissionDocument, options);
      }
export function useGetPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPermissionQuery, GetPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPermissionQuery, GetPermissionQueryVariables>(GetPermissionDocument, options);
        }
export function useGetPermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPermissionQuery, GetPermissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPermissionQuery, GetPermissionQueryVariables>(GetPermissionDocument, options);
        }
export type GetPermissionQueryHookResult = ReturnType<typeof useGetPermissionQuery>;
export type GetPermissionLazyQueryHookResult = ReturnType<typeof useGetPermissionLazyQuery>;
export type GetPermissionSuspenseQueryHookResult = ReturnType<typeof useGetPermissionSuspenseQuery>;
export type GetPermissionQueryResult = Apollo.QueryResult<GetPermissionQuery, GetPermissionQueryVariables>;
export const GetAllRelatedDataForPermissionDocument = gql`
    query GetAllRelatedDataForPermission($withRoles: Boolean = false) {
  roles @include(if: $withRoles) {
    items {
      id
      displayField: displayName
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForPermissionQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForPermissionQuery({
 *   variables: {
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useGetAllRelatedDataForPermissionQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForPermissionQuery, GetAllRelatedDataForPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForPermissionQuery, GetAllRelatedDataForPermissionQueryVariables>(GetAllRelatedDataForPermissionDocument, options);
      }
export function useGetAllRelatedDataForPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForPermissionQuery, GetAllRelatedDataForPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForPermissionQuery, GetAllRelatedDataForPermissionQueryVariables>(GetAllRelatedDataForPermissionDocument, options);
        }
export function useGetAllRelatedDataForPermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForPermissionQuery, GetAllRelatedDataForPermissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForPermissionQuery, GetAllRelatedDataForPermissionQueryVariables>(GetAllRelatedDataForPermissionDocument, options);
        }
export type GetAllRelatedDataForPermissionQueryHookResult = ReturnType<typeof useGetAllRelatedDataForPermissionQuery>;
export type GetAllRelatedDataForPermissionLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForPermissionLazyQuery>;
export type GetAllRelatedDataForPermissionSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForPermissionSuspenseQuery>;
export type GetAllRelatedDataForPermissionQueryResult = Apollo.QueryResult<GetAllRelatedDataForPermissionQuery, GetAllRelatedDataForPermissionQueryVariables>;
export const CreatePermissionDocument = gql`
    mutation CreatePermission($name: String!, $description: String!, $roles: [ID], $withRoles: Boolean = false) {
  createPermission(name: $name, description: $description, roleIds: $roles) {
    ...permissionFields
  }
}
    ${PermissionFieldsFragmentDoc}`;
export type CreatePermissionMutationFn = Apollo.MutationFunction<CreatePermissionMutation, CreatePermissionMutationVariables>;

/**
 * __useCreatePermissionMutation__
 *
 * To run a mutation, you first call `useCreatePermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPermissionMutation, { data, loading, error }] = useCreatePermissionMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      roles: // value for 'roles'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useCreatePermissionMutation(baseOptions?: Apollo.MutationHookOptions<CreatePermissionMutation, CreatePermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePermissionMutation, CreatePermissionMutationVariables>(CreatePermissionDocument, options);
      }
export type CreatePermissionMutationHookResult = ReturnType<typeof useCreatePermissionMutation>;
export type CreatePermissionMutationResult = Apollo.MutationResult<CreatePermissionMutation>;
export type CreatePermissionMutationOptions = Apollo.BaseMutationOptions<CreatePermissionMutation, CreatePermissionMutationVariables>;
export const UpdatePermissionDocument = gql`
    mutation UpdatePermission($id: ID!, $name: String, $description: String, $roles: [ID], $withRoles: Boolean = false) {
  updatePermission(
    id: $id
    name: $name
    description: $description
    roleIds: $roles
  ) {
    ...permissionFields
  }
}
    ${PermissionFieldsFragmentDoc}`;
export type UpdatePermissionMutationFn = Apollo.MutationFunction<UpdatePermissionMutation, UpdatePermissionMutationVariables>;

/**
 * __useUpdatePermissionMutation__
 *
 * To run a mutation, you first call `useUpdatePermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePermissionMutation, { data, loading, error }] = useUpdatePermissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      roles: // value for 'roles'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useUpdatePermissionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePermissionMutation, UpdatePermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePermissionMutation, UpdatePermissionMutationVariables>(UpdatePermissionDocument, options);
      }
export type UpdatePermissionMutationHookResult = ReturnType<typeof useUpdatePermissionMutation>;
export type UpdatePermissionMutationResult = Apollo.MutationResult<UpdatePermissionMutation>;
export type UpdatePermissionMutationOptions = Apollo.BaseMutationOptions<UpdatePermissionMutation, UpdatePermissionMutationVariables>;
export const DeletePermissionDocument = gql`
    mutation DeletePermission($id: ID!, $withRoles: Boolean = false) {
  deletePermission(id: $id) {
    ...permissionFields
  }
}
    ${PermissionFieldsFragmentDoc}`;
export type DeletePermissionMutationFn = Apollo.MutationFunction<DeletePermissionMutation, DeletePermissionMutationVariables>;

/**
 * __useDeletePermissionMutation__
 *
 * To run a mutation, you first call `useDeletePermissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePermissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePermissionMutation, { data, loading, error }] = useDeletePermissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useDeletePermissionMutation(baseOptions?: Apollo.MutationHookOptions<DeletePermissionMutation, DeletePermissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePermissionMutation, DeletePermissionMutationVariables>(DeletePermissionDocument, options);
      }
export type DeletePermissionMutationHookResult = ReturnType<typeof useDeletePermissionMutation>;
export type DeletePermissionMutationResult = Apollo.MutationResult<DeletePermissionMutation>;
export type DeletePermissionMutationOptions = Apollo.BaseMutationOptions<DeletePermissionMutation, DeletePermissionMutationVariables>;
export const CreatedPermissionDocument = gql`
    subscription CreatedPermission($filter: PermissionFilterArgs, $withRoles: Boolean = false) {
  createdPermission(filter: $filter) {
    ...permissionFields
  }
}
    ${PermissionFieldsFragmentDoc}`;

/**
 * __useCreatedPermissionSubscription__
 *
 * To run a query within a React component, call `useCreatedPermissionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedPermissionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedPermissionSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useCreatedPermissionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedPermissionSubscription, CreatedPermissionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedPermissionSubscription, CreatedPermissionSubscriptionVariables>(CreatedPermissionDocument, options);
      }
export type CreatedPermissionSubscriptionHookResult = ReturnType<typeof useCreatedPermissionSubscription>;
export type CreatedPermissionSubscriptionResult = Apollo.SubscriptionResult<CreatedPermissionSubscription>;
export const UpdatedPermissionDocument = gql`
    subscription UpdatedPermission($filter: PermissionFilterArgs, $withRoles: Boolean = false) {
  updatedPermission(filter: $filter) {
    ...permissionFields
  }
}
    ${PermissionFieldsFragmentDoc}`;

/**
 * __useUpdatedPermissionSubscription__
 *
 * To run a query within a React component, call `useUpdatedPermissionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedPermissionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedPermissionSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useUpdatedPermissionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedPermissionSubscription, UpdatedPermissionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedPermissionSubscription, UpdatedPermissionSubscriptionVariables>(UpdatedPermissionDocument, options);
      }
export type UpdatedPermissionSubscriptionHookResult = ReturnType<typeof useUpdatedPermissionSubscription>;
export type UpdatedPermissionSubscriptionResult = Apollo.SubscriptionResult<UpdatedPermissionSubscription>;
export const DeletedPermissionDocument = gql`
    subscription DeletedPermission($filter: PermissionFilterArgs) {
  deletedPermission(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedPermissionSubscription__
 *
 * To run a query within a React component, call `useDeletedPermissionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedPermissionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedPermissionSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedPermissionSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedPermissionSubscription, DeletedPermissionSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedPermissionSubscription, DeletedPermissionSubscriptionVariables>(DeletedPermissionDocument, options);
      }
export type DeletedPermissionSubscriptionHookResult = ReturnType<typeof useDeletedPermissionSubscription>;
export type DeletedPermissionSubscriptionResult = Apollo.SubscriptionResult<DeletedPermissionSubscription>;
export const GetPeopleDocument = gql`
    query GetPeople($filter: PersonFilterArgs, $paging: PageArgs, $sorting: [PersonSortArgs!], $withUser: Boolean = false, $withOrganizations: Boolean = false, $withPersonActionProgresses: Boolean = false, $withPersonRegisterProgresses: Boolean = false, $withPersonSearchProgresses: Boolean = false) {
  people(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...personFields
    }
    totalCount
  }
}
    ${PersonFieldsFragmentDoc}`;

/**
 * __useGetPeopleQuery__
 *
 * To run a query within a React component, call `useGetPeopleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPeopleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPeopleQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withUser: // value for 'withUser'
 *      withOrganizations: // value for 'withOrganizations'
 *      withPersonActionProgresses: // value for 'withPersonActionProgresses'
 *      withPersonRegisterProgresses: // value for 'withPersonRegisterProgresses'
 *      withPersonSearchProgresses: // value for 'withPersonSearchProgresses'
 *   },
 * });
 */
export function useGetPeopleQuery(baseOptions?: Apollo.QueryHookOptions<GetPeopleQuery, GetPeopleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPeopleQuery, GetPeopleQueryVariables>(GetPeopleDocument, options);
      }
export function useGetPeopleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPeopleQuery, GetPeopleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPeopleQuery, GetPeopleQueryVariables>(GetPeopleDocument, options);
        }
export function useGetPeopleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPeopleQuery, GetPeopleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPeopleQuery, GetPeopleQueryVariables>(GetPeopleDocument, options);
        }
export type GetPeopleQueryHookResult = ReturnType<typeof useGetPeopleQuery>;
export type GetPeopleLazyQueryHookResult = ReturnType<typeof useGetPeopleLazyQuery>;
export type GetPeopleSuspenseQueryHookResult = ReturnType<typeof useGetPeopleSuspenseQuery>;
export type GetPeopleQueryResult = Apollo.QueryResult<GetPeopleQuery, GetPeopleQueryVariables>;
export const GetPersonDocument = gql`
    query GetPerson($id: ID!, $withUser: Boolean = false, $withOrganizations: Boolean = false, $withPersonActionProgresses: Boolean = false, $withPersonRegisterProgresses: Boolean = false, $withPersonSearchProgresses: Boolean = false) {
  person(id: $id) {
    ...personFields
  }
}
    ${PersonFieldsFragmentDoc}`;

/**
 * __useGetPersonQuery__
 *
 * To run a query within a React component, call `useGetPersonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withUser: // value for 'withUser'
 *      withOrganizations: // value for 'withOrganizations'
 *      withPersonActionProgresses: // value for 'withPersonActionProgresses'
 *      withPersonRegisterProgresses: // value for 'withPersonRegisterProgresses'
 *      withPersonSearchProgresses: // value for 'withPersonSearchProgresses'
 *   },
 * });
 */
export function useGetPersonQuery(baseOptions: Apollo.QueryHookOptions<GetPersonQuery, GetPersonQueryVariables> & ({ variables: GetPersonQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonQuery, GetPersonQueryVariables>(GetPersonDocument, options);
      }
export function useGetPersonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonQuery, GetPersonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonQuery, GetPersonQueryVariables>(GetPersonDocument, options);
        }
export function useGetPersonSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPersonQuery, GetPersonQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPersonQuery, GetPersonQueryVariables>(GetPersonDocument, options);
        }
export type GetPersonQueryHookResult = ReturnType<typeof useGetPersonQuery>;
export type GetPersonLazyQueryHookResult = ReturnType<typeof useGetPersonLazyQuery>;
export type GetPersonSuspenseQueryHookResult = ReturnType<typeof useGetPersonSuspenseQuery>;
export type GetPersonQueryResult = Apollo.QueryResult<GetPersonQuery, GetPersonQueryVariables>;
export const GetAllRelatedDataForPersonDocument = gql`
    query GetAllRelatedDataForPerson($withUsers: Boolean = false, $withOrganizations: Boolean = false, $withPersonActionProgresses: Boolean = false, $withPersonRegisterProgresses: Boolean = false, $withPersonSearchProgresses: Boolean = false) {
  users @include(if: $withUsers) {
    items {
      id
      displayField: name
    }
  }
  organizations @include(if: $withOrganizations) {
    items {
      id
      displayField: name
    }
  }
  personActionProgresses @include(if: $withPersonActionProgresses) {
    items {
      id
      displayField: id
    }
  }
  personRegisterProgresses @include(if: $withPersonRegisterProgresses) {
    items {
      id
      displayField: id
    }
  }
  personSearchProgresses @include(if: $withPersonSearchProgresses) {
    items {
      id
      displayField: id
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForPersonQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForPersonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForPersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForPersonQuery({
 *   variables: {
 *      withUsers: // value for 'withUsers'
 *      withOrganizations: // value for 'withOrganizations'
 *      withPersonActionProgresses: // value for 'withPersonActionProgresses'
 *      withPersonRegisterProgresses: // value for 'withPersonRegisterProgresses'
 *      withPersonSearchProgresses: // value for 'withPersonSearchProgresses'
 *   },
 * });
 */
export function useGetAllRelatedDataForPersonQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForPersonQuery, GetAllRelatedDataForPersonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForPersonQuery, GetAllRelatedDataForPersonQueryVariables>(GetAllRelatedDataForPersonDocument, options);
      }
export function useGetAllRelatedDataForPersonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForPersonQuery, GetAllRelatedDataForPersonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForPersonQuery, GetAllRelatedDataForPersonQueryVariables>(GetAllRelatedDataForPersonDocument, options);
        }
export function useGetAllRelatedDataForPersonSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForPersonQuery, GetAllRelatedDataForPersonQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForPersonQuery, GetAllRelatedDataForPersonQueryVariables>(GetAllRelatedDataForPersonDocument, options);
        }
export type GetAllRelatedDataForPersonQueryHookResult = ReturnType<typeof useGetAllRelatedDataForPersonQuery>;
export type GetAllRelatedDataForPersonLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForPersonLazyQuery>;
export type GetAllRelatedDataForPersonSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForPersonSuspenseQuery>;
export type GetAllRelatedDataForPersonQueryResult = Apollo.QueryResult<GetAllRelatedDataForPersonQuery, GetAllRelatedDataForPersonQueryVariables>;
export const CreatePersonDocument = gql`
    mutation CreatePerson($firstNames: String!, $prefix: String, $lastName: String!, $address: String!, $addressNumber: String!, $city: String!, $postalCode: String!, $progress: Int, $userId: ID, $organizations: [ID], $personActionProgresses: [ID], $personRegisterProgresses: [ID], $personSearchProgresses: [ID], $withUser: Boolean = false, $withOrganizations: Boolean = false, $withPersonActionProgresses: Boolean = false, $withPersonRegisterProgresses: Boolean = false, $withPersonSearchProgresses: Boolean = false) {
  createPerson(
    firstNames: $firstNames
    prefix: $prefix
    lastName: $lastName
    address: $address
    addressNumber: $addressNumber
    city: $city
    postalCode: $postalCode
    progress: $progress
    userId: $userId
    organizationIds: $organizations
    personActionProgressIds: $personActionProgresses
    personRegisterProgressIds: $personRegisterProgresses
    personSearchProgressIds: $personSearchProgresses
  ) {
    ...personFields
  }
}
    ${PersonFieldsFragmentDoc}`;
export type CreatePersonMutationFn = Apollo.MutationFunction<CreatePersonMutation, CreatePersonMutationVariables>;

/**
 * __useCreatePersonMutation__
 *
 * To run a mutation, you first call `useCreatePersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPersonMutation, { data, loading, error }] = useCreatePersonMutation({
 *   variables: {
 *      firstNames: // value for 'firstNames'
 *      prefix: // value for 'prefix'
 *      lastName: // value for 'lastName'
 *      address: // value for 'address'
 *      addressNumber: // value for 'addressNumber'
 *      city: // value for 'city'
 *      postalCode: // value for 'postalCode'
 *      progress: // value for 'progress'
 *      userId: // value for 'userId'
 *      organizations: // value for 'organizations'
 *      personActionProgresses: // value for 'personActionProgresses'
 *      personRegisterProgresses: // value for 'personRegisterProgresses'
 *      personSearchProgresses: // value for 'personSearchProgresses'
 *      withUser: // value for 'withUser'
 *      withOrganizations: // value for 'withOrganizations'
 *      withPersonActionProgresses: // value for 'withPersonActionProgresses'
 *      withPersonRegisterProgresses: // value for 'withPersonRegisterProgresses'
 *      withPersonSearchProgresses: // value for 'withPersonSearchProgresses'
 *   },
 * });
 */
export function useCreatePersonMutation(baseOptions?: Apollo.MutationHookOptions<CreatePersonMutation, CreatePersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePersonMutation, CreatePersonMutationVariables>(CreatePersonDocument, options);
      }
export type CreatePersonMutationHookResult = ReturnType<typeof useCreatePersonMutation>;
export type CreatePersonMutationResult = Apollo.MutationResult<CreatePersonMutation>;
export type CreatePersonMutationOptions = Apollo.BaseMutationOptions<CreatePersonMutation, CreatePersonMutationVariables>;
export const UpdatePersonDocument = gql`
    mutation UpdatePerson($id: ID!, $firstNames: String, $prefix: String, $lastName: String, $address: String, $addressNumber: String, $city: String, $postalCode: String, $progress: Int, $userId: ID, $organizations: [ID], $personActionProgresses: [ID], $personRegisterProgresses: [ID], $personSearchProgresses: [ID], $withUser: Boolean = false, $withOrganizations: Boolean = false, $withPersonActionProgresses: Boolean = false, $withPersonRegisterProgresses: Boolean = false, $withPersonSearchProgresses: Boolean = false) {
  updatePerson(
    id: $id
    firstNames: $firstNames
    prefix: $prefix
    lastName: $lastName
    address: $address
    addressNumber: $addressNumber
    city: $city
    postalCode: $postalCode
    progress: $progress
    userId: $userId
    organizationIds: $organizations
    personActionProgressIds: $personActionProgresses
    personRegisterProgressIds: $personRegisterProgresses
    personSearchProgressIds: $personSearchProgresses
  ) {
    ...personFields
  }
}
    ${PersonFieldsFragmentDoc}`;
export type UpdatePersonMutationFn = Apollo.MutationFunction<UpdatePersonMutation, UpdatePersonMutationVariables>;

/**
 * __useUpdatePersonMutation__
 *
 * To run a mutation, you first call `useUpdatePersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonMutation, { data, loading, error }] = useUpdatePersonMutation({
 *   variables: {
 *      id: // value for 'id'
 *      firstNames: // value for 'firstNames'
 *      prefix: // value for 'prefix'
 *      lastName: // value for 'lastName'
 *      address: // value for 'address'
 *      addressNumber: // value for 'addressNumber'
 *      city: // value for 'city'
 *      postalCode: // value for 'postalCode'
 *      progress: // value for 'progress'
 *      userId: // value for 'userId'
 *      organizations: // value for 'organizations'
 *      personActionProgresses: // value for 'personActionProgresses'
 *      personRegisterProgresses: // value for 'personRegisterProgresses'
 *      personSearchProgresses: // value for 'personSearchProgresses'
 *      withUser: // value for 'withUser'
 *      withOrganizations: // value for 'withOrganizations'
 *      withPersonActionProgresses: // value for 'withPersonActionProgresses'
 *      withPersonRegisterProgresses: // value for 'withPersonRegisterProgresses'
 *      withPersonSearchProgresses: // value for 'withPersonSearchProgresses'
 *   },
 * });
 */
export function useUpdatePersonMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonMutation, UpdatePersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonMutation, UpdatePersonMutationVariables>(UpdatePersonDocument, options);
      }
export type UpdatePersonMutationHookResult = ReturnType<typeof useUpdatePersonMutation>;
export type UpdatePersonMutationResult = Apollo.MutationResult<UpdatePersonMutation>;
export type UpdatePersonMutationOptions = Apollo.BaseMutationOptions<UpdatePersonMutation, UpdatePersonMutationVariables>;
export const DeletePersonDocument = gql`
    mutation DeletePerson($id: ID!, $withUser: Boolean = false, $withOrganizations: Boolean = false, $withPersonActionProgresses: Boolean = false, $withPersonRegisterProgresses: Boolean = false, $withPersonSearchProgresses: Boolean = false) {
  deletePerson(id: $id) {
    ...personFields
  }
}
    ${PersonFieldsFragmentDoc}`;
export type DeletePersonMutationFn = Apollo.MutationFunction<DeletePersonMutation, DeletePersonMutationVariables>;

/**
 * __useDeletePersonMutation__
 *
 * To run a mutation, you first call `useDeletePersonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePersonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePersonMutation, { data, loading, error }] = useDeletePersonMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withUser: // value for 'withUser'
 *      withOrganizations: // value for 'withOrganizations'
 *      withPersonActionProgresses: // value for 'withPersonActionProgresses'
 *      withPersonRegisterProgresses: // value for 'withPersonRegisterProgresses'
 *      withPersonSearchProgresses: // value for 'withPersonSearchProgresses'
 *   },
 * });
 */
export function useDeletePersonMutation(baseOptions?: Apollo.MutationHookOptions<DeletePersonMutation, DeletePersonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePersonMutation, DeletePersonMutationVariables>(DeletePersonDocument, options);
      }
export type DeletePersonMutationHookResult = ReturnType<typeof useDeletePersonMutation>;
export type DeletePersonMutationResult = Apollo.MutationResult<DeletePersonMutation>;
export type DeletePersonMutationOptions = Apollo.BaseMutationOptions<DeletePersonMutation, DeletePersonMutationVariables>;
export const CreatedPersonDocument = gql`
    subscription CreatedPerson($filter: PersonFilterArgs, $withUser: Boolean = false, $withOrganizations: Boolean = false, $withPersonActionProgresses: Boolean = false, $withPersonRegisterProgresses: Boolean = false, $withPersonSearchProgresses: Boolean = false) {
  createdPerson(filter: $filter) {
    ...personFields
  }
}
    ${PersonFieldsFragmentDoc}`;

/**
 * __useCreatedPersonSubscription__
 *
 * To run a query within a React component, call `useCreatedPersonSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedPersonSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedPersonSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUser: // value for 'withUser'
 *      withOrganizations: // value for 'withOrganizations'
 *      withPersonActionProgresses: // value for 'withPersonActionProgresses'
 *      withPersonRegisterProgresses: // value for 'withPersonRegisterProgresses'
 *      withPersonSearchProgresses: // value for 'withPersonSearchProgresses'
 *   },
 * });
 */
export function useCreatedPersonSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedPersonSubscription, CreatedPersonSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedPersonSubscription, CreatedPersonSubscriptionVariables>(CreatedPersonDocument, options);
      }
export type CreatedPersonSubscriptionHookResult = ReturnType<typeof useCreatedPersonSubscription>;
export type CreatedPersonSubscriptionResult = Apollo.SubscriptionResult<CreatedPersonSubscription>;
export const UpdatedPersonDocument = gql`
    subscription UpdatedPerson($filter: PersonFilterArgs, $withUser: Boolean = false, $withOrganizations: Boolean = false, $withPersonActionProgresses: Boolean = false, $withPersonRegisterProgresses: Boolean = false, $withPersonSearchProgresses: Boolean = false) {
  updatedPerson(filter: $filter) {
    ...personFields
  }
}
    ${PersonFieldsFragmentDoc}`;

/**
 * __useUpdatedPersonSubscription__
 *
 * To run a query within a React component, call `useUpdatedPersonSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedPersonSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedPersonSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUser: // value for 'withUser'
 *      withOrganizations: // value for 'withOrganizations'
 *      withPersonActionProgresses: // value for 'withPersonActionProgresses'
 *      withPersonRegisterProgresses: // value for 'withPersonRegisterProgresses'
 *      withPersonSearchProgresses: // value for 'withPersonSearchProgresses'
 *   },
 * });
 */
export function useUpdatedPersonSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedPersonSubscription, UpdatedPersonSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedPersonSubscription, UpdatedPersonSubscriptionVariables>(UpdatedPersonDocument, options);
      }
export type UpdatedPersonSubscriptionHookResult = ReturnType<typeof useUpdatedPersonSubscription>;
export type UpdatedPersonSubscriptionResult = Apollo.SubscriptionResult<UpdatedPersonSubscription>;
export const DeletedPersonDocument = gql`
    subscription DeletedPerson($filter: PersonFilterArgs) {
  deletedPerson(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedPersonSubscription__
 *
 * To run a query within a React component, call `useDeletedPersonSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedPersonSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedPersonSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedPersonSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedPersonSubscription, DeletedPersonSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedPersonSubscription, DeletedPersonSubscriptionVariables>(DeletedPersonDocument, options);
      }
export type DeletedPersonSubscriptionHookResult = ReturnType<typeof useDeletedPersonSubscription>;
export type DeletedPersonSubscriptionResult = Apollo.SubscriptionResult<DeletedPersonSubscription>;
export const GetPersonActionProgressesDocument = gql`
    query GetPersonActionProgresses($filter: PersonActionProgressFilterArgs, $paging: PageArgs, $sorting: [PersonActionProgressSortArgs!], $withPerson: Boolean = false, $withAction: Boolean = false) {
  personActionProgresses(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...personActionProgressFields
    }
    totalCount
  }
}
    ${PersonActionProgressFieldsFragmentDoc}`;

/**
 * __useGetPersonActionProgressesQuery__
 *
 * To run a query within a React component, call `useGetPersonActionProgressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonActionProgressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonActionProgressesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withPerson: // value for 'withPerson'
 *      withAction: // value for 'withAction'
 *   },
 * });
 */
export function useGetPersonActionProgressesQuery(baseOptions?: Apollo.QueryHookOptions<GetPersonActionProgressesQuery, GetPersonActionProgressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonActionProgressesQuery, GetPersonActionProgressesQueryVariables>(GetPersonActionProgressesDocument, options);
      }
export function useGetPersonActionProgressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonActionProgressesQuery, GetPersonActionProgressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonActionProgressesQuery, GetPersonActionProgressesQueryVariables>(GetPersonActionProgressesDocument, options);
        }
export function useGetPersonActionProgressesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPersonActionProgressesQuery, GetPersonActionProgressesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPersonActionProgressesQuery, GetPersonActionProgressesQueryVariables>(GetPersonActionProgressesDocument, options);
        }
export type GetPersonActionProgressesQueryHookResult = ReturnType<typeof useGetPersonActionProgressesQuery>;
export type GetPersonActionProgressesLazyQueryHookResult = ReturnType<typeof useGetPersonActionProgressesLazyQuery>;
export type GetPersonActionProgressesSuspenseQueryHookResult = ReturnType<typeof useGetPersonActionProgressesSuspenseQuery>;
export type GetPersonActionProgressesQueryResult = Apollo.QueryResult<GetPersonActionProgressesQuery, GetPersonActionProgressesQueryVariables>;
export const GetPersonActionProgressDocument = gql`
    query GetPersonActionProgress($id: ID!, $withPerson: Boolean = false, $withAction: Boolean = false) {
  personActionProgress(id: $id) {
    ...personActionProgressFields
  }
}
    ${PersonActionProgressFieldsFragmentDoc}`;

/**
 * __useGetPersonActionProgressQuery__
 *
 * To run a query within a React component, call `useGetPersonActionProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonActionProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonActionProgressQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withPerson: // value for 'withPerson'
 *      withAction: // value for 'withAction'
 *   },
 * });
 */
export function useGetPersonActionProgressQuery(baseOptions: Apollo.QueryHookOptions<GetPersonActionProgressQuery, GetPersonActionProgressQueryVariables> & ({ variables: GetPersonActionProgressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonActionProgressQuery, GetPersonActionProgressQueryVariables>(GetPersonActionProgressDocument, options);
      }
export function useGetPersonActionProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonActionProgressQuery, GetPersonActionProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonActionProgressQuery, GetPersonActionProgressQueryVariables>(GetPersonActionProgressDocument, options);
        }
export function useGetPersonActionProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPersonActionProgressQuery, GetPersonActionProgressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPersonActionProgressQuery, GetPersonActionProgressQueryVariables>(GetPersonActionProgressDocument, options);
        }
export type GetPersonActionProgressQueryHookResult = ReturnType<typeof useGetPersonActionProgressQuery>;
export type GetPersonActionProgressLazyQueryHookResult = ReturnType<typeof useGetPersonActionProgressLazyQuery>;
export type GetPersonActionProgressSuspenseQueryHookResult = ReturnType<typeof useGetPersonActionProgressSuspenseQuery>;
export type GetPersonActionProgressQueryResult = Apollo.QueryResult<GetPersonActionProgressQuery, GetPersonActionProgressQueryVariables>;
export const GetAllRelatedDataForPersonActionProgressDocument = gql`
    query GetAllRelatedDataForPersonActionProgress($withPeople: Boolean = false, $withActions: Boolean = false) {
  people @include(if: $withPeople) {
    items {
      id
      displayField: id
    }
  }
  actions @include(if: $withActions) {
    items {
      id
      displayField: name
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForPersonActionProgressQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForPersonActionProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForPersonActionProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForPersonActionProgressQuery({
 *   variables: {
 *      withPeople: // value for 'withPeople'
 *      withActions: // value for 'withActions'
 *   },
 * });
 */
export function useGetAllRelatedDataForPersonActionProgressQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForPersonActionProgressQuery, GetAllRelatedDataForPersonActionProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForPersonActionProgressQuery, GetAllRelatedDataForPersonActionProgressQueryVariables>(GetAllRelatedDataForPersonActionProgressDocument, options);
      }
export function useGetAllRelatedDataForPersonActionProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForPersonActionProgressQuery, GetAllRelatedDataForPersonActionProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForPersonActionProgressQuery, GetAllRelatedDataForPersonActionProgressQueryVariables>(GetAllRelatedDataForPersonActionProgressDocument, options);
        }
export function useGetAllRelatedDataForPersonActionProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForPersonActionProgressQuery, GetAllRelatedDataForPersonActionProgressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForPersonActionProgressQuery, GetAllRelatedDataForPersonActionProgressQueryVariables>(GetAllRelatedDataForPersonActionProgressDocument, options);
        }
export type GetAllRelatedDataForPersonActionProgressQueryHookResult = ReturnType<typeof useGetAllRelatedDataForPersonActionProgressQuery>;
export type GetAllRelatedDataForPersonActionProgressLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForPersonActionProgressLazyQuery>;
export type GetAllRelatedDataForPersonActionProgressSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForPersonActionProgressSuspenseQuery>;
export type GetAllRelatedDataForPersonActionProgressQueryResult = Apollo.QueryResult<GetAllRelatedDataForPersonActionProgressQuery, GetAllRelatedDataForPersonActionProgressQueryVariables>;
export const CreatePersonActionProgressDocument = gql`
    mutation CreatePersonActionProgress($progress: String!, $done: Boolean, $personId: ID!, $actionId: ID!, $withPerson: Boolean = false, $withAction: Boolean = false) {
  createPersonActionProgress(
    progress: $progress
    done: $done
    personId: $personId
    actionId: $actionId
  ) {
    ...personActionProgressFields
  }
}
    ${PersonActionProgressFieldsFragmentDoc}`;
export type CreatePersonActionProgressMutationFn = Apollo.MutationFunction<CreatePersonActionProgressMutation, CreatePersonActionProgressMutationVariables>;

/**
 * __useCreatePersonActionProgressMutation__
 *
 * To run a mutation, you first call `useCreatePersonActionProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePersonActionProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPersonActionProgressMutation, { data, loading, error }] = useCreatePersonActionProgressMutation({
 *   variables: {
 *      progress: // value for 'progress'
 *      done: // value for 'done'
 *      personId: // value for 'personId'
 *      actionId: // value for 'actionId'
 *      withPerson: // value for 'withPerson'
 *      withAction: // value for 'withAction'
 *   },
 * });
 */
export function useCreatePersonActionProgressMutation(baseOptions?: Apollo.MutationHookOptions<CreatePersonActionProgressMutation, CreatePersonActionProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePersonActionProgressMutation, CreatePersonActionProgressMutationVariables>(CreatePersonActionProgressDocument, options);
      }
export type CreatePersonActionProgressMutationHookResult = ReturnType<typeof useCreatePersonActionProgressMutation>;
export type CreatePersonActionProgressMutationResult = Apollo.MutationResult<CreatePersonActionProgressMutation>;
export type CreatePersonActionProgressMutationOptions = Apollo.BaseMutationOptions<CreatePersonActionProgressMutation, CreatePersonActionProgressMutationVariables>;
export const UpdatePersonActionProgressDocument = gql`
    mutation UpdatePersonActionProgress($id: ID!, $progress: String, $done: Boolean, $personId: ID, $actionId: ID, $withPerson: Boolean = false, $withAction: Boolean = false) {
  updatePersonActionProgress(
    id: $id
    progress: $progress
    done: $done
    personId: $personId
    actionId: $actionId
  ) {
    ...personActionProgressFields
  }
}
    ${PersonActionProgressFieldsFragmentDoc}`;
export type UpdatePersonActionProgressMutationFn = Apollo.MutationFunction<UpdatePersonActionProgressMutation, UpdatePersonActionProgressMutationVariables>;

/**
 * __useUpdatePersonActionProgressMutation__
 *
 * To run a mutation, you first call `useUpdatePersonActionProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonActionProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonActionProgressMutation, { data, loading, error }] = useUpdatePersonActionProgressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      progress: // value for 'progress'
 *      done: // value for 'done'
 *      personId: // value for 'personId'
 *      actionId: // value for 'actionId'
 *      withPerson: // value for 'withPerson'
 *      withAction: // value for 'withAction'
 *   },
 * });
 */
export function useUpdatePersonActionProgressMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonActionProgressMutation, UpdatePersonActionProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonActionProgressMutation, UpdatePersonActionProgressMutationVariables>(UpdatePersonActionProgressDocument, options);
      }
export type UpdatePersonActionProgressMutationHookResult = ReturnType<typeof useUpdatePersonActionProgressMutation>;
export type UpdatePersonActionProgressMutationResult = Apollo.MutationResult<UpdatePersonActionProgressMutation>;
export type UpdatePersonActionProgressMutationOptions = Apollo.BaseMutationOptions<UpdatePersonActionProgressMutation, UpdatePersonActionProgressMutationVariables>;
export const DeletePersonActionProgressDocument = gql`
    mutation DeletePersonActionProgress($id: ID!, $withPerson: Boolean = false, $withAction: Boolean = false) {
  deletePersonActionProgress(id: $id) {
    ...personActionProgressFields
  }
}
    ${PersonActionProgressFieldsFragmentDoc}`;
export type DeletePersonActionProgressMutationFn = Apollo.MutationFunction<DeletePersonActionProgressMutation, DeletePersonActionProgressMutationVariables>;

/**
 * __useDeletePersonActionProgressMutation__
 *
 * To run a mutation, you first call `useDeletePersonActionProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePersonActionProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePersonActionProgressMutation, { data, loading, error }] = useDeletePersonActionProgressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withPerson: // value for 'withPerson'
 *      withAction: // value for 'withAction'
 *   },
 * });
 */
export function useDeletePersonActionProgressMutation(baseOptions?: Apollo.MutationHookOptions<DeletePersonActionProgressMutation, DeletePersonActionProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePersonActionProgressMutation, DeletePersonActionProgressMutationVariables>(DeletePersonActionProgressDocument, options);
      }
export type DeletePersonActionProgressMutationHookResult = ReturnType<typeof useDeletePersonActionProgressMutation>;
export type DeletePersonActionProgressMutationResult = Apollo.MutationResult<DeletePersonActionProgressMutation>;
export type DeletePersonActionProgressMutationOptions = Apollo.BaseMutationOptions<DeletePersonActionProgressMutation, DeletePersonActionProgressMutationVariables>;
export const CreatedPersonActionProgressDocument = gql`
    subscription CreatedPersonActionProgress($filter: PersonActionProgressFilterArgs, $withPerson: Boolean = false, $withAction: Boolean = false) {
  createdPersonActionProgress(filter: $filter) {
    ...personActionProgressFields
  }
}
    ${PersonActionProgressFieldsFragmentDoc}`;

/**
 * __useCreatedPersonActionProgressSubscription__
 *
 * To run a query within a React component, call `useCreatedPersonActionProgressSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedPersonActionProgressSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedPersonActionProgressSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withPerson: // value for 'withPerson'
 *      withAction: // value for 'withAction'
 *   },
 * });
 */
export function useCreatedPersonActionProgressSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedPersonActionProgressSubscription, CreatedPersonActionProgressSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedPersonActionProgressSubscription, CreatedPersonActionProgressSubscriptionVariables>(CreatedPersonActionProgressDocument, options);
      }
export type CreatedPersonActionProgressSubscriptionHookResult = ReturnType<typeof useCreatedPersonActionProgressSubscription>;
export type CreatedPersonActionProgressSubscriptionResult = Apollo.SubscriptionResult<CreatedPersonActionProgressSubscription>;
export const UpdatedPersonActionProgressDocument = gql`
    subscription UpdatedPersonActionProgress($filter: PersonActionProgressFilterArgs, $withPerson: Boolean = false, $withAction: Boolean = false) {
  updatedPersonActionProgress(filter: $filter) {
    ...personActionProgressFields
  }
}
    ${PersonActionProgressFieldsFragmentDoc}`;

/**
 * __useUpdatedPersonActionProgressSubscription__
 *
 * To run a query within a React component, call `useUpdatedPersonActionProgressSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedPersonActionProgressSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedPersonActionProgressSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withPerson: // value for 'withPerson'
 *      withAction: // value for 'withAction'
 *   },
 * });
 */
export function useUpdatedPersonActionProgressSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedPersonActionProgressSubscription, UpdatedPersonActionProgressSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedPersonActionProgressSubscription, UpdatedPersonActionProgressSubscriptionVariables>(UpdatedPersonActionProgressDocument, options);
      }
export type UpdatedPersonActionProgressSubscriptionHookResult = ReturnType<typeof useUpdatedPersonActionProgressSubscription>;
export type UpdatedPersonActionProgressSubscriptionResult = Apollo.SubscriptionResult<UpdatedPersonActionProgressSubscription>;
export const DeletedPersonActionProgressDocument = gql`
    subscription DeletedPersonActionProgress($filter: PersonActionProgressFilterArgs) {
  deletedPersonActionProgress(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedPersonActionProgressSubscription__
 *
 * To run a query within a React component, call `useDeletedPersonActionProgressSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedPersonActionProgressSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedPersonActionProgressSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedPersonActionProgressSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedPersonActionProgressSubscription, DeletedPersonActionProgressSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedPersonActionProgressSubscription, DeletedPersonActionProgressSubscriptionVariables>(DeletedPersonActionProgressDocument, options);
      }
export type DeletedPersonActionProgressSubscriptionHookResult = ReturnType<typeof useDeletedPersonActionProgressSubscription>;
export type DeletedPersonActionProgressSubscriptionResult = Apollo.SubscriptionResult<DeletedPersonActionProgressSubscription>;
export const GetPersonRegisterProgressesDocument = gql`
    query GetPersonRegisterProgresses($filter: PersonRegisterProgressFilterArgs, $paging: PageArgs, $sorting: [PersonRegisterProgressSortArgs!], $withPerson: Boolean = false, $withRegister: Boolean = false) {
  personRegisterProgresses(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...personRegisterProgressFields
    }
    totalCount
  }
}
    ${PersonRegisterProgressFieldsFragmentDoc}`;

/**
 * __useGetPersonRegisterProgressesQuery__
 *
 * To run a query within a React component, call `useGetPersonRegisterProgressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonRegisterProgressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonRegisterProgressesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withPerson: // value for 'withPerson'
 *      withRegister: // value for 'withRegister'
 *   },
 * });
 */
export function useGetPersonRegisterProgressesQuery(baseOptions?: Apollo.QueryHookOptions<GetPersonRegisterProgressesQuery, GetPersonRegisterProgressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonRegisterProgressesQuery, GetPersonRegisterProgressesQueryVariables>(GetPersonRegisterProgressesDocument, options);
      }
export function useGetPersonRegisterProgressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonRegisterProgressesQuery, GetPersonRegisterProgressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonRegisterProgressesQuery, GetPersonRegisterProgressesQueryVariables>(GetPersonRegisterProgressesDocument, options);
        }
export function useGetPersonRegisterProgressesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPersonRegisterProgressesQuery, GetPersonRegisterProgressesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPersonRegisterProgressesQuery, GetPersonRegisterProgressesQueryVariables>(GetPersonRegisterProgressesDocument, options);
        }
export type GetPersonRegisterProgressesQueryHookResult = ReturnType<typeof useGetPersonRegisterProgressesQuery>;
export type GetPersonRegisterProgressesLazyQueryHookResult = ReturnType<typeof useGetPersonRegisterProgressesLazyQuery>;
export type GetPersonRegisterProgressesSuspenseQueryHookResult = ReturnType<typeof useGetPersonRegisterProgressesSuspenseQuery>;
export type GetPersonRegisterProgressesQueryResult = Apollo.QueryResult<GetPersonRegisterProgressesQuery, GetPersonRegisterProgressesQueryVariables>;
export const GetPersonRegisterProgressDocument = gql`
    query GetPersonRegisterProgress($id: ID!, $withPerson: Boolean = false, $withRegister: Boolean = false) {
  personRegisterProgress(id: $id) {
    ...personRegisterProgressFields
  }
}
    ${PersonRegisterProgressFieldsFragmentDoc}`;

/**
 * __useGetPersonRegisterProgressQuery__
 *
 * To run a query within a React component, call `useGetPersonRegisterProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonRegisterProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonRegisterProgressQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withPerson: // value for 'withPerson'
 *      withRegister: // value for 'withRegister'
 *   },
 * });
 */
export function useGetPersonRegisterProgressQuery(baseOptions: Apollo.QueryHookOptions<GetPersonRegisterProgressQuery, GetPersonRegisterProgressQueryVariables> & ({ variables: GetPersonRegisterProgressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonRegisterProgressQuery, GetPersonRegisterProgressQueryVariables>(GetPersonRegisterProgressDocument, options);
      }
export function useGetPersonRegisterProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonRegisterProgressQuery, GetPersonRegisterProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonRegisterProgressQuery, GetPersonRegisterProgressQueryVariables>(GetPersonRegisterProgressDocument, options);
        }
export function useGetPersonRegisterProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPersonRegisterProgressQuery, GetPersonRegisterProgressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPersonRegisterProgressQuery, GetPersonRegisterProgressQueryVariables>(GetPersonRegisterProgressDocument, options);
        }
export type GetPersonRegisterProgressQueryHookResult = ReturnType<typeof useGetPersonRegisterProgressQuery>;
export type GetPersonRegisterProgressLazyQueryHookResult = ReturnType<typeof useGetPersonRegisterProgressLazyQuery>;
export type GetPersonRegisterProgressSuspenseQueryHookResult = ReturnType<typeof useGetPersonRegisterProgressSuspenseQuery>;
export type GetPersonRegisterProgressQueryResult = Apollo.QueryResult<GetPersonRegisterProgressQuery, GetPersonRegisterProgressQueryVariables>;
export const GetAllRelatedDataForPersonRegisterProgressDocument = gql`
    query GetAllRelatedDataForPersonRegisterProgress($withPeople: Boolean = false, $withRegisters: Boolean = false) {
  people @include(if: $withPeople) {
    items {
      id
      displayField: id
    }
  }
  registers @include(if: $withRegisters) {
    items {
      id
      displayField: name
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForPersonRegisterProgressQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForPersonRegisterProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForPersonRegisterProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForPersonRegisterProgressQuery({
 *   variables: {
 *      withPeople: // value for 'withPeople'
 *      withRegisters: // value for 'withRegisters'
 *   },
 * });
 */
export function useGetAllRelatedDataForPersonRegisterProgressQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForPersonRegisterProgressQuery, GetAllRelatedDataForPersonRegisterProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForPersonRegisterProgressQuery, GetAllRelatedDataForPersonRegisterProgressQueryVariables>(GetAllRelatedDataForPersonRegisterProgressDocument, options);
      }
export function useGetAllRelatedDataForPersonRegisterProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForPersonRegisterProgressQuery, GetAllRelatedDataForPersonRegisterProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForPersonRegisterProgressQuery, GetAllRelatedDataForPersonRegisterProgressQueryVariables>(GetAllRelatedDataForPersonRegisterProgressDocument, options);
        }
export function useGetAllRelatedDataForPersonRegisterProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForPersonRegisterProgressQuery, GetAllRelatedDataForPersonRegisterProgressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForPersonRegisterProgressQuery, GetAllRelatedDataForPersonRegisterProgressQueryVariables>(GetAllRelatedDataForPersonRegisterProgressDocument, options);
        }
export type GetAllRelatedDataForPersonRegisterProgressQueryHookResult = ReturnType<typeof useGetAllRelatedDataForPersonRegisterProgressQuery>;
export type GetAllRelatedDataForPersonRegisterProgressLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForPersonRegisterProgressLazyQuery>;
export type GetAllRelatedDataForPersonRegisterProgressSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForPersonRegisterProgressSuspenseQuery>;
export type GetAllRelatedDataForPersonRegisterProgressQueryResult = Apollo.QueryResult<GetAllRelatedDataForPersonRegisterProgressQuery, GetAllRelatedDataForPersonRegisterProgressQueryVariables>;
export const CreatePersonRegisterProgressDocument = gql`
    mutation CreatePersonRegisterProgress($progress: String!, $done: Boolean, $foundAt: DateTime, $actionDoneAt: DateTime, $personId: ID!, $registerId: ID!, $withPerson: Boolean = false, $withRegister: Boolean = false) {
  createPersonRegisterProgress(
    progress: $progress
    done: $done
    foundAt: $foundAt
    actionDoneAt: $actionDoneAt
    personId: $personId
    registerId: $registerId
  ) {
    ...personRegisterProgressFields
  }
}
    ${PersonRegisterProgressFieldsFragmentDoc}`;
export type CreatePersonRegisterProgressMutationFn = Apollo.MutationFunction<CreatePersonRegisterProgressMutation, CreatePersonRegisterProgressMutationVariables>;

/**
 * __useCreatePersonRegisterProgressMutation__
 *
 * To run a mutation, you first call `useCreatePersonRegisterProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePersonRegisterProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPersonRegisterProgressMutation, { data, loading, error }] = useCreatePersonRegisterProgressMutation({
 *   variables: {
 *      progress: // value for 'progress'
 *      done: // value for 'done'
 *      foundAt: // value for 'foundAt'
 *      actionDoneAt: // value for 'actionDoneAt'
 *      personId: // value for 'personId'
 *      registerId: // value for 'registerId'
 *      withPerson: // value for 'withPerson'
 *      withRegister: // value for 'withRegister'
 *   },
 * });
 */
export function useCreatePersonRegisterProgressMutation(baseOptions?: Apollo.MutationHookOptions<CreatePersonRegisterProgressMutation, CreatePersonRegisterProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePersonRegisterProgressMutation, CreatePersonRegisterProgressMutationVariables>(CreatePersonRegisterProgressDocument, options);
      }
export type CreatePersonRegisterProgressMutationHookResult = ReturnType<typeof useCreatePersonRegisterProgressMutation>;
export type CreatePersonRegisterProgressMutationResult = Apollo.MutationResult<CreatePersonRegisterProgressMutation>;
export type CreatePersonRegisterProgressMutationOptions = Apollo.BaseMutationOptions<CreatePersonRegisterProgressMutation, CreatePersonRegisterProgressMutationVariables>;
export const UpdatePersonRegisterProgressDocument = gql`
    mutation UpdatePersonRegisterProgress($id: ID!, $progress: String, $done: Boolean, $foundAt: DateTime, $actionDoneAt: DateTime, $personId: ID, $registerId: ID, $withPerson: Boolean = false, $withRegister: Boolean = false) {
  updatePersonRegisterProgress(
    id: $id
    progress: $progress
    done: $done
    foundAt: $foundAt
    actionDoneAt: $actionDoneAt
    personId: $personId
    registerId: $registerId
  ) {
    ...personRegisterProgressFields
  }
}
    ${PersonRegisterProgressFieldsFragmentDoc}`;
export type UpdatePersonRegisterProgressMutationFn = Apollo.MutationFunction<UpdatePersonRegisterProgressMutation, UpdatePersonRegisterProgressMutationVariables>;

/**
 * __useUpdatePersonRegisterProgressMutation__
 *
 * To run a mutation, you first call `useUpdatePersonRegisterProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonRegisterProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonRegisterProgressMutation, { data, loading, error }] = useUpdatePersonRegisterProgressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      progress: // value for 'progress'
 *      done: // value for 'done'
 *      foundAt: // value for 'foundAt'
 *      actionDoneAt: // value for 'actionDoneAt'
 *      personId: // value for 'personId'
 *      registerId: // value for 'registerId'
 *      withPerson: // value for 'withPerson'
 *      withRegister: // value for 'withRegister'
 *   },
 * });
 */
export function useUpdatePersonRegisterProgressMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonRegisterProgressMutation, UpdatePersonRegisterProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonRegisterProgressMutation, UpdatePersonRegisterProgressMutationVariables>(UpdatePersonRegisterProgressDocument, options);
      }
export type UpdatePersonRegisterProgressMutationHookResult = ReturnType<typeof useUpdatePersonRegisterProgressMutation>;
export type UpdatePersonRegisterProgressMutationResult = Apollo.MutationResult<UpdatePersonRegisterProgressMutation>;
export type UpdatePersonRegisterProgressMutationOptions = Apollo.BaseMutationOptions<UpdatePersonRegisterProgressMutation, UpdatePersonRegisterProgressMutationVariables>;
export const DeletePersonRegisterProgressDocument = gql`
    mutation DeletePersonRegisterProgress($id: ID!, $withPerson: Boolean = false, $withRegister: Boolean = false) {
  deletePersonRegisterProgress(id: $id) {
    ...personRegisterProgressFields
  }
}
    ${PersonRegisterProgressFieldsFragmentDoc}`;
export type DeletePersonRegisterProgressMutationFn = Apollo.MutationFunction<DeletePersonRegisterProgressMutation, DeletePersonRegisterProgressMutationVariables>;

/**
 * __useDeletePersonRegisterProgressMutation__
 *
 * To run a mutation, you first call `useDeletePersonRegisterProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePersonRegisterProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePersonRegisterProgressMutation, { data, loading, error }] = useDeletePersonRegisterProgressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withPerson: // value for 'withPerson'
 *      withRegister: // value for 'withRegister'
 *   },
 * });
 */
export function useDeletePersonRegisterProgressMutation(baseOptions?: Apollo.MutationHookOptions<DeletePersonRegisterProgressMutation, DeletePersonRegisterProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePersonRegisterProgressMutation, DeletePersonRegisterProgressMutationVariables>(DeletePersonRegisterProgressDocument, options);
      }
export type DeletePersonRegisterProgressMutationHookResult = ReturnType<typeof useDeletePersonRegisterProgressMutation>;
export type DeletePersonRegisterProgressMutationResult = Apollo.MutationResult<DeletePersonRegisterProgressMutation>;
export type DeletePersonRegisterProgressMutationOptions = Apollo.BaseMutationOptions<DeletePersonRegisterProgressMutation, DeletePersonRegisterProgressMutationVariables>;
export const CreatedPersonRegisterProgressDocument = gql`
    subscription CreatedPersonRegisterProgress($filter: PersonRegisterProgressFilterArgs, $withPerson: Boolean = false, $withRegister: Boolean = false) {
  createdPersonRegisterProgress(filter: $filter) {
    ...personRegisterProgressFields
  }
}
    ${PersonRegisterProgressFieldsFragmentDoc}`;

/**
 * __useCreatedPersonRegisterProgressSubscription__
 *
 * To run a query within a React component, call `useCreatedPersonRegisterProgressSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedPersonRegisterProgressSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedPersonRegisterProgressSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withPerson: // value for 'withPerson'
 *      withRegister: // value for 'withRegister'
 *   },
 * });
 */
export function useCreatedPersonRegisterProgressSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedPersonRegisterProgressSubscription, CreatedPersonRegisterProgressSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedPersonRegisterProgressSubscription, CreatedPersonRegisterProgressSubscriptionVariables>(CreatedPersonRegisterProgressDocument, options);
      }
export type CreatedPersonRegisterProgressSubscriptionHookResult = ReturnType<typeof useCreatedPersonRegisterProgressSubscription>;
export type CreatedPersonRegisterProgressSubscriptionResult = Apollo.SubscriptionResult<CreatedPersonRegisterProgressSubscription>;
export const UpdatedPersonRegisterProgressDocument = gql`
    subscription UpdatedPersonRegisterProgress($filter: PersonRegisterProgressFilterArgs, $withPerson: Boolean = false, $withRegister: Boolean = false) {
  updatedPersonRegisterProgress(filter: $filter) {
    ...personRegisterProgressFields
  }
}
    ${PersonRegisterProgressFieldsFragmentDoc}`;

/**
 * __useUpdatedPersonRegisterProgressSubscription__
 *
 * To run a query within a React component, call `useUpdatedPersonRegisterProgressSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedPersonRegisterProgressSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedPersonRegisterProgressSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withPerson: // value for 'withPerson'
 *      withRegister: // value for 'withRegister'
 *   },
 * });
 */
export function useUpdatedPersonRegisterProgressSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedPersonRegisterProgressSubscription, UpdatedPersonRegisterProgressSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedPersonRegisterProgressSubscription, UpdatedPersonRegisterProgressSubscriptionVariables>(UpdatedPersonRegisterProgressDocument, options);
      }
export type UpdatedPersonRegisterProgressSubscriptionHookResult = ReturnType<typeof useUpdatedPersonRegisterProgressSubscription>;
export type UpdatedPersonRegisterProgressSubscriptionResult = Apollo.SubscriptionResult<UpdatedPersonRegisterProgressSubscription>;
export const DeletedPersonRegisterProgressDocument = gql`
    subscription DeletedPersonRegisterProgress($filter: PersonRegisterProgressFilterArgs) {
  deletedPersonRegisterProgress(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedPersonRegisterProgressSubscription__
 *
 * To run a query within a React component, call `useDeletedPersonRegisterProgressSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedPersonRegisterProgressSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedPersonRegisterProgressSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedPersonRegisterProgressSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedPersonRegisterProgressSubscription, DeletedPersonRegisterProgressSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedPersonRegisterProgressSubscription, DeletedPersonRegisterProgressSubscriptionVariables>(DeletedPersonRegisterProgressDocument, options);
      }
export type DeletedPersonRegisterProgressSubscriptionHookResult = ReturnType<typeof useDeletedPersonRegisterProgressSubscription>;
export type DeletedPersonRegisterProgressSubscriptionResult = Apollo.SubscriptionResult<DeletedPersonRegisterProgressSubscription>;
export const GetPersonSearchProgressesDocument = gql`
    query GetPersonSearchProgresses($filter: PersonSearchProgressFilterArgs, $paging: PageArgs, $sorting: [PersonSearchProgressSortArgs!], $withPerson: Boolean = false, $withSearch: Boolean = false) {
  personSearchProgresses(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...personSearchProgressFields
    }
    totalCount
  }
}
    ${PersonSearchProgressFieldsFragmentDoc}`;

/**
 * __useGetPersonSearchProgressesQuery__
 *
 * To run a query within a React component, call `useGetPersonSearchProgressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonSearchProgressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonSearchProgressesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withPerson: // value for 'withPerson'
 *      withSearch: // value for 'withSearch'
 *   },
 * });
 */
export function useGetPersonSearchProgressesQuery(baseOptions?: Apollo.QueryHookOptions<GetPersonSearchProgressesQuery, GetPersonSearchProgressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonSearchProgressesQuery, GetPersonSearchProgressesQueryVariables>(GetPersonSearchProgressesDocument, options);
      }
export function useGetPersonSearchProgressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonSearchProgressesQuery, GetPersonSearchProgressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonSearchProgressesQuery, GetPersonSearchProgressesQueryVariables>(GetPersonSearchProgressesDocument, options);
        }
export function useGetPersonSearchProgressesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPersonSearchProgressesQuery, GetPersonSearchProgressesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPersonSearchProgressesQuery, GetPersonSearchProgressesQueryVariables>(GetPersonSearchProgressesDocument, options);
        }
export type GetPersonSearchProgressesQueryHookResult = ReturnType<typeof useGetPersonSearchProgressesQuery>;
export type GetPersonSearchProgressesLazyQueryHookResult = ReturnType<typeof useGetPersonSearchProgressesLazyQuery>;
export type GetPersonSearchProgressesSuspenseQueryHookResult = ReturnType<typeof useGetPersonSearchProgressesSuspenseQuery>;
export type GetPersonSearchProgressesQueryResult = Apollo.QueryResult<GetPersonSearchProgressesQuery, GetPersonSearchProgressesQueryVariables>;
export const GetPersonSearchProgressDocument = gql`
    query GetPersonSearchProgress($id: ID!, $withPerson: Boolean = false, $withSearch: Boolean = false) {
  personSearchProgress(id: $id) {
    ...personSearchProgressFields
  }
}
    ${PersonSearchProgressFieldsFragmentDoc}`;

/**
 * __useGetPersonSearchProgressQuery__
 *
 * To run a query within a React component, call `useGetPersonSearchProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonSearchProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonSearchProgressQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withPerson: // value for 'withPerson'
 *      withSearch: // value for 'withSearch'
 *   },
 * });
 */
export function useGetPersonSearchProgressQuery(baseOptions: Apollo.QueryHookOptions<GetPersonSearchProgressQuery, GetPersonSearchProgressQueryVariables> & ({ variables: GetPersonSearchProgressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonSearchProgressQuery, GetPersonSearchProgressQueryVariables>(GetPersonSearchProgressDocument, options);
      }
export function useGetPersonSearchProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonSearchProgressQuery, GetPersonSearchProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonSearchProgressQuery, GetPersonSearchProgressQueryVariables>(GetPersonSearchProgressDocument, options);
        }
export function useGetPersonSearchProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPersonSearchProgressQuery, GetPersonSearchProgressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPersonSearchProgressQuery, GetPersonSearchProgressQueryVariables>(GetPersonSearchProgressDocument, options);
        }
export type GetPersonSearchProgressQueryHookResult = ReturnType<typeof useGetPersonSearchProgressQuery>;
export type GetPersonSearchProgressLazyQueryHookResult = ReturnType<typeof useGetPersonSearchProgressLazyQuery>;
export type GetPersonSearchProgressSuspenseQueryHookResult = ReturnType<typeof useGetPersonSearchProgressSuspenseQuery>;
export type GetPersonSearchProgressQueryResult = Apollo.QueryResult<GetPersonSearchProgressQuery, GetPersonSearchProgressQueryVariables>;
export const GetAllRelatedDataForPersonSearchProgressDocument = gql`
    query GetAllRelatedDataForPersonSearchProgress($withPeople: Boolean = false, $withSearches: Boolean = false) {
  people @include(if: $withPeople) {
    items {
      id
      displayField: id
    }
  }
  searches @include(if: $withSearches) {
    items {
      id
      displayField: name
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForPersonSearchProgressQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForPersonSearchProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForPersonSearchProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForPersonSearchProgressQuery({
 *   variables: {
 *      withPeople: // value for 'withPeople'
 *      withSearches: // value for 'withSearches'
 *   },
 * });
 */
export function useGetAllRelatedDataForPersonSearchProgressQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForPersonSearchProgressQuery, GetAllRelatedDataForPersonSearchProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForPersonSearchProgressQuery, GetAllRelatedDataForPersonSearchProgressQueryVariables>(GetAllRelatedDataForPersonSearchProgressDocument, options);
      }
export function useGetAllRelatedDataForPersonSearchProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForPersonSearchProgressQuery, GetAllRelatedDataForPersonSearchProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForPersonSearchProgressQuery, GetAllRelatedDataForPersonSearchProgressQueryVariables>(GetAllRelatedDataForPersonSearchProgressDocument, options);
        }
export function useGetAllRelatedDataForPersonSearchProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForPersonSearchProgressQuery, GetAllRelatedDataForPersonSearchProgressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForPersonSearchProgressQuery, GetAllRelatedDataForPersonSearchProgressQueryVariables>(GetAllRelatedDataForPersonSearchProgressDocument, options);
        }
export type GetAllRelatedDataForPersonSearchProgressQueryHookResult = ReturnType<typeof useGetAllRelatedDataForPersonSearchProgressQuery>;
export type GetAllRelatedDataForPersonSearchProgressLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForPersonSearchProgressLazyQuery>;
export type GetAllRelatedDataForPersonSearchProgressSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForPersonSearchProgressSuspenseQuery>;
export type GetAllRelatedDataForPersonSearchProgressQueryResult = Apollo.QueryResult<GetAllRelatedDataForPersonSearchProgressQuery, GetAllRelatedDataForPersonSearchProgressQueryVariables>;
export const CreatePersonSearchProgressDocument = gql`
    mutation CreatePersonSearchProgress($progress: String!, $done: Boolean, $personId: ID!, $searchId: ID!, $withPerson: Boolean = false, $withSearch: Boolean = false) {
  createPersonSearchProgress(
    progress: $progress
    done: $done
    personId: $personId
    searchId: $searchId
  ) {
    ...personSearchProgressFields
  }
}
    ${PersonSearchProgressFieldsFragmentDoc}`;
export type CreatePersonSearchProgressMutationFn = Apollo.MutationFunction<CreatePersonSearchProgressMutation, CreatePersonSearchProgressMutationVariables>;

/**
 * __useCreatePersonSearchProgressMutation__
 *
 * To run a mutation, you first call `useCreatePersonSearchProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePersonSearchProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPersonSearchProgressMutation, { data, loading, error }] = useCreatePersonSearchProgressMutation({
 *   variables: {
 *      progress: // value for 'progress'
 *      done: // value for 'done'
 *      personId: // value for 'personId'
 *      searchId: // value for 'searchId'
 *      withPerson: // value for 'withPerson'
 *      withSearch: // value for 'withSearch'
 *   },
 * });
 */
export function useCreatePersonSearchProgressMutation(baseOptions?: Apollo.MutationHookOptions<CreatePersonSearchProgressMutation, CreatePersonSearchProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePersonSearchProgressMutation, CreatePersonSearchProgressMutationVariables>(CreatePersonSearchProgressDocument, options);
      }
export type CreatePersonSearchProgressMutationHookResult = ReturnType<typeof useCreatePersonSearchProgressMutation>;
export type CreatePersonSearchProgressMutationResult = Apollo.MutationResult<CreatePersonSearchProgressMutation>;
export type CreatePersonSearchProgressMutationOptions = Apollo.BaseMutationOptions<CreatePersonSearchProgressMutation, CreatePersonSearchProgressMutationVariables>;
export const UpdatePersonSearchProgressDocument = gql`
    mutation UpdatePersonSearchProgress($id: ID!, $progress: String, $done: Boolean, $personId: ID, $searchId: ID, $withPerson: Boolean = false, $withSearch: Boolean = false) {
  updatePersonSearchProgress(
    id: $id
    progress: $progress
    done: $done
    personId: $personId
    searchId: $searchId
  ) {
    ...personSearchProgressFields
  }
}
    ${PersonSearchProgressFieldsFragmentDoc}`;
export type UpdatePersonSearchProgressMutationFn = Apollo.MutationFunction<UpdatePersonSearchProgressMutation, UpdatePersonSearchProgressMutationVariables>;

/**
 * __useUpdatePersonSearchProgressMutation__
 *
 * To run a mutation, you first call `useUpdatePersonSearchProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonSearchProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonSearchProgressMutation, { data, loading, error }] = useUpdatePersonSearchProgressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      progress: // value for 'progress'
 *      done: // value for 'done'
 *      personId: // value for 'personId'
 *      searchId: // value for 'searchId'
 *      withPerson: // value for 'withPerson'
 *      withSearch: // value for 'withSearch'
 *   },
 * });
 */
export function useUpdatePersonSearchProgressMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonSearchProgressMutation, UpdatePersonSearchProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonSearchProgressMutation, UpdatePersonSearchProgressMutationVariables>(UpdatePersonSearchProgressDocument, options);
      }
export type UpdatePersonSearchProgressMutationHookResult = ReturnType<typeof useUpdatePersonSearchProgressMutation>;
export type UpdatePersonSearchProgressMutationResult = Apollo.MutationResult<UpdatePersonSearchProgressMutation>;
export type UpdatePersonSearchProgressMutationOptions = Apollo.BaseMutationOptions<UpdatePersonSearchProgressMutation, UpdatePersonSearchProgressMutationVariables>;
export const DeletePersonSearchProgressDocument = gql`
    mutation DeletePersonSearchProgress($id: ID!, $withPerson: Boolean = false, $withSearch: Boolean = false) {
  deletePersonSearchProgress(id: $id) {
    ...personSearchProgressFields
  }
}
    ${PersonSearchProgressFieldsFragmentDoc}`;
export type DeletePersonSearchProgressMutationFn = Apollo.MutationFunction<DeletePersonSearchProgressMutation, DeletePersonSearchProgressMutationVariables>;

/**
 * __useDeletePersonSearchProgressMutation__
 *
 * To run a mutation, you first call `useDeletePersonSearchProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePersonSearchProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePersonSearchProgressMutation, { data, loading, error }] = useDeletePersonSearchProgressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withPerson: // value for 'withPerson'
 *      withSearch: // value for 'withSearch'
 *   },
 * });
 */
export function useDeletePersonSearchProgressMutation(baseOptions?: Apollo.MutationHookOptions<DeletePersonSearchProgressMutation, DeletePersonSearchProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePersonSearchProgressMutation, DeletePersonSearchProgressMutationVariables>(DeletePersonSearchProgressDocument, options);
      }
export type DeletePersonSearchProgressMutationHookResult = ReturnType<typeof useDeletePersonSearchProgressMutation>;
export type DeletePersonSearchProgressMutationResult = Apollo.MutationResult<DeletePersonSearchProgressMutation>;
export type DeletePersonSearchProgressMutationOptions = Apollo.BaseMutationOptions<DeletePersonSearchProgressMutation, DeletePersonSearchProgressMutationVariables>;
export const CreatedPersonSearchProgressDocument = gql`
    subscription CreatedPersonSearchProgress($filter: PersonSearchProgressFilterArgs, $withPerson: Boolean = false, $withSearch: Boolean = false) {
  createdPersonSearchProgress(filter: $filter) {
    ...personSearchProgressFields
  }
}
    ${PersonSearchProgressFieldsFragmentDoc}`;

/**
 * __useCreatedPersonSearchProgressSubscription__
 *
 * To run a query within a React component, call `useCreatedPersonSearchProgressSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedPersonSearchProgressSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedPersonSearchProgressSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withPerson: // value for 'withPerson'
 *      withSearch: // value for 'withSearch'
 *   },
 * });
 */
export function useCreatedPersonSearchProgressSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedPersonSearchProgressSubscription, CreatedPersonSearchProgressSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedPersonSearchProgressSubscription, CreatedPersonSearchProgressSubscriptionVariables>(CreatedPersonSearchProgressDocument, options);
      }
export type CreatedPersonSearchProgressSubscriptionHookResult = ReturnType<typeof useCreatedPersonSearchProgressSubscription>;
export type CreatedPersonSearchProgressSubscriptionResult = Apollo.SubscriptionResult<CreatedPersonSearchProgressSubscription>;
export const UpdatedPersonSearchProgressDocument = gql`
    subscription UpdatedPersonSearchProgress($filter: PersonSearchProgressFilterArgs, $withPerson: Boolean = false, $withSearch: Boolean = false) {
  updatedPersonSearchProgress(filter: $filter) {
    ...personSearchProgressFields
  }
}
    ${PersonSearchProgressFieldsFragmentDoc}`;

/**
 * __useUpdatedPersonSearchProgressSubscription__
 *
 * To run a query within a React component, call `useUpdatedPersonSearchProgressSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedPersonSearchProgressSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedPersonSearchProgressSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withPerson: // value for 'withPerson'
 *      withSearch: // value for 'withSearch'
 *   },
 * });
 */
export function useUpdatedPersonSearchProgressSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedPersonSearchProgressSubscription, UpdatedPersonSearchProgressSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedPersonSearchProgressSubscription, UpdatedPersonSearchProgressSubscriptionVariables>(UpdatedPersonSearchProgressDocument, options);
      }
export type UpdatedPersonSearchProgressSubscriptionHookResult = ReturnType<typeof useUpdatedPersonSearchProgressSubscription>;
export type UpdatedPersonSearchProgressSubscriptionResult = Apollo.SubscriptionResult<UpdatedPersonSearchProgressSubscription>;
export const DeletedPersonSearchProgressDocument = gql`
    subscription DeletedPersonSearchProgress($filter: PersonSearchProgressFilterArgs) {
  deletedPersonSearchProgress(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedPersonSearchProgressSubscription__
 *
 * To run a query within a React component, call `useDeletedPersonSearchProgressSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedPersonSearchProgressSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedPersonSearchProgressSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedPersonSearchProgressSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedPersonSearchProgressSubscription, DeletedPersonSearchProgressSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedPersonSearchProgressSubscription, DeletedPersonSearchProgressSubscriptionVariables>(DeletedPersonSearchProgressDocument, options);
      }
export type DeletedPersonSearchProgressSubscriptionHookResult = ReturnType<typeof useDeletedPersonSearchProgressSubscription>;
export type DeletedPersonSearchProgressSubscriptionResult = Apollo.SubscriptionResult<DeletedPersonSearchProgressSubscription>;
export const GetRegistersDocument = gql`
    query GetRegisters($filter: RegisterFilterArgs, $paging: PageArgs, $sorting: [RegisterSortArgs!], $withDerivatives: Boolean = false, $withSource: Boolean = false, $withActions: Boolean = false, $withPersonRegisterProgresses: Boolean = false) {
  registers(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...registerFields
    }
    totalCount
  }
}
    ${RegisterFieldsFragmentDoc}`;

/**
 * __useGetRegistersQuery__
 *
 * To run a query within a React component, call `useGetRegistersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withDerivatives: // value for 'withDerivatives'
 *      withSource: // value for 'withSource'
 *      withActions: // value for 'withActions'
 *      withPersonRegisterProgresses: // value for 'withPersonRegisterProgresses'
 *   },
 * });
 */
export function useGetRegistersQuery(baseOptions?: Apollo.QueryHookOptions<GetRegistersQuery, GetRegistersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegistersQuery, GetRegistersQueryVariables>(GetRegistersDocument, options);
      }
export function useGetRegistersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegistersQuery, GetRegistersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegistersQuery, GetRegistersQueryVariables>(GetRegistersDocument, options);
        }
export function useGetRegistersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRegistersQuery, GetRegistersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRegistersQuery, GetRegistersQueryVariables>(GetRegistersDocument, options);
        }
export type GetRegistersQueryHookResult = ReturnType<typeof useGetRegistersQuery>;
export type GetRegistersLazyQueryHookResult = ReturnType<typeof useGetRegistersLazyQuery>;
export type GetRegistersSuspenseQueryHookResult = ReturnType<typeof useGetRegistersSuspenseQuery>;
export type GetRegistersQueryResult = Apollo.QueryResult<GetRegistersQuery, GetRegistersQueryVariables>;
export const GetRegisterDocument = gql`
    query GetRegister($id: ID!, $withDerivatives: Boolean = false, $withSource: Boolean = false, $withActions: Boolean = false, $withPersonRegisterProgresses: Boolean = false) {
  register(id: $id) {
    ...registerFields
  }
}
    ${RegisterFieldsFragmentDoc}`;

/**
 * __useGetRegisterQuery__
 *
 * To run a query within a React component, call `useGetRegisterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegisterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegisterQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withDerivatives: // value for 'withDerivatives'
 *      withSource: // value for 'withSource'
 *      withActions: // value for 'withActions'
 *      withPersonRegisterProgresses: // value for 'withPersonRegisterProgresses'
 *   },
 * });
 */
export function useGetRegisterQuery(baseOptions: Apollo.QueryHookOptions<GetRegisterQuery, GetRegisterQueryVariables> & ({ variables: GetRegisterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegisterQuery, GetRegisterQueryVariables>(GetRegisterDocument, options);
      }
export function useGetRegisterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegisterQuery, GetRegisterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegisterQuery, GetRegisterQueryVariables>(GetRegisterDocument, options);
        }
export function useGetRegisterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRegisterQuery, GetRegisterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRegisterQuery, GetRegisterQueryVariables>(GetRegisterDocument, options);
        }
export type GetRegisterQueryHookResult = ReturnType<typeof useGetRegisterQuery>;
export type GetRegisterLazyQueryHookResult = ReturnType<typeof useGetRegisterLazyQuery>;
export type GetRegisterSuspenseQueryHookResult = ReturnType<typeof useGetRegisterSuspenseQuery>;
export type GetRegisterQueryResult = Apollo.QueryResult<GetRegisterQuery, GetRegisterQueryVariables>;
export const GetAllRelatedDataForRegisterDocument = gql`
    query GetAllRelatedDataForRegister($withDerivatives: Boolean = false, $withSources: Boolean = false, $withActions: Boolean = false, $withPersonRegisterProgresses: Boolean = false) {
  registers @include(if: $withDerivatives) {
    items {
      id
      displayField: name
    }
  }
  registers @include(if: $withSources) {
    items {
      id
      displayField: name
    }
  }
  actions @include(if: $withActions) {
    items {
      id
      displayField: name
    }
  }
  personRegisterProgresses @include(if: $withPersonRegisterProgresses) {
    items {
      id
      displayField: id
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForRegisterQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForRegisterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForRegisterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForRegisterQuery({
 *   variables: {
 *      withDerivatives: // value for 'withDerivatives'
 *      withSources: // value for 'withSources'
 *      withActions: // value for 'withActions'
 *      withPersonRegisterProgresses: // value for 'withPersonRegisterProgresses'
 *   },
 * });
 */
export function useGetAllRelatedDataForRegisterQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForRegisterQuery, GetAllRelatedDataForRegisterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForRegisterQuery, GetAllRelatedDataForRegisterQueryVariables>(GetAllRelatedDataForRegisterDocument, options);
      }
export function useGetAllRelatedDataForRegisterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForRegisterQuery, GetAllRelatedDataForRegisterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForRegisterQuery, GetAllRelatedDataForRegisterQueryVariables>(GetAllRelatedDataForRegisterDocument, options);
        }
export function useGetAllRelatedDataForRegisterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForRegisterQuery, GetAllRelatedDataForRegisterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForRegisterQuery, GetAllRelatedDataForRegisterQueryVariables>(GetAllRelatedDataForRegisterDocument, options);
        }
export type GetAllRelatedDataForRegisterQueryHookResult = ReturnType<typeof useGetAllRelatedDataForRegisterQuery>;
export type GetAllRelatedDataForRegisterLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForRegisterLazyQuery>;
export type GetAllRelatedDataForRegisterSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForRegisterSuspenseQuery>;
export type GetAllRelatedDataForRegisterQueryResult = Apollo.QueryResult<GetAllRelatedDataForRegisterQuery, GetAllRelatedDataForRegisterQueryVariables>;
export const CreateRegisterDocument = gql`
    mutation CreateRegister($email: String, $type: String!, $companyRegister: Boolean!, $order: Int, $name: String!, $machineName: String!, $description: String, $subtitle: String, $contactUrl: String, $siteUrl: String, $logo: String, $derivatives: [ID], $sourceId: ID, $actions: [ID], $personRegisterProgresses: [ID], $withDerivatives: Boolean = false, $withSource: Boolean = false, $withActions: Boolean = false, $withPersonRegisterProgresses: Boolean = false) {
  createRegister(
    email: $email
    type: $type
    companyRegister: $companyRegister
    order: $order
    name: $name
    machineName: $machineName
    description: $description
    subtitle: $subtitle
    contactUrl: $contactUrl
    siteUrl: $siteUrl
    logo: $logo
    derivativesIds: $derivatives
    sourceId: $sourceId
    actionIds: $actions
    personRegisterProgressIds: $personRegisterProgresses
  ) {
    ...registerFields
  }
}
    ${RegisterFieldsFragmentDoc}`;
export type CreateRegisterMutationFn = Apollo.MutationFunction<CreateRegisterMutation, CreateRegisterMutationVariables>;

/**
 * __useCreateRegisterMutation__
 *
 * To run a mutation, you first call `useCreateRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRegisterMutation, { data, loading, error }] = useCreateRegisterMutation({
 *   variables: {
 *      email: // value for 'email'
 *      type: // value for 'type'
 *      companyRegister: // value for 'companyRegister'
 *      order: // value for 'order'
 *      name: // value for 'name'
 *      machineName: // value for 'machineName'
 *      description: // value for 'description'
 *      subtitle: // value for 'subtitle'
 *      contactUrl: // value for 'contactUrl'
 *      siteUrl: // value for 'siteUrl'
 *      logo: // value for 'logo'
 *      derivatives: // value for 'derivatives'
 *      sourceId: // value for 'sourceId'
 *      actions: // value for 'actions'
 *      personRegisterProgresses: // value for 'personRegisterProgresses'
 *      withDerivatives: // value for 'withDerivatives'
 *      withSource: // value for 'withSource'
 *      withActions: // value for 'withActions'
 *      withPersonRegisterProgresses: // value for 'withPersonRegisterProgresses'
 *   },
 * });
 */
export function useCreateRegisterMutation(baseOptions?: Apollo.MutationHookOptions<CreateRegisterMutation, CreateRegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRegisterMutation, CreateRegisterMutationVariables>(CreateRegisterDocument, options);
      }
export type CreateRegisterMutationHookResult = ReturnType<typeof useCreateRegisterMutation>;
export type CreateRegisterMutationResult = Apollo.MutationResult<CreateRegisterMutation>;
export type CreateRegisterMutationOptions = Apollo.BaseMutationOptions<CreateRegisterMutation, CreateRegisterMutationVariables>;
export const UpdateRegisterDocument = gql`
    mutation UpdateRegister($id: ID!, $email: String, $type: String, $companyRegister: Boolean, $order: Int, $name: String, $machineName: String, $description: String, $subtitle: String, $contactUrl: String, $siteUrl: String, $logo: String, $derivatives: [ID], $sourceId: ID, $actions: [ID], $personRegisterProgresses: [ID], $withDerivatives: Boolean = false, $withSource: Boolean = false, $withActions: Boolean = false, $withPersonRegisterProgresses: Boolean = false) {
  updateRegister(
    id: $id
    email: $email
    type: $type
    companyRegister: $companyRegister
    order: $order
    name: $name
    machineName: $machineName
    description: $description
    subtitle: $subtitle
    contactUrl: $contactUrl
    siteUrl: $siteUrl
    logo: $logo
    derivativesIds: $derivatives
    sourceId: $sourceId
    actionIds: $actions
    personRegisterProgressIds: $personRegisterProgresses
  ) {
    ...registerFields
  }
}
    ${RegisterFieldsFragmentDoc}`;
export type UpdateRegisterMutationFn = Apollo.MutationFunction<UpdateRegisterMutation, UpdateRegisterMutationVariables>;

/**
 * __useUpdateRegisterMutation__
 *
 * To run a mutation, you first call `useUpdateRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegisterMutation, { data, loading, error }] = useUpdateRegisterMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *      type: // value for 'type'
 *      companyRegister: // value for 'companyRegister'
 *      order: // value for 'order'
 *      name: // value for 'name'
 *      machineName: // value for 'machineName'
 *      description: // value for 'description'
 *      subtitle: // value for 'subtitle'
 *      contactUrl: // value for 'contactUrl'
 *      siteUrl: // value for 'siteUrl'
 *      logo: // value for 'logo'
 *      derivatives: // value for 'derivatives'
 *      sourceId: // value for 'sourceId'
 *      actions: // value for 'actions'
 *      personRegisterProgresses: // value for 'personRegisterProgresses'
 *      withDerivatives: // value for 'withDerivatives'
 *      withSource: // value for 'withSource'
 *      withActions: // value for 'withActions'
 *      withPersonRegisterProgresses: // value for 'withPersonRegisterProgresses'
 *   },
 * });
 */
export function useUpdateRegisterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRegisterMutation, UpdateRegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRegisterMutation, UpdateRegisterMutationVariables>(UpdateRegisterDocument, options);
      }
export type UpdateRegisterMutationHookResult = ReturnType<typeof useUpdateRegisterMutation>;
export type UpdateRegisterMutationResult = Apollo.MutationResult<UpdateRegisterMutation>;
export type UpdateRegisterMutationOptions = Apollo.BaseMutationOptions<UpdateRegisterMutation, UpdateRegisterMutationVariables>;
export const DeleteRegisterDocument = gql`
    mutation DeleteRegister($id: ID!, $withDerivatives: Boolean = false, $withSource: Boolean = false, $withActions: Boolean = false, $withPersonRegisterProgresses: Boolean = false) {
  deleteRegister(id: $id) {
    ...registerFields
  }
}
    ${RegisterFieldsFragmentDoc}`;
export type DeleteRegisterMutationFn = Apollo.MutationFunction<DeleteRegisterMutation, DeleteRegisterMutationVariables>;

/**
 * __useDeleteRegisterMutation__
 *
 * To run a mutation, you first call `useDeleteRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRegisterMutation, { data, loading, error }] = useDeleteRegisterMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withDerivatives: // value for 'withDerivatives'
 *      withSource: // value for 'withSource'
 *      withActions: // value for 'withActions'
 *      withPersonRegisterProgresses: // value for 'withPersonRegisterProgresses'
 *   },
 * });
 */
export function useDeleteRegisterMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRegisterMutation, DeleteRegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRegisterMutation, DeleteRegisterMutationVariables>(DeleteRegisterDocument, options);
      }
export type DeleteRegisterMutationHookResult = ReturnType<typeof useDeleteRegisterMutation>;
export type DeleteRegisterMutationResult = Apollo.MutationResult<DeleteRegisterMutation>;
export type DeleteRegisterMutationOptions = Apollo.BaseMutationOptions<DeleteRegisterMutation, DeleteRegisterMutationVariables>;
export const CreatedRegisterDocument = gql`
    subscription CreatedRegister($filter: RegisterFilterArgs, $withDerivatives: Boolean = false, $withSource: Boolean = false, $withActions: Boolean = false, $withPersonRegisterProgresses: Boolean = false) {
  createdRegister(filter: $filter) {
    ...registerFields
  }
}
    ${RegisterFieldsFragmentDoc}`;

/**
 * __useCreatedRegisterSubscription__
 *
 * To run a query within a React component, call `useCreatedRegisterSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedRegisterSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedRegisterSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withDerivatives: // value for 'withDerivatives'
 *      withSource: // value for 'withSource'
 *      withActions: // value for 'withActions'
 *      withPersonRegisterProgresses: // value for 'withPersonRegisterProgresses'
 *   },
 * });
 */
export function useCreatedRegisterSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedRegisterSubscription, CreatedRegisterSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedRegisterSubscription, CreatedRegisterSubscriptionVariables>(CreatedRegisterDocument, options);
      }
export type CreatedRegisterSubscriptionHookResult = ReturnType<typeof useCreatedRegisterSubscription>;
export type CreatedRegisterSubscriptionResult = Apollo.SubscriptionResult<CreatedRegisterSubscription>;
export const UpdatedRegisterDocument = gql`
    subscription UpdatedRegister($filter: RegisterFilterArgs, $withDerivatives: Boolean = false, $withSource: Boolean = false, $withActions: Boolean = false, $withPersonRegisterProgresses: Boolean = false) {
  updatedRegister(filter: $filter) {
    ...registerFields
  }
}
    ${RegisterFieldsFragmentDoc}`;

/**
 * __useUpdatedRegisterSubscription__
 *
 * To run a query within a React component, call `useUpdatedRegisterSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedRegisterSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedRegisterSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withDerivatives: // value for 'withDerivatives'
 *      withSource: // value for 'withSource'
 *      withActions: // value for 'withActions'
 *      withPersonRegisterProgresses: // value for 'withPersonRegisterProgresses'
 *   },
 * });
 */
export function useUpdatedRegisterSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedRegisterSubscription, UpdatedRegisterSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedRegisterSubscription, UpdatedRegisterSubscriptionVariables>(UpdatedRegisterDocument, options);
      }
export type UpdatedRegisterSubscriptionHookResult = ReturnType<typeof useUpdatedRegisterSubscription>;
export type UpdatedRegisterSubscriptionResult = Apollo.SubscriptionResult<UpdatedRegisterSubscription>;
export const DeletedRegisterDocument = gql`
    subscription DeletedRegister($filter: RegisterFilterArgs) {
  deletedRegister(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedRegisterSubscription__
 *
 * To run a query within a React component, call `useDeletedRegisterSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedRegisterSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedRegisterSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedRegisterSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedRegisterSubscription, DeletedRegisterSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedRegisterSubscription, DeletedRegisterSubscriptionVariables>(DeletedRegisterDocument, options);
      }
export type DeletedRegisterSubscriptionHookResult = ReturnType<typeof useDeletedRegisterSubscription>;
export type DeletedRegisterSubscriptionResult = Apollo.SubscriptionResult<DeletedRegisterSubscription>;
export const RestoredRegisterDocument = gql`
    subscription RestoredRegister($filter: RegisterFilterArgs, $withDerivatives: Boolean = false, $withSource: Boolean = false, $withActions: Boolean = false, $withPersonRegisterProgresses: Boolean = false) {
  restoredRegister(filter: $filter) {
    ...registerFields
  }
}
    ${RegisterFieldsFragmentDoc}`;

/**
 * __useRestoredRegisterSubscription__
 *
 * To run a query within a React component, call `useRestoredRegisterSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredRegisterSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredRegisterSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withDerivatives: // value for 'withDerivatives'
 *      withSource: // value for 'withSource'
 *      withActions: // value for 'withActions'
 *      withPersonRegisterProgresses: // value for 'withPersonRegisterProgresses'
 *   },
 * });
 */
export function useRestoredRegisterSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredRegisterSubscription, RestoredRegisterSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredRegisterSubscription, RestoredRegisterSubscriptionVariables>(RestoredRegisterDocument, options);
      }
export type RestoredRegisterSubscriptionHookResult = ReturnType<typeof useRestoredRegisterSubscription>;
export type RestoredRegisterSubscriptionResult = Apollo.SubscriptionResult<RestoredRegisterSubscription>;
export const GetRemindersDocument = gql`
    query GetReminders($filter: ReminderFilterArgs, $paging: PageArgs, $sorting: [ReminderSortArgs!], $withUser: Boolean = false, $withMailTemplate: Boolean = false) {
  reminders(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...reminderFields
    }
    totalCount
  }
}
    ${ReminderFieldsFragmentDoc}`;

/**
 * __useGetRemindersQuery__
 *
 * To run a query within a React component, call `useGetRemindersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRemindersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRemindersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withUser: // value for 'withUser'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useGetRemindersQuery(baseOptions?: Apollo.QueryHookOptions<GetRemindersQuery, GetRemindersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRemindersQuery, GetRemindersQueryVariables>(GetRemindersDocument, options);
      }
export function useGetRemindersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRemindersQuery, GetRemindersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRemindersQuery, GetRemindersQueryVariables>(GetRemindersDocument, options);
        }
export function useGetRemindersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRemindersQuery, GetRemindersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRemindersQuery, GetRemindersQueryVariables>(GetRemindersDocument, options);
        }
export type GetRemindersQueryHookResult = ReturnType<typeof useGetRemindersQuery>;
export type GetRemindersLazyQueryHookResult = ReturnType<typeof useGetRemindersLazyQuery>;
export type GetRemindersSuspenseQueryHookResult = ReturnType<typeof useGetRemindersSuspenseQuery>;
export type GetRemindersQueryResult = Apollo.QueryResult<GetRemindersQuery, GetRemindersQueryVariables>;
export const GetReminderDocument = gql`
    query GetReminder($id: ID!, $withUser: Boolean = false, $withMailTemplate: Boolean = false) {
  reminder(id: $id) {
    ...reminderFields
  }
}
    ${ReminderFieldsFragmentDoc}`;

/**
 * __useGetReminderQuery__
 *
 * To run a query within a React component, call `useGetReminderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReminderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReminderQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withUser: // value for 'withUser'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useGetReminderQuery(baseOptions: Apollo.QueryHookOptions<GetReminderQuery, GetReminderQueryVariables> & ({ variables: GetReminderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReminderQuery, GetReminderQueryVariables>(GetReminderDocument, options);
      }
export function useGetReminderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReminderQuery, GetReminderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReminderQuery, GetReminderQueryVariables>(GetReminderDocument, options);
        }
export function useGetReminderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReminderQuery, GetReminderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReminderQuery, GetReminderQueryVariables>(GetReminderDocument, options);
        }
export type GetReminderQueryHookResult = ReturnType<typeof useGetReminderQuery>;
export type GetReminderLazyQueryHookResult = ReturnType<typeof useGetReminderLazyQuery>;
export type GetReminderSuspenseQueryHookResult = ReturnType<typeof useGetReminderSuspenseQuery>;
export type GetReminderQueryResult = Apollo.QueryResult<GetReminderQuery, GetReminderQueryVariables>;
export const GetAllRelatedDataForReminderDocument = gql`
    query GetAllRelatedDataForReminder($withUsers: Boolean = false, $withMailTemplates: Boolean = false) {
  users @include(if: $withUsers) {
    items {
      id
      displayField: name
    }
  }
  mailTemplates @include(if: $withMailTemplates) {
    items {
      id
      displayField: id
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForReminderQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForReminderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForReminderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForReminderQuery({
 *   variables: {
 *      withUsers: // value for 'withUsers'
 *      withMailTemplates: // value for 'withMailTemplates'
 *   },
 * });
 */
export function useGetAllRelatedDataForReminderQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForReminderQuery, GetAllRelatedDataForReminderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForReminderQuery, GetAllRelatedDataForReminderQueryVariables>(GetAllRelatedDataForReminderDocument, options);
      }
export function useGetAllRelatedDataForReminderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForReminderQuery, GetAllRelatedDataForReminderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForReminderQuery, GetAllRelatedDataForReminderQueryVariables>(GetAllRelatedDataForReminderDocument, options);
        }
export function useGetAllRelatedDataForReminderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForReminderQuery, GetAllRelatedDataForReminderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForReminderQuery, GetAllRelatedDataForReminderQueryVariables>(GetAllRelatedDataForReminderDocument, options);
        }
export type GetAllRelatedDataForReminderQueryHookResult = ReturnType<typeof useGetAllRelatedDataForReminderQuery>;
export type GetAllRelatedDataForReminderLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForReminderLazyQuery>;
export type GetAllRelatedDataForReminderSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForReminderSuspenseQuery>;
export type GetAllRelatedDataForReminderQueryResult = Apollo.QueryResult<GetAllRelatedDataForReminderQuery, GetAllRelatedDataForReminderQueryVariables>;
export const CreateReminderDocument = gql`
    mutation CreateReminder($date: DateTime!, $userId: ID!, $mailTemplateId: ID!, $withUser: Boolean = false, $withMailTemplate: Boolean = false) {
  createReminder(date: $date, userId: $userId, mailTemplateId: $mailTemplateId) {
    ...reminderFields
  }
}
    ${ReminderFieldsFragmentDoc}`;
export type CreateReminderMutationFn = Apollo.MutationFunction<CreateReminderMutation, CreateReminderMutationVariables>;

/**
 * __useCreateReminderMutation__
 *
 * To run a mutation, you first call `useCreateReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReminderMutation, { data, loading, error }] = useCreateReminderMutation({
 *   variables: {
 *      date: // value for 'date'
 *      userId: // value for 'userId'
 *      mailTemplateId: // value for 'mailTemplateId'
 *      withUser: // value for 'withUser'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useCreateReminderMutation(baseOptions?: Apollo.MutationHookOptions<CreateReminderMutation, CreateReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReminderMutation, CreateReminderMutationVariables>(CreateReminderDocument, options);
      }
export type CreateReminderMutationHookResult = ReturnType<typeof useCreateReminderMutation>;
export type CreateReminderMutationResult = Apollo.MutationResult<CreateReminderMutation>;
export type CreateReminderMutationOptions = Apollo.BaseMutationOptions<CreateReminderMutation, CreateReminderMutationVariables>;
export const UpdateReminderDocument = gql`
    mutation UpdateReminder($id: ID!, $date: DateTime, $userId: ID, $mailTemplateId: ID, $withUser: Boolean = false, $withMailTemplate: Boolean = false) {
  updateReminder(
    id: $id
    date: $date
    userId: $userId
    mailTemplateId: $mailTemplateId
  ) {
    ...reminderFields
  }
}
    ${ReminderFieldsFragmentDoc}`;
export type UpdateReminderMutationFn = Apollo.MutationFunction<UpdateReminderMutation, UpdateReminderMutationVariables>;

/**
 * __useUpdateReminderMutation__
 *
 * To run a mutation, you first call `useUpdateReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReminderMutation, { data, loading, error }] = useUpdateReminderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *      userId: // value for 'userId'
 *      mailTemplateId: // value for 'mailTemplateId'
 *      withUser: // value for 'withUser'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useUpdateReminderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReminderMutation, UpdateReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReminderMutation, UpdateReminderMutationVariables>(UpdateReminderDocument, options);
      }
export type UpdateReminderMutationHookResult = ReturnType<typeof useUpdateReminderMutation>;
export type UpdateReminderMutationResult = Apollo.MutationResult<UpdateReminderMutation>;
export type UpdateReminderMutationOptions = Apollo.BaseMutationOptions<UpdateReminderMutation, UpdateReminderMutationVariables>;
export const DeleteReminderDocument = gql`
    mutation DeleteReminder($id: ID!, $withUser: Boolean = false, $withMailTemplate: Boolean = false) {
  deleteReminder(id: $id) {
    ...reminderFields
  }
}
    ${ReminderFieldsFragmentDoc}`;
export type DeleteReminderMutationFn = Apollo.MutationFunction<DeleteReminderMutation, DeleteReminderMutationVariables>;

/**
 * __useDeleteReminderMutation__
 *
 * To run a mutation, you first call `useDeleteReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReminderMutation, { data, loading, error }] = useDeleteReminderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withUser: // value for 'withUser'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useDeleteReminderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReminderMutation, DeleteReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReminderMutation, DeleteReminderMutationVariables>(DeleteReminderDocument, options);
      }
export type DeleteReminderMutationHookResult = ReturnType<typeof useDeleteReminderMutation>;
export type DeleteReminderMutationResult = Apollo.MutationResult<DeleteReminderMutation>;
export type DeleteReminderMutationOptions = Apollo.BaseMutationOptions<DeleteReminderMutation, DeleteReminderMutationVariables>;
export const CreatedReminderDocument = gql`
    subscription CreatedReminder($filter: ReminderFilterArgs, $withUser: Boolean = false, $withMailTemplate: Boolean = false) {
  createdReminder(filter: $filter) {
    ...reminderFields
  }
}
    ${ReminderFieldsFragmentDoc}`;

/**
 * __useCreatedReminderSubscription__
 *
 * To run a query within a React component, call `useCreatedReminderSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedReminderSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedReminderSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUser: // value for 'withUser'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useCreatedReminderSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedReminderSubscription, CreatedReminderSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedReminderSubscription, CreatedReminderSubscriptionVariables>(CreatedReminderDocument, options);
      }
export type CreatedReminderSubscriptionHookResult = ReturnType<typeof useCreatedReminderSubscription>;
export type CreatedReminderSubscriptionResult = Apollo.SubscriptionResult<CreatedReminderSubscription>;
export const UpdatedReminderDocument = gql`
    subscription UpdatedReminder($filter: ReminderFilterArgs, $withUser: Boolean = false, $withMailTemplate: Boolean = false) {
  updatedReminder(filter: $filter) {
    ...reminderFields
  }
}
    ${ReminderFieldsFragmentDoc}`;

/**
 * __useUpdatedReminderSubscription__
 *
 * To run a query within a React component, call `useUpdatedReminderSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedReminderSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedReminderSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUser: // value for 'withUser'
 *      withMailTemplate: // value for 'withMailTemplate'
 *   },
 * });
 */
export function useUpdatedReminderSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedReminderSubscription, UpdatedReminderSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedReminderSubscription, UpdatedReminderSubscriptionVariables>(UpdatedReminderDocument, options);
      }
export type UpdatedReminderSubscriptionHookResult = ReturnType<typeof useUpdatedReminderSubscription>;
export type UpdatedReminderSubscriptionResult = Apollo.SubscriptionResult<UpdatedReminderSubscription>;
export const DeletedReminderDocument = gql`
    subscription DeletedReminder($filter: ReminderFilterArgs) {
  deletedReminder(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedReminderSubscription__
 *
 * To run a query within a React component, call `useDeletedReminderSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedReminderSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedReminderSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedReminderSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedReminderSubscription, DeletedReminderSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedReminderSubscription, DeletedReminderSubscriptionVariables>(DeletedReminderDocument, options);
      }
export type DeletedReminderSubscriptionHookResult = ReturnType<typeof useDeletedReminderSubscription>;
export type DeletedReminderSubscriptionResult = Apollo.SubscriptionResult<DeletedReminderSubscription>;
export const GetResetPasswordsDocument = gql`
    query GetResetPasswords($filter: ResetPasswordFilterArgs, $paging: PageArgs, $sorting: [ResetPasswordSortArgs!]) {
  resetPasswords(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...resetPasswordFields
    }
    totalCount
  }
}
    ${ResetPasswordFieldsFragmentDoc}`;

/**
 * __useGetResetPasswordsQuery__
 *
 * To run a query within a React component, call `useGetResetPasswordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResetPasswordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResetPasswordsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useGetResetPasswordsQuery(baseOptions?: Apollo.QueryHookOptions<GetResetPasswordsQuery, GetResetPasswordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResetPasswordsQuery, GetResetPasswordsQueryVariables>(GetResetPasswordsDocument, options);
      }
export function useGetResetPasswordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResetPasswordsQuery, GetResetPasswordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResetPasswordsQuery, GetResetPasswordsQueryVariables>(GetResetPasswordsDocument, options);
        }
export function useGetResetPasswordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResetPasswordsQuery, GetResetPasswordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetResetPasswordsQuery, GetResetPasswordsQueryVariables>(GetResetPasswordsDocument, options);
        }
export type GetResetPasswordsQueryHookResult = ReturnType<typeof useGetResetPasswordsQuery>;
export type GetResetPasswordsLazyQueryHookResult = ReturnType<typeof useGetResetPasswordsLazyQuery>;
export type GetResetPasswordsSuspenseQueryHookResult = ReturnType<typeof useGetResetPasswordsSuspenseQuery>;
export type GetResetPasswordsQueryResult = Apollo.QueryResult<GetResetPasswordsQuery, GetResetPasswordsQueryVariables>;
export const GetResetPasswordDocument = gql`
    query GetResetPassword($id: ID!) {
  resetPassword(id: $id) {
    ...resetPasswordFields
  }
}
    ${ResetPasswordFieldsFragmentDoc}`;

/**
 * __useGetResetPasswordQuery__
 *
 * To run a query within a React component, call `useGetResetPasswordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResetPasswordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResetPasswordQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetResetPasswordQuery(baseOptions: Apollo.QueryHookOptions<GetResetPasswordQuery, GetResetPasswordQueryVariables> & ({ variables: GetResetPasswordQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResetPasswordQuery, GetResetPasswordQueryVariables>(GetResetPasswordDocument, options);
      }
export function useGetResetPasswordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResetPasswordQuery, GetResetPasswordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResetPasswordQuery, GetResetPasswordQueryVariables>(GetResetPasswordDocument, options);
        }
export function useGetResetPasswordSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetResetPasswordQuery, GetResetPasswordQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetResetPasswordQuery, GetResetPasswordQueryVariables>(GetResetPasswordDocument, options);
        }
export type GetResetPasswordQueryHookResult = ReturnType<typeof useGetResetPasswordQuery>;
export type GetResetPasswordLazyQueryHookResult = ReturnType<typeof useGetResetPasswordLazyQuery>;
export type GetResetPasswordSuspenseQueryHookResult = ReturnType<typeof useGetResetPasswordSuspenseQuery>;
export type GetResetPasswordQueryResult = Apollo.QueryResult<GetResetPasswordQuery, GetResetPasswordQueryVariables>;
export const CreateResetPasswordDocument = gql`
    mutation CreateResetPassword($email: String!, $token: String!, $type: String!) {
  createResetPassword(email: $email, token: $token, type: $type) {
    ...resetPasswordFields
  }
}
    ${ResetPasswordFieldsFragmentDoc}`;
export type CreateResetPasswordMutationFn = Apollo.MutationFunction<CreateResetPasswordMutation, CreateResetPasswordMutationVariables>;

/**
 * __useCreateResetPasswordMutation__
 *
 * To run a mutation, you first call `useCreateResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResetPasswordMutation, { data, loading, error }] = useCreateResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *      token: // value for 'token'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<CreateResetPasswordMutation, CreateResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateResetPasswordMutation, CreateResetPasswordMutationVariables>(CreateResetPasswordDocument, options);
      }
export type CreateResetPasswordMutationHookResult = ReturnType<typeof useCreateResetPasswordMutation>;
export type CreateResetPasswordMutationResult = Apollo.MutationResult<CreateResetPasswordMutation>;
export type CreateResetPasswordMutationOptions = Apollo.BaseMutationOptions<CreateResetPasswordMutation, CreateResetPasswordMutationVariables>;
export const UpdateResetPasswordDocument = gql`
    mutation UpdateResetPassword($id: ID!, $email: String, $token: String, $type: String) {
  updateResetPassword(id: $id, email: $email, token: $token, type: $type) {
    ...resetPasswordFields
  }
}
    ${ResetPasswordFieldsFragmentDoc}`;
export type UpdateResetPasswordMutationFn = Apollo.MutationFunction<UpdateResetPasswordMutation, UpdateResetPasswordMutationVariables>;

/**
 * __useUpdateResetPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResetPasswordMutation, { data, loading, error }] = useUpdateResetPasswordMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *      token: // value for 'token'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResetPasswordMutation, UpdateResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResetPasswordMutation, UpdateResetPasswordMutationVariables>(UpdateResetPasswordDocument, options);
      }
export type UpdateResetPasswordMutationHookResult = ReturnType<typeof useUpdateResetPasswordMutation>;
export type UpdateResetPasswordMutationResult = Apollo.MutationResult<UpdateResetPasswordMutation>;
export type UpdateResetPasswordMutationOptions = Apollo.BaseMutationOptions<UpdateResetPasswordMutation, UpdateResetPasswordMutationVariables>;
export const DeleteResetPasswordDocument = gql`
    mutation DeleteResetPassword($id: ID!) {
  deleteResetPassword(id: $id) {
    ...resetPasswordFields
  }
}
    ${ResetPasswordFieldsFragmentDoc}`;
export type DeleteResetPasswordMutationFn = Apollo.MutationFunction<DeleteResetPasswordMutation, DeleteResetPasswordMutationVariables>;

/**
 * __useDeleteResetPasswordMutation__
 *
 * To run a mutation, you first call `useDeleteResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResetPasswordMutation, { data, loading, error }] = useDeleteResetPasswordMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<DeleteResetPasswordMutation, DeleteResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteResetPasswordMutation, DeleteResetPasswordMutationVariables>(DeleteResetPasswordDocument, options);
      }
export type DeleteResetPasswordMutationHookResult = ReturnType<typeof useDeleteResetPasswordMutation>;
export type DeleteResetPasswordMutationResult = Apollo.MutationResult<DeleteResetPasswordMutation>;
export type DeleteResetPasswordMutationOptions = Apollo.BaseMutationOptions<DeleteResetPasswordMutation, DeleteResetPasswordMutationVariables>;
export const CreatedResetPasswordDocument = gql`
    subscription CreatedResetPassword($filter: ResetPasswordFilterArgs) {
  createdResetPassword(filter: $filter) {
    ...resetPasswordFields
  }
}
    ${ResetPasswordFieldsFragmentDoc}`;

/**
 * __useCreatedResetPasswordSubscription__
 *
 * To run a query within a React component, call `useCreatedResetPasswordSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedResetPasswordSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedResetPasswordSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCreatedResetPasswordSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedResetPasswordSubscription, CreatedResetPasswordSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedResetPasswordSubscription, CreatedResetPasswordSubscriptionVariables>(CreatedResetPasswordDocument, options);
      }
export type CreatedResetPasswordSubscriptionHookResult = ReturnType<typeof useCreatedResetPasswordSubscription>;
export type CreatedResetPasswordSubscriptionResult = Apollo.SubscriptionResult<CreatedResetPasswordSubscription>;
export const UpdatedResetPasswordDocument = gql`
    subscription UpdatedResetPassword($filter: ResetPasswordFilterArgs) {
  updatedResetPassword(filter: $filter) {
    ...resetPasswordFields
  }
}
    ${ResetPasswordFieldsFragmentDoc}`;

/**
 * __useUpdatedResetPasswordSubscription__
 *
 * To run a query within a React component, call `useUpdatedResetPasswordSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedResetPasswordSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedResetPasswordSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUpdatedResetPasswordSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedResetPasswordSubscription, UpdatedResetPasswordSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedResetPasswordSubscription, UpdatedResetPasswordSubscriptionVariables>(UpdatedResetPasswordDocument, options);
      }
export type UpdatedResetPasswordSubscriptionHookResult = ReturnType<typeof useUpdatedResetPasswordSubscription>;
export type UpdatedResetPasswordSubscriptionResult = Apollo.SubscriptionResult<UpdatedResetPasswordSubscription>;
export const DeletedResetPasswordDocument = gql`
    subscription DeletedResetPassword($filter: ResetPasswordFilterArgs) {
  deletedResetPassword(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedResetPasswordSubscription__
 *
 * To run a query within a React component, call `useDeletedResetPasswordSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedResetPasswordSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedResetPasswordSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedResetPasswordSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedResetPasswordSubscription, DeletedResetPasswordSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedResetPasswordSubscription, DeletedResetPasswordSubscriptionVariables>(DeletedResetPasswordDocument, options);
      }
export type DeletedResetPasswordSubscriptionHookResult = ReturnType<typeof useDeletedResetPasswordSubscription>;
export type DeletedResetPasswordSubscriptionResult = Apollo.SubscriptionResult<DeletedResetPasswordSubscription>;
export const GetRolesDocument = gql`
    query GetRoles($filter: RoleFilterArgs, $paging: PageArgs, $sorting: [RoleSortArgs!], $withPermissions: Boolean = false, $withUserTenantRoles: Boolean = false) {
  roles(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...roleFields
    }
    totalCount
  }
}
    ${RoleFieldsFragmentDoc}`;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withPermissions: // value for 'withPermissions'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *   },
 * });
 */
export function useGetRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
      }
export function useGetRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
        }
export function useGetRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
        }
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<typeof useGetRolesLazyQuery>;
export type GetRolesSuspenseQueryHookResult = ReturnType<typeof useGetRolesSuspenseQuery>;
export type GetRolesQueryResult = Apollo.QueryResult<GetRolesQuery, GetRolesQueryVariables>;
export const GetRoleDocument = gql`
    query GetRole($id: ID!, $withPermissions: Boolean = false, $withUserTenantRoles: Boolean = false) {
  role(id: $id) {
    ...roleFields
  }
}
    ${RoleFieldsFragmentDoc}`;

/**
 * __useGetRoleQuery__
 *
 * To run a query within a React component, call `useGetRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withPermissions: // value for 'withPermissions'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *   },
 * });
 */
export function useGetRoleQuery(baseOptions: Apollo.QueryHookOptions<GetRoleQuery, GetRoleQueryVariables> & ({ variables: GetRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
      }
export function useGetRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
        }
export function useGetRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
        }
export type GetRoleQueryHookResult = ReturnType<typeof useGetRoleQuery>;
export type GetRoleLazyQueryHookResult = ReturnType<typeof useGetRoleLazyQuery>;
export type GetRoleSuspenseQueryHookResult = ReturnType<typeof useGetRoleSuspenseQuery>;
export type GetRoleQueryResult = Apollo.QueryResult<GetRoleQuery, GetRoleQueryVariables>;
export const GetAllRelatedDataForRoleDocument = gql`
    query GetAllRelatedDataForRole($withPermissions: Boolean = false, $withUserTenantRoles: Boolean = false) {
  permissions @include(if: $withPermissions) {
    items {
      id
      displayField: name
    }
  }
  userTenantRoles @include(if: $withUserTenantRoles) {
    items {
      id
      displayField: id
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForRoleQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForRoleQuery({
 *   variables: {
 *      withPermissions: // value for 'withPermissions'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *   },
 * });
 */
export function useGetAllRelatedDataForRoleQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForRoleQuery, GetAllRelatedDataForRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForRoleQuery, GetAllRelatedDataForRoleQueryVariables>(GetAllRelatedDataForRoleDocument, options);
      }
export function useGetAllRelatedDataForRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForRoleQuery, GetAllRelatedDataForRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForRoleQuery, GetAllRelatedDataForRoleQueryVariables>(GetAllRelatedDataForRoleDocument, options);
        }
export function useGetAllRelatedDataForRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForRoleQuery, GetAllRelatedDataForRoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForRoleQuery, GetAllRelatedDataForRoleQueryVariables>(GetAllRelatedDataForRoleDocument, options);
        }
export type GetAllRelatedDataForRoleQueryHookResult = ReturnType<typeof useGetAllRelatedDataForRoleQuery>;
export type GetAllRelatedDataForRoleLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForRoleLazyQuery>;
export type GetAllRelatedDataForRoleSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForRoleSuspenseQuery>;
export type GetAllRelatedDataForRoleQueryResult = Apollo.QueryResult<GetAllRelatedDataForRoleQuery, GetAllRelatedDataForRoleQueryVariables>;
export const CreateRoleDocument = gql`
    mutation CreateRole($displayName: String!, $description: String!, $permissions: [ID], $userTenantRoles: [ID], $withPermissions: Boolean = false, $withUserTenantRoles: Boolean = false) {
  createRole(
    displayName: $displayName
    description: $description
    permissionIds: $permissions
    userTenantRoleIds: $userTenantRoles
  ) {
    ...roleFields
  }
}
    ${RoleFieldsFragmentDoc}`;
export type CreateRoleMutationFn = Apollo.MutationFunction<CreateRoleMutation, CreateRoleMutationVariables>;

/**
 * __useCreateRoleMutation__
 *
 * To run a mutation, you first call `useCreateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleMutation, { data, loading, error }] = useCreateRoleMutation({
 *   variables: {
 *      displayName: // value for 'displayName'
 *      description: // value for 'description'
 *      permissions: // value for 'permissions'
 *      userTenantRoles: // value for 'userTenantRoles'
 *      withPermissions: // value for 'withPermissions'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *   },
 * });
 */
export function useCreateRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoleMutation, CreateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoleMutation, CreateRoleMutationVariables>(CreateRoleDocument, options);
      }
export type CreateRoleMutationHookResult = ReturnType<typeof useCreateRoleMutation>;
export type CreateRoleMutationResult = Apollo.MutationResult<CreateRoleMutation>;
export type CreateRoleMutationOptions = Apollo.BaseMutationOptions<CreateRoleMutation, CreateRoleMutationVariables>;
export const UpdateRoleDocument = gql`
    mutation UpdateRole($id: ID!, $displayName: String, $description: String, $permissions: [ID], $userTenantRoles: [ID], $withPermissions: Boolean = false, $withUserTenantRoles: Boolean = false) {
  updateRole(
    id: $id
    displayName: $displayName
    description: $description
    permissionIds: $permissions
    userTenantRoleIds: $userTenantRoles
  ) {
    ...roleFields
  }
}
    ${RoleFieldsFragmentDoc}`;
export type UpdateRoleMutationFn = Apollo.MutationFunction<UpdateRoleMutation, UpdateRoleMutationVariables>;

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      displayName: // value for 'displayName'
 *      description: // value for 'description'
 *      permissions: // value for 'permissions'
 *      userTenantRoles: // value for 'userTenantRoles'
 *      withPermissions: // value for 'withPermissions'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *   },
 * });
 */
export function useUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoleMutation, UpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoleMutation, UpdateRoleMutationVariables>(UpdateRoleDocument, options);
      }
export type UpdateRoleMutationHookResult = ReturnType<typeof useUpdateRoleMutation>;
export type UpdateRoleMutationResult = Apollo.MutationResult<UpdateRoleMutation>;
export type UpdateRoleMutationOptions = Apollo.BaseMutationOptions<UpdateRoleMutation, UpdateRoleMutationVariables>;
export const DeleteRoleDocument = gql`
    mutation DeleteRole($id: ID!, $withPermissions: Boolean = false, $withUserTenantRoles: Boolean = false) {
  deleteRole(id: $id) {
    ...roleFields
  }
}
    ${RoleFieldsFragmentDoc}`;
export type DeleteRoleMutationFn = Apollo.MutationFunction<DeleteRoleMutation, DeleteRoleMutationVariables>;

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleMutation, { data, loading, error }] = useDeleteRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withPermissions: // value for 'withPermissions'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *   },
 * });
 */
export function useDeleteRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoleMutation, DeleteRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoleMutation, DeleteRoleMutationVariables>(DeleteRoleDocument, options);
      }
export type DeleteRoleMutationHookResult = ReturnType<typeof useDeleteRoleMutation>;
export type DeleteRoleMutationResult = Apollo.MutationResult<DeleteRoleMutation>;
export type DeleteRoleMutationOptions = Apollo.BaseMutationOptions<DeleteRoleMutation, DeleteRoleMutationVariables>;
export const CreatedRoleDocument = gql`
    subscription CreatedRole($filter: RoleFilterArgs, $withPermissions: Boolean = false, $withUserTenantRoles: Boolean = false) {
  createdRole(filter: $filter) {
    ...roleFields
  }
}
    ${RoleFieldsFragmentDoc}`;

/**
 * __useCreatedRoleSubscription__
 *
 * To run a query within a React component, call `useCreatedRoleSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedRoleSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedRoleSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withPermissions: // value for 'withPermissions'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *   },
 * });
 */
export function useCreatedRoleSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedRoleSubscription, CreatedRoleSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedRoleSubscription, CreatedRoleSubscriptionVariables>(CreatedRoleDocument, options);
      }
export type CreatedRoleSubscriptionHookResult = ReturnType<typeof useCreatedRoleSubscription>;
export type CreatedRoleSubscriptionResult = Apollo.SubscriptionResult<CreatedRoleSubscription>;
export const UpdatedRoleDocument = gql`
    subscription UpdatedRole($filter: RoleFilterArgs, $withPermissions: Boolean = false, $withUserTenantRoles: Boolean = false) {
  updatedRole(filter: $filter) {
    ...roleFields
  }
}
    ${RoleFieldsFragmentDoc}`;

/**
 * __useUpdatedRoleSubscription__
 *
 * To run a query within a React component, call `useUpdatedRoleSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedRoleSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedRoleSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withPermissions: // value for 'withPermissions'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *   },
 * });
 */
export function useUpdatedRoleSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedRoleSubscription, UpdatedRoleSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedRoleSubscription, UpdatedRoleSubscriptionVariables>(UpdatedRoleDocument, options);
      }
export type UpdatedRoleSubscriptionHookResult = ReturnType<typeof useUpdatedRoleSubscription>;
export type UpdatedRoleSubscriptionResult = Apollo.SubscriptionResult<UpdatedRoleSubscription>;
export const DeletedRoleDocument = gql`
    subscription DeletedRole($filter: RoleFilterArgs) {
  deletedRole(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedRoleSubscription__
 *
 * To run a query within a React component, call `useDeletedRoleSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedRoleSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedRoleSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedRoleSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedRoleSubscription, DeletedRoleSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedRoleSubscription, DeletedRoleSubscriptionVariables>(DeletedRoleDocument, options);
      }
export type DeletedRoleSubscriptionHookResult = ReturnType<typeof useDeletedRoleSubscription>;
export type DeletedRoleSubscriptionResult = Apollo.SubscriptionResult<DeletedRoleSubscription>;
export const GetSearchesDocument = gql`
    query GetSearches($filter: SearchFilterArgs, $paging: PageArgs, $sorting: [SearchSortArgs!], $withAction: Boolean = false, $withPersonSearchProgresses: Boolean = false) {
  searches(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...searchFields
    }
    totalCount
  }
}
    ${SearchFieldsFragmentDoc}`;

/**
 * __useGetSearchesQuery__
 *
 * To run a query within a React component, call `useGetSearchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withAction: // value for 'withAction'
 *      withPersonSearchProgresses: // value for 'withPersonSearchProgresses'
 *   },
 * });
 */
export function useGetSearchesQuery(baseOptions?: Apollo.QueryHookOptions<GetSearchesQuery, GetSearchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchesQuery, GetSearchesQueryVariables>(GetSearchesDocument, options);
      }
export function useGetSearchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchesQuery, GetSearchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchesQuery, GetSearchesQueryVariables>(GetSearchesDocument, options);
        }
export function useGetSearchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchesQuery, GetSearchesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchesQuery, GetSearchesQueryVariables>(GetSearchesDocument, options);
        }
export type GetSearchesQueryHookResult = ReturnType<typeof useGetSearchesQuery>;
export type GetSearchesLazyQueryHookResult = ReturnType<typeof useGetSearchesLazyQuery>;
export type GetSearchesSuspenseQueryHookResult = ReturnType<typeof useGetSearchesSuspenseQuery>;
export type GetSearchesQueryResult = Apollo.QueryResult<GetSearchesQuery, GetSearchesQueryVariables>;
export const GetSearchDocument = gql`
    query GetSearch($id: ID!, $withAction: Boolean = false, $withPersonSearchProgresses: Boolean = false) {
  search(id: $id) {
    ...searchFields
  }
}
    ${SearchFieldsFragmentDoc}`;

/**
 * __useGetSearchQuery__
 *
 * To run a query within a React component, call `useGetSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withAction: // value for 'withAction'
 *      withPersonSearchProgresses: // value for 'withPersonSearchProgresses'
 *   },
 * });
 */
export function useGetSearchQuery(baseOptions: Apollo.QueryHookOptions<GetSearchQuery, GetSearchQueryVariables> & ({ variables: GetSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchQuery, GetSearchQueryVariables>(GetSearchDocument, options);
      }
export function useGetSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchQuery, GetSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchQuery, GetSearchQueryVariables>(GetSearchDocument, options);
        }
export function useGetSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchQuery, GetSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchQuery, GetSearchQueryVariables>(GetSearchDocument, options);
        }
export type GetSearchQueryHookResult = ReturnType<typeof useGetSearchQuery>;
export type GetSearchLazyQueryHookResult = ReturnType<typeof useGetSearchLazyQuery>;
export type GetSearchSuspenseQueryHookResult = ReturnType<typeof useGetSearchSuspenseQuery>;
export type GetSearchQueryResult = Apollo.QueryResult<GetSearchQuery, GetSearchQueryVariables>;
export const GetAllRelatedDataForSearchDocument = gql`
    query GetAllRelatedDataForSearch($withActions: Boolean = false, $withPersonSearchProgresses: Boolean = false) {
  actions @include(if: $withActions) {
    items {
      id
      displayField: name
    }
  }
  personSearchProgresses @include(if: $withPersonSearchProgresses) {
    items {
      id
      displayField: id
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForSearchQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForSearchQuery({
 *   variables: {
 *      withActions: // value for 'withActions'
 *      withPersonSearchProgresses: // value for 'withPersonSearchProgresses'
 *   },
 * });
 */
export function useGetAllRelatedDataForSearchQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForSearchQuery, GetAllRelatedDataForSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForSearchQuery, GetAllRelatedDataForSearchQueryVariables>(GetAllRelatedDataForSearchDocument, options);
      }
export function useGetAllRelatedDataForSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForSearchQuery, GetAllRelatedDataForSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForSearchQuery, GetAllRelatedDataForSearchQueryVariables>(GetAllRelatedDataForSearchDocument, options);
        }
export function useGetAllRelatedDataForSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForSearchQuery, GetAllRelatedDataForSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForSearchQuery, GetAllRelatedDataForSearchQueryVariables>(GetAllRelatedDataForSearchDocument, options);
        }
export type GetAllRelatedDataForSearchQueryHookResult = ReturnType<typeof useGetAllRelatedDataForSearchQuery>;
export type GetAllRelatedDataForSearchLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForSearchLazyQuery>;
export type GetAllRelatedDataForSearchSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForSearchSuspenseQuery>;
export type GetAllRelatedDataForSearchQueryResult = Apollo.QueryResult<GetAllRelatedDataForSearchQuery, GetAllRelatedDataForSearchQueryVariables>;
export const CreateSearchDocument = gql`
    mutation CreateSearch($name: String!, $searchUrl: String, $order: Int, $actionId: ID, $personSearchProgresses: [ID], $withAction: Boolean = false, $withPersonSearchProgresses: Boolean = false) {
  createSearch(
    name: $name
    searchUrl: $searchUrl
    order: $order
    actionId: $actionId
    personSearchProgressIds: $personSearchProgresses
  ) {
    ...searchFields
  }
}
    ${SearchFieldsFragmentDoc}`;
export type CreateSearchMutationFn = Apollo.MutationFunction<CreateSearchMutation, CreateSearchMutationVariables>;

/**
 * __useCreateSearchMutation__
 *
 * To run a mutation, you first call `useCreateSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSearchMutation, { data, loading, error }] = useCreateSearchMutation({
 *   variables: {
 *      name: // value for 'name'
 *      searchUrl: // value for 'searchUrl'
 *      order: // value for 'order'
 *      actionId: // value for 'actionId'
 *      personSearchProgresses: // value for 'personSearchProgresses'
 *      withAction: // value for 'withAction'
 *      withPersonSearchProgresses: // value for 'withPersonSearchProgresses'
 *   },
 * });
 */
export function useCreateSearchMutation(baseOptions?: Apollo.MutationHookOptions<CreateSearchMutation, CreateSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSearchMutation, CreateSearchMutationVariables>(CreateSearchDocument, options);
      }
export type CreateSearchMutationHookResult = ReturnType<typeof useCreateSearchMutation>;
export type CreateSearchMutationResult = Apollo.MutationResult<CreateSearchMutation>;
export type CreateSearchMutationOptions = Apollo.BaseMutationOptions<CreateSearchMutation, CreateSearchMutationVariables>;
export const UpdateSearchDocument = gql`
    mutation UpdateSearch($id: ID!, $name: String, $searchUrl: String, $order: Int, $actionId: ID, $personSearchProgresses: [ID], $withAction: Boolean = false, $withPersonSearchProgresses: Boolean = false) {
  updateSearch(
    id: $id
    name: $name
    searchUrl: $searchUrl
    order: $order
    actionId: $actionId
    personSearchProgressIds: $personSearchProgresses
  ) {
    ...searchFields
  }
}
    ${SearchFieldsFragmentDoc}`;
export type UpdateSearchMutationFn = Apollo.MutationFunction<UpdateSearchMutation, UpdateSearchMutationVariables>;

/**
 * __useUpdateSearchMutation__
 *
 * To run a mutation, you first call `useUpdateSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSearchMutation, { data, loading, error }] = useUpdateSearchMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      searchUrl: // value for 'searchUrl'
 *      order: // value for 'order'
 *      actionId: // value for 'actionId'
 *      personSearchProgresses: // value for 'personSearchProgresses'
 *      withAction: // value for 'withAction'
 *      withPersonSearchProgresses: // value for 'withPersonSearchProgresses'
 *   },
 * });
 */
export function useUpdateSearchMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSearchMutation, UpdateSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSearchMutation, UpdateSearchMutationVariables>(UpdateSearchDocument, options);
      }
export type UpdateSearchMutationHookResult = ReturnType<typeof useUpdateSearchMutation>;
export type UpdateSearchMutationResult = Apollo.MutationResult<UpdateSearchMutation>;
export type UpdateSearchMutationOptions = Apollo.BaseMutationOptions<UpdateSearchMutation, UpdateSearchMutationVariables>;
export const DeleteSearchDocument = gql`
    mutation DeleteSearch($id: ID!, $withAction: Boolean = false, $withPersonSearchProgresses: Boolean = false) {
  deleteSearch(id: $id) {
    ...searchFields
  }
}
    ${SearchFieldsFragmentDoc}`;
export type DeleteSearchMutationFn = Apollo.MutationFunction<DeleteSearchMutation, DeleteSearchMutationVariables>;

/**
 * __useDeleteSearchMutation__
 *
 * To run a mutation, you first call `useDeleteSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSearchMutation, { data, loading, error }] = useDeleteSearchMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withAction: // value for 'withAction'
 *      withPersonSearchProgresses: // value for 'withPersonSearchProgresses'
 *   },
 * });
 */
export function useDeleteSearchMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSearchMutation, DeleteSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSearchMutation, DeleteSearchMutationVariables>(DeleteSearchDocument, options);
      }
export type DeleteSearchMutationHookResult = ReturnType<typeof useDeleteSearchMutation>;
export type DeleteSearchMutationResult = Apollo.MutationResult<DeleteSearchMutation>;
export type DeleteSearchMutationOptions = Apollo.BaseMutationOptions<DeleteSearchMutation, DeleteSearchMutationVariables>;
export const CreatedSearchDocument = gql`
    subscription CreatedSearch($filter: SearchFilterArgs, $withAction: Boolean = false, $withPersonSearchProgresses: Boolean = false) {
  createdSearch(filter: $filter) {
    ...searchFields
  }
}
    ${SearchFieldsFragmentDoc}`;

/**
 * __useCreatedSearchSubscription__
 *
 * To run a query within a React component, call `useCreatedSearchSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedSearchSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedSearchSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withAction: // value for 'withAction'
 *      withPersonSearchProgresses: // value for 'withPersonSearchProgresses'
 *   },
 * });
 */
export function useCreatedSearchSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedSearchSubscription, CreatedSearchSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedSearchSubscription, CreatedSearchSubscriptionVariables>(CreatedSearchDocument, options);
      }
export type CreatedSearchSubscriptionHookResult = ReturnType<typeof useCreatedSearchSubscription>;
export type CreatedSearchSubscriptionResult = Apollo.SubscriptionResult<CreatedSearchSubscription>;
export const UpdatedSearchDocument = gql`
    subscription UpdatedSearch($filter: SearchFilterArgs, $withAction: Boolean = false, $withPersonSearchProgresses: Boolean = false) {
  updatedSearch(filter: $filter) {
    ...searchFields
  }
}
    ${SearchFieldsFragmentDoc}`;

/**
 * __useUpdatedSearchSubscription__
 *
 * To run a query within a React component, call `useUpdatedSearchSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedSearchSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedSearchSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withAction: // value for 'withAction'
 *      withPersonSearchProgresses: // value for 'withPersonSearchProgresses'
 *   },
 * });
 */
export function useUpdatedSearchSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedSearchSubscription, UpdatedSearchSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedSearchSubscription, UpdatedSearchSubscriptionVariables>(UpdatedSearchDocument, options);
      }
export type UpdatedSearchSubscriptionHookResult = ReturnType<typeof useUpdatedSearchSubscription>;
export type UpdatedSearchSubscriptionResult = Apollo.SubscriptionResult<UpdatedSearchSubscription>;
export const DeletedSearchDocument = gql`
    subscription DeletedSearch($filter: SearchFilterArgs) {
  deletedSearch(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedSearchSubscription__
 *
 * To run a query within a React component, call `useDeletedSearchSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedSearchSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedSearchSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedSearchSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedSearchSubscription, DeletedSearchSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedSearchSubscription, DeletedSearchSubscriptionVariables>(DeletedSearchDocument, options);
      }
export type DeletedSearchSubscriptionHookResult = ReturnType<typeof useDeletedSearchSubscription>;
export type DeletedSearchSubscriptionResult = Apollo.SubscriptionResult<DeletedSearchSubscription>;
export const RestoredSearchDocument = gql`
    subscription RestoredSearch($filter: SearchFilterArgs, $withAction: Boolean = false, $withPersonSearchProgresses: Boolean = false) {
  restoredSearch(filter: $filter) {
    ...searchFields
  }
}
    ${SearchFieldsFragmentDoc}`;

/**
 * __useRestoredSearchSubscription__
 *
 * To run a query within a React component, call `useRestoredSearchSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRestoredSearchSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestoredSearchSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withAction: // value for 'withAction'
 *      withPersonSearchProgresses: // value for 'withPersonSearchProgresses'
 *   },
 * });
 */
export function useRestoredSearchSubscription(baseOptions?: Apollo.SubscriptionHookOptions<RestoredSearchSubscription, RestoredSearchSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<RestoredSearchSubscription, RestoredSearchSubscriptionVariables>(RestoredSearchDocument, options);
      }
export type RestoredSearchSubscriptionHookResult = ReturnType<typeof useRestoredSearchSubscription>;
export type RestoredSearchSubscriptionResult = Apollo.SubscriptionResult<RestoredSearchSubscription>;
export const GetTenantsDocument = gql`
    query GetTenants($filter: TenantFilterArgs, $paging: PageArgs, $sorting: [TenantSortArgs!], $withUserTenantRoles: Boolean = false, $withUniqueRegistrations: Boolean = false) {
  tenants(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...tenantFields
    }
    totalCount
  }
}
    ${TenantFieldsFragmentDoc}`;

/**
 * __useGetTenantsQuery__
 *
 * To run a query within a React component, call `useGetTenantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withUniqueRegistrations: // value for 'withUniqueRegistrations'
 *   },
 * });
 */
export function useGetTenantsQuery(baseOptions?: Apollo.QueryHookOptions<GetTenantsQuery, GetTenantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantsQuery, GetTenantsQueryVariables>(GetTenantsDocument, options);
      }
export function useGetTenantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantsQuery, GetTenantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantsQuery, GetTenantsQueryVariables>(GetTenantsDocument, options);
        }
export function useGetTenantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantsQuery, GetTenantsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTenantsQuery, GetTenantsQueryVariables>(GetTenantsDocument, options);
        }
export type GetTenantsQueryHookResult = ReturnType<typeof useGetTenantsQuery>;
export type GetTenantsLazyQueryHookResult = ReturnType<typeof useGetTenantsLazyQuery>;
export type GetTenantsSuspenseQueryHookResult = ReturnType<typeof useGetTenantsSuspenseQuery>;
export type GetTenantsQueryResult = Apollo.QueryResult<GetTenantsQuery, GetTenantsQueryVariables>;
export const GetTenantDocument = gql`
    query GetTenant($id: ID!, $withUserTenantRoles: Boolean = false, $withUniqueRegistrations: Boolean = false) {
  tenant(id: $id) {
    ...tenantFields
  }
}
    ${TenantFieldsFragmentDoc}`;

/**
 * __useGetTenantQuery__
 *
 * To run a query within a React component, call `useGetTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withUniqueRegistrations: // value for 'withUniqueRegistrations'
 *   },
 * });
 */
export function useGetTenantQuery(baseOptions: Apollo.QueryHookOptions<GetTenantQuery, GetTenantQueryVariables> & ({ variables: GetTenantQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantQuery, GetTenantQueryVariables>(GetTenantDocument, options);
      }
export function useGetTenantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantQuery, GetTenantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantQuery, GetTenantQueryVariables>(GetTenantDocument, options);
        }
export function useGetTenantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTenantQuery, GetTenantQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTenantQuery, GetTenantQueryVariables>(GetTenantDocument, options);
        }
export type GetTenantQueryHookResult = ReturnType<typeof useGetTenantQuery>;
export type GetTenantLazyQueryHookResult = ReturnType<typeof useGetTenantLazyQuery>;
export type GetTenantSuspenseQueryHookResult = ReturnType<typeof useGetTenantSuspenseQuery>;
export type GetTenantQueryResult = Apollo.QueryResult<GetTenantQuery, GetTenantQueryVariables>;
export const GetAllRelatedDataForTenantDocument = gql`
    query GetAllRelatedDataForTenant($withUserTenantRoles: Boolean = false, $withUniqueRegistrations: Boolean = false) {
  userTenantRoles @include(if: $withUserTenantRoles) {
    items {
      id
      displayField: id
    }
  }
  uniqueRegistrations @include(if: $withUniqueRegistrations) {
    items {
      id
      displayField: id
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForTenantQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForTenantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForTenantQuery({
 *   variables: {
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withUniqueRegistrations: // value for 'withUniqueRegistrations'
 *   },
 * });
 */
export function useGetAllRelatedDataForTenantQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForTenantQuery, GetAllRelatedDataForTenantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForTenantQuery, GetAllRelatedDataForTenantQueryVariables>(GetAllRelatedDataForTenantDocument, options);
      }
export function useGetAllRelatedDataForTenantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForTenantQuery, GetAllRelatedDataForTenantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForTenantQuery, GetAllRelatedDataForTenantQueryVariables>(GetAllRelatedDataForTenantDocument, options);
        }
export function useGetAllRelatedDataForTenantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForTenantQuery, GetAllRelatedDataForTenantQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForTenantQuery, GetAllRelatedDataForTenantQueryVariables>(GetAllRelatedDataForTenantDocument, options);
        }
export type GetAllRelatedDataForTenantQueryHookResult = ReturnType<typeof useGetAllRelatedDataForTenantQuery>;
export type GetAllRelatedDataForTenantLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForTenantLazyQuery>;
export type GetAllRelatedDataForTenantSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForTenantSuspenseQuery>;
export type GetAllRelatedDataForTenantQueryResult = Apollo.QueryResult<GetAllRelatedDataForTenantQuery, GetAllRelatedDataForTenantQueryVariables>;
export const CreateTenantDocument = gql`
    mutation CreateTenant($name: String!, $timeZone: String!, $userTenantRoles: [ID], $uniqueRegistrations: [ID], $withUserTenantRoles: Boolean = false, $withUniqueRegistrations: Boolean = false) {
  createTenant(
    name: $name
    timeZone: $timeZone
    userTenantRoleIds: $userTenantRoles
    uniqueRegistrationIds: $uniqueRegistrations
  ) {
    ...tenantFields
  }
}
    ${TenantFieldsFragmentDoc}`;
export type CreateTenantMutationFn = Apollo.MutationFunction<CreateTenantMutation, CreateTenantMutationVariables>;

/**
 * __useCreateTenantMutation__
 *
 * To run a mutation, you first call `useCreateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTenantMutation, { data, loading, error }] = useCreateTenantMutation({
 *   variables: {
 *      name: // value for 'name'
 *      timeZone: // value for 'timeZone'
 *      userTenantRoles: // value for 'userTenantRoles'
 *      uniqueRegistrations: // value for 'uniqueRegistrations'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withUniqueRegistrations: // value for 'withUniqueRegistrations'
 *   },
 * });
 */
export function useCreateTenantMutation(baseOptions?: Apollo.MutationHookOptions<CreateTenantMutation, CreateTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTenantMutation, CreateTenantMutationVariables>(CreateTenantDocument, options);
      }
export type CreateTenantMutationHookResult = ReturnType<typeof useCreateTenantMutation>;
export type CreateTenantMutationResult = Apollo.MutationResult<CreateTenantMutation>;
export type CreateTenantMutationOptions = Apollo.BaseMutationOptions<CreateTenantMutation, CreateTenantMutationVariables>;
export const UpdateTenantDocument = gql`
    mutation UpdateTenant($id: ID!, $name: String, $timeZone: String, $userTenantRoles: [ID], $uniqueRegistrations: [ID], $withUserTenantRoles: Boolean = false, $withUniqueRegistrations: Boolean = false) {
  updateTenant(
    id: $id
    name: $name
    timeZone: $timeZone
    userTenantRoleIds: $userTenantRoles
    uniqueRegistrationIds: $uniqueRegistrations
  ) {
    ...tenantFields
  }
}
    ${TenantFieldsFragmentDoc}`;
export type UpdateTenantMutationFn = Apollo.MutationFunction<UpdateTenantMutation, UpdateTenantMutationVariables>;

/**
 * __useUpdateTenantMutation__
 *
 * To run a mutation, you first call `useUpdateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantMutation, { data, loading, error }] = useUpdateTenantMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      timeZone: // value for 'timeZone'
 *      userTenantRoles: // value for 'userTenantRoles'
 *      uniqueRegistrations: // value for 'uniqueRegistrations'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withUniqueRegistrations: // value for 'withUniqueRegistrations'
 *   },
 * });
 */
export function useUpdateTenantMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTenantMutation, UpdateTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTenantMutation, UpdateTenantMutationVariables>(UpdateTenantDocument, options);
      }
export type UpdateTenantMutationHookResult = ReturnType<typeof useUpdateTenantMutation>;
export type UpdateTenantMutationResult = Apollo.MutationResult<UpdateTenantMutation>;
export type UpdateTenantMutationOptions = Apollo.BaseMutationOptions<UpdateTenantMutation, UpdateTenantMutationVariables>;
export const DeleteTenantDocument = gql`
    mutation DeleteTenant($id: ID!, $withUserTenantRoles: Boolean = false, $withUniqueRegistrations: Boolean = false) {
  deleteTenant(id: $id) {
    ...tenantFields
  }
}
    ${TenantFieldsFragmentDoc}`;
export type DeleteTenantMutationFn = Apollo.MutationFunction<DeleteTenantMutation, DeleteTenantMutationVariables>;

/**
 * __useDeleteTenantMutation__
 *
 * To run a mutation, you first call `useDeleteTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTenantMutation, { data, loading, error }] = useDeleteTenantMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withUniqueRegistrations: // value for 'withUniqueRegistrations'
 *   },
 * });
 */
export function useDeleteTenantMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTenantMutation, DeleteTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTenantMutation, DeleteTenantMutationVariables>(DeleteTenantDocument, options);
      }
export type DeleteTenantMutationHookResult = ReturnType<typeof useDeleteTenantMutation>;
export type DeleteTenantMutationResult = Apollo.MutationResult<DeleteTenantMutation>;
export type DeleteTenantMutationOptions = Apollo.BaseMutationOptions<DeleteTenantMutation, DeleteTenantMutationVariables>;
export const CreatedTenantDocument = gql`
    subscription CreatedTenant($filter: TenantFilterArgs, $withUserTenantRoles: Boolean = false, $withUniqueRegistrations: Boolean = false) {
  createdTenant(filter: $filter) {
    ...tenantFields
  }
}
    ${TenantFieldsFragmentDoc}`;

/**
 * __useCreatedTenantSubscription__
 *
 * To run a query within a React component, call `useCreatedTenantSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedTenantSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedTenantSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withUniqueRegistrations: // value for 'withUniqueRegistrations'
 *   },
 * });
 */
export function useCreatedTenantSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedTenantSubscription, CreatedTenantSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedTenantSubscription, CreatedTenantSubscriptionVariables>(CreatedTenantDocument, options);
      }
export type CreatedTenantSubscriptionHookResult = ReturnType<typeof useCreatedTenantSubscription>;
export type CreatedTenantSubscriptionResult = Apollo.SubscriptionResult<CreatedTenantSubscription>;
export const UpdatedTenantDocument = gql`
    subscription UpdatedTenant($filter: TenantFilterArgs, $withUserTenantRoles: Boolean = false, $withUniqueRegistrations: Boolean = false) {
  updatedTenant(filter: $filter) {
    ...tenantFields
  }
}
    ${TenantFieldsFragmentDoc}`;

/**
 * __useUpdatedTenantSubscription__
 *
 * To run a query within a React component, call `useUpdatedTenantSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedTenantSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedTenantSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withUniqueRegistrations: // value for 'withUniqueRegistrations'
 *   },
 * });
 */
export function useUpdatedTenantSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedTenantSubscription, UpdatedTenantSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedTenantSubscription, UpdatedTenantSubscriptionVariables>(UpdatedTenantDocument, options);
      }
export type UpdatedTenantSubscriptionHookResult = ReturnType<typeof useUpdatedTenantSubscription>;
export type UpdatedTenantSubscriptionResult = Apollo.SubscriptionResult<UpdatedTenantSubscription>;
export const DeletedTenantDocument = gql`
    subscription DeletedTenant($filter: TenantFilterArgs) {
  deletedTenant(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedTenantSubscription__
 *
 * To run a query within a React component, call `useDeletedTenantSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedTenantSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedTenantSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedTenantSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedTenantSubscription, DeletedTenantSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedTenantSubscription, DeletedTenantSubscriptionVariables>(DeletedTenantDocument, options);
      }
export type DeletedTenantSubscriptionHookResult = ReturnType<typeof useDeletedTenantSubscription>;
export type DeletedTenantSubscriptionResult = Apollo.SubscriptionResult<DeletedTenantSubscription>;
export const GetUniqueRegistrationsDocument = gql`
    query GetUniqueRegistrations($filter: UniqueRegistrationFilterArgs, $paging: PageArgs, $sorting: [UniqueRegistrationSortArgs!], $withTenant: Boolean = false) {
  uniqueRegistrations(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...uniqueRegistrationFields
    }
    totalCount
  }
}
    ${UniqueRegistrationFieldsFragmentDoc}`;

/**
 * __useGetUniqueRegistrationsQuery__
 *
 * To run a query within a React component, call `useGetUniqueRegistrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUniqueRegistrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUniqueRegistrationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useGetUniqueRegistrationsQuery(baseOptions?: Apollo.QueryHookOptions<GetUniqueRegistrationsQuery, GetUniqueRegistrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUniqueRegistrationsQuery, GetUniqueRegistrationsQueryVariables>(GetUniqueRegistrationsDocument, options);
      }
export function useGetUniqueRegistrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUniqueRegistrationsQuery, GetUniqueRegistrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUniqueRegistrationsQuery, GetUniqueRegistrationsQueryVariables>(GetUniqueRegistrationsDocument, options);
        }
export function useGetUniqueRegistrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUniqueRegistrationsQuery, GetUniqueRegistrationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUniqueRegistrationsQuery, GetUniqueRegistrationsQueryVariables>(GetUniqueRegistrationsDocument, options);
        }
export type GetUniqueRegistrationsQueryHookResult = ReturnType<typeof useGetUniqueRegistrationsQuery>;
export type GetUniqueRegistrationsLazyQueryHookResult = ReturnType<typeof useGetUniqueRegistrationsLazyQuery>;
export type GetUniqueRegistrationsSuspenseQueryHookResult = ReturnType<typeof useGetUniqueRegistrationsSuspenseQuery>;
export type GetUniqueRegistrationsQueryResult = Apollo.QueryResult<GetUniqueRegistrationsQuery, GetUniqueRegistrationsQueryVariables>;
export const GetUniqueRegistrationDocument = gql`
    query GetUniqueRegistration($id: ID!, $withTenant: Boolean = false) {
  uniqueRegistration(id: $id) {
    ...uniqueRegistrationFields
  }
}
    ${UniqueRegistrationFieldsFragmentDoc}`;

/**
 * __useGetUniqueRegistrationQuery__
 *
 * To run a query within a React component, call `useGetUniqueRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUniqueRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUniqueRegistrationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useGetUniqueRegistrationQuery(baseOptions: Apollo.QueryHookOptions<GetUniqueRegistrationQuery, GetUniqueRegistrationQueryVariables> & ({ variables: GetUniqueRegistrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUniqueRegistrationQuery, GetUniqueRegistrationQueryVariables>(GetUniqueRegistrationDocument, options);
      }
export function useGetUniqueRegistrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUniqueRegistrationQuery, GetUniqueRegistrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUniqueRegistrationQuery, GetUniqueRegistrationQueryVariables>(GetUniqueRegistrationDocument, options);
        }
export function useGetUniqueRegistrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUniqueRegistrationQuery, GetUniqueRegistrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUniqueRegistrationQuery, GetUniqueRegistrationQueryVariables>(GetUniqueRegistrationDocument, options);
        }
export type GetUniqueRegistrationQueryHookResult = ReturnType<typeof useGetUniqueRegistrationQuery>;
export type GetUniqueRegistrationLazyQueryHookResult = ReturnType<typeof useGetUniqueRegistrationLazyQuery>;
export type GetUniqueRegistrationSuspenseQueryHookResult = ReturnType<typeof useGetUniqueRegistrationSuspenseQuery>;
export type GetUniqueRegistrationQueryResult = Apollo.QueryResult<GetUniqueRegistrationQuery, GetUniqueRegistrationQueryVariables>;
export const GetAllRelatedDataForUniqueRegistrationDocument = gql`
    query GetAllRelatedDataForUniqueRegistration($withTenants: Boolean = false) {
  tenants @include(if: $withTenants) {
    items {
      id
      displayField: name
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForUniqueRegistrationQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForUniqueRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForUniqueRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForUniqueRegistrationQuery({
 *   variables: {
 *      withTenants: // value for 'withTenants'
 *   },
 * });
 */
export function useGetAllRelatedDataForUniqueRegistrationQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForUniqueRegistrationQuery, GetAllRelatedDataForUniqueRegistrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForUniqueRegistrationQuery, GetAllRelatedDataForUniqueRegistrationQueryVariables>(GetAllRelatedDataForUniqueRegistrationDocument, options);
      }
export function useGetAllRelatedDataForUniqueRegistrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForUniqueRegistrationQuery, GetAllRelatedDataForUniqueRegistrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForUniqueRegistrationQuery, GetAllRelatedDataForUniqueRegistrationQueryVariables>(GetAllRelatedDataForUniqueRegistrationDocument, options);
        }
export function useGetAllRelatedDataForUniqueRegistrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForUniqueRegistrationQuery, GetAllRelatedDataForUniqueRegistrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForUniqueRegistrationQuery, GetAllRelatedDataForUniqueRegistrationQueryVariables>(GetAllRelatedDataForUniqueRegistrationDocument, options);
        }
export type GetAllRelatedDataForUniqueRegistrationQueryHookResult = ReturnType<typeof useGetAllRelatedDataForUniqueRegistrationQuery>;
export type GetAllRelatedDataForUniqueRegistrationLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForUniqueRegistrationLazyQuery>;
export type GetAllRelatedDataForUniqueRegistrationSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForUniqueRegistrationSuspenseQuery>;
export type GetAllRelatedDataForUniqueRegistrationQueryResult = Apollo.QueryResult<GetAllRelatedDataForUniqueRegistrationQuery, GetAllRelatedDataForUniqueRegistrationQueryVariables>;
export const CreateUniqueRegistrationDocument = gql`
    mutation CreateUniqueRegistration($active: Boolean!, $tenantId: ID, $withTenant: Boolean = false) {
  createUniqueRegistration(active: $active, tenantId: $tenantId) {
    ...uniqueRegistrationFields
  }
}
    ${UniqueRegistrationFieldsFragmentDoc}`;
export type CreateUniqueRegistrationMutationFn = Apollo.MutationFunction<CreateUniqueRegistrationMutation, CreateUniqueRegistrationMutationVariables>;

/**
 * __useCreateUniqueRegistrationMutation__
 *
 * To run a mutation, you first call `useCreateUniqueRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUniqueRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUniqueRegistrationMutation, { data, loading, error }] = useCreateUniqueRegistrationMutation({
 *   variables: {
 *      active: // value for 'active'
 *      tenantId: // value for 'tenantId'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useCreateUniqueRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateUniqueRegistrationMutation, CreateUniqueRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUniqueRegistrationMutation, CreateUniqueRegistrationMutationVariables>(CreateUniqueRegistrationDocument, options);
      }
export type CreateUniqueRegistrationMutationHookResult = ReturnType<typeof useCreateUniqueRegistrationMutation>;
export type CreateUniqueRegistrationMutationResult = Apollo.MutationResult<CreateUniqueRegistrationMutation>;
export type CreateUniqueRegistrationMutationOptions = Apollo.BaseMutationOptions<CreateUniqueRegistrationMutation, CreateUniqueRegistrationMutationVariables>;
export const UpdateUniqueRegistrationDocument = gql`
    mutation UpdateUniqueRegistration($id: ID!, $active: Boolean, $tenantId: ID, $withTenant: Boolean = false) {
  updateUniqueRegistration(id: $id, active: $active, tenantId: $tenantId) {
    ...uniqueRegistrationFields
  }
}
    ${UniqueRegistrationFieldsFragmentDoc}`;
export type UpdateUniqueRegistrationMutationFn = Apollo.MutationFunction<UpdateUniqueRegistrationMutation, UpdateUniqueRegistrationMutationVariables>;

/**
 * __useUpdateUniqueRegistrationMutation__
 *
 * To run a mutation, you first call `useUpdateUniqueRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUniqueRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUniqueRegistrationMutation, { data, loading, error }] = useUpdateUniqueRegistrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      active: // value for 'active'
 *      tenantId: // value for 'tenantId'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useUpdateUniqueRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUniqueRegistrationMutation, UpdateUniqueRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUniqueRegistrationMutation, UpdateUniqueRegistrationMutationVariables>(UpdateUniqueRegistrationDocument, options);
      }
export type UpdateUniqueRegistrationMutationHookResult = ReturnType<typeof useUpdateUniqueRegistrationMutation>;
export type UpdateUniqueRegistrationMutationResult = Apollo.MutationResult<UpdateUniqueRegistrationMutation>;
export type UpdateUniqueRegistrationMutationOptions = Apollo.BaseMutationOptions<UpdateUniqueRegistrationMutation, UpdateUniqueRegistrationMutationVariables>;
export const DeleteUniqueRegistrationDocument = gql`
    mutation DeleteUniqueRegistration($id: ID!, $withTenant: Boolean = false) {
  deleteUniqueRegistration(id: $id) {
    ...uniqueRegistrationFields
  }
}
    ${UniqueRegistrationFieldsFragmentDoc}`;
export type DeleteUniqueRegistrationMutationFn = Apollo.MutationFunction<DeleteUniqueRegistrationMutation, DeleteUniqueRegistrationMutationVariables>;

/**
 * __useDeleteUniqueRegistrationMutation__
 *
 * To run a mutation, you first call `useDeleteUniqueRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUniqueRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUniqueRegistrationMutation, { data, loading, error }] = useDeleteUniqueRegistrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useDeleteUniqueRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUniqueRegistrationMutation, DeleteUniqueRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUniqueRegistrationMutation, DeleteUniqueRegistrationMutationVariables>(DeleteUniqueRegistrationDocument, options);
      }
export type DeleteUniqueRegistrationMutationHookResult = ReturnType<typeof useDeleteUniqueRegistrationMutation>;
export type DeleteUniqueRegistrationMutationResult = Apollo.MutationResult<DeleteUniqueRegistrationMutation>;
export type DeleteUniqueRegistrationMutationOptions = Apollo.BaseMutationOptions<DeleteUniqueRegistrationMutation, DeleteUniqueRegistrationMutationVariables>;
export const CreatedUniqueRegistrationDocument = gql`
    subscription CreatedUniqueRegistration($filter: UniqueRegistrationFilterArgs, $withTenant: Boolean = false) {
  createdUniqueRegistration(filter: $filter) {
    ...uniqueRegistrationFields
  }
}
    ${UniqueRegistrationFieldsFragmentDoc}`;

/**
 * __useCreatedUniqueRegistrationSubscription__
 *
 * To run a query within a React component, call `useCreatedUniqueRegistrationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedUniqueRegistrationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedUniqueRegistrationSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useCreatedUniqueRegistrationSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedUniqueRegistrationSubscription, CreatedUniqueRegistrationSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedUniqueRegistrationSubscription, CreatedUniqueRegistrationSubscriptionVariables>(CreatedUniqueRegistrationDocument, options);
      }
export type CreatedUniqueRegistrationSubscriptionHookResult = ReturnType<typeof useCreatedUniqueRegistrationSubscription>;
export type CreatedUniqueRegistrationSubscriptionResult = Apollo.SubscriptionResult<CreatedUniqueRegistrationSubscription>;
export const UpdatedUniqueRegistrationDocument = gql`
    subscription UpdatedUniqueRegistration($filter: UniqueRegistrationFilterArgs, $withTenant: Boolean = false) {
  updatedUniqueRegistration(filter: $filter) {
    ...uniqueRegistrationFields
  }
}
    ${UniqueRegistrationFieldsFragmentDoc}`;

/**
 * __useUpdatedUniqueRegistrationSubscription__
 *
 * To run a query within a React component, call `useUpdatedUniqueRegistrationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedUniqueRegistrationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedUniqueRegistrationSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withTenant: // value for 'withTenant'
 *   },
 * });
 */
export function useUpdatedUniqueRegistrationSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedUniqueRegistrationSubscription, UpdatedUniqueRegistrationSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedUniqueRegistrationSubscription, UpdatedUniqueRegistrationSubscriptionVariables>(UpdatedUniqueRegistrationDocument, options);
      }
export type UpdatedUniqueRegistrationSubscriptionHookResult = ReturnType<typeof useUpdatedUniqueRegistrationSubscription>;
export type UpdatedUniqueRegistrationSubscriptionResult = Apollo.SubscriptionResult<UpdatedUniqueRegistrationSubscription>;
export const DeletedUniqueRegistrationDocument = gql`
    subscription DeletedUniqueRegistration($filter: UniqueRegistrationFilterArgs) {
  deletedUniqueRegistration(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedUniqueRegistrationSubscription__
 *
 * To run a query within a React component, call `useDeletedUniqueRegistrationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedUniqueRegistrationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedUniqueRegistrationSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedUniqueRegistrationSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedUniqueRegistrationSubscription, DeletedUniqueRegistrationSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedUniqueRegistrationSubscription, DeletedUniqueRegistrationSubscriptionVariables>(DeletedUniqueRegistrationDocument, options);
      }
export type DeletedUniqueRegistrationSubscriptionHookResult = ReturnType<typeof useDeletedUniqueRegistrationSubscription>;
export type DeletedUniqueRegistrationSubscriptionResult = Apollo.SubscriptionResult<DeletedUniqueRegistrationSubscription>;
export const GetUsersDocument = gql`
    query GetUsers($filter: UserFilterArgs, $paging: PageArgs, $sorting: [UserSortArgs!], $withUserTenantRoles: Boolean = false, $withPeople: Boolean = false, $withReminders: Boolean = false) {
  users(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...userFields
    }
    totalCount
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withPeople: // value for 'withPeople'
 *      withReminders: // value for 'withReminders'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetUserDocument = gql`
    query GetUser($id: ID!, $withUserTenantRoles: Boolean = false, $withPeople: Boolean = false, $withReminders: Boolean = false) {
  user(id: $id) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withPeople: // value for 'withPeople'
 *      withReminders: // value for 'withReminders'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables> & ({ variables: GetUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetAllRelatedDataForUserDocument = gql`
    query GetAllRelatedDataForUser($withUserTenantRoles: Boolean = false, $withPeople: Boolean = false, $withReminders: Boolean = false) {
  userTenantRoles @include(if: $withUserTenantRoles) {
    items {
      id
      displayField: id
    }
  }
  people @include(if: $withPeople) {
    items {
      id
      displayField: id
    }
  }
  reminders @include(if: $withReminders) {
    items {
      id
      displayField: id
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForUserQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForUserQuery({
 *   variables: {
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withPeople: // value for 'withPeople'
 *      withReminders: // value for 'withReminders'
 *   },
 * });
 */
export function useGetAllRelatedDataForUserQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForUserQuery, GetAllRelatedDataForUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForUserQuery, GetAllRelatedDataForUserQueryVariables>(GetAllRelatedDataForUserDocument, options);
      }
export function useGetAllRelatedDataForUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForUserQuery, GetAllRelatedDataForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForUserQuery, GetAllRelatedDataForUserQueryVariables>(GetAllRelatedDataForUserDocument, options);
        }
export function useGetAllRelatedDataForUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForUserQuery, GetAllRelatedDataForUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForUserQuery, GetAllRelatedDataForUserQueryVariables>(GetAllRelatedDataForUserDocument, options);
        }
export type GetAllRelatedDataForUserQueryHookResult = ReturnType<typeof useGetAllRelatedDataForUserQuery>;
export type GetAllRelatedDataForUserLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForUserLazyQuery>;
export type GetAllRelatedDataForUserSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForUserSuspenseQuery>;
export type GetAllRelatedDataForUserQueryResult = Apollo.QueryResult<GetAllRelatedDataForUserQuery, GetAllRelatedDataForUserQueryVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($name: String!, $email: String!, $active: Boolean!, $avatar: String, $termsAndConditions: Boolean, $locale: String!, $timeZone: String!, $progress: Int, $userTenantRoles: [ID], $people: [ID], $reminders: [ID], $withUserTenantRoles: Boolean = false, $withPeople: Boolean = false, $withReminders: Boolean = false) {
  createUser(
    name: $name
    email: $email
    active: $active
    avatar: $avatar
    termsAndConditions: $termsAndConditions
    locale: $locale
    timeZone: $timeZone
    progress: $progress
    userTenantRoleIds: $userTenantRoles
    personIds: $people
    reminderIds: $reminders
  ) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      active: // value for 'active'
 *      avatar: // value for 'avatar'
 *      termsAndConditions: // value for 'termsAndConditions'
 *      locale: // value for 'locale'
 *      timeZone: // value for 'timeZone'
 *      progress: // value for 'progress'
 *      userTenantRoles: // value for 'userTenantRoles'
 *      people: // value for 'people'
 *      reminders: // value for 'reminders'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withPeople: // value for 'withPeople'
 *      withReminders: // value for 'withReminders'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($id: ID!, $name: String, $email: String, $active: Boolean, $avatar: String, $termsAndConditions: Boolean, $locale: String, $timeZone: String, $progress: Int, $userTenantRoles: [ID], $people: [ID], $reminders: [ID], $withUserTenantRoles: Boolean = false, $withPeople: Boolean = false, $withReminders: Boolean = false) {
  updateUser(
    id: $id
    name: $name
    email: $email
    active: $active
    avatar: $avatar
    termsAndConditions: $termsAndConditions
    locale: $locale
    timeZone: $timeZone
    progress: $progress
    userTenantRoleIds: $userTenantRoles
    personIds: $people
    reminderIds: $reminders
  ) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      active: // value for 'active'
 *      avatar: // value for 'avatar'
 *      termsAndConditions: // value for 'termsAndConditions'
 *      locale: // value for 'locale'
 *      timeZone: // value for 'timeZone'
 *      progress: // value for 'progress'
 *      userTenantRoles: // value for 'userTenantRoles'
 *      people: // value for 'people'
 *      reminders: // value for 'reminders'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withPeople: // value for 'withPeople'
 *      withReminders: // value for 'withReminders'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($id: ID!, $withUserTenantRoles: Boolean = false, $withPeople: Boolean = false, $withReminders: Boolean = false) {
  deleteUser(id: $id) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withPeople: // value for 'withPeople'
 *      withReminders: // value for 'withReminders'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const CreatedUserDocument = gql`
    subscription CreatedUser($filter: UserFilterArgs, $withUserTenantRoles: Boolean = false, $withPeople: Boolean = false, $withReminders: Boolean = false) {
  createdUser(filter: $filter) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useCreatedUserSubscription__
 *
 * To run a query within a React component, call `useCreatedUserSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedUserSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedUserSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withPeople: // value for 'withPeople'
 *      withReminders: // value for 'withReminders'
 *   },
 * });
 */
export function useCreatedUserSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedUserSubscription, CreatedUserSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedUserSubscription, CreatedUserSubscriptionVariables>(CreatedUserDocument, options);
      }
export type CreatedUserSubscriptionHookResult = ReturnType<typeof useCreatedUserSubscription>;
export type CreatedUserSubscriptionResult = Apollo.SubscriptionResult<CreatedUserSubscription>;
export const UpdatedUserDocument = gql`
    subscription UpdatedUser($filter: UserFilterArgs, $withUserTenantRoles: Boolean = false, $withPeople: Boolean = false, $withReminders: Boolean = false) {
  updatedUser(filter: $filter) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useUpdatedUserSubscription__
 *
 * To run a query within a React component, call `useUpdatedUserSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedUserSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedUserSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withPeople: // value for 'withPeople'
 *      withReminders: // value for 'withReminders'
 *   },
 * });
 */
export function useUpdatedUserSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedUserSubscription, UpdatedUserSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedUserSubscription, UpdatedUserSubscriptionVariables>(UpdatedUserDocument, options);
      }
export type UpdatedUserSubscriptionHookResult = ReturnType<typeof useUpdatedUserSubscription>;
export type UpdatedUserSubscriptionResult = Apollo.SubscriptionResult<UpdatedUserSubscription>;
export const DeletedUserDocument = gql`
    subscription DeletedUser($filter: UserFilterArgs) {
  deletedUser(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedUserSubscription__
 *
 * To run a query within a React component, call `useDeletedUserSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedUserSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedUserSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedUserSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedUserSubscription, DeletedUserSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedUserSubscription, DeletedUserSubscriptionVariables>(DeletedUserDocument, options);
      }
export type DeletedUserSubscriptionHookResult = ReturnType<typeof useDeletedUserSubscription>;
export type DeletedUserSubscriptionResult = Apollo.SubscriptionResult<DeletedUserSubscription>;
export const GetUserTenantRolesDocument = gql`
    query GetUserTenantRoles($filter: UserTenantRoleFilterArgs, $paging: PageArgs, $sorting: [UserTenantRoleSortArgs!], $withUser: Boolean = false, $withTenant: Boolean = false, $withRole: Boolean = false) {
  userTenantRoles(filter: $filter, paging: $paging, sorting: $sorting) {
    items {
      ...userTenantRoleFields
    }
    totalCount
  }
}
    ${UserTenantRoleFieldsFragmentDoc}`;

/**
 * __useGetUserTenantRolesQuery__
 *
 * To run a query within a React component, call `useGetUserTenantRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTenantRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTenantRolesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *      withUser: // value for 'withUser'
 *      withTenant: // value for 'withTenant'
 *      withRole: // value for 'withRole'
 *   },
 * });
 */
export function useGetUserTenantRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserTenantRolesQuery, GetUserTenantRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserTenantRolesQuery, GetUserTenantRolesQueryVariables>(GetUserTenantRolesDocument, options);
      }
export function useGetUserTenantRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserTenantRolesQuery, GetUserTenantRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserTenantRolesQuery, GetUserTenantRolesQueryVariables>(GetUserTenantRolesDocument, options);
        }
export function useGetUserTenantRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserTenantRolesQuery, GetUserTenantRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserTenantRolesQuery, GetUserTenantRolesQueryVariables>(GetUserTenantRolesDocument, options);
        }
export type GetUserTenantRolesQueryHookResult = ReturnType<typeof useGetUserTenantRolesQuery>;
export type GetUserTenantRolesLazyQueryHookResult = ReturnType<typeof useGetUserTenantRolesLazyQuery>;
export type GetUserTenantRolesSuspenseQueryHookResult = ReturnType<typeof useGetUserTenantRolesSuspenseQuery>;
export type GetUserTenantRolesQueryResult = Apollo.QueryResult<GetUserTenantRolesQuery, GetUserTenantRolesQueryVariables>;
export const GetUserTenantRoleDocument = gql`
    query GetUserTenantRole($id: ID!, $withUser: Boolean = false, $withTenant: Boolean = false, $withRole: Boolean = false) {
  userTenantRole(id: $id) {
    ...userTenantRoleFields
  }
}
    ${UserTenantRoleFieldsFragmentDoc}`;

/**
 * __useGetUserTenantRoleQuery__
 *
 * To run a query within a React component, call `useGetUserTenantRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTenantRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTenantRoleQuery({
 *   variables: {
 *      id: // value for 'id'
 *      withUser: // value for 'withUser'
 *      withTenant: // value for 'withTenant'
 *      withRole: // value for 'withRole'
 *   },
 * });
 */
export function useGetUserTenantRoleQuery(baseOptions: Apollo.QueryHookOptions<GetUserTenantRoleQuery, GetUserTenantRoleQueryVariables> & ({ variables: GetUserTenantRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserTenantRoleQuery, GetUserTenantRoleQueryVariables>(GetUserTenantRoleDocument, options);
      }
export function useGetUserTenantRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserTenantRoleQuery, GetUserTenantRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserTenantRoleQuery, GetUserTenantRoleQueryVariables>(GetUserTenantRoleDocument, options);
        }
export function useGetUserTenantRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserTenantRoleQuery, GetUserTenantRoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserTenantRoleQuery, GetUserTenantRoleQueryVariables>(GetUserTenantRoleDocument, options);
        }
export type GetUserTenantRoleQueryHookResult = ReturnType<typeof useGetUserTenantRoleQuery>;
export type GetUserTenantRoleLazyQueryHookResult = ReturnType<typeof useGetUserTenantRoleLazyQuery>;
export type GetUserTenantRoleSuspenseQueryHookResult = ReturnType<typeof useGetUserTenantRoleSuspenseQuery>;
export type GetUserTenantRoleQueryResult = Apollo.QueryResult<GetUserTenantRoleQuery, GetUserTenantRoleQueryVariables>;
export const GetAllRelatedDataForUserTenantRoleDocument = gql`
    query GetAllRelatedDataForUserTenantRole($withUsers: Boolean = false, $withTenants: Boolean = false, $withRoles: Boolean = false) {
  users @include(if: $withUsers) {
    items {
      id
      displayField: name
    }
  }
  tenants @include(if: $withTenants) {
    items {
      id
      displayField: name
    }
  }
  roles @include(if: $withRoles) {
    items {
      id
      displayField: displayName
    }
  }
}
    `;

/**
 * __useGetAllRelatedDataForUserTenantRoleQuery__
 *
 * To run a query within a React component, call `useGetAllRelatedDataForUserTenantRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRelatedDataForUserTenantRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRelatedDataForUserTenantRoleQuery({
 *   variables: {
 *      withUsers: // value for 'withUsers'
 *      withTenants: // value for 'withTenants'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useGetAllRelatedDataForUserTenantRoleQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRelatedDataForUserTenantRoleQuery, GetAllRelatedDataForUserTenantRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRelatedDataForUserTenantRoleQuery, GetAllRelatedDataForUserTenantRoleQueryVariables>(GetAllRelatedDataForUserTenantRoleDocument, options);
      }
export function useGetAllRelatedDataForUserTenantRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRelatedDataForUserTenantRoleQuery, GetAllRelatedDataForUserTenantRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRelatedDataForUserTenantRoleQuery, GetAllRelatedDataForUserTenantRoleQueryVariables>(GetAllRelatedDataForUserTenantRoleDocument, options);
        }
export function useGetAllRelatedDataForUserTenantRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllRelatedDataForUserTenantRoleQuery, GetAllRelatedDataForUserTenantRoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllRelatedDataForUserTenantRoleQuery, GetAllRelatedDataForUserTenantRoleQueryVariables>(GetAllRelatedDataForUserTenantRoleDocument, options);
        }
export type GetAllRelatedDataForUserTenantRoleQueryHookResult = ReturnType<typeof useGetAllRelatedDataForUserTenantRoleQuery>;
export type GetAllRelatedDataForUserTenantRoleLazyQueryHookResult = ReturnType<typeof useGetAllRelatedDataForUserTenantRoleLazyQuery>;
export type GetAllRelatedDataForUserTenantRoleSuspenseQueryHookResult = ReturnType<typeof useGetAllRelatedDataForUserTenantRoleSuspenseQuery>;
export type GetAllRelatedDataForUserTenantRoleQueryResult = Apollo.QueryResult<GetAllRelatedDataForUserTenantRoleQuery, GetAllRelatedDataForUserTenantRoleQueryVariables>;
export const CreateUserTenantRoleDocument = gql`
    mutation CreateUserTenantRole($userId: ID!, $tenantId: ID!, $roleId: ID!, $withUser: Boolean = false, $withTenant: Boolean = false, $withRole: Boolean = false) {
  createUserTenantRole(userId: $userId, tenantId: $tenantId, roleId: $roleId) {
    ...userTenantRoleFields
  }
}
    ${UserTenantRoleFieldsFragmentDoc}`;
export type CreateUserTenantRoleMutationFn = Apollo.MutationFunction<CreateUserTenantRoleMutation, CreateUserTenantRoleMutationVariables>;

/**
 * __useCreateUserTenantRoleMutation__
 *
 * To run a mutation, you first call `useCreateUserTenantRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserTenantRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserTenantRoleMutation, { data, loading, error }] = useCreateUserTenantRoleMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      tenantId: // value for 'tenantId'
 *      roleId: // value for 'roleId'
 *      withUser: // value for 'withUser'
 *      withTenant: // value for 'withTenant'
 *      withRole: // value for 'withRole'
 *   },
 * });
 */
export function useCreateUserTenantRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserTenantRoleMutation, CreateUserTenantRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserTenantRoleMutation, CreateUserTenantRoleMutationVariables>(CreateUserTenantRoleDocument, options);
      }
export type CreateUserTenantRoleMutationHookResult = ReturnType<typeof useCreateUserTenantRoleMutation>;
export type CreateUserTenantRoleMutationResult = Apollo.MutationResult<CreateUserTenantRoleMutation>;
export type CreateUserTenantRoleMutationOptions = Apollo.BaseMutationOptions<CreateUserTenantRoleMutation, CreateUserTenantRoleMutationVariables>;
export const UpdateUserTenantRoleDocument = gql`
    mutation UpdateUserTenantRole($id: ID!, $userId: ID, $tenantId: ID, $roleId: ID, $withUser: Boolean = false, $withTenant: Boolean = false, $withRole: Boolean = false) {
  updateUserTenantRole(
    id: $id
    userId: $userId
    tenantId: $tenantId
    roleId: $roleId
  ) {
    ...userTenantRoleFields
  }
}
    ${UserTenantRoleFieldsFragmentDoc}`;
export type UpdateUserTenantRoleMutationFn = Apollo.MutationFunction<UpdateUserTenantRoleMutation, UpdateUserTenantRoleMutationVariables>;

/**
 * __useUpdateUserTenantRoleMutation__
 *
 * To run a mutation, you first call `useUpdateUserTenantRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserTenantRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserTenantRoleMutation, { data, loading, error }] = useUpdateUserTenantRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *      tenantId: // value for 'tenantId'
 *      roleId: // value for 'roleId'
 *      withUser: // value for 'withUser'
 *      withTenant: // value for 'withTenant'
 *      withRole: // value for 'withRole'
 *   },
 * });
 */
export function useUpdateUserTenantRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserTenantRoleMutation, UpdateUserTenantRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserTenantRoleMutation, UpdateUserTenantRoleMutationVariables>(UpdateUserTenantRoleDocument, options);
      }
export type UpdateUserTenantRoleMutationHookResult = ReturnType<typeof useUpdateUserTenantRoleMutation>;
export type UpdateUserTenantRoleMutationResult = Apollo.MutationResult<UpdateUserTenantRoleMutation>;
export type UpdateUserTenantRoleMutationOptions = Apollo.BaseMutationOptions<UpdateUserTenantRoleMutation, UpdateUserTenantRoleMutationVariables>;
export const DeleteUserTenantRoleDocument = gql`
    mutation DeleteUserTenantRole($id: ID!, $withUser: Boolean = false, $withTenant: Boolean = false, $withRole: Boolean = false) {
  deleteUserTenantRole(id: $id) {
    ...userTenantRoleFields
  }
}
    ${UserTenantRoleFieldsFragmentDoc}`;
export type DeleteUserTenantRoleMutationFn = Apollo.MutationFunction<DeleteUserTenantRoleMutation, DeleteUserTenantRoleMutationVariables>;

/**
 * __useDeleteUserTenantRoleMutation__
 *
 * To run a mutation, you first call `useDeleteUserTenantRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserTenantRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserTenantRoleMutation, { data, loading, error }] = useDeleteUserTenantRoleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      withUser: // value for 'withUser'
 *      withTenant: // value for 'withTenant'
 *      withRole: // value for 'withRole'
 *   },
 * });
 */
export function useDeleteUserTenantRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserTenantRoleMutation, DeleteUserTenantRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserTenantRoleMutation, DeleteUserTenantRoleMutationVariables>(DeleteUserTenantRoleDocument, options);
      }
export type DeleteUserTenantRoleMutationHookResult = ReturnType<typeof useDeleteUserTenantRoleMutation>;
export type DeleteUserTenantRoleMutationResult = Apollo.MutationResult<DeleteUserTenantRoleMutation>;
export type DeleteUserTenantRoleMutationOptions = Apollo.BaseMutationOptions<DeleteUserTenantRoleMutation, DeleteUserTenantRoleMutationVariables>;
export const CreatedUserTenantRoleDocument = gql`
    subscription CreatedUserTenantRole($filter: UserTenantRoleFilterArgs, $withUser: Boolean = false, $withTenant: Boolean = false, $withRole: Boolean = false) {
  createdUserTenantRole(filter: $filter) {
    ...userTenantRoleFields
  }
}
    ${UserTenantRoleFieldsFragmentDoc}`;

/**
 * __useCreatedUserTenantRoleSubscription__
 *
 * To run a query within a React component, call `useCreatedUserTenantRoleSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCreatedUserTenantRoleSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreatedUserTenantRoleSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUser: // value for 'withUser'
 *      withTenant: // value for 'withTenant'
 *      withRole: // value for 'withRole'
 *   },
 * });
 */
export function useCreatedUserTenantRoleSubscription(baseOptions?: Apollo.SubscriptionHookOptions<CreatedUserTenantRoleSubscription, CreatedUserTenantRoleSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CreatedUserTenantRoleSubscription, CreatedUserTenantRoleSubscriptionVariables>(CreatedUserTenantRoleDocument, options);
      }
export type CreatedUserTenantRoleSubscriptionHookResult = ReturnType<typeof useCreatedUserTenantRoleSubscription>;
export type CreatedUserTenantRoleSubscriptionResult = Apollo.SubscriptionResult<CreatedUserTenantRoleSubscription>;
export const UpdatedUserTenantRoleDocument = gql`
    subscription UpdatedUserTenantRole($filter: UserTenantRoleFilterArgs, $withUser: Boolean = false, $withTenant: Boolean = false, $withRole: Boolean = false) {
  updatedUserTenantRole(filter: $filter) {
    ...userTenantRoleFields
  }
}
    ${UserTenantRoleFieldsFragmentDoc}`;

/**
 * __useUpdatedUserTenantRoleSubscription__
 *
 * To run a query within a React component, call `useUpdatedUserTenantRoleSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdatedUserTenantRoleSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdatedUserTenantRoleSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *      withUser: // value for 'withUser'
 *      withTenant: // value for 'withTenant'
 *      withRole: // value for 'withRole'
 *   },
 * });
 */
export function useUpdatedUserTenantRoleSubscription(baseOptions?: Apollo.SubscriptionHookOptions<UpdatedUserTenantRoleSubscription, UpdatedUserTenantRoleSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdatedUserTenantRoleSubscription, UpdatedUserTenantRoleSubscriptionVariables>(UpdatedUserTenantRoleDocument, options);
      }
export type UpdatedUserTenantRoleSubscriptionHookResult = ReturnType<typeof useUpdatedUserTenantRoleSubscription>;
export type UpdatedUserTenantRoleSubscriptionResult = Apollo.SubscriptionResult<UpdatedUserTenantRoleSubscription>;
export const DeletedUserTenantRoleDocument = gql`
    subscription DeletedUserTenantRole($filter: UserTenantRoleFilterArgs) {
  deletedUserTenantRole(filter: $filter) {
    id
  }
}
    `;

/**
 * __useDeletedUserTenantRoleSubscription__
 *
 * To run a query within a React component, call `useDeletedUserTenantRoleSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedUserTenantRoleSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedUserTenantRoleSubscription({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeletedUserTenantRoleSubscription(baseOptions?: Apollo.SubscriptionHookOptions<DeletedUserTenantRoleSubscription, DeletedUserTenantRoleSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<DeletedUserTenantRoleSubscription, DeletedUserTenantRoleSubscriptionVariables>(DeletedUserTenantRoleDocument, options);
      }
export type DeletedUserTenantRoleSubscriptionHookResult = ReturnType<typeof useDeletedUserTenantRoleSubscription>;
export type DeletedUserTenantRoleSubscriptionResult = Apollo.SubscriptionResult<DeletedUserTenantRoleSubscription>;
export const GetFullUserDocument = gql`
    query GetFullUser($id: ID!) {
  user(id: $id) {
    id
    name
    email
    emailVerifiedAt
    active
    avatar
    userTenantRoles {
      items {
        id
        userId
        tenantId
        roleId
        role {
          id
          machineName
          displayField: machineName
        }
        tenant {
          id
          name
          displayField: name
        }
        displayField: id
      }
      totalCount
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetFullUserQuery__
 *
 * To run a query within a React component, call `useGetFullUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFullUserQuery(baseOptions: Apollo.QueryHookOptions<GetFullUserQuery, GetFullUserQueryVariables> & ({ variables: GetFullUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFullUserQuery, GetFullUserQueryVariables>(GetFullUserDocument, options);
      }
export function useGetFullUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFullUserQuery, GetFullUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFullUserQuery, GetFullUserQueryVariables>(GetFullUserDocument, options);
        }
export function useGetFullUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFullUserQuery, GetFullUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFullUserQuery, GetFullUserQueryVariables>(GetFullUserDocument, options);
        }
export type GetFullUserQueryHookResult = ReturnType<typeof useGetFullUserQuery>;
export type GetFullUserLazyQueryHookResult = ReturnType<typeof useGetFullUserLazyQuery>;
export type GetFullUserSuspenseQueryHookResult = ReturnType<typeof useGetFullUserSuspenseQuery>;
export type GetFullUserQueryResult = Apollo.QueryResult<GetFullUserQuery, GetFullUserQueryVariables>;
export const CreateUserWithTenantRoleDocument = gql`
    mutation CreateUserWithTenantRole($name: String!, $email: String!, $active: Boolean!, $avatar: String, $termsAndConditions: Boolean, $userTenantRoles: [ID], $tenantId: String, $roleId: String, $invite: Boolean, $locale: String!, $timeZone: String!, $withUserTenantRoles: Boolean = false, $withPeople: Boolean = false, $withReminders: Boolean = false) {
  createUser(
    name: $name
    email: $email
    active: $active
    avatar: $avatar
    termsAndConditions: $termsAndConditions
    userTenantRoleIds: $userTenantRoles
    tenantId: $tenantId
    roleId: $roleId
    invite: $invite
    locale: $locale
    timeZone: $timeZone
  ) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;
export type CreateUserWithTenantRoleMutationFn = Apollo.MutationFunction<CreateUserWithTenantRoleMutation, CreateUserWithTenantRoleMutationVariables>;

/**
 * __useCreateUserWithTenantRoleMutation__
 *
 * To run a mutation, you first call `useCreateUserWithTenantRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserWithTenantRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserWithTenantRoleMutation, { data, loading, error }] = useCreateUserWithTenantRoleMutation({
 *   variables: {
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      active: // value for 'active'
 *      avatar: // value for 'avatar'
 *      termsAndConditions: // value for 'termsAndConditions'
 *      userTenantRoles: // value for 'userTenantRoles'
 *      tenantId: // value for 'tenantId'
 *      roleId: // value for 'roleId'
 *      invite: // value for 'invite'
 *      locale: // value for 'locale'
 *      timeZone: // value for 'timeZone'
 *      withUserTenantRoles: // value for 'withUserTenantRoles'
 *      withPeople: // value for 'withPeople'
 *      withReminders: // value for 'withReminders'
 *   },
 * });
 */
export function useCreateUserWithTenantRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserWithTenantRoleMutation, CreateUserWithTenantRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserWithTenantRoleMutation, CreateUserWithTenantRoleMutationVariables>(CreateUserWithTenantRoleDocument, options);
      }
export type CreateUserWithTenantRoleMutationHookResult = ReturnType<typeof useCreateUserWithTenantRoleMutation>;
export type CreateUserWithTenantRoleMutationResult = Apollo.MutationResult<CreateUserWithTenantRoleMutation>;
export type CreateUserWithTenantRoleMutationOptions = Apollo.BaseMutationOptions<CreateUserWithTenantRoleMutation, CreateUserWithTenantRoleMutationVariables>;
export const CreateContentWithFillDocument = gql`
    mutation createContentWithFill($name: String!, $fill: String!, $language: String!) {
  createContentWithFill(name: $name, fill: $fill, language: $language)
}
    `;
export type CreateContentWithFillMutationFn = Apollo.MutationFunction<CreateContentWithFillMutation, CreateContentWithFillMutationVariables>;

/**
 * __useCreateContentWithFillMutation__
 *
 * To run a mutation, you first call `useCreateContentWithFillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentWithFillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentWithFillMutation, { data, loading, error }] = useCreateContentWithFillMutation({
 *   variables: {
 *      name: // value for 'name'
 *      fill: // value for 'fill'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useCreateContentWithFillMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentWithFillMutation, CreateContentWithFillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentWithFillMutation, CreateContentWithFillMutationVariables>(CreateContentWithFillDocument, options);
      }
export type CreateContentWithFillMutationHookResult = ReturnType<typeof useCreateContentWithFillMutation>;
export type CreateContentWithFillMutationResult = Apollo.MutationResult<CreateContentWithFillMutation>;
export type CreateContentWithFillMutationOptions = Apollo.BaseMutationOptions<CreateContentWithFillMutation, CreateContentWithFillMutationVariables>;
export const UpdateContentWithFillDocument = gql`
    mutation updateContentWithFill($id: ID!, $name: String!, $fill: String!, $language: String!) {
  updateContentWithFill(id: $id, name: $name, fill: $fill, language: $language)
}
    `;
export type UpdateContentWithFillMutationFn = Apollo.MutationFunction<UpdateContentWithFillMutation, UpdateContentWithFillMutationVariables>;

/**
 * __useUpdateContentWithFillMutation__
 *
 * To run a mutation, you first call `useUpdateContentWithFillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentWithFillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentWithFillMutation, { data, loading, error }] = useUpdateContentWithFillMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      fill: // value for 'fill'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUpdateContentWithFillMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentWithFillMutation, UpdateContentWithFillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentWithFillMutation, UpdateContentWithFillMutationVariables>(UpdateContentWithFillDocument, options);
      }
export type UpdateContentWithFillMutationHookResult = ReturnType<typeof useUpdateContentWithFillMutation>;
export type UpdateContentWithFillMutationResult = Apollo.MutationResult<UpdateContentWithFillMutation>;
export type UpdateContentWithFillMutationOptions = Apollo.BaseMutationOptions<UpdateContentWithFillMutation, UpdateContentWithFillMutationVariables>;
export const GetPersonOrganizationsDocument = gql`
    query GetPersonOrganizations($personId: String!) {
  organizations(
    filter: {personId: {eq: $personId}}
    sorting: {direction: DESC, field: createdAt}
  ) {
    items {
      id
      name
      registrationNumber
      personId
    }
  }
}
    `;

/**
 * __useGetPersonOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetPersonOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonOrganizationsQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useGetPersonOrganizationsQuery(baseOptions: Apollo.QueryHookOptions<GetPersonOrganizationsQuery, GetPersonOrganizationsQueryVariables> & ({ variables: GetPersonOrganizationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonOrganizationsQuery, GetPersonOrganizationsQueryVariables>(GetPersonOrganizationsDocument, options);
      }
export function useGetPersonOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonOrganizationsQuery, GetPersonOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonOrganizationsQuery, GetPersonOrganizationsQueryVariables>(GetPersonOrganizationsDocument, options);
        }
export function useGetPersonOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPersonOrganizationsQuery, GetPersonOrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPersonOrganizationsQuery, GetPersonOrganizationsQueryVariables>(GetPersonOrganizationsDocument, options);
        }
export type GetPersonOrganizationsQueryHookResult = ReturnType<typeof useGetPersonOrganizationsQuery>;
export type GetPersonOrganizationsLazyQueryHookResult = ReturnType<typeof useGetPersonOrganizationsLazyQuery>;
export type GetPersonOrganizationsSuspenseQueryHookResult = ReturnType<typeof useGetPersonOrganizationsSuspenseQuery>;
export type GetPersonOrganizationsQueryResult = Apollo.QueryResult<GetPersonOrganizationsQuery, GetPersonOrganizationsQueryVariables>;
export const DeleteOrganizationsDataDocument = gql`
    mutation DeleteOrganizationsData($ids: [ID!]!) {
  deleteManyOrganizations(ids: $ids) {
    id
  }
}
    `;
export type DeleteOrganizationsDataMutationFn = Apollo.MutationFunction<DeleteOrganizationsDataMutation, DeleteOrganizationsDataMutationVariables>;

/**
 * __useDeleteOrganizationsDataMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationsDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationsDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationsDataMutation, { data, loading, error }] = useDeleteOrganizationsDataMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteOrganizationsDataMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationsDataMutation, DeleteOrganizationsDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationsDataMutation, DeleteOrganizationsDataMutationVariables>(DeleteOrganizationsDataDocument, options);
      }
export type DeleteOrganizationsDataMutationHookResult = ReturnType<typeof useDeleteOrganizationsDataMutation>;
export type DeleteOrganizationsDataMutationResult = Apollo.MutationResult<DeleteOrganizationsDataMutation>;
export type DeleteOrganizationsDataMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationsDataMutation, DeleteOrganizationsDataMutationVariables>;
export const GetPersonRegisterProgressDataDocument = gql`
    query GetPersonRegisterProgressData($personId: String!, $registerId: String!) {
  personRegisterProgresses(
    filter: {personId: {eq: $personId}, registerId: {eq: $registerId}}
  ) {
    items {
      ...personRegisterProgressQuery
    }
  }
}
    ${PersonRegisterProgressQueryFragmentDoc}`;

/**
 * __useGetPersonRegisterProgressDataQuery__
 *
 * To run a query within a React component, call `useGetPersonRegisterProgressDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonRegisterProgressDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonRegisterProgressDataQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *      registerId: // value for 'registerId'
 *   },
 * });
 */
export function useGetPersonRegisterProgressDataQuery(baseOptions: Apollo.QueryHookOptions<GetPersonRegisterProgressDataQuery, GetPersonRegisterProgressDataQueryVariables> & ({ variables: GetPersonRegisterProgressDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonRegisterProgressDataQuery, GetPersonRegisterProgressDataQueryVariables>(GetPersonRegisterProgressDataDocument, options);
      }
export function useGetPersonRegisterProgressDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonRegisterProgressDataQuery, GetPersonRegisterProgressDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonRegisterProgressDataQuery, GetPersonRegisterProgressDataQueryVariables>(GetPersonRegisterProgressDataDocument, options);
        }
export function useGetPersonRegisterProgressDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPersonRegisterProgressDataQuery, GetPersonRegisterProgressDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPersonRegisterProgressDataQuery, GetPersonRegisterProgressDataQueryVariables>(GetPersonRegisterProgressDataDocument, options);
        }
export type GetPersonRegisterProgressDataQueryHookResult = ReturnType<typeof useGetPersonRegisterProgressDataQuery>;
export type GetPersonRegisterProgressDataLazyQueryHookResult = ReturnType<typeof useGetPersonRegisterProgressDataLazyQuery>;
export type GetPersonRegisterProgressDataSuspenseQueryHookResult = ReturnType<typeof useGetPersonRegisterProgressDataSuspenseQuery>;
export type GetPersonRegisterProgressDataQueryResult = Apollo.QueryResult<GetPersonRegisterProgressDataQuery, GetPersonRegisterProgressDataQueryVariables>;
export const UpdatePersonSearchProgressionDocument = gql`
    mutation updatePersonSearchProgression($searchId: String!, $personId: String!, $registerId: String!, $progress: String!) {
  updateOrCreatePersonSearchProgressProgression(
    searchId: $searchId
    personId: $personId
    registerId: $registerId
    progress: $progress
  ) {
    ...personRegisterProgressQuery
  }
}
    ${PersonRegisterProgressQueryFragmentDoc}`;
export type UpdatePersonSearchProgressionMutationFn = Apollo.MutationFunction<UpdatePersonSearchProgressionMutation, UpdatePersonSearchProgressionMutationVariables>;

/**
 * __useUpdatePersonSearchProgressionMutation__
 *
 * To run a mutation, you first call `useUpdatePersonSearchProgressionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonSearchProgressionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonSearchProgressionMutation, { data, loading, error }] = useUpdatePersonSearchProgressionMutation({
 *   variables: {
 *      searchId: // value for 'searchId'
 *      personId: // value for 'personId'
 *      registerId: // value for 'registerId'
 *      progress: // value for 'progress'
 *   },
 * });
 */
export function useUpdatePersonSearchProgressionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonSearchProgressionMutation, UpdatePersonSearchProgressionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonSearchProgressionMutation, UpdatePersonSearchProgressionMutationVariables>(UpdatePersonSearchProgressionDocument, options);
      }
export type UpdatePersonSearchProgressionMutationHookResult = ReturnType<typeof useUpdatePersonSearchProgressionMutation>;
export type UpdatePersonSearchProgressionMutationResult = Apollo.MutationResult<UpdatePersonSearchProgressionMutation>;
export type UpdatePersonSearchProgressionMutationOptions = Apollo.BaseMutationOptions<UpdatePersonSearchProgressionMutation, UpdatePersonSearchProgressionMutationVariables>;
export const UpdatePersonActionProgressionDocument = gql`
    mutation updatePersonActionProgression($actionId: String!, $personId: String!, $registerId: String!, $progress: String!) {
  updateOrCreatePersonActionProgressProgression(
    actionId: $actionId
    personId: $personId
    registerId: $registerId
    progress: $progress
  ) {
    ...personRegisterProgressQuery
  }
}
    ${PersonRegisterProgressQueryFragmentDoc}`;
export type UpdatePersonActionProgressionMutationFn = Apollo.MutationFunction<UpdatePersonActionProgressionMutation, UpdatePersonActionProgressionMutationVariables>;

/**
 * __useUpdatePersonActionProgressionMutation__
 *
 * To run a mutation, you first call `useUpdatePersonActionProgressionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonActionProgressionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonActionProgressionMutation, { data, loading, error }] = useUpdatePersonActionProgressionMutation({
 *   variables: {
 *      actionId: // value for 'actionId'
 *      personId: // value for 'personId'
 *      registerId: // value for 'registerId'
 *      progress: // value for 'progress'
 *   },
 * });
 */
export function useUpdatePersonActionProgressionMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonActionProgressionMutation, UpdatePersonActionProgressionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonActionProgressionMutation, UpdatePersonActionProgressionMutationVariables>(UpdatePersonActionProgressionDocument, options);
      }
export type UpdatePersonActionProgressionMutationHookResult = ReturnType<typeof useUpdatePersonActionProgressionMutation>;
export type UpdatePersonActionProgressionMutationResult = Apollo.MutationResult<UpdatePersonActionProgressionMutation>;
export type UpdatePersonActionProgressionMutationOptions = Apollo.BaseMutationOptions<UpdatePersonActionProgressionMutation, UpdatePersonActionProgressionMutationVariables>;
export const GetRegistersDataDocument = gql`
    query GetRegistersData {
  registers(sorting: {direction: ASC, field: order}) {
    items {
      id
      email
      type
      companyRegister
      name
      subtitle
      description
      siteUrl
      contactUrl
      siteUrl
      order
      logo
      __typename
      actions {
        items {
          id
          name
          description
          order
          type
          __typename
          message {
            id
            title
            content
            __typename
          }
          searches {
            items {
              id
              name
              order
              searchUrl
              __typename
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetRegistersDataQuery__
 *
 * To run a query within a React component, call `useGetRegistersDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistersDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistersDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRegistersDataQuery(baseOptions?: Apollo.QueryHookOptions<GetRegistersDataQuery, GetRegistersDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegistersDataQuery, GetRegistersDataQueryVariables>(GetRegistersDataDocument, options);
      }
export function useGetRegistersDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegistersDataQuery, GetRegistersDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegistersDataQuery, GetRegistersDataQueryVariables>(GetRegistersDataDocument, options);
        }
export function useGetRegistersDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRegistersDataQuery, GetRegistersDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRegistersDataQuery, GetRegistersDataQueryVariables>(GetRegistersDataDocument, options);
        }
export type GetRegistersDataQueryHookResult = ReturnType<typeof useGetRegistersDataQuery>;
export type GetRegistersDataLazyQueryHookResult = ReturnType<typeof useGetRegistersDataLazyQuery>;
export type GetRegistersDataSuspenseQueryHookResult = ReturnType<typeof useGetRegistersDataSuspenseQuery>;
export type GetRegistersDataQueryResult = Apollo.QueryResult<GetRegistersDataQuery, GetRegistersDataQueryVariables>;